webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiDateFormat = exports.numberFormat = exports.rnd = exports.safeDA = exports.convert = exports.simpleSnakeCase = undefined;

var _stringify = __webpack_require__(565);

var _stringify2 = _interopRequireDefault(_stringify);

exports.cssClassName = cssClassName;
exports._isContain = _isContain;
exports.isServer = isServer;
exports.capitalize = capitalize;
exports.deepValueByString = deepValueByString;
exports.getArticleLinks = getArticleLinks;
exports.arrayUnique = arrayUnique;

var _catnip = __webpack_require__(576);

var _catnip2 = _interopRequireDefault(_catnip);

var _camelcaseKeys = __webpack_require__(574);

var _camelcaseKeys2 = _interopRequireDefault(_camelcaseKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//default helpers
function cssDecamelize(string) {
  var newString = string.split('_').filter(function (n) {
    return n !== '';
  }).join('-');
  newString = newString.replace(/([a-z](?=[A-Z]))/g, '$1+');
  return newString.split('+').join('-').toLowerCase();
}

function cssClassName(string) {
  return (0, _catnip2.default)(cssDecamelize(string));
}

function _isContain(arr, element) {
  return arr.indexOf(element) > -1;
}
var simpleSnakeCase = exports.simpleSnakeCase = function simpleSnakeCase(str) {
  return str.split(/(?=[A-Z])/).join('_').toLowerCase();
};

function toPhone(str) {
  var res = str.replace(/\D/g, '');
  if (res.length > 2) res = res.substr(0, 3) + '-' + res.substr(3, 20);
  if (res.length > 6) res = res.substr(0, 7) + '-' + res.substr(7, 4);

  return res;
}

var convert = exports.convert = {
  toSnake: function toSnake(str) {
    return str.split(/(?=[A-Z])/).join('_').toLowerCase();
  },
  toKebab: function toKebab(str) {
    var newString = str.replace(/(\w(?=[A-Z]))/g, '$1+').replace(/[_-]/g, '+');
    return newString.split('+').join('-').toLowerCase();
  },
  toCleanKebab: function toCleanKebab(str) {
    return str.replace(/[^\w\s_]/g, '').split(/\s+/).join('-').toLowerCase();
  },
  toCamel: function toCamel(str) {
    return str.replace(/[_-]([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
  },
  toTitleCase: function toTitleCase(str) {
    var newString = str.replace(/[_-]/, ' ');
    return newString.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  toPhone: toPhone,
  obj: {
    toCamel: function toCamel(str) {
      return (0, _camelcaseKeys2.default)(str, { deep: true });
    }
  }
};

function isServer() {
  try {
    window === void 0;
    return false;
  } catch (e) {
    return true;
  }
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function deepValueByString(obj, path) {
  path = path.split('.');
  var length = path.length;
  for (var i = 0; i < length; i++) {
    obj = obj[path[i]];
  }
  return obj;
}

function getArticleLinks(ids, entities) {
  return ids.map(function (id) {
    var entitie = entities[id];

    return {
      title: entitie.title,
      url: '/wiki/' + entitie.level0 + '/' + id,
      level1: entitie.level1,
      level0: entitie.level0
    };
  });
}

//save deep access to objects and arrays, ex. of use:   safeDA([{a:{b:10}}], ['0', 'a', 'b'], 0),
// return value or noResult value, if there is no noResult value returns false.
var safeDA = exports.safeDA = function safeDA(object, props) {
  var noResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return props.reduce(function (prefix, val) {
    return prefix && prefix[val] ? prefix[val] : noResult;
  }, object);
};

function rndStr(long) {
  var n = Math.ceil(long / 5);
  var string = '';
  for (var i = 0; i < n; i++) {
    string += Math.random().toString(36).substring(8);
  }
  return string.substr(0, long);
}

var rnd = exports.rnd = {
  str: rndStr,
  num: function num(long) {
    return Math.round(Math.random() * Math.pow(10, long));
  }

  //number format function ex. of use: numberFormat(100000000000, 2) => '10,000,000.00'
};var numberFormat = exports.numberFormat = function numberFormat(n, dp) {

  if (!n) return '0';
  var e = '',
      s = e + n,
      l = s.length,
      b = n < 0 ? 1 : 0,
      i = s.lastIndexOf('.'),
      j = i == -1 ? l : i,
      r = e,
      d = s.substr(j + 1, dp);
  while ((j -= 3) > b) {
    r = ',' + s.substr(j, 3) + r;
  }
  return s.substr(0, j + 3) + r + (dp ? '.' + d + (d.length < dp ? '00000'.substr(0, dp - d.length) : e) : e);
};

function arrayUnique(array) {
  var a = array.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if ((0, _stringify2.default)(a[i]) === (0, _stringify2.default)(a[j])) a.splice(j--, 1);
    }
  }

  return a;
}

var apiDateFormat = exports.apiDateFormat = function apiDateFormat(momentDate) {
  return momentDate.format('YYYYMMDDTHHmmss[Z]');
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(770);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Title');

var A_Title = function A_Title(_ref) {
  var type = _ref.type,
      theme = _ref.theme,
      mix = _ref.mix,
      children = _ref.children;


  var tagType = void 0;
  switch (type) {
    case 'hero':
      tagType = 'h1';
      break;
    case 'section':
      tagType = 'h2';
      break;
    case 'info-column':
      tagType = 'h3';
      break;
    case 'inner-pages':
      tagType = 'h3';
      break;
    default:
      tagType = 'p';
  }

  return _react2.default.createElement(tagType, { className: cn({ type: type, theme: theme }, [mix]) }, children);
};

A_Title.propTypes = {
  type: T.oneOf(['hero', //ProximaNova Uppercase bold 72px
  'section', //ProximaNova bold 72px
  'info-column', //ProximaNova bold 31px
  'inner-pages']),
  theme: T.oneOf(['bright', //white ProximaNova bold 72px
  'dark'] //black title used for sections
  ),
  children: T.any.isRequired //title text
};

A_Title.defaultProps = {
  theme: 'dark'
};

exports.default = A_Title;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REQUEST = exports.REQUEST = 'REQUEST_';
var OPEN = exports.OPEN = 'OPEN_';
var TOGGLE = exports.TOGGLE = 'TOGGLE_';
var FETCH = exports.FETCH = 'FETCH_';
var CLOSE = exports.CLOSE = 'CLOSE_';
var SET = exports.SET = 'SET_';
var CLEAN = exports.CLEAN = 'CLEAN_';

var BLOCKCHAIN_TRANSACTIONS = exports.BLOCKCHAIN_TRANSACTIONS = 'BLOCKCHAIN_TRANSACTIONS';
var HMQ_STATISTICS = exports.HMQ_STATISTICS = 'HMQ_STATISTICS';
var HMQ_MARKETS = exports.HMQ_MARKETS = 'HMQ_MARKETS';
var HMQ_HOLDERS = exports.HMQ_HOLDERS = 'HMQ_HOLDERS';
var HMQ_HOLDER = exports.HMQ_HOLDER = 'HMQ_HOLDER';
var HMQ_HOLDER_T = exports.HMQ_HOLDER_T = 'HMQ_HOLDER_T';
var HMQ_LOG = exports.HMQ_LOG = 'HMQ_LOG';
var HMQ_SECTION = exports.HMQ_SECTION = 'HMQ_SECTION';
var HMQ_BLOCK = exports.HMQ_BLOCK = 'HMQ_BLOCK';
var HMQ_GRAPH = exports.HMQ_GRAPH = 'HMQ_GRAPH';
var HMQ_HASH = exports.HMQ_HASH = 'HMQ_HASH';
var HMQ_SEARCH = exports.HMQ_SEARCH = 'HMQ_SEARCH';

var THEME = exports.THEME = 'THEME';
var OPEN_ROUTE = exports.OPEN_ROUTE = 'OPEN_ROUTE';
var POST = exports.POST = 'POST';
var PEOPLE_MODAL = exports.PEOPLE_MODAL = 'PEOPLE_MODAL';
var POSTS = exports.POSTS = 'POSTS';
var ERROR = exports.ERROR = 'ERROR';
var MENU = exports.MENU = 'MENU';
var PARTNERS = exports.PARTNERS = 'PARTNERS';
var AMBASSADORS = exports.AMBASSADORS = 'AMBASSADORS';
var BY_REFERENCE = exports.BY_REFERENCE = 'BY_REFERENCE';
var CAREERS = exports.CAREERS = 'CAREERS';

var CONTENT = exports.CONTENT = 'CONTENT';
var STATIC_DATA = exports.STATIC_DATA = 'STATIC_DATA';
var WIKI = exports.WIKI = 'WIKI';
var WIKI_SEARCH = exports.WIKI_SEARCH = 'WIKI_SEARCH';
var USERS_NUMBER = exports.USERS_NUMBER = 'USERS_NUMBER';

var JOIN_FORM = exports.JOIN_FORM = 'JOIN_FORM';
var SUBSCRIBE_FORM = exports.SUBSCRIBE_FORM = 'SUBSCRIBE_FORM';
var AMBASSADORS_FORM = exports.AMBASSADORS_FORM = 'AMBASSADORS_FORM';

var START = exports.START = '_START';
var SUCCESS = exports.SUCCESS = '_SUCCESS';
var FAIL = exports.FAIL = '_FAIL';

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRoute = setRoute;
exports.setHmqSection = setHmqSection;
exports.setTheme = setTheme;
exports.openMenu = openMenu;
exports.closeMenu = closeMenu;
exports.toggleMenu = toggleMenu;
exports.openPopup = openPopup;
exports.closePopup = closePopup;
exports.openPeopleModal = openPeopleModal;
exports.closePeopleModal = closePeopleModal;

var _constants = __webpack_require__(12);

function setRoute(str) {
  var data = str.split('/').filter(function (entry) {
    return entry.trim() != '';
  });
  return {
    type: _constants.SET + _constants.OPEN_ROUTE,
    data: data
  };
}

function setHmqSection(data) {
  return {
    type: _constants.SET + _constants.HMQ_SECTION,
    data: data
  };
}

function setTheme(data) {
  return {
    type: _constants.SET + _constants.THEME,
    data: data
  };
}

function openMenu() {
  return {
    type: _constants.OPEN + _constants.MENU
  };
}

function closeMenu() {
  return {
    type: _constants.CLOSE + _constants.MENU
  };
}

function toggleMenu() {
  return {
    type: _constants.TOGGLE + _constants.MENU
  };
}

function openPopup(data) {
  return {
    type: _constants.OPEN + _constants.POPUP,
    data: data
  };
}

function closePopup() {
  return {
    type: _constants.CLOSE + _constants.POPUP
  };
}

function openPeopleModal(data) {
  return {
    type: _constants.OPEN + _constants.PEOPLE_MODAL,
    data: data
  };
}

function closePeopleModal() {
  return {
    type: _constants.CLOSE + _constants.PEOPLE_MODAL
  };
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(760);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Container');

var A_Container = function A_Container(_ref) {
  var mix = _ref.mix,
      children = _ref.children,
      type = _ref.type;
  return _react2.default.createElement(
    'div',
    { className: cn({ type: type }, [mix]) },
    children
  );
};

A_Container.propTypes = {
  type: T.oneOf(['video-hero', // video-hero
  'init', // only side paddings
  'section-hmq', // descktop: 32/40 tablet: 32/16, no bottom line
  'wide', // wide container
  'mob-wide-line', // wide border line 40/16
  'section', // container with paddings-top 32, padding-bottom, and border-bottom margin-bottom
  'section-last-mob', // container with paddings-top 32, padding-bottom, and no border, mob margin-bottom 40px
  'section-long-text', //container with paddings-top 32
  'section-clean', // container with paddings-top 32, witout border bottom and margin bottom
  'section-interactive', // container with paddings-top 32, padding-bottom,
  'equal', // container with paddings-top 32, margin-bottom 40, does't change on device, no bottom line
  'section-wiki'] //container addings-top 32, margin-bottom 16, padding-bottom 15, line, center
  ),
  children: T.node.isRequired
};

A_Container.defaultProps = {};
exports.default = A_Container;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(761);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_H');

var A_H = function A_H(_ref) {
  var type = _ref.type,
      icon = _ref.icon,
      children = _ref.children,
      center = _ref.center,
      mix = _ref.mix;


  var tagType = void 0;
  switch (type) {
    case 'animated-hero':
    case 'video-hero':
      tagType = 'h1';
      break;
    case 'hero':
      tagType = 'h1';
      break;
    case 'section':
      tagType = 'h2';
      break;
    case 'android-white':
      tagType = 'h2';
      break;
    case 'android-black':
      tagType = 'h2';
      break;
    case 'timeline':
      tagType = 'h2';
      break;
    case 'search':
      tagType = 'h3';
      break;
    case 'section-sub':
      tagType = 'h4';
      break;
    case 'bs':
    case 'tooltip':
    case 'hmq-e':
    case 's':
      tagType = 'h5';
      break;
    case 'tooltip-sub':
    case 'b-xs':
    case 'xs':
      tagType = 'h6';
      break;
    case 'xxl':
      tagType = 'h6';
      break;
    case 'openitem':
      tagType = 'h6';
      break;
    default:
      tagType = 'h3';
  }

  center = center && 'center';

  return _react2.default.createElement(tagType, { className: cn({ type: type }, [center, mix]) }, icon ? _react2.default.createElement(
    'span',
    { className: cn('iconed', { icon: icon }, [center]) },
    children
  ) : children);
};

A_H.propTypes = {
  type: T.oneOf(['animated-hero', 'video-hero', 'hmq-e', 'hmq', // black icon title for hmq explorer 16/25 /600, mob -margin left 16px
  'hero', //black bold 25
  'search', // white bold 25 used on wiki search
  'timeline', // black title uses at component O_Timeline, 16/24
  'bs', // blue title uses at hero home page, 16/24
  'wiki-result', // blue title 16/24/600/ marign-bottom 8
  'window', // black bold title 16/24 used on subscribe/personal/join/partners tooltip pages
  'tooltip', // black bold title 16/24 used on tooltip marign bottom 2px
  'tooltip-sub', //blue subtitle 15/26 used on tooltip marign bottom 8px
  'xs', // black title uses at hero home page, 13/20 bold
  'section', //black title used for sections 23/32 padding-bottom 10
  'section-sub', //black title used for sections 23/32 padding-bottom 10
  'section-c', //black title used for sections 23/32 padding-bottom 30, always text-align center
  'xxl', //black title used at error page 60
  'openitem', //light black used in open source page
  'hmq-title', //
  'android-white', // white bold 30 used on mobile-app
  'android-black'] // white bold 30 used on mobile-app
  ),
  icon: T.oneOf(['placeholder'] // placeholder icon
  ),
  children: T.any.isRequired
};

A_H.defaultProps = {};
exports.default = A_H;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return true && !!window.__INITIAL_STATE__;
};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(658);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_SectionCounter');

var A_SectionCounter = function A_SectionCounter(_ref) {
  var mix = _ref.mix,
      sectionNum = _ref.sectionNum,
      theme = _ref.theme;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { theme: theme }) },
    '\u2014 ',
    sectionNum < 10 ? '0' + sectionNum + '.' : sectionNum + '.'
  );
};

exports.default = A_SectionCounter;


A_SectionCounter.propTypes = {
  mix: T.string, //BEM mixin from parent block
  sectionNum: T.number.isRequired, //section number to render
  theme: T.oneOf(['dark', // black counter
  'bright'] // sky-blue counter
  ).isRequired
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(758);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Btn_H');

var defClickHandler = function defClickHandler(e) {};

var A_Btn_H = function A_Btn_H(_ref) {
  var mix = _ref.mix,
      children = _ref.children,
      type = _ref.type,
      formHasErrors = _ref.formHasErrors,
      to = _ref.to,
      clickHandler = _ref.clickHandler;

  switch (type) {
    case 'submit':
      return _react2.default.createElement(
        'button',
        {
          className: cn([mix], { formHasErrors: formHasErrors }),
          type: 'submit'
        },
        children
      );
    default:
      return _react2.default.createElement(
        'a',
        { className: cn([mix]), href: to, target: '_blank', style: { display: 'inline-block' }, onClick: clickHandler ? clickHandler : defClickHandler },
        children
      );
  }
};

exports.default = A_Btn_H;


A_Btn_H.propTypes = {
  mix: T.string, //BEM mixin from parent block
  type: T.oneOf(['submit'] // form submit btn
  ),
  formHasErrors: T.bool // form error mod for submit-btn
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(768);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_P');

var A_P = function A_P(_ref) {
  var children = _ref.children,
      type = _ref.type,
      mix = _ref.mix;
  return _react2.default.createElement(
    'p',
    { className: cn({ type: type }, [mix]) },
    children
  );
};

A_P.propTypes = {
  type: T.oneOf(['animated-hero', 'video-hero', 'hmq-e', //
  'hero', // 15/26 + blue border on left side
  'first', // 	18/28
  'second', // 14
  'third', // 15/26
  'third-center', // 15/26 + alight-text: center
  'fourth', // 15/26.600 brand blue
  'fifth', // 13/1.54 grey
  'third-center_white', // 15/26 + alight-text: center
  'third-center_white', // 15/26 + alight-text: center
  'sixth', // 13/20 #48474c
  'android-white', // 13/20 white
  'android-black'] // 13/20 #565759 padding-top: 1.5rem padding-bottom: 4rem
  )
};

A_P.defaultProps = {};
exports.default = A_P;

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(689);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_SectionCounter');

var A_SectionCounter = function A_SectionCounter(_ref) {
  var mix = _ref.mix,
      sectionNum = _ref.sectionNum,
      theme = _ref.theme;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { theme: theme }) },
    '\u2014 ',
    sectionNum < 10 ? '0' + sectionNum + '.' : sectionNum + '.'
  );
};

exports.default = A_SectionCounter;


A_SectionCounter.propTypes = {
  mix: T.string, //BEM mixin from parent block
  sectionNum: T.number.isRequired, //section number to render
  theme: T.oneOf(['dark', // black counter
  'bright'] // sky-blue counter
  ).isRequired
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(709);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_SectionCounter');

var A_SectionCounter = function A_SectionCounter(_ref) {
  var mix = _ref.mix,
      sectionNum = _ref.sectionNum,
      theme = _ref.theme;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { theme: theme }) },
    '\u2014 ',
    sectionNum < 10 ? '0' + sectionNum + '.' : sectionNum + '.'
  );
};

exports.default = A_SectionCounter;


A_SectionCounter.propTypes = {
  mix: T.string, //BEM mixin from parent block
  sectionNum: T.number.isRequired, //section number to render
  theme: T.oneOf(['dark', // black counter
  'bright'] // sky-blue counter
  ).isRequired
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(729);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_SectionCounter');

var A_SectionCounter = function A_SectionCounter(_ref) {
  var mix = _ref.mix,
      sectionNum = _ref.sectionNum,
      theme = _ref.theme;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { theme: theme }) },
    '\u2014 ',
    sectionNum < 10 ? '0' + sectionNum + '.' : sectionNum + '.'
  );
};

exports.default = A_SectionCounter;


A_SectionCounter.propTypes = {
  mix: T.string, //BEM mixin from parent block
  sectionNum: T.number.isRequired, //section number to render
  theme: T.oneOf(['dark', // black counter
  'bright'] // sky-blue counter
  ).isRequired
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(749);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_SectionCounter');

var A_SectionCounter = function A_SectionCounter(_ref) {
  var mix = _ref.mix,
      sectionNum = _ref.sectionNum,
      theme = _ref.theme;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { theme: theme }) },
    '\u2014 ',
    sectionNum < 10 ? '0' + sectionNum + '.' : sectionNum + '.'
  );
};

exports.default = A_SectionCounter;


A_SectionCounter.propTypes = {
  mix: T.string, //BEM mixin from parent block
  sectionNum: T.number.isRequired, //section number to render
  theme: T.oneOf(['dark', // black counter
  'bright'] // sky-blue counter
  ).isRequired
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _reactRouter = __webpack_require__(24);

__webpack_require__(765);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Link');

var A_Link = function A_Link(_ref) {
  var children = _ref.children,
      type = _ref.type,
      block = _ref.block,
      disabled = _ref.disabled,
      external = _ref.external,
      to = _ref.to,
      props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'type', 'block', 'disabled', 'external', 'to']);


  var _link = void 0,
      content = void 0;
  var className = cn({ block: block, type: type }, [disabled && 'disabled']);
  if (type == 'section-link') {
    content = _react2.default.createElement(
      'span',
      null,
      children,
      _react2.default.createElement(
        'span',
        { style: { whiteSpace: 'nowrap' } },
        ' here \xBB'
      )
    );
  } else {
    content = children;
  }
  if (external) {
    _link = _react2.default.createElement(
      'a',
      { className: className, href: to, target: '_blank' },
      content
    );
  } else {
    _link = _react2.default.createElement(
      _reactRouter.Link,
      (0, _extends3.default)({ className: className }, props, { to: to }),
      content
    );
  }
  return _link;
};
A_Link.propTypes = {
  type: T.oneOf(['article', // wiki articles not bold text
  'transactions', // transactions
  'hmq-card', // hmq card link with overflow|text-overflow|whitespace settings
  'primary', // brand blue link
  'crumbs', // brand  blue link 12, weight 600
  'crumbs-notlast', // brand  blue link 12, weight 600 + icon
  'hero-list-links', // brand blue link 15/26
  'white', // white links
  'section-link', //blue links in info blocks automatically add ` here »`
  'section-link-clean', //blue links in info blocks automatically without 'here »'
  'block' // display block link

  ]),
  external: T.bool, // for external links
  disabled: T.bool,
  children: T.node.isRequired
};

A_Link.defaultProps = {
  // type: 'primary'
};

exports.default = A_Link;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(762);

var _utils = __webpack_require__(1);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Image');

var A_Image = function (_Component) {
  (0, _inherits3.default)(A_Image, _Component);

  function A_Image() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, A_Image);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = A_Image.__proto__ || (0, _getPrototypeOf2.default)(A_Image)).call.apply(_ref, [this].concat(args))), _this), _this.state = { imgReady: false }, _this.handleLoad = function () {
      _this.setState({ imgReady: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(A_Image, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.src !== nextProps.src) {
        this.setState({ imgReady: false });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var complete = this.node && this.node.complete;
      if ((0, _initialLoad2.default)() && complete) {
        this.forceUpdate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          rounded = _props.rounded,
          realSize = _props.realSize,
          link = _props.link,
          type = _props.type,
          preProps = (0, _objectWithoutProperties3.default)(_props, ['rounded', 'realSize', 'link', 'type']);
      var onClick = preProps.onClick,
          objectFit = preProps.objectFit,
          props = (0, _objectWithoutProperties3.default)(preProps, ['onClick', 'objectFit']);

      var complete = !!this.node && this.node.complete;
      var imgReady = complete || this.state.imgReady;
      rounded = rounded && 'rounded';
      link = link && 'link';
      realSize = realSize && 'real-size';

      return _react2.default.createElement(
        'span',
        { className: cn('root') },
        _react2.default.createElement('img', (0, _extends3.default)({
          ref: function ref(node) {
            return _this2.node = node;
          },
          className: cn('img', { onClick: !!onClick, objectFit: objectFit, type: type }, [rounded, link, realSize]),
          onLoad: this.handleLoad,
          style: imgReady ? {} : { display: 'none' },
          onClick: onClick
        }, props)),
        _react2.default.createElement('div', { style: imgReady ? { display: 'none' } : {}, className: cn('loader') })
      );
    }
  }]);
  return A_Image;
}(_react.Component);

A_Image.propTypes = {
  src: T.string.isRequired,
  alt: T.string.isRequired,
  width: T.number,
  height: T.number,
  onClick: T.func,
  objectFit: T.oneOf(['contain', // increases or decreases the size of the image to fill the box whilst preserving its aspect-ratio.
  'cover-hidden' // height 100% of widht
  ]),
  type: T.oneOf(['avatar', 'avatar-sm']),
  realSize: T.bool, // width and height auto
  rounded: T.bool, // rounded Images.
  link: T.bool // remove space under the image in links
};

A_Image.defaultProps = {
  src: 'https://dummyimage.com/100x50/fff7ff/e0557d&title=NoPhoto',
  alt: ''
};

exports.default = A_Image;

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(784);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_Hero');

var O_Hero = function O_Hero(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: cn('root') },
    _react2.default.createElement(
      'div',
      { className: cn('text') },
      children
    )
  );
};

O_Hero.propTypes = {
  img: T.shape({
    src: T.string.isRequired,
    alt: T.string.isRequired
  }).isRequired
};

O_Hero.defaultProps = {};
exports.default = O_Hero;

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUTTER_CMS_API_URL = exports.BUTTER_CMS_API_URL = 'https://api.buttercms.com/v2';
var BUTTER_CMS_API_AUTH_TOKEN = exports.BUTTER_CMS_API_AUTH_TOKEN = 'b251deef79e07f942e09e2df3fb18755f90522f2';

var BUTTER_CMS_API_ENDPOINTS = exports.BUTTER_CMS_API_ENDPOINTS = {
  post: '/posts/',
  posts: '/posts/',
  content: '/content/',
  wiki: '/content/'
};

var ENDPOINT_CAREERS = exports.ENDPOINT_CAREERS = 'http://188.166.170.8/v1/vacancies';

var WEBSITE_DOMAIN_NAME = exports.WEBSITE_DOMAIN_NAME = 'humaniq.com';
var HUMANIQ_BACKEND_API_URL = exports.HUMANIQ_BACKEND_API_URL = 'https://f03pn9k2v8.execute-api.eu-west-1.amazonaws.com';
var ENDPOINT_JOIN_FORM = exports.ENDPOINT_JOIN_FORM = HUMANIQ_BACKEND_API_URL + '/dev/subscriptions/partners';
var ENDPOINT_SUBSCRIBE_FORM = exports.ENDPOINT_SUBSCRIBE_FORM = HUMANIQ_BACKEND_API_URL + '/dev/subscriptions/newsletters';
var ENDPOINT_AMBASSADORS_FORM = exports.ENDPOINT_AMBASSADORS_FORM = HUMANIQ_BACKEND_API_URL + '/dev/subscriptions/ambassadors';

var ENDPOINT_PARTNERS = exports.ENDPOINT_PARTNERS = 'https://s3-eu-west-1.amazonaws.com/humaniq-web-backend-public/partners';
var ENDPOINT_PARTNERS_LIST = exports.ENDPOINT_PARTNERS_LIST = ENDPOINT_PARTNERS + '/partners.json';

var ENPOINT_AMBASSADORS = exports.ENPOINT_AMBASSADORS = 'https://s3-eu-west-1.amazonaws.com/humaniq-web-backend-public/ambassadors';
var ENPOINT_AMBASSADORS_LIST = exports.ENPOINT_AMBASSADORS_LIST = ENPOINT_AMBASSADORS + '/ambassadors.json';

var ENDPOINT_WIKI_SEARCH = exports.ENDPOINT_WIKI_SEARCH = 'https://f03pn9k2v8.execute-api.eu-west-1.amazonaws.com/dev/articles/search';

var AUTH_HEADERS = exports.AUTH_HEADERS = { Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJkOGE5ZjhhNTk3YzU0ZjkxOWVlZDRmMWRmOTU2NjQwMiIsImlhdCI6MTUwMjI2NzM3NSwiZXhwIjpudWxsLCJhdWQiOiJodHRwOi8vaHVtYW5pcS5jb20iLCJzdWIiOiIifQ.VtxsTEM9pQTdQ1Acr1BL_v-4wk2Hgl3Wwjdfjy5iBmI' };

var ENDPOINT_HMQ_STATISTICS = exports.ENDPOINT_HMQ_STATISTICS = HUMANIQ_BACKEND_API_URL + '/dev/blockchain/stats?extended=true';
var ENDPOINT_HMQ_MARKETS = exports.ENDPOINT_HMQ_MARKETS = HUMANIQ_BACKEND_API_URL + '/dev/markets';
var ENDPOINT_HMQ_HOLDERS = exports.ENDPOINT_HMQ_HOLDERS = HUMANIQ_BACKEND_API_URL + '/dev/blockchain/wallets';
var ENDPOINT_HMQ_LOG = exports.ENDPOINT_HMQ_LOG = HUMANIQ_BACKEND_API_URL + '/dev/blockchain/transactions';
var ENDPOINT_HMQ_BLOCK = exports.ENDPOINT_HMQ_BLOCK = HUMANIQ_BACKEND_API_URL + '/dev/blockchain/blocks/';
var ENDPOINT_HMQ_GRAPH = exports.ENDPOINT_HMQ_GRAPH = HUMANIQ_BACKEND_API_URL + '/dev/exchange/rates';
var ENDPOINT_HMQ_HASH = exports.ENDPOINT_HMQ_HASH = HUMANIQ_BACKEND_API_URL + '/dev/blockchain/transactions/';
var ENDPOINT_HMQ_SEARCH = exports.ENDPOINT_HMQ_SEARCH = HUMANIQ_BACKEND_API_URL + '/dev/blockchain/search';
var ENDPOINT_USERS_NUMBER = exports.ENDPOINT_USERS_NUMBER = ( false ? ':' + (process.env.PORT || 8080) : '') + '/v1/mixpanel';

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var articleList = exports.articleList = [{
  img: "/img/news/news-11.jpg",
  title: "Announcing Humaniq Care charity platform",
  url: "https://blog.humaniq.co/announcing-humaniq-care-charity-platform-bfc00770155b",
  src: "Humaniq blog",
  date: "January 22, 2019"
}, {
  img: "/img/news/news-10.jpg",
  title: "Humaniq's second charity pilot is underway: helping deaf children in Sierra Leone",
  url: "https://blog.humaniq.co/humaniqs-second-charity-pilot-is-underway-helping-deaf-children-in-sierra-leone-54dfe51718b",
  src: "Humaniq blog",
  date: "December 26, 2019"
}, {
  img: "/img/news/news-9.jpg",
  title: "Humaniq for Good Platform demonstrates the power of Blockchain",
  url: "https://blog.humaniq.co/humaniq-for-good-platform-demonstrates-the-power-of-blockchain-a-sierra-leone-charity-raises-200-c8585ce28f02",
  src: "Humaniq blog",
  date: "December 17, 2019"
}, {
  img: "/img/news/news-7.jpg",
  title: "New option to buy HMQ tokens is available now!",
  url: "#xchange",
  src: "Humaniq blog",
  date: "August 30, 2018"
}, {
  img: "/img/news/news-6.jpg",
  title: "The Research That Drives the Humaniq App",
  url: "https://blog.humaniq.co/getting-into-african-users-minds-the-research-that-drives-the-humaniq-app-42e53dc56212",
  src: "Humaniq",
  date: "August 30, 2018",
  target: "_blank"
}, {
  img: "/img/news/news-8.jpg",
  title: "Why Humaniq can’t be everywhere at once: the country expansion process explained",
  url: "https://blog.humaniq.co/why-humaniq-cant-be-everywhere-at-once-the-country-expansion-process-explained-97981d4b5173",
  src: "Humaniq blog",
  date: "August 30, 2018",
  target: "_blank"
}, {
  img: "/img/news/news-5.jpg",
  title: "New Humaniq App Location: Equatorial Guinea",
  url: "https://blog.humaniq.co/why-humaniq-cant-be-everywhere-at-once-the-country-expansion-process-explained-97981d4b5173",
  src: "Humaniq blog",
  date: "August 30, 2018",
  target: "_blank"
}, {
  img: "/img/news/humaniq_jamii.jpg",
  title: "Humaniq and Jamii Africa Insurance Company Became Partners",
  url: "https://ethereumworldnews.com/humaniq-announces-partnership-with-jamii-africa-insurance-company/",
  src: "ethereum world news",
  date: "August 23, 2018",
  target: "_blank"
}, {
  img: "/img/news/business-chats.png",
  title: "Humaniq launched Business Chats feature",
  url: "",
  src: "Humaniq",
  date: "August 23, 2018"
}, {
  img: "/img/news/fintech_report.png",
  title: "Humaniq named as one of the “Leading Companies” in the “FinTech for Social Good” report",
  url: "https://www.dka.global/fintech-for-social-good",
  src: "dka.global",
  date: "August 23, 2018",
  target: "_blank"
}, {
  img: "/img/news/hotbit-2.jpg",
  title: "HMQ Coin Is Added To A New Secure Cryptocurrency Platform HOTBIT",
  url: "https://www.coinspeaker.com/2018/08/07/hmq-coin-is-added-to-a-new-secure-cryptocurrency-platform-hotbit/",
  src: "Coinspeaker",
  date: "August 23, 2018",
  target: "_blank"
}, {
  img: "/img/news/main-1.png",
  title: "Humaniq Recognised As Leading “Blockchain For Social Good” Use Case At UK Parliament Reception",
  url: "https://ethereumworldnews.com/humaniq-recognised-as-leading-blockchain-for-social-good-use-case-at-uk-parliament-reception/",
  src: "ethereum world news",
  date: "July 18, 2018",
  target: "_blank"
}, {
  img: "/img/news/news-4.jpg",
  title: "Global goals for both business and development allow everybody to win",
  url: "https://blog.humaniq.co/sglobal-goals-for-both-business-and-development-allow-everybody-to-win-7c310918304",
  src: "humaniq",
  date: "May 22, 2018",
  target: "_blank"

}, {
  img: "/img/news/news-2.png",
  title: "Success: first working hybrid Blockchain and 100,000-strong community",
  url: "https://blog.humaniq.co/success-first-working-hybrid-blockchain-and-100-000-strong-community-7ed4d701084",
  src: "humaniq",
  date: "March 19, 2018",
  target: "_blank"

}, {
  img: "/img/news/news-3.png",
  title: "Africa calling: first hybrid Blockchain to accelerate growth of digital economy",
  url: "https://blog.humaniq.co/africa-calling-first-hybrid-blockchain-to-accelerate-growth-of-digital-economy-6daca33e23be",
  src: "humaniq",
  date: "June 7, 2018",
  target: "_blank"
}];

var mainList = exports.mainList = [{
  img: "/img/news/ev-3.jpg",
  title: "New option to buy HMQ <br/>tokens is available now!",
  url: "#xchange",
  more: "Now you can buy HMQ tokens instantly and directly via our new widget provided by Coinswitch paying for them by any of 300 crypto coins supported within the widget.",
  button: "Buy now",
  uid: "buynow",
  isInt: true,
  date: ""
}, {
  img: "/img/news/ev-4.jpg",
  title: "The Research That Drives the Humaniq App",
  url: "https://blog.humaniq.co/getting-into-african-users-minds-the-research-that-drives-the-humaniq-app-42e53dc56212",
  more: "Humaniq presented the financial behavior research among individuals with no financial inclusion in Africa, carried out together with International Methodological Association specialists.",
  button: "Learn more",
  uid: "research"
}, {
  img: "/img/news/ev-5.jpg",
  title: "New Humaniq App Location: Equatorial Guinea",
  more: "The Humaniq Mobile App with e-wallet, secure chat, and biometrical identification features is now available in 21 African countries.",
  url: "https://blog.humaniq.co/why-humaniq-cant-be-everywhere-at-once-the-country-expansion-process-explained-97981d4b5173",
  button: "Learn more",
  uid: "guinea"
}];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submit = submit;

var _humaniqBackendApi = __webpack_require__(75);

var _api = __webpack_require__(45);

var _constants = __webpack_require__(12);

function submit(formName, data) {
  var endpoint = void 0,
      form = void 0;
  switch (formName) {
    case 'join':
      endpoint = _api.ENDPOINT_JOIN_FORM;
      form = _constants.JOIN_FORM;
      break;
    case 'subscribe':
      endpoint = _api.ENDPOINT_SUBSCRIBE_FORM;
      form = _constants.SUBSCRIBE_FORM;
      if (window.ga) window.ga('send', 'event', 'other', 'subscribe-btn-click');
      if (window.fbq) window.fbq('track', 'Lead');
      break;
    case 'ambassadors':
      endpoint = _api.ENDPOINT_AMBASSADORS_FORM;
      form = _constants.AMBASSADORS_FORM;
  }

  return {
    /*[BACKEND_CALL]: {
      endpoint,
      method: 'POST',
      payload: data,
      types: [
        POST + form + START,
        POST + form + SUCCESS,
        POST + form + FAIL,
      ]
    }*/
  };
}

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(763);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_InputText_H');

var A_InputText_H = function (_Component) {
  (0, _inherits3.default)(A_InputText_H, _Component);

  function A_InputText_H() {
    (0, _classCallCheck3.default)(this, A_InputText_H);
    return (0, _possibleConstructorReturn3.default)(this, (A_InputText_H.__proto__ || (0, _getPrototypeOf2.default)(A_InputText_H)).apply(this, arguments));
  }

  (0, _createClass3.default)(A_InputText_H, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          handleChange = _props.handleChange,
          placeholder = _props.placeholder,
          onFocus = _props.onFocus,
          error = _props.error;


      var hasError = !!error;
      return _react2.default.createElement(
        'fieldset',
        { className: cn({ hasError: hasError }) },
        _react2.default.createElement('input', {
          ref: function ref(node) {
            return _this2.input = node;
          },
          className: cn('input'),
          placeholder: placeholder,
          type: 'text',
          value: value,
          onFocus: onFocus,
          onChange: function onChange(e) {
            return handleChange(e.target.value);
          }
        })
      );
    }
  }]);
  return A_InputText_H;
}(_react.Component);

A_InputText_H.propTypes = {
  handleChange: T.func.isRequired,
  value: T.string.isRequired,
  placeHolder: T.string
};

A_InputText_H.defaultProps = {};

exports.default = A_InputText_H;

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(136);

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _keys = __webpack_require__(210);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _validateHelpers = __webpack_require__(561);

var _immutabilityHelper = __webpack_require__(816);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultError = {
  email: 'Looks like an invalid email address',
  url: 'Looks like an invalid url address',
  maxLengh: function maxLengh(max) {
    return 'Maximum length is ' + max + ' characters.';
  },
  required: 'Please fill this field'
};

var _valFuncObj = {
  email: _validateHelpers.validateEmail,
  url: _validateHelpers.validateWebsiteName,
  maxLengh: { val: _validateHelpers.validateMaxLength, defaultoption: 100 },
  required: function required(val) {
    return val && !!val.length;
  }
};

exports.default = function (ComposedComponent, config) {
  return function (_Component) {
    (0, _inherits3.default)(FormHoc, _Component);

    function FormHoc() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, FormHoc);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FormHoc.__proto__ || (0, _getPrototypeOf2.default)(FormHoc)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        pagination: _this.setFormPagination(config.pagination, config.fieldNames),
        fields: _this.getInitValues(config.fieldNames),
        needValidation: false,
        validations: _this.getFormValidationConfig(config.validations, config.customErrors),
        formValid: false,
        submited: false
      }, _this.onFieldChange = function (fieldName, value) {
        var _update = void 0;
        if (_this.state.needValidation) {
          var _this$validate$fieldN = _this.validate((0, _defineProperty3.default)({}, fieldName, value))[fieldName],
              error = _this$validate$fieldN.error,
              valid = _this$validate$fieldN.valid;

          _update = { fields: (0, _defineProperty3.default)({}, fieldName, { $set: { valid: valid, error: error, value: value } }) };
        } else {
          _update = { fields: (0, _defineProperty3.default)({}, fieldName, { value: { $set: value } }) };
        }

        var newState = (0, _immutabilityHelper2.default)(_this.state, _update);
        _this.setState(newState);
      }, _this.checkCurrentErrors = function (formFields) {
        var currentErrors = [];

        for (var field in formFields) {
          if (formFields.hasOwnProperty(field)) {
            currentErrors = [].concat((0, _toConsumableArray3.default)(currentErrors), [formFields[field].error]);
          }
        }

        return !currentErrors.every(function (error) {
          return error === null;
        });
      }, _this.onSubmit = function (pagination) {
        var _this$state = _this.state,
            fields = _this$state.fields,
            pagesLength = _this$state.pagination.pagesLength;
        var _this$props = _this.props,
            formPage = _this$props.formPage,
            setFormPage = _this$props.setFormPage;


        var values = {};

        for (var field in fields) {
          if (fields.hasOwnProperty(field)) {
            if (pagination) {
              config.fieldNames[formPage - 1].forEach(function (field) {
                values[field] = fields[field].value;
              });
            } else {
              values[field] = fields[field].value;
            }
          }
        }
        var valResults = _this.validate(values);

        var fieldUpdates = {};

        for (var name in valResults) {
          var _valResults$name = valResults[name],
              error = _valResults$name.error,
              _valid = _valResults$name.valid;

          fieldUpdates[name] = { valid: { $set: _valid }, error: { $set: error } };
        }

        var newState = (0, _immutabilityHelper2.default)(_this.state, { fields: fieldUpdates }),
            valid = (0, _keys2.default)(valResults).every(function (key) {
          return valResults[key].valid;
        });

        newState.needValidation = true;

        if (valid) {
          newState.formValid = true;
          if (pagination) {
            newState.needValidation = false;
            if (formPage !== pagesLength) {
              return setFormPage(formPage + 1);
            }
          }
          newState.submited = true;
          var _values = {};
          for (var _name in fields) {
            if (fields.hasOwnProperty(_name)) {
              _values[_name] = fields[_name].value;
            }
          }
          _this.props.handleSubmit(_values);
        }

        _this.setState(newState);
      }, _this.handleSubmit = function (e) {
        e.preventDefault();
        _this.onSubmit(config.pagination);
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FormHoc, [{
      key: 'setFormPagination',
      value: function setFormPagination() {
        var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var fieldNamesArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];


        if (!fieldNamesArray.length) {
          this.throwError('empty config.fieldNames');
        }

        return {
          pagesLength: pagination ? fieldNamesArray.length : 1
        };
      }
    }, {
      key: 'getInitValues',
      value: function getInitValues(fieldNamesArray) {
        var formFields = [];
        var res = {};

        fieldNamesArray.forEach(function (field) {
          if (config.pagination) {
            formFields = [].concat((0, _toConsumableArray3.default)(formFields), (0, _toConsumableArray3.default)(field));
          } else {
            formFields = [].concat((0, _toConsumableArray3.default)(formFields), [field]);
          }
        });

        formFields.forEach(function (fieldName) {
          res[fieldName] = {
            value: '',
            error: null,
            valid: false
          };
        });

        return res;
      }
    }, {
      key: 'getFormValidationConfig',
      value: function getFormValidationConfig() {
        var validations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var customErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var res = {};

        for (var fieldName in validations) {
          if (validations.hasOwnProperty(fieldName)) {
            res[fieldName] = this.getFieldValidationConfig(validations[fieldName], fieldName, customErrors[fieldName]);
          }
        }

        return res;
      }
    }, {
      key: 'getFieldValidationConfig',
      value: function getFieldValidationConfig(fieldConfig, fieldName, customError) {
        var _this2 = this;

        var type = void 0,
            error = void 0,
            option = void 0;

        switch (_typeOf(fieldConfig)) {
          case 'array':
            var types = [];
            fieldConfig.forEach(function (config) {
              var type = _this2.getFieldValidationConfig(config, fieldName);
              types = types.concat(type);
            });
            return types;
          case 'object':
            type = fieldConfig.type;
            error = customError && customError[type] || defaultError[type];
            option = fieldConfig.option;
            return [this.getInitValType({ type: type, error: error, option: option })];
          case 'string':
            type = fieldConfig;
            error = customError || defaultError[type];
            return [this.getInitValType({ type: type, error: error })];
          case 'undefined':
            return [];
        }
      }
    }, {
      key: 'getInitError',
      value: function getInitError(errorConfig, type) {
        if (_typeOf(errorConfig) === 'array') {
          return errorConfig[type];
        } else {
          return errorConfig;
        }
      }
    }, {
      key: 'getInitValType',
      value: function getInitValType(_ref2) {
        var type = _ref2.type,
            option = _ref2.option,
            error = _ref2.error;

        var errorFunc = _typeOf(error) === 'function';

        return { type: type, option: option, errorFunc: errorFunc, error: error };
      }
    }, {
      key: 'throwError',
      value: function throwError(error) {
        console.error('HOC error', error);
      }
    }, {
      key: 'validate',
      value: function validate(values) {
        var _this3 = this;

        var res = {};
        var validations = this.state.validations;

        for (var fieldName in values) {
          if (values.hasOwnProperty(fieldName)) {
            (function () {
              var value = values[fieldName];

              var error = void 0,
                  valid = void 0;
              var validationsArr = validations[fieldName];
              validationsArr.every(function (validationOption) {
                var validation = _this3.getValidation(validationOption);
                var _valObj = validation(value);

                error = _valObj.error;
                valid = _valObj.isValid;
                return valid;
              });
              res[fieldName] = { valid: valid, error: error };
            })();
          }
        }

        return res;
      }
    }, {
      key: 'getValidation',
      value: function getValidation(_ref3) {
        var type = _ref3.type,
            option = _ref3.option,
            error = _ref3.error,
            errorFunc = _ref3.errorFunc;

        var _validationRule = _valFuncObj[type];
        var validationFunc = void 0;
        if (_typeOf(_validationRule) == 'object') {
          var _option = option || _validationRule.defaultoption;
          validationFunc = function validationFunc(value) {
            return _validationRule.val(value, _option);
          };
        } else {
          validationFunc = _validationRule;
        }

        return function (value) {
          var isValid = validationFunc(value);
          var _error = errorFunc ? error(option) : error;

          return {
            isValid: isValid,
            error: !isValid ? _error : null
          };
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            fields = _state.fields,
            formValid = _state.formValid,
            submited = _state.submited,
            needValidation = _state.needValidation;
        var props = (0, _objectWithoutProperties3.default)(this.props, []);

        delete props.handeSubmit;

        return _react2.default.createElement(ComposedComponent, {
          fields: fields,
          formValid: formValid,
          needValidation: needValidation,
          formHasErrors: this.checkCurrentErrors(fields),
          submited: submited,
          handleSubmit: this.handleSubmit,
          onFieldChange: this.onFieldChange,
          formPage: this.props.formPage
        });
      }
    }]);
    return FormHoc;
  }(_react.Component);
};

var _typeOf = function _typeOf(v) {
  if (Array.isArray(v)) return 'array';
  return typeof v === 'undefined' ? 'undefined' : (0, _typeof3.default)(v);
};

// if(error !== oldError || oldValidStatus !== valid){
//   const newState = update(this.state, {fields:{[fieldName]:{valid:{$set: valid}, error:{$set: error}}}})
//   this.setError(newState)
// }

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(657);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumns');

var _createInfoColumns = function _createInfoColumns(columns) {
  return columns.map(function (column, index) {
    return _react2.default.createElement(
      'div',
      { key: 'info-column-' + (index + 1), className: cn('column') },
      column.imageSrc ? _react2.default.createElement('img', { className: cn('column-image'), src: column.imageSrc }) : null,
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('column-title'), type: 'info-column', theme: 'dark' },
        column.title
      ),
      _react2.default.createElement(
        'p',
        { className: cn('column-text') },
        column.text
      )
    );
  });
};

var M_InfoColumns = function M_InfoColumns(_ref) {
  var mix = _ref.mix,
      columns = _ref.columns,
      type = _ref.type,
      layout = _ref.layout;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { type: type, layout: layout }) },
    _createInfoColumns(columns)
  );
};

exports.default = M_InfoColumns;


M_InfoColumns.propTypes = {
  mix: T.string, //BEM mixin from parent block
  columns: T.array.isRequired, //Columns to render
  type: T.oneOf(['narrow', //400px column width
  'slider'] //50% initial width for sliders
  ),
  layout: T.oneOf(['global-challenge'] //for global challenge sect
  )
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(688);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumns');

var _createInfoColumns = function _createInfoColumns(columns) {
  return columns.map(function (column, index) {
    return _react2.default.createElement(
      'div',
      { key: 'info-column-' + (index + 1), className: cn('column') },
      column.imageSrc ? _react2.default.createElement('img', { className: cn('column-image'), src: column.imageSrc }) : null,
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('column-title'), type: 'info-column', theme: 'dark' },
        column.title
      ),
      _react2.default.createElement(
        'p',
        { className: cn('column-text') },
        column.text
      )
    );
  });
};

var M_InfoColumns = function M_InfoColumns(_ref) {
  var mix = _ref.mix,
      columns = _ref.columns,
      type = _ref.type,
      layout = _ref.layout;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { type: type, layout: layout }) },
    _createInfoColumns(columns)
  );
};

exports.default = M_InfoColumns;


M_InfoColumns.propTypes = {
  mix: T.string, //BEM mixin from parent block
  columns: T.array.isRequired, //Columns to render
  type: T.oneOf(['narrow', //400px column width
  'slider'] //50% initial width for sliders
  ),
  layout: T.oneOf(['global-challenge'] //for global challenge sect
  )
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(708);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumns');

var _createInfoColumns = function _createInfoColumns(columns) {
  return columns.map(function (column, index) {
    return _react2.default.createElement(
      'div',
      { key: 'info-column-' + (index + 1), className: cn('column') },
      column.imageSrc ? _react2.default.createElement('img', { className: cn('column-image'), src: column.imageSrc }) : null,
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('column-title'), type: 'info-column', theme: 'dark' },
        column.title
      ),
      _react2.default.createElement(
        'p',
        { className: cn('column-text') },
        column.text
      )
    );
  });
};

var M_InfoColumns = function M_InfoColumns(_ref) {
  var mix = _ref.mix,
      columns = _ref.columns,
      type = _ref.type,
      layout = _ref.layout;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { type: type, layout: layout }) },
    _createInfoColumns(columns)
  );
};

exports.default = M_InfoColumns;


M_InfoColumns.propTypes = {
  mix: T.string, //BEM mixin from parent block
  columns: T.array.isRequired, //Columns to render
  type: T.oneOf(['narrow', //400px column width
  'slider'] //50% initial width for sliders
  ),
  layout: T.oneOf(['global-challenge'] //for global challenge sect
  )
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(728);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumns');

var _createInfoColumns = function _createInfoColumns(columns) {
  return columns.map(function (column, index) {
    return _react2.default.createElement(
      'div',
      { key: 'info-column-' + (index + 1), className: cn('column') },
      column.imageSrc ? _react2.default.createElement('img', { className: cn('column-image'), src: column.imageSrc }) : null,
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('column-title'), type: 'info-column', theme: 'dark' },
        column.title
      ),
      _react2.default.createElement(
        'p',
        { className: cn('column-text') },
        column.text
      )
    );
  });
};

var M_InfoColumns = function M_InfoColumns(_ref) {
  var mix = _ref.mix,
      columns = _ref.columns,
      type = _ref.type,
      layout = _ref.layout;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { type: type, layout: layout }) },
    _createInfoColumns(columns)
  );
};

exports.default = M_InfoColumns;


M_InfoColumns.propTypes = {
  mix: T.string, //BEM mixin from parent block
  columns: T.array.isRequired, //Columns to render
  type: T.oneOf(['narrow', //400px column width
  'slider'] //50% initial width for sliders
  ),
  layout: T.oneOf(['global-challenge'] //for global challenge sect
  )
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(748);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumns');

var _createInfoColumns = function _createInfoColumns(columns) {
  return columns.map(function (column, index) {
    return _react2.default.createElement(
      'div',
      { key: 'info-column-' + (index + 1), className: cn('column') },
      column.imageSrc ? _react2.default.createElement('img', { className: cn('column-image'), src: column.imageSrc }) : null,
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('column-title'), type: 'info-column', theme: 'dark' },
        column.title
      ),
      _react2.default.createElement(
        'p',
        { className: cn('column-text') },
        column.text
      )
    );
  });
};

var M_InfoColumns = function M_InfoColumns(_ref) {
  var mix = _ref.mix,
      columns = _ref.columns,
      type = _ref.type,
      layout = _ref.layout;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { type: type, layout: layout }) },
    _createInfoColumns(columns)
  );
};

exports.default = M_InfoColumns;


M_InfoColumns.propTypes = {
  mix: T.string, //BEM mixin from parent block
  columns: T.array.isRequired, //Columns to render
  type: T.oneOf(['narrow', //400px column width
  'slider'] //50% initial width for sliders
  ),
  layout: T.oneOf(['global-challenge'] //for global challenge sect
  )
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Logo_H = __webpack_require__(198);

var _A_Logo_H2 = _interopRequireDefault(_A_Logo_H);

var _M_SocialLinks_H = __webpack_require__(134);

var _M_SocialLinks_H2 = _interopRequireDefault(_M_SocialLinks_H);

var _FooterLinks = __webpack_require__(470);

var _FooterLinks2 = _interopRequireDefault(_FooterLinks);

__webpack_require__(783);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_Footer_H');

var O_Footer_H = function O_Footer_H(_ref) {
  var mix = _ref.mix,
      openPopup = _ref.openPopup;
  return _react2.default.createElement(
    'footer',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('top') },
      _react2.default.createElement(_A_Logo_H2.default, {
        mix: cn('logo')
      }),
      _react2.default.createElement(
        _M_SocialLinks_H2.default,
        {
          mix: cn('social-links'),
          type: 'footer'
        },
        'Join to make a difference with humaniq'
      )
    ),
    _react2.default.createElement(_FooterLinks2.default, {
      mix: cn('bottom'),
      openPopup: openPopup
    })
  );
};

exports.default = O_Footer_H;


O_Footer_H.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var imgPath = 'img/team_s';
var ambassadorsPath = 'img/ambassadors';

var advisers = exports.advisers = [{
  name: 'David Applefield',
  position: 'Adviser',
  bio: 'Is an American writer and media specialist living in Paris. He has as spent his career developing creative and innovative solutions for business leaders, heads of state, ministries, NGOs, and other not-for- profit foundations. He is the Financial Times representative for Africa, the Middle East and emerging markets.',
  imgSrc: imgPath + '/david_applefield.jpg'
}, {
  name: 'Hazem Danny Al-Nakib',
  position: 'Adviser',
  bio: '',
  imgSrc: imgPath + '/hazem_danny.jpg'
},
//{
//    name: 'Richard Kastelein',
//    position: 'Adviser',
//    bio:
//    'Founder and publisher of industry publication Blockchain News (EST 2015) at www.the-blockchain.com, a partner at ICO services collective Token.Agency ($500m+ and 90+ ICOs), director of education company Blockchain Partners (Oracle Partner) and ICO event organiser at leading industry event CryptoFinancing (Europe\'s first ICO event now branded Tokenomicon) - Vancouver native Richard Kastelein is an award-winning publisher, innovation executive and entrepreneur. He sits on the advisory boards of some two dozen Blockchain startups and has written over 2000 articles on Blockchain technology and startups at Blockchain News and has also published pioneering articles on ICOs in Harvard Business Review and Venturebeat.',
//    imgSrc: `${imgPath}/richard_kastelein.jpg`,
//},
{
  name: 'Matt McKibbin',
  position: 'Adviser',
  bio: 'Is a business development guru and a decentralization evangelist. He became interested in Bitcoin and the blockchain technology in 2012. Technologically savvy, he is an extroverted connector driven by a desire to see transformative and decentralized technologies positively affect the 7 billion people on the planet. He is based in the Washington DC metro area.',
  imgSrc: imgPath + '/matt_mckibbin.jpg'
}, {
  name: 'Alex Bausch',
  position: 'Adviser',
  bio: 'Is an entrepreneur with broad experience in all aspects of international business development and the creation of global technology companies. He strongly believes in partner ecosystems which aim to inspire and spawn new innovations. His specialties include: SaaS services, mobile identity security, the IoT, enterprise managed mobility, decentralised ledger technology, marketing, and product development.',
  imgSrc: imgPath + '/alex_bausch.jpg'
},
//{
//  name: 'Nick Ayton',
//  position: 'Adviser',
//  bio:
//    'Is a writer, speaker and educator of all things Blockchain and Cryptocurrency. He is a Fintech 100 Influencer and Number 21 Rise Blockchain Top 100. He has had eight startups and held many senior roles in major IT and tech companies. He now chairs various Blockchain events and advises a range of clients on Blockchain technology, bitcoin and Ethereum. One of his latest projects is to raise funds using cryptoeconomics and create a new film finance model to make a mini- series for TV about the Bitcoin Revolution, an asset backed Token, and a new Media and Film Production business on Ethereum.',
//  imgSrc: `${imgPath}/nick_ayton.jpg`,
//},
{
  name: 'Michael Terpin',
  position: 'Adviser',
  bio: "Michael Terpin co-founded BitAngels (www.bitangels.co), the world's first angel network for digital currency startups, in May 2013, and now serves as its chairman. The distributed angel network currently has more than 600 members, and it has made more than 25 investments in bitcoin and cryptocurrency companies with two exits and several follow-on rounds. Terpin is also co-founder and managing partner of bCommerce Labs (www.bcommercelabs.com), the first technology incubator fund focused on e-commerce companies for bitcoin and the blockchain, and a partner at Flight VC.",
  imgSrc: imgPath + '/michael_terpin.jpg'
}, {
  name: 'Dmitry Kaminskiy',
  position: 'Adviser',
  bio: 'An innovative entrepreneur and investor active in Biotech, Fintech, Blockchain and artificial intelligence, Dmitry is co-founder of the Deep Knowledge Ventures investment fund, focused on investments in AI and Deeptech. He adheres to the principle of impact investment in all his business activities, believing that business should make a social impact, and he supports the deployment of Blockchain for Good, which led to his decision to support Humaniq from its inception.',
  imgSrc: imgPath + '/dmitry_kaminskiy.jpg'
},
//{
//  name: 'Paolo Tasca',
//  position: 'Adviser',
//  bio:
//    'Paolo Tasca is a FinTech economist specialising in P2P Financial System. An advisor for different international organisations including the EU Parliament on blockchain technologies, Paolo recently joined the University College London as Director of the Centre for Blockchain Technologies (UCL CBT).  Prior to that, he has been a senior research economist at Deutsche Bundesbank working on digital currencies and P2P lending. Paolo is the co-author of the bestseller "FINTECH Book" and the co-editor of the book "Banking Beyond Banks and Money.',
//  imgSrc: `${imgPath}/paolo_tasca.jpg`,
//},
{
  name: 'Paul Mears',
  position: 'Adviser',
  bio: 'Paul started his career with Ernst and Young in London and is a UK qualified CPA. Over the last 30 years he has worked in a wide range of industries including Telecoms, Construction, Software, Hedge Funds in a wide range of CFO to Operational Finance roles.\n' + 'Mr. Mears left the UK in 1999 and has since lived and worked in New York, Vancouver, Amsterdam, Hong Kong and is currently a resident of Monaco. Paul has over the last 5 years been an active angel investor in early stage Tech, Apps, Medical Devices and with a passion for Stem Cell Biotech.\n' + 'Mr. Mears has a passion for ensuring creative artists are rewarded for their work and is a great believer in the ability of the blockchain to be a key player in that space and to ensure that artists are fairly rewarded for the work they create.',
  imgSrc: imgPath + '/paul_mears.jpg'
}, {
  name: 'Margaretta Colangelo',
  position: 'Adviser',
  bio: 'In tech companies, thinking is the primary activity and the core process used to create value. One of the challenges when thinking about technology is keeping up with constant innovation and envisioning what will evolve next. To stay abreast of emerging technologies, I\'ve built this think tank of investors, entrepreneurs, researchers, and engineers around the world who have progressive ideas. Like a natural ecosystem, our ecosystem consists of interlinked resources that complement each other. As the community expands, it\'s value increases exponentially for everyone in it. These are some of the people with whom I collaborate regularly.',
  imgSrc: imgPath + '/margaretta_colangelo.jpg'
}];

var team = exports.team = [{
  name: 'Alex Fork',
  position: 'Founder, CEO',
  bio: 'Humaniq founder and Fintech entrepreneur Alex is one of the most important members of the international Blockchain community, who has worked with the UN to lead the deployment of Blockchain technology to improve the efficiency of UN resources and remittances. He has also spearheaded the harnessing of blockchains in Russia, organising a conference for 500 participants on the Ethereum Blockchain; authoring Bitcoin. More than Just Money; and founding the Fintech accelerator for startups in Russia, Future Fintech. He started Humaniq to help lift the global banked out of poverty.',
  imgSrc: imgPath + '/alex_fork.jpg'
}];

var ambassadors = exports.ambassadors = [{
  name: "Abdallah Amour",
  position: "Tanzania",
  bio: "Abdallah from dar es salaam Tanzania graduated from institute of finance management (IFM) with a final degree in information technology runs his own accompany. Triple A Petroleum & Logistics Ltd as Managing Director. In 2013 introduced in Crypto-currecy and Blockchain technology and joined different professional platform.",
  imgSrc: ambassadorsPath + '/abdallah_amour.jpg'
},
// {
//   name: "Akonam Richards",
//   position: "River State",
//   bio: "",
//   imgSrc:  `${ambassadorsPath}/`
// },
{
  name: "Alakanani Itireleng",
  position: "Botswana",
  bio: "Alakanani is a qualified teacher. She has a BA in humanities, Post Graduate Diploma in Education and MBA in international business. Alakanani is an entrepreneur, she runs a blockchain technology hub Satoshicentre. Alakanani is a bitcoin enthusiastic and trainer.",
  imgSrc: ambassadorsPath + '/alakanani_itireleng.jpg'
},
// {
//   name: "Cedric Rwambibi",
//   position: "Rwanda",
//   bio: "",
//   imgSrc:  `${ambassadorsPath}/`
// },
{
  name: "Edgar Mtenga",
  position: "Tanzania",
  bio: "Edgar Hermen is a workaholic dude who loves challenging himself intellectually and socially. winning and losing does not matter to him but what he gains out of it matters the most to him.",
  imgSrc: ambassadorsPath + '/edgar_mtenga.jpg'
}, {
  name: "Eto Olei",
  position: "Nigeria",
  bio: "Etotaziba Olei has a background in Computer Science and Informatics. He studied Computer science in Rivers State Polytechnic and the Niger Delta University. \n" + "Eto is a fast gear to social promotions and performance strategies specialized in survey project management. \n" + "In his free time, he hangs out with family and friends and also loves spending time in the music studio - making music.",
  imgSrc: ambassadorsPath + '/olei_eto.jpg'
}, {
  name: "Frank Chiss",
  position: "Tanzania",
  bio: "Frank Chiss is a RE/MAX Agent/Enterprenuer and Humaniq Ambassador representing Dar es salaam, Tanzania. Provides education about cryptocurrency in social networks and social platforms.",
  imgSrc: ambassadorsPath + '/frank_chiss.jpg'
}, {
  name: "Frednand Fimbo",
  position: "Tanzania",
  bio: "Fredinand Fimbo is an Independent Researcher&Entrepreneur,  Ambassador of Humaniq in Dar es Salaam, Tanzania, he has been engaged in project related to the crypto-currency and IT in the crypto-sphere.",
  imgSrc: ambassadorsPath + '/frednand_fimbo.jpg'
}, {
  name: "German Kitula",
  position: "Tanzania",
  bio: "German Kitula born in july, 1993 and raised in Tanzania. I graduated my form four studies at Rulenge High School in 2012.I joined the University of Dar es salaam Computing Center in 2014 with a diploma in computing and information technology(ICT) together with CCNA. Currently am doing networking and graphic design at Bugsnet company.",
  imgSrc: ambassadorsPath + '/german_kitula.jpg'
}, {
  name: "Grace Ipini",
  position: "Tanzania",
  bio: "",
  imgSrc: ambassadorsPath + '/grace_ipini.jpg'
}, {
  name: "Kabonire Ruhinda",
  position: "Uganda",
  bio: "After earning my bachelor's degree in Computer engineering, I ventured further into the computing world to" + " explore my passion for programming, as well as artificial intelligence as a whole. " + "I currently work as an intern at the artificial intelligence & data science research lag (AIR lab) at the" + " college of computing and information science (CoCIS) at Makerere university, where I'm focused on working" + " various projects, so as to enhance my skills, but also help out to the best way I can, to achieve certain set" + " targets.",
  imgSrc: ambassadorsPath + '/KabonireRuhinda.jpg'
}, {
  name: "Karabo Segale",
  position: "South Africa",
  bio: "Karabo was born in South Africa and lives in North West Province in a small town called Rustenburg in Ramoga Village. Is an Ambassador for Humaniq, a businessman, is into trading and mining Bitcoins.",
  imgSrc: ambassadorsPath + '/karabo_segale.jpg'
}, {
  name: "Md.Mofassair Hossain Dhaka",
  position: "Bangladesh",
  bio: "",
  imgSrc: ambassadorsPath + '/Md.MofassairHossainDhaka.jpg'
}, {
  name: "Oladimeji Shekoni",
  position: "Nigeria",
  bio: "Oladimeji Shekoni is an expert in block chain technology. He has facilitated a series of crypto-workshops since 2012 including the first ever Block Chain Conference organised by the Central Bank of Nigeria. He is keen on sharing knowledge to help individuals and coporate entities understand and optimize the benefits of cryptocurrency for wealth creation. \n" + "Shekoni is a Social and Behavioural Investogator, and a graduate of Psychology from the prestigious University of Ibadan.",
  imgSrc: ambassadorsPath + '/oladimeji_shekoni.jpg'
},
// {
//   name: "Omenigbo Priscilla",
//   position: "Guinea",
//   bio: "",
//   imgSrc:  `${ambassadorsPath}/omenigbo_priscilla.png`
// },
{
  name: "Peter Sampson",
  position: "Tanzania",
  bio: "Peter is a tech entrepreneur running his own venture specialized in technology development with high growth potential, holds a Bcs in Information technology with interest in blockchain technology.",
  imgSrc: ambassadorsPath + '/peter_sampson.jpg'
},
//{
//  name: "Pius Okedinachi",
//  position: "Nigeria",
//  bio: "",
//  imgSrc:  `${ambassadorsPath}/PiusOkedinachi.jpg`,
//},
{
  name: "Roger Justin Noah",
  position: "Cameroon",
  bio: "Noah is a cryptocurrency investor and trader, running bitcoin educational courses.",
  imgSrc: ambassadorsPath + '/NoahRogerJustin_2x.png'
}, {
  name: "Frank Deya ",
  position: "Kenya",
  bio: "Business Developer, Entrepreneur. \n" + "Experienced Business Development & Projects\n" + "Manager with a demonstrated history of\n" + "working in ICT, media production, fintech and\n" + "blockchain.",
  imgSrc: ambassadorsPath + '/frank_deya.jpg'
}];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(24);

exports.default = _reactRouter.browserHistory;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BACKEND_CALL = undefined;

var _promise = __webpack_require__(135);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(571);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _constants = __webpack_require__(12);

var _superagent = __webpack_require__(295);

var _superagent2 = _interopRequireDefault(_superagent);

var _qs = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BACKEND_CALL = exports.BACKEND_CALL = 'BACKEND_CALL';

var nextAction = function nextAction(action, data) {
  return (0, _extends4.default)({}, action, data, (0, _defineProperty3.default)({}, BACKEND_CALL, undefined));
};

exports.default = function () {
  return function (next) {
    return function (action) {
      if (!action[BACKEND_CALL]) return next(action);

      var _action$BACKEND_CALL$ = (0, _slicedToArray3.default)(action[BACKEND_CALL].types, 3),
          requestType = _action$BACKEND_CALL$[0],
          successType = _action$BACKEND_CALL$[1],
          failureType = _action$BACKEND_CALL$[2];

      var data = action[BACKEND_CALL].data;


      next(nextAction(action, { type: requestType, data: data }));

      var promise = APICall(action[BACKEND_CALL]);

      promise.then(function (response) {
        return next(nextAction(action, { data: (0, _extends4.default)({}, response, { initdata: data }), type: successType }));
      }, function (error) {
        next({ type: _constants.ERROR, data: { error: error, failureType: failureType, action: action } });
        return next(nextAction(action, { type: failureType }));
      });
      return promise;
    };
  };
};

function APICall(_ref) {
  var endpoint = _ref.endpoint,
      method = _ref.method,
      query = _ref.query,
      payload = _ref.payload,
      headers = _ref.headers,
      type = _ref.type;

  return new _promise2.default(function (resolve, reject) {
    var r = _superagent2.default[method.toLowerCase()]('' + endpoint);

    if (query) r.query((0, _qs.stringify)(query));

    if (payload) r = r.send(payload);

    if (headers) r = r.set(headers);

    if (type) r = r.type(type);

    r.then(function (data) {
      return resolve(data.body);
    }, function (error) {
      return reject(error);
    });
  });
}

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  return function (_ReactComponent) {
    (0, _inherits3.default)(Swiper, _ReactComponent);

    function Swiper() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Swiper);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Swiper.__proto__ || (0, _getPrototypeOf2.default)(Swiper)).call.apply(_ref, [this].concat(args))), _this), _this.originalX = 0, _this.onTouchStart = function (e) {
        var touch = e.changedTouches[0];
        var current = _this.getCurrentPosition(touch);
        _this.originalX = current.x;
      }, _this.onTouchMove = function (e) {
        var touch = e.changedTouches[0];
        var delta = _this.getDelta(touch);

        if (Math.abs(delta.x) > _this.swipeComponent.threshold) {
          if (delta.x > 0) _this.swipeComponent.onSwipeRight();
          if (delta.x < 0) _this.swipeComponent.onSwipeLeft();
          var current = _this.getCurrentPosition(touch);
          _this.originalX = current.x;
        }
      }, _this.getCurrentPosition = function (touch) {
        return { x: parseInt(touch.screenX) };
      }, _this.getDelta = function (touch) {
        return { x: parseInt(touch.screenX) - _this.originalX };
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Swiper, [{
      key: 'componendDidUpdate',
      value: function componendDidUpdate() {
        this.forceUpdate();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(Component, (0, _extends3.default)({}, this.props, {
          ref: function ref(node) {
            return _this2.swipeComponent = node;
          },
          onTouchStart: this.onTouchStart,
          onTouchMove: this.onTouchMove
        }));
      }
    }]);
    return Swiper;
  }(_react.PureComponent);
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isMobile = exports.isMobile =  true ? window.isMobile : {};

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(773);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('Exchanges_Slider');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'exchanges-slider-' + name);
};

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var name = _ref.name,
        url = _ref.url,
        img = _ref.img,
        mark = _ref.mark,
        cls = _ref.cls;

    return _react2.default.createElement(
      "div",
      { key: "exchanges-slider-item-" + (index + 1) },
      url ? _react2.default.createElement(
        "a",
        { className: cn('slide'), href: url, title: name, target: "_blank", onClick: function onClick() {
            handleLinkClick(name);
          } },
        _react2.default.createElement("img", { src: img }),
        mark ? _react2.default.createElement(
          "div",
          { className: 'mark ' + cls },
          mark
        ) : null
      ) : _react2.default.createElement(
        "div",
        { className: cn('slide'), title: name, onClick: function onClick() {
            handleLinkClick(name);
          } },
        _react2.default.createElement("img", { src: img }),
        mark ? _react2.default.createElement(
          "div",
          { className: 'mark ' + cls },
          mark
        ) : null
      )
    );
  });
};

var M_Exchanges_Slider = function (_React$Component) {
  (0, _inherits3.default)(M_Exchanges_Slider, _React$Component);

  function M_Exchanges_Slider() {
    (0, _classCallCheck3.default)(this, M_Exchanges_Slider);
    return (0, _possibleConstructorReturn3.default)(this, (M_Exchanges_Slider.__proto__ || (0, _getPrototypeOf2.default)(M_Exchanges_Slider)).apply(this, arguments));
  }

  (0, _createClass3.default)(M_Exchanges_Slider, [{
    key: "render",
    value: function render() {
      var settings = {
        loop: true,
        slide: "a",

        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        dots: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        mobileFirst: true,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,

        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }]
      };
      return _react2.default.createElement(
        _reactSlick2.default,
        settings,
        _createLinks(socialLinks)
      );
    }
  }]);
  return M_Exchanges_Slider;
}(_react2.default.Component);

exports.default = M_Exchanges_Slider;


M_Exchanges_Slider.propTypes = {};

var socialLinks = [{
  name: 'bittrex',
  url: 'https://bittrex.com/Market/Index?MarketName=BTC-HMQ',
  img: "/img/exchanges/bittrex.png",
  mark: "Top volume",
  cls: "blue"
}, {
  name: 'etherdelta',
  url: 'https://etherdelta.com/#HMQ-ETH',
  img: "/img/exchanges/etherdelta.png"
}, {
  name: 'idex',
  url: 'https://idex.market/eth/hmq',
  img: "/img/exchanges/idex.png"
}, {
  name: 'hotbit',
  url: 'https://www.hotbit.io/exchange?symbol=HMQ_BTC',
  img: "/img/exchanges/hotbit.png",
  mark: "FRESHLY LISTED",
  cls: "blue"
}, {
  name: 'mercatox',
  url: 'https://mercatox.com/exchange/HMQ/BTC',
  img: "/img/exchanges/mercatox.png"
}, {
  name: 'upbit',
  url: 'https://upbit.com/exchange?code=CRIX.UPBIT.BTC-HMQ',
  img: "/img/exchanges/upbit.png"
}, {
  name: 'yobit',
  url: 'https://yobit.net/ru/trade/HMQ/BTC',
  img: "/img/exchanges/yobit.png"
}, {
  name: 'new_exchange',
  url: '',
  img: "/img/exchanges/new_exchange.png",
  mark: "Soon, stay tuned",
  cls: "pink"
}];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(775);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_SocialLinks_G');

var socialIcons = '/img/design-v2/icons/social/sprite.svg';

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'social-click-' + name);
  if (window.fbq) window.fbq('trackCustom', 'socialClick', { name: name });
};

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var name = _ref.name,
        url = _ref.url;


    return _react2.default.createElement(
      'a',
      {
        key: 'socialLink-' + (index + 1),
        className: cn('link'),
        href: url,
        title: name,
        target: '_blank',
        onClick: function onClick() {
          handleLinkClick(name);
        }
      },
      _react2.default.createElement(
        'svg',
        null,
        _react2.default.createElement('use', { xlinkHref: socialIcons + '#' + name })
      )
    );
  });
};

var M_SocialLinks_H = function M_SocialLinks_H(_ref2) {
  var mix = _ref2.mix,
      children = _ref2.children,
      type = _ref2.type;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { type: type }) },
    _react2.default.createElement(
      'p',
      { className: cn('title') },
      children
    ),
    _react2.default.createElement(
      'nav',
      { className: cn('links-list') },
      _createLinks(socialLinks)
    )
  );
};

exports.default = M_SocialLinks_H;


M_SocialLinks_H.propTypes = {
  mix: T.string, //BEM mixin from parent block
  type: T.oneOf(['section', // layout for sections
  'footer'] // layour for footer
  ).isRequired
};

var socialLinks = [{
  name: 'facebook',
  url: 'https://www.facebook.com/humaniq.co/'
}, {
  name: 'twitter',
  url: 'https://twitter.com/Humaniq'
}, {
  name: 'instagram',
  url: 'https://www.instagram.com/humaniq_com/'
}, {
  name: 'github',
  url: 'https://github.com/humaniq'
}, {
  name: 'youtube',
  url: 'https://www.youtube.com/channel/UCXatRidLHbngYUtF8JXICPA'
}, {
  name: 'slack',
  url: 'https://humaniq-co.slack.com/'
}, {
  name: 'linkedin',
  url: 'https://www.linkedin.com/company/humaniq'
}, {
  name: 'telegram',
  url: 'https://t.me/hmqtalk'
}];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _Subscribe = __webpack_require__(486);

var _Subscribe2 = _interopRequireDefault(_Subscribe);

var _Ambasadors = __webpack_require__(484);

var _Ambasadors2 = _interopRequireDefault(_Ambasadors);

var _actions = __webpack_require__(54);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var O_SimpleForm_H = function (_Component) {
  (0, _inherits3.default)(O_SimpleForm_H, _Component);

  function O_SimpleForm_H() {
    (0, _classCallCheck3.default)(this, O_SimpleForm_H);
    return (0, _possibleConstructorReturn3.default)(this, (O_SimpleForm_H.__proto__ || (0, _getPrototypeOf2.default)(O_SimpleForm_H)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_SimpleForm_H, [{
    key: 'getForm',
    value: function getForm(formType, _ref) {
      var submit = _ref.submit,
          props = (0, _objectWithoutProperties3.default)(_ref, ['submit']);

      switch (formType) {
        case 'subscribe':
          return _react2.default.createElement(_Subscribe2.default, (0, _extends3.default)({}, props, { handleSubmit: function handleSubmit(data) {
              return submit('subscribe', data);
            } }));
        case 'ambasadors':
          return _react2.default.createElement(_Ambasadors2.default, (0, _extends3.default)({}, props, { handleSubmit: function handleSubmit(data) {
              return submit('ambassadors', data);
            } }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var formType = this.props.formType;
      // console.log('this.props from Simple Form',this.props);
      // console.log('formType from Simple Form',formType);

      return formType ? this.getForm(formType, this.props) : null;
    }
  }]);
  return O_SimpleForm_H;
}(_react.Component);

O_SimpleForm_H.propTypes = {
  formType: T.oneOf(['subscribe', 'ambasadors'])
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ submit: _actions.submit }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(O_SimpleForm_H);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFetchActions = __webpack_require__(551);

Object.defineProperty(exports, 'createFetchActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createFetchActions).default;
  }
});

var _createRequestActions = __webpack_require__(553);

Object.defineProperty(exports, 'createRequestActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createRequestActions).default;
  }
});

var _createPostActions = __webpack_require__(552);

Object.defineProperty(exports, 'createPostActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createPostActions).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(757);

var _reactRouter = __webpack_require__(24);

var _utils = __webpack_require__(1);

var _M_Ripple = __webpack_require__(133);

var _M_Ripple2 = _interopRequireDefault(_M_Ripple);

var _history = __webpack_require__(74);

var _history2 = _interopRequireDefault(_history);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Btn');


var A_Btn = function A_Btn(_ref) {
  var type = _ref.type,
      children = _ref.children,
      disabled = _ref.disabled,
      btnType = _ref.btnType,
      to = _ref.to,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties3.default)(_ref, ['type', 'children', 'disabled', 'btnType', 'to', 'onClick']);


  disabled = disabled && 'disabled';

  switch (type) {
    case 'window-link':
      return _react2.default.createElement(
        _reactRouter.Link,
        (0, _extends3.default)({ className: cn('link', { type: type }, [disabled]), disabled: disabled, external: true }, (0, _extends3.default)({ onClick: onClick, to: to }, props)),
        children
      );
    case 'inline':

      return _react2.default.createElement(
        _reactRouter.Link,
        (0, _extends3.default)({ className: cn('link', { type: type }, [disabled]), disabled: disabled }, (0, _extends3.default)({ onClick: onClick, to: to }, props)),
        children
      );
    case 'standart-form':
    case 'nav-btn':
      return _react2.default.createElement(
        _M_Ripple2.default,
        { onClick: onClick },
        _react2.default.createElement(
          'button',
          (0, _extends3.default)({ className: cn('button', { type: type }, [disabled]), type: btnType }, props),
          children
        )
      );
    case 'window':
    case 'link-standart-form':
    case 'link-subscribe':
    case 'material-r-link':
    case 'material-r-link-window':
      return _react2.default.createElement(
        _M_Ripple2.default,
        { onClick: function onClick() {
            return _history2.default.push(to);
          }, className: cn('ripple', { type: type }) },
        _react2.default.createElement(
          _reactRouter.Link,
          (0, _extends3.default)({ className: cn('link', { type: type }, [disabled]) }, props),
          children
        )
      );
    case 'popup-link':
      return _react2.default.createElement(
        _M_Ripple2.default,
        (0, _extends3.default)({ onClick: onClick }, { className: cn('ripple', { type: type }) }),
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: cn('link', { type: type }, [disabled]), type: btnType }, props),
          children
        )
      );
    default:
      return _react2.default.createElement(
        'button',
        (0, _extends3.default)({ className: cn('button', { type: type }, [disabled]), type: btnType }, (0, _extends3.default)({ onClick: onClick }, props)),
        children
      );
  }
};

A_Btn.propTypes = {
  type: T.oneOf(['material-r-link-window', // material-r-link used on simple form pages
  'material-r-link', // link that looks like material raised button
  'personal-nav-btn', // 170x82 white ripple link style button 100%/100%, padding: 0 1.3rem
  'popup-link', // popup link
  'nav-btn', // 82 white ripple link style button 100%/100%, padding: 0 1.3rem
  'link-subscribe', //big blue button used on home page
  'standart-form', // normal blue button with white text
  // 'link-standart-form', // link looks like standart form  blue button with white text
  'window', //big wide blue button, used on simple form pages
  'link', //link without styles display table
  'inline' //link without styles display inline
  ]).isRequired,
  btnType: T.oneOf([// button tag attribute
  'button', 'submit', 'reset']),
  to: T.string.isRequired,
  disabled: T.bool
};

A_Btn.defaultProps = {
  to: '#',
  btnType: 'button'
};

exports.default = A_Btn;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(769);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Textarea_H');

var A_Textarea_H = function (_Component) {
  (0, _inherits3.default)(A_Textarea_H, _Component);

  function A_Textarea_H() {
    (0, _classCallCheck3.default)(this, A_Textarea_H);
    return (0, _possibleConstructorReturn3.default)(this, (A_Textarea_H.__proto__ || (0, _getPrototypeOf2.default)(A_Textarea_H)).apply(this, arguments));
  }

  (0, _createClass3.default)(A_Textarea_H, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          handleChange = _props.handleChange,
          placeholder = _props.placeholder,
          onFocus = _props.onFocus,
          error = _props.error;


      var hasError = !!error;
      return _react2.default.createElement(
        'fieldset',
        { className: cn({ hasError: hasError }) },
        _react2.default.createElement('textarea', {
          ref: function ref(node) {
            return _this2.input = node;
          },
          className: cn('textarea'),
          placeholder: placeholder,
          value: value,
          onFocus: onFocus,
          onChange: function onChange(e) {
            return handleChange(e.target.value);
          }
        })
      );
    }
  }]);
  return A_Textarea_H;
}(_react.Component);

A_Textarea_H.propTypes = {
  handleChange: T.func.isRequired,
  value: T.string.isRequired,
  placeHolder: T.string
};

A_Textarea_H.defaultProps = {};

exports.default = A_Textarea_H;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(231);

var _Ripple = __webpack_require__(467);

var _Ripple2 = _interopRequireDefault(_Ripple);

var _utils = __webpack_require__(1);

var _propsValidationHelpers = __webpack_require__(207);

var _reactApiHelpers = __webpack_require__(208);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_Ripple');

var M_Ripple = function (_Component) {
  (0, _inherits3.default)(M_Ripple, _Component);

  function M_Ripple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_Ripple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_Ripple.__proto__ || (0, _getPrototypeOf2.default)(M_Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      cursorPos: {}
    }, _this.handleClick = function (e) {
      var cursorPos = {
        top: e.clientY,
        left: e.clientX,
        time: Date.now()
      };
      _this.setState({ cursorPos: cursorPos });
    }, _this.delayClick = function (onClick, delay) {
      setTimeout(onClick, delay);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_Ripple, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          _onClick = _props.onClick,
          delay = _props.delay,
          props = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onClick', 'delay']);


      var _newChild = void 0;
      if (_onClick) {
        _newChild = (0, _react.cloneElement)((0, _reactApiHelpers.universalChildrenOnly)(children), { onClick: function onClick() {
            return _this2.delayClick(_onClick, delay);
          } });
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: cn('parent', [className])
        }, props, {
          onMouseUp: this.handleClick,
          onTouchEnd: this.handleClick
        }),
        _newChild ? _newChild : children,
        _react2.default.createElement(_Ripple2.default, { cursorPos: this.state.cursorPos })
      );
    }
  }]);
  return M_Ripple;
}(_react.Component);

M_Ripple.propTypes = {
  delay: T.number, // custom delay
  className: T.string,
  children: _propsValidationHelpers.oneChild.isRequired // should be only one element array or a node(string, jsx, ...etc)
};

M_Ripple.defaultProps = {
  delay: 300 //default delay
};

exports.default = M_Ripple;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(776);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_SocialLinks_H');

var socialIcons = '/img/design-v2/icons/social/sprite.svg';

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'social-click-' + name);
  if (window.fbq) window.fbq('trackCustom', 'socialClick', { name: name });
};

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var name = _ref.name,
        url = _ref.url;


    return _react2.default.createElement(
      'a',
      {
        key: 'socialLink-' + (index + 1),
        className: cn('link'),
        href: url,
        title: name,
        target: '_blank',
        onClick: function onClick() {
          handleLinkClick(name);
        }
      },
      _react2.default.createElement(
        'svg',
        null,
        _react2.default.createElement('use', { xlinkHref: socialIcons + '#' + name })
      )
    );
  });
};

var M_SocialLinks_H = function M_SocialLinks_H(_ref2) {
  var mix = _ref2.mix,
      children = _ref2.children,
      type = _ref2.type;
  return _react2.default.createElement(
    'div',
    { className: cn([mix], { type: type }) },
    _react2.default.createElement(
      'p',
      { className: cn('title') },
      children
    ),
    _react2.default.createElement(
      'nav',
      { className: cn('links-list') },
      _createLinks(socialLinks)
    )
  );
};

exports.default = M_SocialLinks_H;


M_SocialLinks_H.propTypes = {
  mix: T.string, //BEM mixin from parent block
  type: T.oneOf(['section', // layout for sections
  'footer'] // layour for footer
  ).isRequired
};

var socialLinks = [{
  name: 'facebook',
  url: 'https://www.facebook.com/humaniq.co/'
}, {
  name: 'twitter',
  url: 'https://twitter.com/Humaniq'
}, {
  name: 'instagram',
  url: 'https://www.instagram.com/humaniq_com/'
}, {
  name: 'github',
  url: 'https://github.com/humaniq'
}, {
  name: 'youtube',
  url: 'https://www.youtube.com/channel/UCXatRidLHbngYUtF8JXICPA'
}, {
  name: 'slack',
  url: 'https://humaniq-co.slack.com/'
}, {
  name: 'linkedin',
  url: 'https://www.linkedin.com/company/humaniq'
}, {
  name: 'telegram',
  url: 'https://t.me/hmqtalk'
}];

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(759);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Btn_H_2');

var A_Btn_H = function A_Btn_H(_ref) {
  var mix = _ref.mix,
      children = _ref.children,
      type = _ref.type,
      formHasErrors = _ref.formHasErrors,
      to = _ref.to;

  switch (type) {
    case 'submit':
      return _react2.default.createElement(
        'button',
        {
          className: cn([mix], { formHasErrors: formHasErrors }),
          type: 'submit'
        },
        children
      );
    default:
      return _react2.default.createElement(
        'a',
        { className: cn([mix]), href: to, target: '_blank', style: { display: 'inline-block' } },
        children
      );
  }
};

exports.default = A_Btn_H;


A_Btn_H.propTypes = {
  mix: T.string, //BEM mixin from parent block
  type: T.oneOf(['submit'] // form submit btn
  ),
  formHasErrors: T.bool // form error mod for submit-btn
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(764);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_InputText_H_2');

var A_InputText_H = function (_Component) {
  (0, _inherits3.default)(A_InputText_H, _Component);

  function A_InputText_H() {
    (0, _classCallCheck3.default)(this, A_InputText_H);
    return (0, _possibleConstructorReturn3.default)(this, (A_InputText_H.__proto__ || (0, _getPrototypeOf2.default)(A_InputText_H)).apply(this, arguments));
  }

  (0, _createClass3.default)(A_InputText_H, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          handleChange = _props.handleChange,
          placeholder = _props.placeholder,
          onFocus = _props.onFocus,
          error = _props.error;


      var hasError = !!error;
      return _react2.default.createElement(
        'fieldset',
        { className: cn({ hasError: hasError }) },
        _react2.default.createElement('input', {
          ref: function ref(node) {
            return _this2.input = node;
          },
          className: cn('input'),
          placeholder: placeholder,
          type: 'text',
          value: value,
          onFocus: onFocus,
          onChange: function onChange(e) {
            return handleChange(e.target.value);
          }
        })
      );
    }
  }]);
  return A_InputText_H;
}(_react.Component);

A_InputText_H.propTypes = {
  handleChange: T.func.isRequired,
  value: T.string.isRequired,
  placeHolder: T.string
};

A_InputText_H.defaultProps = {};

exports.default = A_InputText_H;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(767);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Logo_H');

var A_Logo_H = function A_Logo_H(_ref) {
  var mix = _ref.mix,
      theme = _ref.theme;
  return _react2.default.createElement(
    'svg',
    {
      className: cn({ theme: theme }, [mix]),
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 117 25'
    },
    _react2.default.createElement('path', { d: 'M7.7423 13.2173C4.69873 13.2173 2.22223 10.7491 2.22223 7.71569C2.22223 4.68228 4.69873 2.21403 7.7423 2.21403C10.7859 2.21403 13.2624 4.68228 13.2624 7.71569C13.2624 10.7491 10.7859 13.2173 7.7423 13.2173ZM7.7423 1.68685e-07C3.47335 1.68685e-07 -1.538e-06 3.46098 -1.538e-06 7.71569C-1.538e-06 11.9704 3.47335 15.4322 7.7423 15.4322C9.90135 15.4322 11.856 14.5451 13.2624 13.1186V15.045H15.4838V7.71569C15.4838 3.46098 12.0113 1.68685e-07 7.7423 1.68685e-07Z', transform: 'translate(58.6924 5.11987)', fill: '#00A3FF' }),
    _react2.default.createElement('path', { d: 'M14.6539 6.1329C14.6539 9.48505 11.9177 12.2122 8.55429 12.2122C5.19092 12.2122 2.45467 9.48505 2.45467 6.1329V-9.2167e-08H-4.05505e-07V6.1329C-4.05505e-07 10.8338 3.83761 14.6586 8.55429 14.6586C13.2717 14.6586 17.1086 10.8338 17.1086 6.1329V-9.2167e-08H14.6539V6.1329Z', transform: 'translate(19.6963 5.50609)', fill: '#00A3FF' }),
    _react2.default.createElement('path', { d: 'M8.54493 5.5724L3.02953 5.50788e-08H6.96751e-07V14.6586H2.26279V2.79942L7.16588 7.65505V14.6586H9.42867V7.65505L14.331 2.79942V14.6586H16.5938V5.50788e-08H14.0611L8.54493 5.5724Z', transform: 'translate(39.5112 5.50632)', fill: '#00A3FF' }),
    _react2.default.createElement('path', { d: 'M8.11203 2.32054C11.3015 2.32054 13.8965 4.90694 13.8965 8.08495C13.8965 11.2637 11.3015 13.8501 8.11203 13.8501C4.92338 13.8501 2.32831 11.2637 2.32831 8.08495C2.32831 4.90694 4.92338 2.32054 8.11203 2.32054ZM16.2241 8.10206C16.2241 8.09661 16.2241 8.09117 16.2241 8.08495C16.2241 3.62735 12.5853 -1.61559e-07 8.11203 -1.61559e-07C3.63949 -1.61559e-07 -3.32917e-06 3.62735 -3.32917e-06 8.08495C-3.32917e-06 8.09117 0.000780796 8.09661 0.000780796 8.10206H-3.32917e-06C-3.32917e-06 12.5604 3.63949 16.1878 8.11203 16.1878C10.3748 16.1878 12.4231 15.2588 13.8965 13.7639V20.2598H16.2241V8.25676H16.2209C16.2209 8.20545 16.2241 8.15414 16.2241 8.10206Z', transform: 'translate(100.776 4.74019)', fill: '#00A3FF' }),
    _react2.default.createElement('path', { d: 'M17.0579 12.7618C17.0579 7.43971 13.1891 4.33633 8.50593 4.33633C6.14486 4.33633 4.00453 5.29487 2.45467 6.84111V7.51868e-09H0V5.55996V20.165H2.45467V15.4819V14.9027V12.1305C2.45467 9.20441 5.39138 6.78359 8.50593 6.78359C11.8693 6.78359 14.6048 9.50993 14.6048 12.8621V20.165H17.0602V12.7618H17.0579Z', fill: '#00A3FF' }),
    _react2.default.createElement('path', { d: 'M16.6172 13.7149V-1.7283e-07H14.3544V11.5498L2.28229 -1.7283e-07H1.71835e-06V0.942985L0.0194998 0.961643V14.5871H2.28229V3.12592L14.3169 14.64H16.6172V13.7149Z', transform: 'translate(76.8118 5.52458)', fill: '#00A3FF' }),
    _react2.default.createElement('path', { d: 'M-2.46439e-07 14.5863H2.28151V1.25445e-08H-2.46439e-07V14.5863Z', transform: 'translate(96.1516 5.57886)', fill: '#00A3FF' }),
    '  '
  );
};

A_Logo_H.propTypes = {
  mix: T.string, //BEM mixin from parent block
  theme: T.oneOf(['dark', // black logo
  'bright'] // white logo
  )
};

A_Logo_H.defaultProps = {
  theme: 'dark'
};

exports.default = A_Logo_H;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(24);

__webpack_require__(771);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_CareerPreview');
// import * as T from "prop-types";

var M_CareerPreview = function M_CareerPreview(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      createdAt = _ref.createdAt,
      mix = _ref.mix,
      _id = _ref._id,
      type = _ref.type;

  return _react2.default.createElement(
    'div',
    { className: cn('item', [mix]) },
    type === 'single' ? _react2.default.createElement(
      'h3',
      { className: cn('item-title', { type: type }) },
      title
    ) : _react2.default.createElement(
      _reactRouter.Link,
      { to: '/careers/' + _id, className: cn('item-title') },
      title
    ),
    _react2.default.createElement(
      'p',
      { className: cn('item-subtitle') },
      subtitle
    )
  );
};

M_CareerPreview.propTypes = {};

M_CareerPreview.defaultProps = {};

exports.default = M_CareerPreview;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(774);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_SocialLinks_F');

var socialIcons = '/img/design-v2/icons/social/sprite.svg';

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'social-click-' + name);
  if (window.fbq) window.fbq('trackCustom', 'socialClick', { name: name });
};

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var name = _ref.name,
        url = _ref.url;


    return _react2.default.createElement(
      'a',
      {
        key: 'socialLink-' + (index + 1),
        className: cn('link'),
        href: url,
        title: name,
        target: '_blank',
        onClick: function onClick() {
          handleLinkClick(name);
        }
      },
      _react2.default.createElement(
        'svg',
        null,
        _react2.default.createElement('use', { xlinkHref: socialIcons + '#' + name })
      )
    );
  });
};

var M_SocialLinks_H = function M_SocialLinks_H(_ref2) {
  var mix = _ref2.mix,
      children = _ref2.children,
      type = _ref2.type;
  return _react2.default.createElement(
    'div',
    { className: 'm-socials-f' },
    _react2.default.createElement(
      'div',
      { className: cn([mix], { type: type }) },
      _react2.default.createElement(
        'nav',
        { className: cn('links-list') },
        _createLinks(socialLinks)
      )
    ),
    _react2.default.createElement(
      'div',
      { className: cn([mix], { type: type }) },
      _react2.default.createElement(
        'nav',
        { className: cn('links-list') },
        _createLinks(socialLinks2)
      )
    )
  );
};

exports.default = M_SocialLinks_H;


M_SocialLinks_H.propTypes = {
  mix: T.string, //BEM mixin from parent block
  type: T.oneOf(['section', // layout for sections
  'section2', // layout for sections
  'footer'] // layour for footer
  ).isRequired
};

var socialLinks = [{
  name: 'facebook',
  url: 'https://www.facebook.com/humaniq.co/'
}, {
  name: 'twitter',
  url: 'https://twitter.com/Humaniq'
}, {
  name: 'instagram',
  url: 'https://www.instagram.com/humaniq_com/'
  /*,
   {
    name: 'github',
    url: 'https://github.com/humaniq',
  }*/
}];

var socialLinks2 = [{
  name: 'youtube',
  url: 'https://www.youtube.com/channel/UCXatRidLHbngYUtF8JXICPA'
},
/*
{
  name: 'slack',
  url: 'https://humaniq-co.slack.com/'
},
*/
{
  name: 'linkedin',
  url: 'https://www.linkedin.com/company/humaniq'
}, {
  name: 'telegram',
  url: 'https://t.me/hmqtalk'
}];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(777);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_Tooltip');

var M_Tooltip = function M_Tooltip(_ref) {
  var children = _ref.children,
      type = _ref.type,
      size = _ref.size,
      mix = _ref.mix;

  return _react2.default.createElement(
    'div',
    { className: cn('wrapper', [mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('root', { type: type, size: size }) },
      children
    )
  );
};

M_Tooltip.propTypes = {
  type: T.oneOf(['left', 'right', 'top', 'bottom']),
  size: T.oneOf(['wide', //50rem
  'normal'] //24.5rem
  )
};

M_Tooltip.defaultProps = {
  type: 'right',
  size: 'normal'
};
exports.default = M_Tooltip;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(778);

var _utils = __webpack_require__(1);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_ArticleList');


var O_ArticleList = function O_ArticleList(_ref) {
  var articles = _ref.articles,
      title = _ref.title;

  var getList = function getList(articles, i) {
    var renderedArticles = articles.map(function (article, i) {
      return _react2.default.createElement(
        'li',
        { key: "key_" + i, className: cn('article-item') },
        _react2.default.createElement(
          _A_Link2.default,
          { to: article.url, type: 'article' },
          article.title
        )
      );
    });
    return _react2.default.createElement(
      'ul',
      { key: 'key_' + i, className: cn('list') },
      renderedArticles
    );
  };
  var lists = [];

  for (var i = 0; i < 3; i++) {
    var arr = articles.splice(0, 4);
    var list = getList(arr, i);
    lists.push(list);
  }
  return _react2.default.createElement(
    _A_Container2.default,
    null,
    _react2.default.createElement(
      'div',
      { className: cn('root') },
      _react2.default.createElement(
        _A_H2.default,
        { type: 'section' },
        title
      ),
      _react2.default.createElement(
        'div',
        { className: cn('lists') },
        lists
      )
    )
  );
};

O_ArticleList.propTypes = {
  articles: T.arrayOf(T.shape({
    url: T.string.isRequired,
    title: T.string.isRequired
  })).isRequired,
  title: T.string.isRequired
};

O_ArticleList.defaultProps = {
  articles: [{ url: '', title: '' }]
};
exports.default = O_ArticleList;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _M_CareerPreview = __webpack_require__(199);

var _M_CareerPreview2 = _interopRequireDefault(_M_CareerPreview);

__webpack_require__(779);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_CareersList');
// import * as T from "prop-types";

var O_CareersList = function O_CareersList(_ref) {
  var entities = _ref.entities,
      type = _ref.type;

  var renderedItems = entities.map(function (props) {
    return _react2.default.createElement(_M_CareerPreview2.default, (0, _extends3.default)({ key: props._id }, props));
  });

  for (var i = 0; i < 3; i++) {
    renderedItems.push(_react2.default.createElement(_M_CareerPreview2.default, { mix: cn('item-empty'), key: 'empty-' + (i + 1) }));
  }

  return _react2.default.createElement(
    'div',
    { className: cn({ type: type }) },
    renderedItems
  );
};

O_CareersList.propTypes = {};

O_CareersList.defaultProps = {
  entities: []
};
exports.default = O_CareersList;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(791);

var _utils = __webpack_require__(1);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_Crumbs');


var O_Сrumbs = function O_Сrumbs(_ref) {
  var path = _ref.path,
      notLink = _ref.notLink;

  var crumbs = path.map(function (item, i, arr) {
    var notLast = i + 1 !== arr.length;
    var type = notLast ? 'crumbs-notlast' : 'crumbs';
    if (notLink) {
      return _react2.default.createElement(
        'span',
        { key: 'key_' + i, className: cn('not-links', { 'not-last': notLast }) },
        item.name
      );
    } else {
      return _react2.default.createElement(
        _A_Link2.default,
        { type: type, key: 'key_' + i, to: item.url },
        item.name
      );
    }
  });

  return _react2.default.createElement(
    'div',
    { className: cn('root') },
    crumbs
  );
};

O_Сrumbs.propTypes = {
  path: T.array.isRequired
};

O_Сrumbs.defaultProps = {
  path: []
};
exports.default = O_Сrumbs;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.fetchAmbassadors = fetchAmbassadors;

var _helpers = __webpack_require__(109);

var _humaniqBackendApi = __webpack_require__(75);

var _api = __webpack_require__(45);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchAmbassadors() {
  return (0, _defineProperty3.default)({}, _humaniqBackendApi.BACKEND_CALL, {
    endpoint: _api.ENPOINT_AMBASSADORS_LIST,
    method: 'GET',
    types: (0, _helpers.createFetchActions)(_constants.AMBASSADORS)
  });
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTER_CMS_CALL = undefined;

var _promise = __webpack_require__(135);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _superagent = __webpack_require__(295);

var _superagent2 = _interopRequireDefault(_superagent);

var _qs = __webpack_require__(162);

var _api = __webpack_require__(45);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTER_CMS_CALL = exports.BUTTER_CMS_CALL = 'BUTTER_CMS_CALL';

var nextAction = function nextAction(action, data) {
  return (0, _extends4.default)({}, action, data, (0, _defineProperty3.default)({}, BUTTER_CMS_CALL, undefined));
};

exports.default = function () {
  return function (next) {
    return function (action) {
      if (!action[BUTTER_CMS_CALL]) return next(action);

      var _action$BUTTER_CMS_CA = action[BUTTER_CMS_CALL],
          data = _action$BUTTER_CMS_CA.data,
          butterType = _action$BUTTER_CMS_CA.butter,
          actionType = butterType === _constants.CONTENT ? data.collection.toUpperCase() : butterType,
          requestType = _constants.REQUEST + actionType + _constants.START,
          successType = _constants.REQUEST + actionType + _constants.SUCCESS,
          failureType = _constants.REQUEST + actionType + _constants.FAIL;


      var endpoint = _api.BUTTER_CMS_API_ENDPOINTS[butterType.toLowerCase()],
          query = void 0;

      switch (butterType) {
        case _constants.WIKI:
        case _constants.CONTENT:
          var collection = data.collection,
              slugs = data.slugs,
              keys = void 0;

          if (!slugs || slugs.length === 0) {
            keys = collection.toLowerCase();
          } else {
            keys = slugs.map(function (arg) {
              return collection.toLowerCase() + '[slug=' + arg + ']';
            }).join(',');
          }
          query = { keys: keys };
          break;
        case _constants.POST:
          endpoint += data.id;
      }

      next(nextAction(action, { type: requestType, data: data }));

      var promise = APICall({ endpoint: endpoint, query: query });

      promise.then(function (response) {
        return next(nextAction(action, {
          data: response.data,
          type: successType
        }));
      }, function (error) {
        next(nextAction(action, { type: failureType }));
        next({ type: _constants.ERROR, data: error });
      });
      return promise;
    };
  };
};

function APICall(_ref) {
  var endpoint = _ref.endpoint,
      query = _ref.query;

  return new _promise2.default(function (resolve, reject) {
    var r = _superagent2.default.get('' + (_api.BUTTER_CMS_API_URL + endpoint)),
        authToken = { auth_token: _api.BUTTER_CMS_API_AUTH_TOKEN };

    r.query((0, _qs.stringify)(authToken));

    if (query) r.query((0, _qs.stringify)(query));
    r.then(function (data) {
      return resolve(data.body);
    }, function (error) {
      return reject(error);
    });
  });
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oneChild = exports.dateString = undefined;

var _dateHelpers = __webpack_require__(557);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateString = exports.dateString = function () {
  function validation(props, propName) {
    var testValue = props[propName];
    if (!testValue) return null;
    if (!(0, _dateHelpers._isDateValid)(testValue) || typeof testValue != 'string') {
      return new Error('wrong format of date string: ' + testValue + ', check ' + propName + ' ');
    }
    return null;
  }

  validation.isRequired = function (props, propName, componentName) {
    var testValue = props[propName];
    if (!testValue) return new Error('props ' + propName + ' is required');
    return validation(props, propName, componentName);
  };
  return validation;
}();

var oneChild = exports.oneChild = function () {
  function validation(props, propName) {
    var testValue = props[propName];
    if (!testValue) return null;
    if (_react2.default.Children.count(testValue) !== 1) {
      return new Error('Should be only one child');
    }
    return null;
  }

  validation.isRequired = function (props, propName, componentName) {
    var testValue = props[propName];
    if (!testValue) return new Error('props ' + propName + ' is required');
    return validation(props, propName, componentName);
  };
  return validation;
}();

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.universalChildrenOnly = universalChildrenOnly;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function universalChildrenOnly(children) {
  return Array.isArray(children) && children.length === 1 ? children[0] : _react2.default.Children.only(children);
}

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(24);

__webpack_require__(632);

var _routes = __webpack_require__(518);

var _routes2 = _interopRequireDefault(_routes);

var _reactRedux = __webpack_require__(19);

var _history = __webpack_require__(74);

var _history2 = _interopRequireDefault(_history);

var _store = __webpack_require__(554);

var _store2 = _interopRequireDefault(_store);

var _prepareData = __webpack_require__(559);

var _prepareData2 = _interopRequireDefault(_prepareData);

var _actions = __webpack_require__(15);

var _hashLinkScroll = __webpack_require__(558);

var _progressCalculation = __webpack_require__(560);

var _progressCalculation2 = _interopRequireDefault(_progressCalculation);

var _jquery = __webpack_require__(160);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _store2.default)(window.__INITIAL_STATE__);
// import offlinePluginStart from 'utils/offlinePlugin'


window.jQuery = _jquery2.default;
window.$ = _jquery2.default;
global.jQuery = _jquery2.default;

var App = function (_PureComponent) {
  (0, _inherits3.default)(App, _PureComponent);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (true) {
        // TODO: test on iOS device!!!
        (0, _progressCalculation2.default)();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(
          _reactRouter.Router,
          {
            history: _history2.default,
            key: Math.random(),
            onUpdate: function onUpdate() {
              var state = store.getState();
              state.navigation.isMenuOpened && store.dispatch((0, _actions.closeMenu)());
              (0, _hashLinkScroll.hashLinkScroll)();
            }
          },
          (0, _routes2.default)(store)
        )
      );
    }
  }]);
  return App;
}(_react.PureComponent);

function historyCb(location) {
  (0, _reactRouter.match)({ location: location, routes: (0, _routes2.default)(store) }, function (error, redirectLocation, renderProps) {
    if (!error && !redirectLocation && renderProps) {
      (0, _prepareData2.default)(store, renderProps);
    }
  });
}

_history2.default.listen(historyCb);
// hashLinkScroll()

historyCb(window.location);
// offlinePluginStart()

exports.default = App;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(319);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps() {

  return { advisers: advisers, team: team, timeLineData: timeLineData };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);


var imgPath = 'img/team_g';
// const founders = [
//   {
//     name: 'Alex Fork',
//     position: 'Head of Humaniq',
//     bio: 'Humaniq founder and Fintech entrepreneur Alex is one of the most important members of the international Blockchain community, who has worked with the UN to lead the deployment of Blockchain technology to improve the efficiency of UN resources and remittances. He has also spearheaded the harnessing of blockchains in Russia, organising a conference for 500 participants on the Ethereum Blockchain; authoring Bitcoin. More than Just Money; and founding the Fintech accelerator for startups in Russia, Future Fintech. He started Humaniq to help lift the global banked out of poverty.',
//     imgSrc: `${imgPath}/alex_fork.png`
//   },
//   {
//     name: 'Dinis Guarda',
//     position: 'CEO and Co-Founder of Humaniq',
//     bio: 'Digital age influencer Dinis is the founder of digital communications consultancy Ztudium and manager of websites <a href="https://intelligenthq.com" target="_blank">intelligenthq.com</a>, <a href="https://openbusinesscouncil.org" target="_blank">openbusinesscouncil.org</a>, <a href="https://tradersdna.com" target="_blank">tradersdna.com</a>, and <a href="https://hedgethink.com" target="_blank">hedgethink.com</a>. Dinis also co-founded BlockchainAge, a blockchain research and tech influencer, platform, book and film; led the digital strategy for invstr.com; authored books including The Next Tsunami: Blockchain plus AI and IOT and led a digital master course in London for Group INSEEC. He has been ranked as in the top 100 Blockchain and Fintech influencers.',
//     imgSrc: `${imgPath}/dinis_guarda.jpg`
//   },
//   {
//     name: 'Dmitry Kaminskiy',
//     position: 'Executive Chairman and Co-Founder',
//     bio: 'An innovative entrepreneur and investor active in Biotech, Fintech, Blockchain and artificial intelligence, Dmitry is co-founder of the Deep Knowledge Ventures investment fund, focused on investments in AI and Deeptech. He adheres to the principle of impact investment in all his business activities, believing that business should make a social impact, and he supports the deployment of Blockchain for Good, which led to his decision to support Humaniq from its inception.',
//     imgSrc: `${imgPath}/dmitry_kaminskiy.jpg`
//   },
// ]

var advisers = [
// {
//   name: 'Dinis Guarda',
//   position: 'Adviser',
//   bio:
//     'Digital age influencer Dinis is the founder of digital communications consultancy Ztudium and manager of websites <a href="https://intelligenthq.com" target="_blank">intelligenthq.com</a>, <a href="https://openbusinesscouncil.org" target="_blank">openbusinesscouncil.org</a>, <a href="https://tradersdna.com" target="_blank">tradersdna.com</a>, and <a href="https://hedgethink.com" target="_blank">hedgethink.com</a>. Dinis also co-founded BlockchainAge, a blockchain research and tech influencer, platform, book and film; led the digital strategy for invstr.com; authored books including The Next Tsunami: Blockchain plus AI and IOT and led a digital master course in London for Group INSEEC. He has been ranked as in the top 100 Blockchain and Fintech influencers.',
//   imgSrc: `${imgPath}/dinis_guarda.png`,
// },
{
  name: 'David Applefield',
  position: 'Adviser',
  bio: 'Is an American writer and media specialist living in Paris. He has as spent his career developing creative and innovative solutions for business leaders, heads of state, ministries, NGOs, and other not-for- profit foundations. He is the Financial Times representative for Africa, the Middle East and emerging markets.',
  imgSrc: imgPath + '/david_applefield.png'
},
// {
//   name: 'Iggy Bassi',
//   position: 'Adviser',
//   bio:
//     'Is the co-founder and serves as a Director of GADCO, a venture focused on sustainable agriculture and livelihood development in West Africa with LATAM technologies. He has a long track record in building companies in the technology, finance, and impact markets – in both emerged and emerging markets. Over the past 20 years he has advised many global companies (inc. Fortune 500), sovereigns, and entrepreneurs on solving problems in competitiveness, sustainability, scenario planning, and structuring complex transactions. He works at the intersection of technology, sustainability, food security, global security, and innovative thinking around the collaborative economy.',
//   imgSrc: `${imgPath}/iggy_bassi.png`,
// },
//{
//    name: 'Richard Kastelein',
//    position: 'Adviser',
//    bio:
//    'Founder and publisher of industry publication Blockchain News (EST 2015) at www.the-blockchain.com, a partner at ICO services collective Token.Agency ($500m+ and 90+ ICOs), director of education company Blockchain Partners (Oracle Partner) and ICO event organiser at leading industry event CryptoFinancing (Europe\'s first ICO event now branded Tokenomicon) - Vancouver native Richard Kastelein is an award-winning publisher, innovation executive and entrepreneur. He sits on the advisory boards of some two dozen Blockchain startups and has written over 2000 articles on Blockchain technology and startups at Blockchain News and has also published pioneering articles on ICOs in Harvard Business Review and Venturebeat.',
//    imgSrc: `${imgPath}/richard_kastelein.jpg`,
//},
{
  name: 'Matt McKibbin',
  position: 'Adviser',
  bio: 'Is a business development guru and a decentralization evangelist. He became interested in Bitcoin and the blockchain technology in 2012. Technologically savvy, he is an extroverted connector driven by a desire to see transformative and decentralized technologies positively affect the 7 billion people on the planet. He is based in the Washington DC metro area.',
  imgSrc: imgPath + '/matt_mckibbin.png'
}, {
  name: 'Alex Bausch',
  position: 'Adviser',
  bio: 'Is an entrepreneur with broad experience in all aspects of international business development and the creation of global technology companies. He strongly believes in partner ecosystems which aim to inspire and spawn new innovations. His specialties include: SaaS services, mobile identity security, the IoT, enterprise managed mobility, decentralised ledger technology, marketing, and product development.',
  imgSrc: imgPath + '/alex_bausch.png'
},
//{
//  name: 'Nick Ayton',
//  position: 'Adviser',
//  bio:
//    'Is a writer, speaker and educator of all things Blockchain and Cryptocurrency. He is a Fintech 100 Influencer and Number 21 Rise Blockchain Top 100. He has had eight startups and held many senior roles in major IT and tech companies. He now chairs various Blockchain events and advises a range of clients on Blockchain technology, bitcoin and Ethereum. One of his latest projects is to raise funds using cryptoeconomics and create a new film finance model to make a mini- series for TV about the Bitcoin Revolution, an asset backed Token, and a new Media and Film Production business on Ethereum.',
//  imgSrc: `${imgPath}/nick_ayton.png`,
//},
// {
//   name: 'Ron Morris',
//   position: 'Adviser',
//   bio:
//     'Has been designing and delivering educational programs in multiple countries for over a decade. After several years working for Groupe INSEEC, France’s largest higher education group, he went on to direct their London campus, bringing in top-tier thought leaders, practitioners, and companies to contribute to programs and events. He has now opened a new campus for Groupe INSEEC in San Francisco, delivering immersive, challenge-based programs focused on innovation and entrepreneurship, bringing together a wide range of startups, accelerators, institutes, and thought leaders.',
//   imgSrc: `${imgPath}/ron_morris.png`,
// },
// {
//   name: 'Tim Campbell',
//   position: 'Adviser',
//   bio: "In previous roles Tim has been a key government advisor on Diversity, Small Business Social Enterprise and Entrepreneurship. Tim was also Boris Johnson's Training and Enterprise ambassador for the City of London whilst Mr Johnson was Mayor of London.<br />In February 2012 Tim was awarded the MBE for his efforts supporting enterprise and he currently sits on the City of London's Education Board. Tim is a keen runner and martial arts enthusiast and is happily married with two children. ",
//   imgSrc: `${imgPath}/tim_campbell.png`,
// },
{
  name: 'Michael Terpin',
  position: 'Adviser',
  bio: "Michael Terpin co-founded BitAngels (www.bitangels.co), the world's first angel network for digital currency startups, in May 2013, and now serves as its chairman. The distributed angel network currently has more than 600 members, and it has made more than 25 investments in bitcoin and cryptocurrency companies with two exits and several follow-on rounds. Terpin is also co-founder and managing partner of bCommerce Labs (www.bcommercelabs.com), the first technology incubator fund focused on e-commerce companies for bitcoin and the blockchain, and a partner at Flight VC.",
  imgSrc: imgPath + '/michael_terpin.png'
}, {
  name: 'Dmitry Kaminskiy',
  position: 'Adviser',
  bio: 'An innovative entrepreneur and investor active in Biotech, Fintech, Blockchain and artificial intelligence, Dmitry is co-founder of the Deep Knowledge Ventures investment fund, focused on investments in AI and Deeptech. He adheres to the principle of impact investment in all his business activities, believing that business should make a social impact, and he supports the deployment of Blockchain for Good, which led to his decision to support Humaniq from its inception.',
  imgSrc: imgPath + '/dmitry_kaminskiy.png'
},
// {
//   name: 'Chami Akmeemana',
//   position: 'Adviser',
//   imgSrc: `${imgPath}/chami_akmeemana.png`,
// },
//{
//  name: 'Paolo Tasca',
//  position: 'Adviser',
//  bio: 'Paolo Tasca is a FinTech economist specialising in P2P Financial System. An advisor for different international organisations including the EU Parliament on blockchain technologies, Paolo recently joined the University College London as Director of the Centre for Blockchain Technologies (UCL CBT).  Prior to that, he has been a senior research economist at Deutsche Bundesbank working on digital currencies and P2P lending. Paolo is the co-author of the bestseller "FINTECH Book" and the co-editor of the book "Banking Beyond Banks and Money.',
//  imgSrc: `${imgPath}/paolo_tasca.png`,
//},
{
  name: 'Margaretta Colangelo',
  position: 'Adviser',
  bio: 'In tech companies, thinking is the primary activity and the core process used to create value. One of the challenges when thinking about technology is keeping up with constant innovation and envisioning what will evolve next. To stay abreast of emerging technologies, I\'ve built this think tank of investors, entrepreneurs, researchers, and engineers around the world who have progressive ideas. Like a natural ecosystem, our ecosystem consists of interlinked resources that complement each other. As the community expands, it\'s value increases exponentially for everyone in it. These are some of the people with whom I collaborate regularly.',
  imgSrc: imgPath + '/margaretta_colangelo.jpg'
}];

var team = [{
  name: 'Alex Fork',
  position: 'Founder, CEO',
  bio: 'Humaniq founder and Fintech entrepreneur Alex is one of the most important members of the international Blockchain community, who has worked with the UN to lead the deployment of Blockchain technology to improve the efficiency of UN resources and remittances. He has also spearheaded the harnessing of blockchains in Russia, organising a conference for 500 participants on the Ethereum Blockchain; authoring Bitcoin. More than Just Money; and founding the Fintech accelerator for startups in Russia, Future Fintech. He started Humaniq to help lift the global banked out of poverty.',
  imgSrc: imgPath + '/alex_fork.png'
},
//{
//  name: 'Javed Khattak',
//  position: 'CFO',
//  bio: 'Javed has a background as an actuary and of finance, consulting and startups. He loves technology, especially gadgets, AI and virtual reality, and believes in Blockchain for Good. He is working with Humaniq to bring greater opportunities and fairness to the world.',
//  imgSrc: `${imgPath}/javed_khattak.png`,
//},
//{
//  name: 'Hazem Danny Al-Nakib',
//  position: 'CIO',
//  bio: '',
//  imgSrc: `${imgPath}/hazem_danny.jpg`,
//},
//{
//  name: 'Anton Mozgovoy',
//  position: 'Team Lead',
//  bio: 'Anton was motivated to work with Humaniq to use his experience in both computer science and finance to help to bring happiness for all across the world. He is passionate about freedriving and wakeboarding, and, of course, staying late to finish work.',
//  imgSrc: `${imgPath}/anton_mozgovoy.png`
//},
// {
//   name: 'Peyman Irani',
//   position: 'SMM, CSS',
//   bio: 'Peyman’s background is in sales and marketing, entrepreneurship, and social media and he is passionate about his family, innovation and humanitarian capitalism. Fairness means a lot to him and he believes we can do something great for humanity at Humaniq.',
//   imgSrc: `${imgPath}/peyman_irani.png`,
// },
{
  name: 'Kirill Goryunov',
  position: 'CPO',
  bio: '',
  imgSrc: imgPath + '/kirill_goryunov.jpg'
},
//{
//  name: 'Kherel Kechil',
//  position: 'Lead Frontend Developer',
//  bio: 'Kherel is a digital nomad. He joined Humaniq to experience and participate in the financial evolution, and observe changes to the better in the country where he currently resides - China.',
//  imgSrc: `${imgPath}/kherel_kechil.png`,
//},
// {
//   name: 'Serafima Semkina',
//   position: 'CAO',
//   bio: 'Bringing experience of management and economics, Serafima’s passions include art, music and Russian literature and the crypto-economy. She cannot stand inequality and is happy to have the opportunity to tackle it with Humaniq.',
//   imgSrc: `${imgPath}/serafima_semkina.png`
// },
//{
//  name: 'Harry Bright',
//  position: 'CBDO',
//  bio: 'Bringing experience of management and economics, Serafima’s passions include art, music and Russian literature and the crypto-economy. She cannot stand inequality and is happy to have the opportunity to tackle it with Humaniq.',
//  imgSrc: `${imgPath}/harry_bright.jpg`,
//},
//{
//  name: 'Andrey Gidaspov',
//  position: 'Chief Global Development Officer',
//  bio: '',
//  imgSrc: `${imgPath}/andrey_gidaspov.jpg`,
//},
// {
//   name: 'Pavel Kiselyov',
//   position: 'Lead Backend Developer',
//   bio: '',
//   imgSrc: `${imgPath}/pavel_kiselyov.jpg`
// },
// {
//   name: 'Georgii Oleinikov',
//   position: 'Developer',
//   bio: 'Bringing experience of mathematics and computer science, Georgii loves things that have an impact and people that make these things happen. He believes there is big room for improvement in the financial sector, with many not served.',
//   imgSrc: `${imgPath}/georgii_oleinikov.png`
// },
{
  name: 'Segrey Blinov',
  position: 'SMM, CSS',
  bio: 'Bringing experience of social media and customer service support, Segrey is passionate about Blockchain technology and his family.',
  imgSrc: imgPath + '/segrey_blinov.png'
}, {
  name: 'Danny Kass',
  position: 'SMM, CSS',
  bio: 'Danny’s background is in social media, B2B sales and customer service support. He loves cryptoeconomy and technology and at Humaniq is motivated to disrupt the financial industry with an ecosystem for entrepreneurs to make changes from the bottom up.',
  imgSrc: imgPath + '/danny_kass.png'
},
//{
//  name: 'Andrey Shevchenko',
//  position: 'SMM, CSS',
//  bio: 'Andriy has experience in computer science, security research, online community building and entrepreneurship and is passionate about both improving the world and space exploration. At Humaniq he wants to contribute to something good for humanity and boost financial independence.',
//  imgSrc: `${imgPath}/andriy_schechenko.png`,
//},
//{
//  name: 'Lee Baker',
//  position: 'Writer',
//  bio: 'Lee has a background in both communications and community organising and loves story-telling to inspire positive action and to connect with others to change things for the better. He wants to unleash the power of the collaborative economy and help everyone to put their destinies into their own hands.',
//  imgSrc: `${imgPath}/lee_baker.png`,
//},
{
  name: 'Olga Derbio',
  position: 'Graphic Designer',
  bio: 'Olga has a background in architecture, interior design and graphic design, and is passionate about inspiring others, building sites, spontaneity, and the universe. She is at Humaniq so she can be creative for social good - and to become a crypto geek!',
  imgSrc: imgPath + '/olga_derbio.png'
}];

var timeLineData = [{
  year: '2016',
  months: [{
    name: 'April',
    events: ['Inception of the Humaniq idea by Alex Fork.']
  }, {
    name: 'November',
    events: ['Humaniq Whitebook is written and the original project team is formed.']
  }, {
    name: 'December',
    events: ['Humaniq.co website is launched and pre-ICO is announced']
  }]
}, {
  year: '2017',
  months: [{
    name: 'February',
    events: ['Smart contracts are being developed, due diligence and marketing campaign take place.', 'Humaniq team meets with project partners in India. Alex Fork conducts the first performance tests of the project in unbanked regions of India.', 'Humaniq announces first online hackathon', 'Pre-ICO (crowdsale) is launched']
  }, {
    name: 'March',
    events: ['Alpha version of the app is available for testing on IOS and Android.']
  }, {
    name: 'April',
    events: ['Humaniq collects $1.5 mln in the first hour of their ICO.']
  }, {
    name: 'May',
    events: ['App with new enchanced biometrics is being released.']
  }, {
    name: 'Now',
    events: ['Humaniq is 43 people now, working from 14 countries.']
  }]
}];

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(180);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SE_AboutMeta = function SE_AboutMeta() {
  return _react2.default.createElement(
    _reactHelmet2.default,
    null,
    _react2.default.createElement('html', { lang: 'en', id: 'about' }),
    _react2.default.createElement('link', { rel: 'canonical', href: 'https://about.humaniq.com/about' })
  );
};

exports.default = SE_AboutMeta;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(633);

var _utils = __webpack_require__(1);

var _meta = __webpack_require__(318);

var _meta2 = _interopRequireDefault(_meta);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

var _M_Tooltip = __webpack_require__(201);

var _M_Tooltip2 = _interopRequireDefault(_M_Tooltip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('About');
/*import Timeline from './Timeline'*/

var About = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, About);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = About.__proto__ || (0, _getPrototypeOf2.default)(About)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      filter: 'All'
    }, _this.nodes = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(About, [{
    key: 'getFounders',


    // componentDidMount() {
    //   console.log('componentDidMount')
    //   window.addEventListener('resize', this.forceUpdate);
    //   this.forceUpdate()
    // }
    //
    // componentWillUnmount() {
    //   console.log('componentWillUnmount')
    //   window.removeEventListener('resize', this.forceUpdate);
    // }
    //
    // componentDidUpdate() {
    //   const defaultNode = this.default
    //   if(!defaultNode || !defaultNode.getBoundingClientRect().right){
    //     console.log(!defaultNode, !defaultNode.getBoundingClientRect().right, 'не работает', defaultNode.offsetLeft)
    //   } else{
    //     console.log(!defaultNode, !defaultNode.getBoundingClientRect().right, 'работает', defaultNode.offsetLeft)
    //   }
    // }

    value: function getFounders(founders) {

      var renderedFounders = founders.map(function (_ref2, i, arr) {
        var name = _ref2.name,
            position = _ref2.position,
            bio = _ref2.bio,
            imgSrc = _ref2.imgSrc;

        var tooltipPlace = i === arr.length - 1 ? 'left' : 'right';
        return _react2.default.createElement(
          'div',
          { className: cn('founder'), key: 'key_' + i },
          _react2.default.createElement(_A_Image2.default, {
            src: imgSrc,
            alt: name,
            rounded: true
          }),
          _react2.default.createElement(
            'span',
            { className: cn('tooltip', { type: tooltipPlace }) },
            _react2.default.createElement(
              _M_Tooltip2.default,
              { type: tooltipPlace, size: 'wide' },
              _react2.default.createElement(
                _A_H2.default,
                { type: 'tooltip' },
                name
              ),
              _react2.default.createElement(
                _A_H2.default,
                { type: 'tooltip-sub' },
                position
              ),
              _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: bio } })
            )
          )
        );
      });
      return _react2.default.createElement(
        'ul',
        { className: cn('founders') },
        renderedFounders
      );
    }
  }, {
    key: 'getTeam',
    value: function getTeam(entities) {
      var _this2 = this;

      var _renderedTeam = entities.map(function (_ref3, i) {
        var name = _ref3.name,
            bio = _ref3.bio,
            imgSrc = _ref3.imgSrc,
            position = _ref3.position;

        var kebabName = _utils.convert.toCleanKebab(name);
        // let tooltipPlace;
        // if(this.nodes[kebabName]){
        //   console.log(
        //     kebabName,
        //     this.nodes[kebabName].offsetLeft,
        //     this.nodes[kebabName],
        //     // this.nodes.default.getBoundingClientRect().right,
        //     // this.nodes[kebabName].getBoundingClientRect().right,
        //     // this.nodes.default.getBoundingClientRect().right - this.nodes[kebabName].getBoundingClientRect().right < 200
        //   )
        // }
        //
        // if (
        //   this.default
        //   && this.nodes[kebabName]
        //   && (this.default.getBoundingClientRect().right - this.nodes[kebabName].getBoundingClientRect().right < 200)
        // ) {
        //   tooltipPlace = 'left'
        // } else {
        //   tooltipPlace = 'right'
        // }

        var tooltipPlace = (i + 1) % 5 === 0 ? 'left' : 'right';

        return _react2.default.createElement(
          'div',
          {
            className: cn('team-member'),
            key: kebabName,
            ref: function ref(node) {
              return _this2.nodes[kebabName] = node;
            }
          },
          _react2.default.createElement(
            'div',
            { className: cn('team-member-img') },
            _react2.default.createElement(_A_Image2.default, {
              src: imgSrc,
              alt: name,
              rounded: true
            }),
            _react2.default.createElement(
              'span',
              { className: cn('tooltip', { type: tooltipPlace }) },
              _react2.default.createElement(
                _M_Tooltip2.default,
                { type: tooltipPlace, size: 'wide' },
                _react2.default.createElement(
                  _A_H2.default,
                  { type: 'tooltip' },
                  name
                ),
                position && _react2.default.createElement(
                  _A_H2.default,
                  { type: 'tooltip-sub' },
                  position
                ),
                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: bio } })
              )
            )
          )
        );
      });

      for (var i = 0; i < 7; i++) {
        _renderedTeam.push(_react2.default.createElement('div', {
          className: cn('team-member-empty'),
          key: 'key_' + i
        }));
      }
      return _react2.default.createElement(
        'div',
        { className: cn('team-list') },
        _renderedTeam
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          advisers = _props.advisers,
          team = _props.team;
      // const renderedFounders = this.getFounders(founders)

      var renderedAdvisers = this.getTeam(advisers);
      var renderedTeam = this.getTeam(team);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_meta2.default, null),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _O_Hero2.default,
            { img: { src: "/img/illustrations/about-us.svg", alt: "parners" } },
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'About Humaniq'
            ),
            _react2.default.createElement(
              _A_P2.default,
              { type: 'hero' },
              'A little snapshot about the people that live Humaniq and run Humaniq.'
            )
          ),
          _react2.default.createElement(
            _A_H2.default,
            { type: 'section' },
            'Our Mission'
          ),
          _react2.default.createElement(
            _A_P2.default,
            { type: 'third' },
            'Today, two billion people around the world do not have access to banking.  Humaniq aims to increase financial inclusion worldwide by providing new financial services to the unbanked based on Blockchain technology and biometric identification systems. With this new mobile digital economy, we will help people who are excluded from the financial system break free from poverty and improve their lives, and emerging economies shift into the cryptoeconomy. '
          )
        ),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _A_H2.default,
            { type: 'section' },
            'Humaniq Team'
          ),
          _react2.default.createElement(
            'div',
            { ref: function ref(node) {
                return _this3.default = node;
              }, style: { width: '100%', height: 1 } },
            ' '
          ),
          _react2.default.createElement(
            'div',
            null,
            renderedTeam
          )
        ),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _A_H2.default,
            { type: 'section' },
            'Humaniq Advisers'
          ),
          _react2.default.createElement(
            'div',
            null,
            renderedAdvisers
          )
        )
      );
    }
  }]);
  return About;
}(_react.Component);

About.propTypes = {
  //founders: T.array.isRequired,
  advisers: T.array.isRequired,
  team: T.array.isRequired
};

exports.default = About;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(322);

var _page2 = _interopRequireDefault(_page);

var _redux = __webpack_require__(28);

var _actions = __webpack_require__(15);

var _people = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps() {
  var countries = _people.ambassadors.map(function (v) {
    return v.position;
  }).filter(function (v, i, a) {
    return a.indexOf(v) === i;
  });

  return { entities: _people.ambassadors, countries: countries };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ openPopup: _actions.openPopup }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(180);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SE_PartnersMeta = function SE_PartnersMeta() {
  return _react2.default.createElement(
    _reactHelmet2.default,
    null,
    _react2.default.createElement('html', { lang: 'en', id: 'ambassadors' }),
    _react2.default.createElement('link', { rel: 'canonical', href: 'https://about.humaniq.com/ambassadors' })
  );
};

exports.default = SE_PartnersMeta;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(634);

var _utils = __webpack_require__(1);

var _meta = __webpack_require__(321);

var _meta2 = _interopRequireDefault(_meta);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

var _A_Btn = __webpack_require__(131);

var _A_Btn2 = _interopRequireDefault(_A_Btn);

var _M_Dropdown = __webpack_require__(466);

var _M_Dropdown2 = _interopRequireDefault(_M_Dropdown);

var _M_Tooltip = __webpack_require__(201);

var _M_Tooltip2 = _interopRequireDefault(_M_Tooltip);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('Ambassadors');

var Ambassadors = function (_Component) {
  (0, _inherits3.default)(Ambassadors, _Component);

  function Ambassadors() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Ambassadors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ambassadors.__proto__ || (0, _getPrototypeOf2.default)(Ambassadors)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      filter: 'All'
    }, _this.nodes = [], _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Ambassadors, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('resize', this.forceUpdate);
      this.forceUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('resize', this.forceUpdate);
    }
  }, {
    key: 'getAmbassadors',
    value: function getAmbassadors(entities, filter) {
      var _this2 = this;

      var filtered = void 0;
      if (filter == 'All') {
        filtered = entities;
      } else {
        filtered = entities.filter(function (entity) {
          return entity.position === filter;
        });
      }

      var _renderedAmbassadors = filtered.map(function (partner, i) {
        var tooltipPlace = void 0;
        if (_this2.nodes[0] && _this2.nodes[i + 1] && _this2.nodes[0].offsetLeft + _this2.nodes[i + 1].offsetLeft > 200) {
          tooltipPlace = 'left';
        } else {
          tooltipPlace = 'right';
        }

        return _react2.default.createElement(
          'div',
          {
            className: cn('list-item'),
            key: partner.name,
            ref: function ref(node) {
              return _this2.nodes[i + 1] = node;
            }
          },
          _react2.default.createElement(_A_Image2.default, {
            src: partner.imgSrc,
            alt: partner.name,
            rounded: true
          }),
          _react2.default.createElement(
            'span',
            { className: cn('tooltip', { type: tooltipPlace }) },
            _react2.default.createElement(
              _M_Tooltip2.default,
              { type: tooltipPlace },
              _react2.default.createElement(
                _A_H2.default,
                { type: 'tooltip' },
                partner.name
              ),
              _react2.default.createElement(
                'span',
                { onClick: function onClick() {
                    return _this2.setState({ filter: partner.position });
                  }, style: { cursor: 'pointer' } },
                _react2.default.createElement(
                  _A_H2.default,
                  { type: 'tooltip-sub' },
                  partner.position
                )
              ),
              partner.bio
            )
          ),
          _react2.default.createElement(
            'span',
            { className: cn('link') },
            _react2.default.createElement(
              _A_Link2.default,
              { to: partner.link, external: true, type: 'block' },
              ' '
            )
          )
        );
      });

      for (var i = 0; i < 7; i++) {
        _renderedAmbassadors.push(_react2.default.createElement('div', {
          className: cn('list-item-empty'),
          key: 'key_' + i
        }));
      }
      return _renderedAmbassadors;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          countries = _props.countries,
          entities = _props.entities,
          openPopup = _props.openPopup;

      var options = ['All'].concat((0, _toConsumableArray3.default)(countries));

      var filter = this.state.filter;

      return _react2.default.createElement(
        'div',
        { className: cn('section-wrapper') },
        _react2.default.createElement(_meta2.default, null),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _O_Hero2.default,
            {
              img: { src: "/img/illustrations/ambassadors.svg", alt: "ambassadors" }
            },
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'Our Global Team'
            ),
            _react2.default.createElement(
              _A_P2.default,
              { type: 'hero' },
              'At Humaniq, everything we do is motivated by our wish to provide the most widespread access to banking possible.'
            )
          ),
          _react2.default.createElement(
            _A_H2.default,
            { type: 'section' },
            'Ever growing network'
          ),
          _react2.default.createElement(
            _A_P2.default,
            { type: 'third' },
            'We want to communicate directly with the people we wish to serve: the unbanked. People without access to banking live in very rural areas. This is why we\u2019ve started our Ambassador Program. Our ambassadors live in these developing countries and know the culture well. They are helping to promote cryptocurrencies in the Global South, as well as explaining the Humaniq project and app to the people in their countries.'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('list-wrapper') },
            _react2.default.createElement(
              'div',
              {
                className: cn('list'),
                ref: function ref(node) {
                  return _this3.nodes[0] = node;
                }
              },
              this.getAmbassadors(entities, filter)
            )
          )
        )
      );
    }
  }]);
  return Ambassadors;
}(_react.Component);

/*
          <div className={cn('form')}>
            <div className={cn('form-select')}>
              <M_Dropdown
                selected={filter}
                options={options}
                onChange={filter => this.setState({filter})}
              />
            </div>
            <A_Btn
              type='popup-link'
              onClick = {() => openPopup('ambasadors')}
            >Join Ambassadors Program</A_Btn>
          </div>


*/

Ambassadors.propTypes = {
  entities: T.array.isRequired,
  countries: T.array.isRequired
};

exports.default = Ambassadors;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(635);

var _utils = __webpack_require__(1);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as T from "prop-types";
var cn = (0, _utils.cssClassName)('Opinion');


var Opinion = function Opinion(_ref) {
  var name = _ref.name,
      title = _ref.title,
      text = _ref.text,
      img = _ref.img,
      right = _ref.right;

  return _react2.default.createElement(
    'div',
    { className: cn(), id: _utils.convert.toCleanKebab(name) },
    _react2.default.createElement(
      'div',
      { className: cn('profile', { right: right }) },
      _react2.default.createElement('img', { className: cn('profile-image'), src: img }),
      _react2.default.createElement(
        _A_P2.default,
        { mix: cn('profile-name') },
        name
      ),
      _react2.default.createElement(
        'p',
        { className: cn('profile-title') },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: cn('opinion') },
      _react2.default.createElement(
        _A_P2.default,
        { mix: cn('opinion-name') },
        name
      ),
      _react2.default.createElement('p', { className: cn('opinion-text'), dangerouslySetInnerHTML: { __html: text } })
    )
  );
};

Opinion.propTypes = {};

Opinion.defaultProps = {};
exports.default = Opinion;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(325);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(636);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _Opinion = __webpack_require__(323);

var _Opinion2 = _interopRequireDefault(_Opinion);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _reactYoutube = __webpack_require__(957);

var _reactYoutube2 = _interopRequireDefault(_reactYoutube);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)("anniversary");


var path = '/img/anniversary/';
var opinionsDate = [
//{
//  name: "Nick Ayton",
//  title: 'Adviser',
//  img: `${path}nick-ayton.png`,
//  text: 'I have been with the team since the very beginning, when Alex Fork had written the first draft of the Humaniq Whitepaper. I have watched this project grow and flourish and become a force for real change. <br/>' +
//  'Bringing opportunity to unbanked cannot be underestimated, thus Humaniq is a Blockchain pioneer for social good. The benchmark against for future projects will be measured. Blockchain technologies promise so much and Humaniq is literally the first the company funded by the crypto community that IS delivering on its promises. <br/>' +
//  'I support social impact projects and Humaniq is now in a position to make a real difference in emerging markets, principally the African region. <br/>' +
//  'It is a cause for hope, for change and creates the opportunity for prosperity and where communities can unlock their potential and exchange and trade what value they have.'
//},
{
  name: "Paul Mears",
  title: 'Adviser',
  img: path + "paul-mears.png",
  text: 'I work with Humaniq for 18 months approximately.<br/>' + 'Humaniq is a company that is looking to utilise innovative technology and the power of cryptocurrency to bring developed world benefits to the emerging markets and less developed world <br/>' + ' I am passionate about Humanaiq as it has a purpose to imprive the lives of those who are less fortunate than us in the developed world. I am a strong advocate of enabling people to improve their lives by providing them with tools to take advantage of opportunities and facilitate change and to grow communities'
},
//{
//  name: "Anton Mozgovoy",
//  title: 'Chief Technical Officer at Humaniq',
//  img: `${path}anton-mozgovoy.png`,
//  text: "I've been working for Humaniq for 1 year. <br/>" +
//  "If I was to describe Humaniq's mission in one sentence, I'd say that we are here to provide social and financial services for the underserved communities. For those who don't have government IDs - we create digital identities; for those who don't have access to banking system - we create crypto wallets; for those who don't have access to private communication - we provide forever free and secure chats. As to the team, here in Humaniq we've managed to gather best of the best. It is the greatest team I've ever worked in. <br/>" +
//  "Humaniq for me is an opportunity to build a platform for opportunities."
//},
{
  name: "Serafima Semkina",
  title: 'Chief Administrative Officer at Humaniq',
  img: path + "serafima-semkina.png",
  text: 'I am with Humaniq team for 1 year and 4 months. <br />' + 'Humaniq’s team has always been very consonant and vibrant while creating beautiful synergy. Humaniq is united by the joint desire to make world a better place. Every member of the team is emotionally motivated and it is very inspiring. Therefore the main purpose of Humaniq is to empower equality and kindness all across the globe and beyond <br />' + 'For me Humaniq is a company that challenges status quo to achieve not only its goals, but reaching out to those in need.'
},
//{
//  name: "Javed Khattak",
//  title: 'Chief Financial Officer at Humaniq',
//  img: `${path}javed-khattak.png`,
//  text: "I have been with Humaniq since July 2017. <br />" +
//  "I believe Humaniq and its goal of financial inclusion is absolutely fantastic. It calls out to me at many different levels, in particular as, while it brings alongside many economic opportunities, it is aimed at helping humanity, reducing poverty and improving lives in groups where the need is one of the highest. This sort of positive and humanitarian impact is very close to my heart.<br />" +
//  "I feel that the entire team at Humaniq is great - we all get along and everyone is extremely talented. And we have the positive drive and motivation to keep moving forward with the Humaniq vision because I believe we all share that vision and these values of making the world a better place"
//},
{
  name: "Anastasia Yugai",
  title: 'Strategy and business development manager',
  img: path + "anastasia-yugai.png",
  text: "I am working Humaniq team since August 2017. <br />" + "Humaniq is the opportunity. Using our mobile app everyone can create their digital social capital to use it as a springboard for a better life. <br />" + "For me, Humaniq is the great team with true values. I am realy glad to be a part of such a wonderful project which tries to make people's lives easier."
},
//{
//  name: "Pius Okedinachi",
//  title: 'Ambassador at Humaniq',
//  img: `${path}pius-okedinachi.png`,
//  text: "My first work with the Humaniq team was in August 2017. <br />" +
//  "Humaniq, for me its timely. The objectives and the purpose for which it stands for. There is no better time to the reach the unbanked but now. I’ve always wanted to be a part of the Blockchain move which has Africa at heart, so, when I was introduced to Humaniq, my first question was to know its objectives and drive, and when I got the answer from the Whitepaper I was all in, trying to give my best. <br />" +
//  "Humaniq to me is a FinTech, not just for now but for the future."
//},
{
  name: "Oladimeji Shekoni",
  title: 'Ambassador at Humaniq',
  img: path + "oladimeji-shekoni.png",
  text: "I have been with Humaniq for a year now. <br />" + "I would describe Humaniq as a visionary concept, with the objective of assisting everyone around the world in achieving their life goals. It's not just about financial inclusion, it is about helping people who are underprivileged to live a normal life. It's about caring for the poor. It's about reaching the forgotten and everyone cut out of civilization. Achieving the goals set by Humaniq would mean putting an end to hunger, strife, and even wars in many parts of the world. This is more of humanitarian mission and its a purpose worth working for. <br />" + "The team of Humaniq have been fantastic and unrelenting, success is not a destination its a journey and they have shown how committed they are towards this journey within the past one year."
}, {
  name: "Chris Konstantopoulos",
  title: 'Investor',
  img: path + "chris-konstantopoulos.png",
  text: "I have been investing in crypto currencies for 2 years now.<br />" + "There has been no platform to date where the unbanked of the world can transact and be a part of the financial world, let alone the cryptocurrency one, until Humaniq came along. We always knew the “who, what, where” questions to this major issue and Humaniq solves the “how”. It is quite possibly the only solution to third world financial problems and a major advantage is they will start in a system that is noble and pure as opposed to the rest of the world that started on an archaic, corruptible and unfair platform. <br />" + "The team of Humaniq are some of the most amazing people you can talk to. They have the best people leading each role in the project with is very crucial to success. No matter what criticism comes their way, it really shows that they know what they are doing and only have the projects best intentions in mind."
}];

var Anniversary = function (_Component) {
  (0, _inherits3.default)(Anniversary, _Component);

  function Anniversary() {
    (0, _classCallCheck3.default)(this, Anniversary);
    return (0, _possibleConstructorReturn3.default)(this, (Anniversary.__proto__ || (0, _getPrototypeOf2.default)(Anniversary)).apply(this, arguments));
  }

  (0, _createClass3.default)(Anniversary, [{
    key: "getOpinions",
    value: function getOpinions() {
      return opinionsDate.map(function (data, i) {
        return _react2.default.createElement(_Opinion2.default, (0, _extends3.default)({}, data, { key: i, right: !!(i % 2) }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var opts = {
        height: "500px",
        width: "100%",
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
          // autoplay: 1
        }
      };

      return _react2.default.createElement(
        _A_Container2.default,
        { mix: cn() },
        _react2.default.createElement(_reactYoutube2.default, { videoId: "B91ZW1tlh10", opts: opts }),
        _react2.default.createElement(
          _A_Title_H2.default,
          { type: "hero", mix: cn("title") },
          "Humaniq Challenge Trailer 2018"
        ),
        _react2.default.createElement("hr", null),
        _react2.default.createElement(
          _A_P2.default,
          { type: "first", mix: cn("text") },
          "We held a major competition for startup projects which had a great potential to help the world's unbanked population. ",
          _react2.default.createElement("br", null),
          " About 450 participants who applied presented projects made especially for Humaniq, a decentralized financial platform.",
          _react2.default.createElement("br", null),
          "3 winners were able to join the expedition to Kenya to gain a better understanding of unbanked people\u2019s lives and needs.",
          _react2.default.createElement("br", null),
          "The private screening of the full Humaniq Challenge story is coming up on 17th of May in Kenya, United Kingdom, United States, Belarus, Israel."
        ),
        _react2.default.createElement(
          _A_Title_H2.default,
          { type: "section", mix: cn("title") },
          "Opinions"
        ),
        _react2.default.createElement(
          _A_P2.default,
          { type: "first", mix: cn("text") },
          "Read what different people say about Humaniq, its goal and mission. We are really happy to have so many people believing in our common success!"
        ),
        _react2.default.createElement("hr", null),
        this.getOpinions()
      );
    }
  }]);
  return Anniversary;
}(_react.Component);

Anniversary.propTypes = {};

exports.default = Anniversary;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(327);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var _state$careers = state.careers,
      entities = _state$careers.entities,
      loaded = _state$careers.loaded,
      loading = _state$careers.loading;
  // console.log(JSON.stringify(entities))

  return { entities: entities, loaded: loaded, loading: loading };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _O_CareersList = __webpack_require__(203);

var _O_CareersList2 = _interopRequireDefault(_O_CareersList);

__webpack_require__(637);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('Careers');
// import * as T from "prop-types";


var Careers = function Careers(_ref) {
  var entities = _ref.entities,
      loaded = _ref.loaded,
      loading = _ref.loading;

  return _react2.default.createElement(
    _A_Container2.default,
    { type: 'section-clean' },
    _react2.default.createElement(
      _A_Title_H2.default,
      { type: 'section', mix: cn('title') },
      'Careers'
    ),
    !loading && loaded && !entities.length ? _react2.default.createElement(
      'p',
      { className: cn('no-vacancies') },
      'Humaniq is constantly growing and looking for valuable assets for our team. The list of Humaniq vacancies gets updated regularly, so if you share our values and wish to join us, we will be happy to welcome your CVs at ',
      _react2.default.createElement(
        'a',
        { href: 'mailto:hr@humaniq.com', target: '_blank' },
        'hr@humaniq.com'
      ),
      '. We are currently interested in specialists with the focus on:',
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
          'li',
          null,
          'Product management'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Customer development'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Analytics and Targeting'
        ),
        _react2.default.createElement(
          'li',
          null,
          'SMM & Community'
        ),
        _react2.default.createElement(
          'li',
          null,
          'E-mail marketing'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Blockchain Development'
        )
      ),
      _react2.default.createElement('br', null),
      'Should you not have found a vacancy of interest on this list, we will in any case be happy to receive a resume from you. As soon as we have an opening that corresponds to your skills, we will be sure to get in touch.'
    ) : _react2.default.createElement(_O_CareersList2.default, { entities: entities })
  );
};

Careers.propTypes = {};

Careers.defaultProps = {};
exports.default = Careers;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(329);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
  var _state$careers = state.careers,
      entities = _state$careers.entities,
      loaded = _state$careers.loaded,
      loading = _state$careers.loading;
  var id = ownProps.id;


  var entity = entities.find(function (_ref) {
    var _id = _ref._id;
    return _id === id;
  });
  return { entity: entity, loaded: loaded, loading: loading, entities: entities };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(210);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _M_CareerPreview = __webpack_require__(199);

var _M_CareerPreview2 = _interopRequireDefault(_M_CareerPreview);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(638);

var _utils = __webpack_require__(1);

var _O_CareersList = __webpack_require__(203);

var _O_CareersList2 = _interopRequireDefault(_O_CareersList);

var _history = __webpack_require__(74);

var _history2 = _interopRequireDefault(_history);

var _reactRouter = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)("CareersItem");
// import * as T from "prop-types";

var CareersItem = function (_Component) {
  (0, _inherits3.default)(CareersItem, _Component);

  function CareersItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CareersItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CareersItem.__proto__ || (0, _getPrototypeOf2.default)(CareersItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CareersItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkIfExist();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkIfExist();
    }
  }, {
    key: "checkIfExist",
    value: function checkIfExist() {
      var _props = this.props,
          loading = _props.loading,
          loaded = _props.loaded,
          entity = _props.entity;

      if (!loading && loaded && !(0, _keys2.default)(entity).length) {
        _history2.default.push("/error/404");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          entity = _props2.entity,
          entities = _props2.entities;


      return _react2.default.createElement(
        _A_Container2.default,
        { type: "section-clean", mix: cn("container") },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: "/careers" },
          _react2.default.createElement(
            _A_Title_H2.default,
            { type: "section", mix: cn("title") },
            "Careers",
            " "
          )
        ),
        _react2.default.createElement(
          "div",
          { className: cn("root") },
          _react2.default.createElement(
            "div",
            { className: cn("left") },
            _react2.default.createElement(_M_CareerPreview2.default, (0, _extends3.default)({}, entity, { type: "single" })),
            _react2.default.createElement("div", {
              className: cn("body"),
              dangerouslySetInnerHTML: { __html: entity.body }
            }),
            _react2.default.createElement(
              _A_Title_H2.default,
              { mix: cn("title-contact"), type: "inner-pages" },
              "Contact us",
              " "
            ),
            _react2.default.createElement(
              "p",
              null,
              "If you are interested in this position please send your resume to",
              " ",
              _react2.default.createElement(
                "a",
                { href: "mailto:hr@humaniq.com", target: "_blank" },
                "hr@humaniq.com"
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: cn("right") },
            _react2.default.createElement(_O_CareersList2.default, { entities: entities })
          )
        )
      );
    }
  }]);
  return CareersItem;
}(_react.Component);

CareersItem.propTypes = {};

CareersItem.defaultProps = {
  entity: {}
};

exports.default = CareersItem;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(331);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(639);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('ContactUs');

var ContactUs = function (_Component) {
  (0, _inherits3.default)(ContactUs, _Component);

  function ContactUs() {
    (0, _classCallCheck3.default)(this, ContactUs);
    return (0, _possibleConstructorReturn3.default)(this, (ContactUs.__proto__ || (0, _getPrototypeOf2.default)(ContactUs)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContactUs, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: cn('section-wrapper') },
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _O_Hero2.default,
            null,
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'Contact Humaniq'
            ),
            _react2.default.createElement(
              _A_P2.default,
              { type: 'hero' },
              'Humaniq is proud of its wide partnership network which includes everybody from fintech companies and Blockchain communities to publishing media and app developers.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('contactus') },
            _react2.default.createElement(
              'section',
              { className: cn('support') },
              _react2.default.createElement(
                _A_H2.default,
                { type: 'section' },
                'Customer Support'
              ),
              _react2.default.createElement(
                _A_P2.default,
                { type: 'third' },
                'For any questions you may have please contact:'
              ),
              _react2.default.createElement(
                _A_Link2.default,
                { to: 'mailto:info@humaniq.com', type: 'primary', external: true },
                'info@humaniq.com'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('policy') },
              _react2.default.createElement(
                _A_H2.default,
                { type: 'section' },
                'Questions regarding Privacy Policy'
              ),
              _react2.default.createElement(
                _A_P2.default,
                { type: 'third' },
                'If you have any questions regarding our user or data Privacy Policy, please ',
                _react2.default.createElement(
                  _A_Link2.default,
                  { to: 'mailto:info@humaniq.com', type: 'primary', external: true },
                  'reach out to us.'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ContactUs;
}(_react.Component);

exports.default = ContactUs;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(333);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(160);

var _jquery2 = _interopRequireDefault(_jquery);

var _A_Btn = __webpack_require__(131);

var _A_Btn2 = _interopRequireDefault(_A_Btn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryString = __webpack_require__(248);

var Deeplink = function (_Component) {
  (0, _inherits3.default)(Deeplink, _Component);

  function Deeplink() {
    (0, _classCallCheck3.default)(this, Deeplink);
    return (0, _possibleConstructorReturn3.default)(this, (Deeplink.__proto__ || (0, _getPrototypeOf2.default)(Deeplink)).apply(this, arguments));
  }

  (0, _createClass3.default)(Deeplink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var downloadURL = 'https://play.google.com/store/apps/details?id=com.humaniq.lite';
      var redirectURL = '';

      if (typeof location !== 'undefined' && typeof location.search !== 'undefined' && location.search !== '') {
        var parsedQuery = queryString.parse(location.search);

        if (typeof parsedQuery !== 'undefined' && parsedQuery !== null && typeof parsedQuery.l !== 'undefined' && parsedQuery.l !== '') {
          var allowedPatterns = [/^profile\/(main|edit)$/g, /^request$/g, /^send\/[A-z0-9]+$/g, /^chat\/[A-z0-9]+$/g, /^groupchat\/[A-z0-9]+$/g, /^bizchats$/g, /^bizchat\/biz_[A-z0-9]+$/g, /^stories$/g, /^story\/[A-z0-9]+$/g, /^support$/g];

          for (var i = 0; i < allowedPatterns.length; i++) {
            if (allowedPatterns[i].test(parsedQuery.l)) {
              redirectURL = parsedQuery.l;
              break;
            }
          }
        }
      }

      if (redirectURL !== '') {
        redirectURL = 'humaniq://humaniq.com/' + redirectURL;

        (0, _jquery2.default)('#button-dl').attr({ 'action': downloadURL });
        (0, _jquery2.default)('#button-app').attr({ 'action': redirectURL });
        window.location = redirectURL;

        setTimeout(function () {
          window.location = downloadURL;
        }, 1000);
      } else {
        (0, _jquery2.default)('#button-dl').hide();
        (0, _jquery2.default)('#button-app').hide();
        (0, _jquery2.default)('#errorDiv').show();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { "maxWidth": "768px", "margin": "0 auto", "padding": "15px" } },
        _react2.default.createElement(
          'div',
          { id: 'errorDiv', style: { "color": "#f00", "textAlign": "center", "display": "none" } },
          'Wrong request!'
        ),
        _react2.default.createElement(
          'form',
          { id: 'button-dl', action: '', method: 'GET', target: '_blank' },
          _react2.default.createElement(
            _A_Btn2.default,
            { type: 'material-r-link-window', btnType: 'submit' },
            'Download'
          )
        ),
        _react2.default.createElement(
          'form',
          { id: 'button-app', action: '', method: 'GET', target: '_blank' },
          _react2.default.createElement(
            _A_Btn2.default,
            { type: 'material-r-link-window', btnType: 'submit' },
            'Open App'
          )
        )
      );
    }
  }]);
  return Deeplink;
}(_react.Component);

exports.default = Deeplink;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(640);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('Error');

var Error = function (_Component) {
  (0, _inherits3.default)(Error, _Component);

  function Error() {
    (0, _classCallCheck3.default)(this, Error);
    return (0, _possibleConstructorReturn3.default)(this, (Error.__proto__ || (0, _getPrototypeOf2.default)(Error)).apply(this, arguments));
  }

  (0, _createClass3.default)(Error, [{
    key: 'render',
    value: function render() {
      var err = this.props.err;

      var message = void 0;
      if (err === '500') {
        message = '500 internal server error';
      } else {
        message = 'Welp, we searched all through the back end, and we couldn’t find the page you’re looking for';
      }

      return _react2.default.createElement(
        'div',
        { className: cn('section-wrapper') },
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            'div',
            { className: cn('error') },
            _react2.default.createElement(
              'div',
              { className: cn('error-main') },
              _react2.default.createElement(
                'div',
                { className: cn('error-main-image') },
                _react2.default.createElement('img', { src: '/img/humaniq-logos/group.png', alt: 'Humaniq' })
              ),
              _react2.default.createElement(
                'div',
                { className: cn('error-main-message') },
                _react2.default.createElement(
                  _A_H2.default,
                  { type: 'xxl' },
                  err
                ),
                _react2.default.createElement(
                  'span',
                  { className: cn('message') },
                  message,
                  '!'
                ),
                _react2.default.createElement(
                  _A_P2.default,
                  { type: 'hero' },
                  _react2.default.createElement(
                    _A_Link2.default,
                    { to: '/', type: 'primary' },
                    'Go back to home page \xBB'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Error;
}(_react.Component);

Error.propTypes = {
  err: T.string
};

Error.defaultProps = {
  err: '404'
};
exports.default = Error;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(336);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(641);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('FrequentlyAskedQuestions');

var FrequentlyAskedQuestions = function (_Component) {
  (0, _inherits3.default)(FrequentlyAskedQuestions, _Component);

  function FrequentlyAskedQuestions() {
    (0, _classCallCheck3.default)(this, FrequentlyAskedQuestions);
    return (0, _possibleConstructorReturn3.default)(this, (FrequentlyAskedQuestions.__proto__ || (0, _getPrototypeOf2.default)(FrequentlyAskedQuestions)).apply(this, arguments));
  }

  (0, _createClass3.default)(FrequentlyAskedQuestions, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: cn('section-wrapper') },
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _O_Hero2.default,
            null,
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'Frequently Asked Questions'
            ),
            _react2.default.createElement(
              _A_P2.default,
              { type: 'hero' },
              'Humaniq is a simple and secure mobile app, delivering financial inclusion solutions globally.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('faq') },
            _react2.default.createElement(
              'section',
              { className: cn('firstquestion') },
              _react2.default.createElement(
                'h2',
                null,
                '1. What is the Humaniq token?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'The HMQ token is a blockchain based crypto currency used inside the Humaniq app which is traded on cryptocurrency exchange markets, giving it a certain value in US dollars (which is displayed in real time on the app).'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'HMQ is the world\'s first hybrid blockchain based crypto currency in your Humaniq app wallet. As long as you get your HMQ you can use it immediately to exchange it with other people or buy some goods. You can use it within Humaniq app or on stock exchange. You can receive your fees in HMQ and use it as usual money the way you use cash or credit cards, but in a much-much safer way. HMQ is your digital wallet and your digital deposit box.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'The HMQ currency has several advantages over traditional cash:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'It has zero fees for any transfer'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'It\'s international money, sending it into another country is the same as sending it to your friend'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'You can receive tokens for free by doing simple actions in Humaniq app'
                )
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '2. How can I use this app?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'In Humaniq app you can:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Invite your friends and text with them with secured chats'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Create and use a wallet'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Send or receive HMQ'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Get HMQ BONUS'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Participate in surveys and earn HMQ Tokens'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Trade or buy things via business chats'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Find some interesting content in info bots'
                )
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '3. How can I get FREE BONUS HMQ tokens for:'
              ),
              _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Initial registration - you get HMQ bonus for the initial registration right after the application downloading and Validation by Flash Call in order to complete the registration procedure'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'BIO identification \u2013 you get a HMQ bonus after passing Bio identification: photo + graphic key'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Inviting friends - you get a HMQ bonus for inviting friends after they have registered your promo code.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Being invited by a friend \u2013 you can use the promocode of your friend that has invited you right after downloading the application and adding it at \xABmore\xBB tab on your profile.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Having a first outgoing transaction of the week to a friend from the application contact list.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Having a first incoming transaction of the week from a friend from application contact list.'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'But remember that after reaching $20 USD in total BONUS you will not be granted any more tokens. $20 USD is the maximum that you can get. You can still do all the actions mentioned above, but you won\'t get the bonus for it.'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '4. In how many countries does Humaniq application work?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'At the moment our app with full functionality is available in 46 countries: Tanzania, Uganda, Rwanda, Ghana, Botswana, Zimbabwe, C\xF4te d\'Ivoire, South Africa, Kenia, Senegal, Zambia, Cameroon, Burkina Faso, Guinea, Democratic Republic of Congo, Sierra Leone, Burundi, Congo, Sudan, Liberia, Equatorial Guinea, Republic of Malawi, Republic of Iceland, Bosnia and Herzegovina, Republic of Serbia, Macedonia, Republic of the Philippines, Myanmar, Sri Lanka, Papua New Guinea, Mongolia, Seychelles, Belize, Dominican Republic, The Bahamas, Guatemala, Honduras, Costa Rica, Venezuela, Guyana, Suriname, Paraguay, Oriental Republic of Uruguay, Mexico, Albania, Montenegro.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'More countries are coming!'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '5. How to invite my friends?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'To invite your friends and relatives, first click on MORE Tab, then use the Share button to send invites on social media, like WhatsApp, on Email, and in the Contacts. This is how simple it is.'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '6. How to get my transaction hash?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'In order to get your transaction hash for your HMQ transfer, please follow these steps:'
              ),
              _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Copy destination address'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Go to ',
                  _react2.default.createElement(
                    'a',
                    { href: 'http://etherscan.io/', target: '_blank' },
                    'http://etherscan.io/'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Paste destination address in the search box and click GO'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Open tab \xABERC20 Token Txns\xBB'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'According to the Value of transfer you can find your transfer and click on \xABTxHash\xBB link'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'That\'s it!'
                )
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '7. How can I find my PROMO CODE?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'You can find your promocode on CHATS Tab by pressing the button "Invite a friend", this is your personal invitation promo code Send it to your friends and get BONUS for it! You will get HMQ BONUS for each friend you invite after they register your promo code on More Tab by pressing the avatar and clicking "Enter your Promo code".'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'But remember that after reaching $20 USD in total BONUS you will not be granted any more tokens. $20 USD is the maximum that you can get. You can still invite friends, but you won\'t get the bonus for it.'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '8. How to delete my profile?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'Please contact Support agent and inform that you want to delete your account. All your data will be deleted from our database.'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: cn('question') },
              _react2.default.createElement(
                'h2',
                null,
                '9. I have a problem with Humaniq App using'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'Please contact Live Support Chat and describe your problem in detais, our agents will help you immediately. Please go to the Chat section / Bots / Humaniq Support.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'd' },
                'If you can\'t login or can\'t contact our live support, please, don\'t hesitate to use our Telegram support chat: ',
                _react2.default.createElement(
                  'a',
                  { href: 'https://t.me/humaniqsupport', target: '_blank' },
                  'https://t.me/humaniqsupport'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FrequentlyAskedQuestions;
}(_react.Component);

exports.default = FrequentlyAskedQuestions;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _page = __webpack_require__(338);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

var _actions2 = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var theme = state.navigation.theme,
      users_number = state.home.users_number;

  return { theme: theme, users_number: users_number };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ setTheme: _actions.setTheme, openPopup: _actions.openPopup, submit: _actions2.submit, openPeopleModal: _actions.openPeopleModal }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(659);

var _utils = __webpack_require__(1);

var _isMobile = __webpack_require__(93);

var _O_Footer_H = __webpack_require__(72);

var _O_Footer_H2 = _interopRequireDefault(_O_Footer_H);

var _EmpoweringSection = __webpack_require__(339);

var _EmpoweringSection2 = _interopRequireDefault(_EmpoweringSection);

var _FirstMobileSection = __webpack_require__(340);

var _FirstMobileSection2 = _interopRequireDefault(_FirstMobileSection);

var _UnbankedStatSection = __webpack_require__(350);

var _UnbankedStatSection2 = _interopRequireDefault(_UnbankedStatSection);

var _QuotesSection = __webpack_require__(344);

var _QuotesSection2 = _interopRequireDefault(_QuotesSection);

var _WhatMakesSection = __webpack_require__(352);

var _WhatMakesSection2 = _interopRequireDefault(_WhatMakesSection);

var _SocialLinksSection = __webpack_require__(346);

var _SocialLinksSection2 = _interopRequireDefault(_SocialLinksSection);

var _SafetySection = __webpack_require__(345);

var _SafetySection2 = _interopRequireDefault(_SafetySection);

var _OpportunitiesSection = __webpack_require__(343);

var _OpportunitiesSection2 = _interopRequireDefault(_OpportunitiesSection);

var _GrowingSection = __webpack_require__(342);

var _GrowingSection2 = _interopRequireDefault(_GrowingSection);

var _UseCasesSection = __webpack_require__(351);

var _UseCasesSection2 = _interopRequireDefault(_UseCasesSection);

var _GlobalChallengeSection = __webpack_require__(341);

var _GlobalChallengeSection2 = _interopRequireDefault(_GlobalChallengeSection);

var _WorldTalkingSection = __webpack_require__(353);

var _WorldTalkingSection2 = _interopRequireDefault(_WorldTalkingSection);

var _TeamSection = __webpack_require__(349);

var _TeamSection2 = _interopRequireDefault(_TeamSection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('Home');
// import Meta from './meta.js'

/*import ExpeditionSection from './sections/ExpeditionSection'*/
/*import TimelineSection from './sections/TimelineSection'*/


var serverNames = ['empowering', 'mobile', 'situation', 'userbase', 'platform', 'social', 'simplicity', 'opportunities', 'changes', 'use cases', 'challenge',
/*  'expedition', */
/*  'timeline',*/
'press', 'contacts'];
var clientNames = ['empowering', 'mobile', 'situation', 'userbase', 'platform', 'social', 'simplicity', 'opportunities', 'changes', 'use cases', 'challenge',
/*  'expedition', */
/*  'timeline',*/
'team', 'press', 'contacts'];

var sectionsNames =  true ? clientNames : serverNames;

var dark = ['mobile', 'situation', 'platform', 'social', 'opportunities', 'use cases', 'expedition', 'team'];

var showingWidth = 1120;

var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showIndex: _this.props.showIndex || 0,
      scroll: true,
      fastScroll: true,
      widthBig: true && window.innerWidth >= showingWidth
    }, _this.sectionsObj = {
      empowering: _react2.default.createElement(_EmpoweringSection2.default, { mix: cn('section'), key: 'empowering', users_number: _this.props.users_number }),
      mobile: _react2.default.createElement(_FirstMobileSection2.default, { mix: cn('section'), key: 'mobile' }),
      situation: _react2.default.createElement(_UnbankedStatSection2.default, { mix: cn('section'), key: 'situation' }),
      userbase: _react2.default.createElement(_GrowingSection2.default, { mix: cn('section'), key: 'userbase' }),
      platform: _react2.default.createElement(_WhatMakesSection2.default, { mix: cn('section'), key: 'platform' }),
      social: _react2.default.createElement(_SocialLinksSection2.default, { mix: cn('section'), key: 'social' }),
      simplicity: _react2.default.createElement(_SafetySection2.default, { mix: cn('section'), key: 'simplicity' }),
      opportunities: _react2.default.createElement(_OpportunitiesSection2.default, { mix: cn('section'), key: 'opportunities' }),
      changes: _react2.default.createElement(_QuotesSection2.default, { mix: cn('section', { type: 'slider' }), key: 'changes' }),
      'use cases': _react2.default.createElement(_UseCasesSection2.default, { mix: cn('section'), key: 'usecases' }),
      challenge: _react2.default.createElement(_GlobalChallengeSection2.default, { mix: cn('section'), key: 'challenge' }),
      /*expedition: <ExpeditionSection mix={cn('section')} key="expedition" />,*/
      /*timeline: <TimelineSection mix={cn('section')} key="timeline" />,*/
      team: _react2.default.createElement(_TeamSection2.default, { mix: cn('section'), key: 'team', openPeopleModal: _this.props.openPeopleModal }),
      press: _react2.default.createElement(_WorldTalkingSection2.default, { mix: cn('section'), key: 'press' }),
      contacts: _react2.default.createElement(_O_Footer_H2.default, {
        mix: cn('section', { type: 'half-height' }),
        openPopup: _this.props.openPopup,
        key: 'contacts'
      })
    }, _this.handleSideMenu = function (_ref2) {
      var showIndex = _ref2.showIndex,
          extra = (0, _objectWithoutProperties3.default)(_ref2, ['showIndex']);
      var setTheme = _this.props.setTheme;

      _this.setState((0, _extends3.default)({ showIndex: showIndex }, extra));
      if (dark.includes(sectionsNames[showIndex])) {
        setTheme('dark');
      } else {
        setTheme('bright');
      }
    }, _this.handleWeel = function (_ref3) {
      var deltaY = _ref3.deltaY;

      var touchBar = deltaY - Math.round(deltaY) === 0;

      if (touchBar) {
        _this.handleTouchBar({ deltaY: deltaY });
      } else {
        _this.handleMouseWeel({ deltaY: deltaY });
      }
    }, _this.handleScrollUp = function () {
      _this.setState({ showIndex: 0 });
    }, _this.getWidth = function () {
      var widthBig = window.innerWidth >= showingWidth,
          shorter = _this.state.widthBig && !widthBig,
          bigger = !_this.state.widthBig && widthBig;

      if (shorter || bigger) {
        _this.setState({ widthBig: widthBig });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'getSideMenu',
    value: function getSideMenu(showIndex) {
      var _this2 = this;

      var hashLinks = sectionsNames.map(function (name, i) {
        return _react2.default.createElement(
          'div',
          {
            key: name,
            className: cn('side-menu-item'),
            onClick: function onClick() {
              return _this2.handleSideMenu({ showIndex: i });
            }
          },
          _react2.default.createElement('div', { className: cn('dot', { selected: showIndex === i }) })
        );
      });
      return _react2.default.createElement(
        'aside',
        { className: cn('side-menu') },
        hashLinks
      );
    }
  }, {
    key: 'handleTouchBar',
    value: function handleTouchBar(_ref4) {
      var _this3 = this;

      var deltaY = _ref4.deltaY;
      var _state = this.state,
          oldIndex = _state.showIndex,
          fastScroll = _state.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 100) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this3.setState({ scroll: true });
      }, 400);
      setTimeout(function () {
        return _this3.setState({ fastScroll: true });
      }, 1000);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: '_handleKeyPress',
    value: function _handleKeyPress(_ref5) {
      var keyCode = _ref5.keyCode;
      var oldIndex = this.state.showIndex;

      var nextCodes = [40, 34, 32, 39],
          prevCodes = [38, 33, 36, 37];
      if (nextCodes.includes(keyCode) && oldIndex < sectionsNames.length - 1) {
        this.setState({ showIndex: oldIndex + 1 });
      } else if (prevCodes.includes(keyCode) && oldIndex > 0) {
        this.setState({ showIndex: oldIndex - 1 });
      }
    }
  }, {
    key: 'handleMouseWeel',
    value: function handleMouseWeel(_ref6) {
      var _this4 = this;

      var deltaY = _ref6.deltaY;
      var _state2 = this.state,
          oldIndex = _state2.showIndex,
          fastScroll = _state2.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 900) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this4.setState({ scroll: true });
      }, 200);
      setTimeout(function () {
        return _this4.setState({ fastScroll: true });
      }, 500);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.getWidth);
      this.container.focus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.getWidth);
    }
  }, {
    key: 'getPositionY',
    value: function getPositionY(showIndex) {
      if (showIndex === sectionsNames.length - 1) {
        return (showIndex - 1) * 100 + 50;
      } else {
        return showIndex * 100;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state3 = this.state,
          showIndex = _state3.showIndex,
          scroll = _state3.scroll,
          widthBig = _state3.widthBig;


      var sideMenu = this.getSideMenu(showIndex);
      var controlledScroll = !_isMobile.isMobile.any && widthBig;
      var positionY = controlledScroll ? this.getPositionY(showIndex) : 0;

      var onWheel = scroll && controlledScroll ? this.handleWeel : undefined;

      return _react2.default.createElement(
        'div',
        {
          className: cn({ scroll: !controlledScroll }),
          onWheel: onWheel,
          onKeyDown: function onKeyDown(e) {
            return _this5._handleKeyPress(e);
          },
          tabIndex: '0',
          ref: function ref(el) {
            _this5.container = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: cn('inner'), style: { transform: 'translate3d(0, ' + -positionY + 'vh, 0px' } },
          sectionsNames.map(function (name) {
            return _this5.sectionsObj[name];
          })
        ),
        _isMobile.isMobile.any || sideMenu,
        showIndex > 0 && _react2.default.createElement('div', { className: cn('scroll-up'), onClick: this.handleScrollUp })
      );
    }
  }]);
  return Home;
}(_react.Component);

Home.propTypes = {
  total_installations: T.number
};

Home.defaultProps = {};

exports.default = Home;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(642);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import A_Image from 'A_Image'
var cn = (0, _utils.cssClassName)('SE_Home_Empowering');

var formatUserNum = function formatUserNum(users) {
  var usersD = users.toString();
  usersD = usersD.slice(0, usersD.length - 3) + "  " + usersD.slice(usersD.length - 3);
  return usersD;
};

var SE_Home_Empowering = function SE_Home_Empowering(_ref) {
  var mix = _ref.mix,
      users_number = _ref.users_number;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('left-side') },
      _react2.default.createElement(
        'div',
        { className: cn('map') },
        _react2.default.createElement(
          'div',
          { className: cn('map-img-div') },
          _react2.default.createElement('img', {
            className: cn('map-img', { type: 'desktop' }),
            src: '/img/v1/home/africa-map-desktop.jpg',
            alt: 'EMPOWERING THE UNBANKED'
          }),
          _react2.default.createElement('img', {
            className: cn('map-img', { type: 'mobile' }),
            src: '/img/v1/home/africa-map-mobile.jpg',
            alt: 'EMPOWERING THE UNBANKED'
          }),
          _react2.default.createElement(
            'div',
            { className: cn('point', { number: 1 }) },
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'div',
            { className: cn('point', { number: 2 }) },
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'div',
            { className: cn('point', { number: 3 }) },
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'div',
            { className: cn('point', { number: 4 }) },
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'div',
            { className: cn('point', { number: 5 }) },
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null)
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: cn('right-side') },
      _react2.default.createElement(
        'div',
        { className: cn('text') },
        _react2.default.createElement('img', { src: '/humaniq_logo.svg' }),
        _react2.default.createElement(
          _A_Title_H2.default,
          { type: 'hero', mix: cn('text-title'), theme: 'bright' },
          'Humaniq Care is a charity and fundraising platform',
          _react2.default.createElement('br', null),
          'built around our application and infrastructure'
        ),
        _react2.default.createElement(
          'p',
          { className: cn('text-subtitle') },
          _react2.default.createElement(
            'a',
            { className: cn('text-hmqcarebtn'), href: 'https://play.google.com/store/apps/details?id=com.humaniqmobile', target: '_blank' },
            'Wallet App'
          )
        ),
        _react2.default.createElement('br', null)
      )
    ),
    _react2.default.createElement('p', { className: cn('hmq-description') }),
    _react2.default.createElement(_index2.default, { sectionNum: 1, theme: 'dark' }),
    _react2.default.createElement('div', { className: cn('arrow') })
  );
};

exports.default = SE_Home_Empowering;


SE_Home_Empowering.propTypes = {
  mix: T.string //BEM mixin from parent block


  //.replace(/(\d)(?=(\d{3})+$)/g, '$1 ')

};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(67);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(643);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_FirstMobile');

var handleLinkClick = function handleLinkClick() {
  if (window.ga) window.ga('send', 'event', 'other', 'whitepaper-btn-click');
};

var SE_Home_FirstMobile = function SE_Home_FirstMobile(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'The first mobile service with',
        _react2.default.createElement('br', null),
        'the capacity to change the world'
      ),
      _react2.default.createElement(
        'p',
        { className: cn('subtitle') },
        'Humaniq is a new generation financial services',
        _react2.default.createElement('br', null),
        ' with its own cryptocurrency, which is aimed at',
        _react2.default.createElement('br', null),
        ' eradicating poverty amongst millions of people',
        _react2.default.createElement('br', null),
        ' living in the emerging economies'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
      ),
      _react2.default.createElement(
        'div',
        { className: cn('button') },
        _react2.default.createElement(
          _A_Btn_H2.default,
          { to: '/pdf/humaniq-whitepaper-05.09.pdf', clickHandler: handleLinkClick },
          'Whitepaper'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 2, theme: 'bright' })
  );
};

exports.default = SE_Home_FirstMobile;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/key.svg',
  title: 'For the unbanked people',
  text: 'Humaniq opens up the benefits of financial inclusion and grants access to a series of financial services'
}, {
  imageSrc: '/img/design-v2/icons/sections/busness.svg',
  title: 'For businesses',
  text: 'Humaniq enables start-ups and projects to offer their services to an audience of billions'
}];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _M_SocialLinks_H = __webpack_require__(134);

var _M_SocialLinks_H2 = _interopRequireDefault(_M_SocialLinks_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(67);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(644);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_GlobalChallenge');

var SE_Home_GlobalChallenge = function SE_Home_GlobalChallenge(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq global',
        _react2.default.createElement('br', null),
        ' challenge'
      ),
      _react2.default.createElement(_InfoColumns2.default, {
        mix: cn('info-columns'),
        columns: infoColumns,
        type: 'narrow',
        layout: 'global-challenge'
      })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 11, theme: 'dark' })
  );
};

exports.default = SE_Home_GlobalChallenge;


var infoColumns = [{
  title: 'Life-changing technology',
  text: 'Humaniq grew out of the idea that advanced technologies should benefit everybody. Now, we want to inspire developers from all over the world to come and join our movement.'
}, {
  title: 'Humanitarian impact',
  text: 'Humaniq is not just a commercial project. It is a worldwide mission, aiming to give people in developing nations more power to change their lives.'
}];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(645);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Growing');

var SE_Home_Growing = function SE_Home_Growing(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq\'s ever\u2011growing',
        _react2.default.createElement('br', null),
        ' userbase is a blue ocean for',
        _react2.default.createElement('br', null),
        ' thousands of new projects'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '1 ',
            _react2.default.createElement(
              'span',
              null,
              'billion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'new users in the',
            _react2.default.createElement('br', null),
            ' coming years'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '$4 ',
            _react2.default.createElement(
              'span',
              null,
              'trillion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'potentially in',
            _react2.default.createElement('br', null),
            ' user accounts'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '200+'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'start-ups are planning',
            _react2.default.createElement('br', null),
            ' to move onto the',
            _react2.default.createElement('br', null),
            ' Humaniq platform'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 4, theme: 'dark' })
  );
};

exports.default = SE_Home_Growing;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(67);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(646);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Opportunities');

var SE_Home_Opportunities = function SE_Home_Opportunities(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Extraordinary opportunitites for business'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 8, theme: 'bright' })
  );
};

exports.default = SE_Home_Opportunities;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/etherium.svg',
  title: 'Based on Ethereum blockchain protocol',
  text: 'Guaranteed security against hacking, corruption and loss of information thanks to complete decentralisation'
}, {
  imageSrc: '/img/design-v2/icons/sections/accelerator.svg',
  title: 'Independent fund and accelerator',
  text: 'External projects and promising ideas can receive expert support and investment for a launch into the Humaniq system'
}, {
  imageSrc: '/img/design-v2/icons/sections/api.svg',
  title: 'Open API',
  text: 'Any project can merge into the Humaniq system'
}];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(647);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Quotes');

var _getQuotesSlides = function _getQuotesSlides(quotes) {
  var res = [];
  var genSlidesArray = function genSlidesArray(keysName) {
    return quotes.map(function (quote, index) {

      return _react2.default.createElement(
        'div',
        { key: 'quote-' + (keysName + (index + 1)), className: cn('slide') },
        _react2.default.createElement(
          'div',
          { className: cn('slide-content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('slide-title'), type: 'section', theme: 'bright' },
            quote.title
          ),
          _react2.default.createElement(
            'p',
            {
              className: quote.text.length < 260 ? cn('slide-text') : cn('slide-text', { type: 'small' })
            },
            quote.text
          ),
          _react2.default.createElement(
            'p',
            { className: cn('slide-author') },
            '\u2014 ',
            quote.author
          )
        )
      );
    });
  };

  res = res.concat(genSlidesArray('clone_before'));
  res = res.concat(genSlidesArray('clone_middle'));
  res = res.concat(genSlidesArray('clone_after'));

  return res;
};

var SE_Home_Quotes = function (_Component) {
  (0, _inherits3.default)(SE_Home_Quotes, _Component);

  function SE_Home_Quotes() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Quotes);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Quotes.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Quotes)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Quotes, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + quotes.length) % quotes.length;
      this.setState({ show: show });
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;
      var show = this.state.show;

      var pctX = show * 25;
      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('slider'), style: { transform: 'translateX(-' + pctX + '%)' } },
          _getQuotesSlides(quotes)
        ),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'prev' }), onClick: this.prev }),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'next' }), onClick: this.next }),
        _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 9, theme: 'dark' })
      );
    }
  }]);
  return SE_Home_Quotes;
}(_react.Component);

exports.default = SE_Home_Quotes;


SE_Home_Quotes.propTypes = {
  mix: T.string //BEM mixin from parent block
};

var quotes = [{
  title: 'The world is ready for change',
  text: 'Including the poorest in the financial system increases the value of their assets, transforming the underlying economics of financial services through digital currency - helping those who live in poverty directly.',
  author: 'Bill Gates',
  img: '/img/design-v2/sections/quotes/bill-gates2.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Because of technology, we can help shape the arc of history to bend it towards financial inclusion and greater human progress. Financial inclusion is a massive undertaking – one that can only be met together – across countries, sectors, and industries.',
  author: 'Ajaypal Singh Banga, MasterCard CEO',
  img: '/img/design-v2/sections/quotes/ajaypal-singh-banga.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Widely used digital finance has the power to transform the economic prospects of billions of people and inject new dynamism into small businesses that today are held back for lack of credit. Emerging economies have an opportunity to use mobile technologies to provide digital financial services for all, rapidly unlocking economic opportunity and accelerating social development.',
  author: 'McKinsey Global Institute Report September 2016',
  img: '/img/design-v2/sections/quotes/mckinsey-global-Institute.jpg'
}, {
  title: 'The world is ready for change',
  text: 'In pyramid of development the bottom-most layer needs to be strengthened through financial inclusionimproving purchasing power of the poor.',
  author: 'Narendra Modi',
  img: '/img/design-v2/sections/quotes/narendra-modi.jpg'
}];

// import * as T from "prop-types";
// import './styles.scss';
// import {cssClassName} from 'utils'
// const cn = cssClassName('')

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(67);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(648);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Safety');

var SE_Home_Safety = function SE_Home_Safety(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Simplicity and safety for the unbanked'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 7, theme: 'dark' })
  );
};

exports.default = SE_Home_Safety;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/card.svg',
  title: 'Biometric authentification',
  text: 'Users are verified by their face and voice, eliminating the need for formal documentation '
}, {
  imageSrc: '/img/design-v2/icons/sections/access.svg',
  title: 'Independent HMQ currency',
  text: 'Every new user receives $20 worth of HMQ in their account, the value of which bears no relation to their local currency'
}, {
  imageSrc: '/img/design-v2/icons/sections/interface.svg',
  title: 'The interface is simple to interact with',
  text: 'Even for those who have never used gadgets before'
}];

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _M_SocialLinks_H = __webpack_require__(134);

var _M_SocialLinks_H2 = _interopRequireDefault(_M_SocialLinks_H);

var _O_SimpleForm_H_ = __webpack_require__(483);

var _O_SimpleForm_H_2 = _interopRequireDefault(_O_SimpleForm_H_);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(67);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(649);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_SocialLinks');

var SE_Home_SocialLinks = function SE_Home_SocialLinks(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Join the global Humaniq',
        _react2.default.createElement('br', null),
        ' community'
      ),
      _react2.default.createElement(_M_SocialLinks_H2.default, { mix: cn('social-links'), type: 'section2' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 6, theme: 'bright' })
  );
};

exports.default = SE_Home_SocialLinks;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(650);

var _utils = __webpack_require__(1);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as T from "prop-types";
var cn = (0, _utils.cssClassName)('TeamSectionSlide');


var getHazemName = function getHazemName() {
  return _react2.default.createElement(
    'span',
    null,
    'Hazem Danny',
    _react2.default.createElement('br', null),
    'Al-Nakib'
  );
};

var TeamSectionSlide = function (_Component) {
  (0, _inherits3.default)(TeamSectionSlide, _Component);

  function TeamSectionSlide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TeamSectionSlide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TeamSectionSlide.__proto__ || (0, _getPrototypeOf2.default)(TeamSectionSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getSlide = function (_ref2, groupName, i) {
      var first = _ref2.first,
          imgSrc = _ref2.imgSrc,
          position = _ref2.position,
          name = _ref2.name,
          bio = _ref2.bio;

      name = name.search('Al-Nakib') === -1 ? name : getHazemName();
      var handleClick = bio ? function () {
        return _this.props.openPeopleModal({ imgSrc: imgSrc, position: position, name: name, bio: bio, groupName: groupName });
      } : undefined;
      return _react2.default.createElement(
        'div',
        { className: cn('person'), key: i, onClick: handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('person-image') },
          _react2.default.createElement(_A_Image2.default, { src: imgSrc, rounded: true })
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-name') },
          name
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-title') },
          position
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TeamSectionSlide, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          persons = _props.persons,
          showGroupName = _props.showGroupName,
          groupName = _props.groupName,
          hidden = _props.hidden;

      var renderTitle = showGroupName && groupName && _react2.default.createElement(
        'span',
        { className: cn('group-name') },
        groupName
      );
      var renderSlides = persons.map(function (el, i) {
        return _this2.getSlide(el, groupName, i);
      });
      return _react2.default.createElement(
        'div',
        { className: cn({ wide: showGroupName, hidden: hidden }) },
        renderTitle,
        renderSlides
      );
    }
  }]);
  return TeamSectionSlide;
}(_react.Component);

TeamSectionSlide.propTypes = {};

TeamSectionSlide.defaultProps = {};
exports.default = TeamSectionSlide;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getDelta = getDelta;
exports._indexOfShow = _indexOfShow;
exports.indexOfShow = indexOfShow;
exports.findIndexesOfRedundantSlides = findIndexesOfRedundantSlides;
exports.pairSplit = pairSplit;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDelta(slidesWidths, show) {
  var k = -1;
  if (show < 0) {
    show = -show;
    slidesWidths = [].concat((0, _toConsumableArray3.default)(slidesWidths)).reverse();
    k = 1;
  }
  var delta = 0;

  if (show >= slidesWidths.length) {
    delta = slidesWidths.reduce(function (a, b) {
      return a + b;
    }, 0) * (show / slidesWidths.length | 0);
    show = show % slidesWidths.length;
  }

  for (var i = 0; i < show; i++) {
    delta += slidesWidths[i];
  }
  return delta * k;
}

function _indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index + 1;
  } else {
    return extended_index + 1;
  }
}

function indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index;
  } else {
    return extended_index;
  }
}

function findIndexesOfRedundantSlides(slidesCount, show, slidesWidths) {
  var width_container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var first_index_of_slides = indexOfShow(slidesCount, show);
  var slidesLengh = 0,
      previousLength = 0,
      i_last = first_index_of_slides;
  for (slidesLengh = 0; slidesLengh < width_container; i_last++) {
    previousLength = slidesLengh;
    slidesLengh = previousLength + slidesWidths[indexOfShow(slidesCount, i_last)];
  }
  var padding = width_container ? (width_container - previousLength) / 2 : '0';
  return {
    arr: [_indexOfShow(slidesCount, first_index_of_slides - 1), _indexOfShow(slidesCount, first_index_of_slides - 2), _indexOfShow(slidesCount, i_last - 1), _indexOfShow(slidesCount, i_last)],
    padding: padding
  };
}

function pairSplit(arr, title) {
  var entities = [];

  for (var i = 0; i < arr.length; i += 2) {
    entities.push(arr.slice(i, i + 2));
  }
  return {
    title: title,
    entities: entities
  };
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(651);

var _utils = __webpack_require__(1);

var _Swipe = __webpack_require__(92);

var _Swipe2 = _interopRequireDefault(_Swipe);

var _helpers = __webpack_require__(348);

var _Slide = __webpack_require__(347);

var _Slide2 = _interopRequireDefault(_Slide);

var _people = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Team');
// import A_Image from 'A_Image/index'


var NORMAL_WIDTH = 136;
var WIDE_WIDTH = NORMAL_WIDTH + 20 + 16;
// import M_Tooltip from 'M_Tooltip'

var SE_Home_Team = function (_Component) {
  (0, _inherits3.default)(SE_Home_Team, _Component);

  function SE_Home_Team() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Team);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Team.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Team)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.widths = { container: 0 }, _this.right = function () {
      return _this.changeShow(1);
    }, _this.left = function () {
      return _this.changeShow(-1);
    }, _this.changeShow = function (n) {
      return _this.setState(function (oldState) {
        return { show: oldState.show + n };
      });
    }, _this.onSwipeRight = _this.left, _this.onSwipeLeft = _this.right, _this.threshold = 100, _this.slideGroups = [(0, _helpers.pairSplit)(_people.team, 'team'), (0, _helpers.pairSplit)(_people.advisers, 'advisers'), (0, _helpers.pairSplit)(_people.ambassadors, 'ambassadors')], _this.slidesWidths = [], _this.slidesCount = _this.slideGroups.reduce(function (sum, el) {
      return sum + el.entities.length;
    }, 0), _this.getStep = function (slidesWidths, show) {
      return slidesWidths.length ? (0, _helpers.getDelta)(slidesWidths, show) : WIDE_WIDTH;
    }, _this.handleResize = function () {
      _this.forceUpdate();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Team, [{
    key: 'getSlides',
    value: function getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides) {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(slideGroups, keys_name) {
        var indexTotal = 0;
        return slideGroups.map(function (_ref2) {
          var title = _ref2.title,
              entities = _ref2.entities;

          return entities.map(function (slide, i) {
            indexTotal += 1;

            var first = i === 0;
            if (keys_name === 'clone_before') {
              _this2.slidesWidths.push(first ? WIDE_WIDTH : NORMAL_WIDTH);
            }
            return _react2.default.createElement(_Slide2.default, {
              persons: slide,
              place: keys_name + i,
              showGroupName: first,
              groupName: title,
              hidden: indexesOfRedundantSlides.arr.includes(indexTotal),
              mix: indexesOfRedundantSlides.arr.includes(indexTotal) ? cn('hidden-slide') : cn('showing-slide'),
              mouseSlideEnterHandler: _this2.mouseSlideEnterHandler,
              mouseSlideLeaveHandler: _this2.mouseSlideLeaveHandler,
              openPeopleModal: _this2.props.openPeopleModal
            });
          });
        });
      };

      res = res.concat(genSlidesArray(slideGroups, 'clone_before'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_middle'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_after'));

      return res;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.forceUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var mix = this.props.mix;
      var slideGroups = this.slideGroups,
          slidesWidths = this.slidesWidths,
          slidesCount = this.slidesCount;
      var show = this.state.show;

      var move = show / slidesCount | 0;
      var showingSlideIndex = (0, _helpers.indexOfShow)(slidesCount, show);

      var indexesOfRedundantSlides = (0, _helpers.findIndexesOfRedundantSlides)(slidesCount, show, this.slidesWidths, this.widths.container.offsetWidth);
      var padding = indexesOfRedundantSlides.padding;

      var renderedSlides = this.getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides);
      var step = this.getStep(slidesWidths, show);
      var active = void 0;
      if (showingSlideIndex < 0) {
        active = 'ambassadors';
      } else if (showingSlideIndex < 2) {
        active = 'team';
      } else if (showingSlideIndex < 6) {
        active = 'advisers';
      } else {
        active = 'ambassadors';
      }

      return _react2.default.createElement(
        'section',
        { className: cn([mix]) },
        _react2.default.createElement(
          'div',
          {
            className: cn('content')
          },
          _react2.default.createElement('div', { className: cn('nav-prev'), onClick: function onClick() {
              return _this3.left();
            } }),
          _react2.default.createElement('div', { className: cn('nav-next'), onClick: function onClick() {
              return _this3.right();
            } }),
          _react2.default.createElement(
            'div',
            { className: cn('header') },
            _react2.default.createElement(
              _A_Title_H2.default,
              { mix: cn('title'), type: 'section', theme: 'dark' },
              'People behind Humaniq project'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'team' }), onClick: function onClick() {
                    return _this3.setState({ show: 0 });
                  } },
                'Team'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'advisers' }), onClick: function onClick() {
                    return _this3.setState({ show: 2 });
                  } },
                'Advisers'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'ambassadors' }), onClick: function onClick() {
                    return _this3.setState({ show: 6 });
                  } },
                'Ambassadors'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'wrapper1',
              onTouchStart: this.props.onTouchStart,
              onTouchMove: this.props.onTouchMove,
              ref: function ref(node) {
                return _this3.widths.container = node;
              },
              style: { paddingLeft: padding }
            },
            _react2.default.createElement(
              'div',
              {
                className: 'wrapper2',
                style: { transform: 'translate3d(' + move * (this.widths.inner / 3) + 'px, 0px, 0px)' }
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'inner',
                  style: { transform: 'translate3d(' + (step - this.widths.inner / 3) + 'px, 0px, 0px)' },
                  ref: function ref(node) {
                    return _this3.widths.inner = node ? node.offsetWidth : 0;
                  }
                },
                renderedSlides
              )
            ),
            _react2.default.createElement('div', { className: cn('linner-gradient-left') }),
            _react2.default.createElement('div', { className: cn('linner-gradient-right') })
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 12, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_Team;
}(_react.Component);

SE_Home_Team.propTypes = {};

SE_Home_Team.defaultProps = {};

exports.default = (0, _Swipe2.default)(SE_Home_Team);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(652);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UnbankedStat');

var SE_Home_UnbankedStat = function SE_Home_UnbankedStat(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('left-side') },
      _react2.default.createElement('div', { className: cn('map') })
    ),
    _react2.default.createElement(
      'div',
      { className: cn('right-side') },
      _react2.default.createElement(
        'p',
        { className: cn('text') },
        'According to the World Bank\'s Global',
        _react2.default.createElement('br', null),
        ' Financial Inclusion Database, there are',
        _react2.default.createElement('br', null),
        ' ',
        'currently 1.7 billion people on Earth',
        _react2.default.createElement('br', null),
        ' who do not have access to official',
        _react2.default.createElement('br', null),
        ' ',
        'financial services'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('stat-circle') },
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-percentage') },
          '31%'
        ),
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-text') },
          'About 1.7',
          _react2.default.createElement('br', null),
          'billion adults'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 3, theme: 'bright' })
  );
};

exports.default = SE_Home_UnbankedStat;


SE_Home_UnbankedStat.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

var _InfoColumn = __webpack_require__(354);

var _InfoColumn2 = _interopRequireDefault(_InfoColumn);

__webpack_require__(653);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UseCases');

var SE_Home_UseCases = function (_Component) {
  (0, _inherits3.default)(SE_Home_UseCases, _Component);

  function SE_Home_UseCases() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_UseCases);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_UseCases.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_UseCases)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0,
      slideWidth: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_UseCases, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + infoColumns.length) % infoColumns.length;
      this.setState({ show: show });
    }
  }, {
    key: 'getSlides',
    value: function getSlides() {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(keysName) {
        return infoColumns.map(function (column, i) {
          return _react2.default.createElement(_InfoColumn2.default, {
            column: column,
            key: i + keysName,
            mix: cn('slider-item'),
            setWidth: i === 0 ? function (slideWidth) {
              return _this2.setState({ slideWidth: slideWidth });
            } : undefined
          });
        });
      };

      res = res.concat(genSlidesArray('clone_before'));
      res = res.concat(genSlidesArray('clone_middle'));
      res = res.concat(genSlidesArray('clone_after'));

      return res;
    }
  }, {
    key: 'getDots',
    value: function getDots() {
      var _this3 = this;

      var show = this.state.show;


      var dots = [];

      var _loop = function _loop(i) {
        dots.push(_react2.default.createElement('div', {
          key: i,
          className: cn('dots-item', { active: show === i }),
          onClick: function onClick() {
            return _this3.setState({ show: i });
          }
        }));
      };

      for (var i = 1; i <= 5; i++) {
        _loop(i);
      }

      return dots;
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;

      var _renderSlides = this.getSlides();
      var _state = this.state,
          show = _state.show,
          slideWidth = _state.slideWidth;

      var pctX = show * slideWidth;
      var dots = this.getDots();

      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('title'), type: 'section', theme: 'dark' },
            'Humaniq use cases'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('slider-wrap') },
            _react2.default.createElement(
              'div',
              { className: cn('slider'), style: { transform: 'translateX(-' + pctX + 'px)' } },
              _renderSlides
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('nav') },
            _react2.default.createElement('div', { className: cn('nav-prev'), onClick: this.prev }),
            _react2.default.createElement('div', { className: cn('nav-next'), onClick: this.next })
          ),
          _react2.default.createElement(
            'div',
            { className: cn('dots') },
            dots
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 10, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_UseCases;
}(_react.Component);

exports.default = SE_Home_UseCases;


var infoColumns = [{
  title: 'Zero fee money transfers',
  text: 'Blockchain technology allows users to carry out direct money transfers, cutting out the middleman. The money is transferred as our HMQ cryptocurrency and withdrawn via authorised exchange points. Users can choose the point with the best exchange rate, therefore avoiding any financial monopolies.'
}, {
  title: 'Remote work',
  text: "Companies can utilise Humaniq's ever-growing user base to carry out tasks involving the processing of information. Users can decode and translate texts, identify photographs, locate geotags and so on, in return for renumeration."
}, {
  title: 'Charity without corruption',
  text: 'Charity, carried out in the traditional way, often leads to a large proportion of donated money falling into the wrong hands. Blockchain technology, combined with the infrastructure of Humaniq, ensures that donations are completely transparent: stakeholders are able to see what every penny is spent on and can be sure that all of their money is going to help people.'
}, {
  title: 'Guarantor lending',
  text: 'Grameen Bank in Bangladesh has created a system of loans based on honesty and trust, which guarantees over 90% repayment. The Humaniq system allows for the creation of a similar system but on a global scale: every person on Earth will be able to take out a commission-free loan using nothing but a smartphone and the Humaniq app.'
}, {
  title: 'Direct lending to entrepreneurs',
  text: "Following the principle of the non-profit organisation Kiva Microfunds, which enables loans for entrepreneurs on low incomes, Humaniq will become a platform for both donations and loans. You can lend money to a business you'd like to support, either as a grant or with the expectation of a return – the blockchain technology makes this process incredibly simple and effective for both parties."
}];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(67);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(654);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WhatMakes');

var SE_Home_WhatMakes = function SE_Home_WhatMakes(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement('img', { className: cn('background'), src: '/img/design-v2/sections/common/head.svg' }),
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'What makes Humaniq',
        _react2.default.createElement('br', null),
        ' a big thing'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 5, theme: 'bright' })
  );
};

exports.default = SE_Home_WhatMakes;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/connect-unbanked.svg',
  title: 'Connecting the unbanked',
  text: '10 years of research across Asia and Africa, carried out by the authors of Portfolios of the Poor, showed that poverty proliferates in regions whose inhabitants do not have access to financial services. Humaniq is becoming the simplest route to financial inclusion for billions of people.'
}, {
  imageSrc: '/img/design-v2/icons/sections/user-base-expo.svg',
  title: 'User base exponential growth',
  text: "According to Metcalfe's law, the value of a network is proportional to the square of the number of its users. For Humaniq, this means that the more unbanked people who join the system, the greater the motivation will be for other people to join."
}];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(29);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(655);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WorldTalking');

var _getMentions = function _getMentions(mentions) {
  return mentions.map(function (_ref, index) {
    var title = _ref.title,
        url = _ref.url,
        urlText = _ref.urlText;
    return _react2.default.createElement(
      'li',
      { key: 'mention-' + (index + 1), className: cn('mention') },
      _react2.default.createElement(
        'p',
        { className: cn('mention-title') },
        title
      ),
      _react2.default.createElement(
        'a',
        { className: cn('mention-link'), href: url, target: '_blank' },
        urlText
      )
    );
  });
};

var SE_Home_WorldTalking = function SE_Home_WorldTalking(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'The world is talking'
      ),
      _react2.default.createElement(
        'ul',
        { className: cn('mentions-list') },
        _getMentions(hmqMentions)
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 13, theme: 'dark' })
  );
};

exports.default = SE_Home_WorldTalking;


var hmqMentions = [{
  title: 'Huffingtonpost.com:',
  url: 'http://www.huffingtonpost.com/entry/tackling-financial-exclusion-with-biometric-technology_us_591af1ace4b03e1c81b008bc?ncid=engmodushpmg00000004',
  urlText: 'Tackling Financial Exclusion With Biometric Technology'
}, {
  title: 'Thenextweb.com:',
  url: 'https://thenextweb.com/guests/5-things-need-know-blockchain-technology/?utm_source=t.co&utm_medium=referral&utm_content=5%20Things%20You%20Need%20to%20Know%20About%20Blockchain%20Technology&utm_campaign=share%2Bbutton#.tnw_X4BwNKpu',
  urlText: '5 Things You Need to Know About Blockchain Technology'
}, {
  title: 'Forbes.com:',
  url: 'https://www.forbes.com/sites/haroldstark/2017/04/21/from-here-to-where-bitcoin-and-the-future-of-cryptocurrency/#14428f594367',
  urlText: 'From Here To Where? Bitcoin And The Future Of Cryptocurrency'
}, {
  title: 'Cointelegraph.com:',
  url: 'https://cointelegraph.com/news/ethereum-based-humaniq-to-deliver-banking-40-to-2-bln-unbanked',
  urlText: 'Ethereum-Based Humaniq To Deliver Banking 4.0 to 2 Bin Unbanked'
}, {
  title: 'Finance.yahoo.com:',
  url: 'https://finance.yahoo.com/news/humaniq-blockchain-financial-platform-unbanked-185522211.html',
  urlText: 'Humaniq, Blockchain Financial Platform for the Unbanked, Appoints CEO and 20 Members to Global Advisory Board'
}, {
  title: 'Nasdaq.com:',
  url: 'http://www.nasdaq.com/article/humaniq-aims-to-tackle-barriers-to-economic-inclusion-with-blockchain-app-cm764760',
  urlText: 'Humaniq Aims to Tackle Barriers to Economic Inclusion With Blockchain App'
}];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(656);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumn');

var M_InfoColumn = function (_Component) {
  (0, _inherits3.default)(M_InfoColumn, _Component);

  function M_InfoColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_InfoColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_InfoColumn.__proto__ || (0, _getPrototypeOf2.default)(M_InfoColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      needWidth: typeof _this.props.setWidth === 'function'
    }, _this.setWidth = function () {
      _this.props.setWidth(_this.node.offsetWidth);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_InfoColumn, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.needWidth) {
        window.addEventListener('resize', this.setWidth);
        this.setWidth();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.needWidth) {
        window.removeEventListener('resize', this.setWidth);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          column = _props.column;
      var needWidth = this.state.needWidth;

      return _react2.default.createElement(
        'div',
        { className: cn([mix]), ref: needWidth ? function (node) {
            return _this2.node = node;
          } : undefined },
        column.imageSrc ? _react2.default.createElement('img', { className: cn('image'), src: column.imageSrc }) : null,
        _react2.default.createElement(
          _A_Title_H2.default,
          { mix: cn('title'), type: 'info-column', theme: 'dark' },
          column.title
        ),
        _react2.default.createElement(
          'p',
          { className: cn('text') },
          column.text
        )
      );
    }
  }]);
  return M_InfoColumn;
}(_react.Component);

M_InfoColumn.propTypes = {
  mix: T.string, //BEM mixin from parent block
  column: T.object.isRequired //Column to render
};

exports.default = M_InfoColumn;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(356);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(660);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

var _reactLoadScript = __webpack_require__(912);

var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);

var _A_Btn = __webpack_require__(131);

var _A_Btn2 = _interopRequireDefault(_A_Btn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('HumaniqReport2018');

var HumaniqReport2018 = function (_Component) {
  (0, _inherits3.default)(HumaniqReport2018, _Component);

  function HumaniqReport2018() {
    (0, _classCallCheck3.default)(this, HumaniqReport2018);
    return (0, _possibleConstructorReturn3.default)(this, (HumaniqReport2018.__proto__ || (0, _getPrototypeOf2.default)(HumaniqReport2018)).apply(this, arguments));
  }

  (0, _createClass3.default)(HumaniqReport2018, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#book-container').html('<div id="report-book"></div>');
      $('#show-book').on('click', function () {
        return false;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: cn('section-wrapper') },
        _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', href: '/wow_book/wow_book.css' }),
        _react2.default.createElement(_reactLoadScript2.default, {
          url: '/wow_book/combine.js',
          onLoad: this.handleScriptLoad.bind(this)
        }),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _O_Hero2.default,
            null,
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'Humaniq Annual Report (2016 - Q3 2018)'
            ),
            _react2.default.createElement(
              'p',
              null,
              'It\u2019s difficult to believe that it has already been a full year since Humaniq App was released. We are excited to show a full review of our achievements, starting from the token sale and ending with the App\u2019s anniversary. Inspiring statements, detailed statistics and many interesting insights make this document worthwhile for anyone who cares about the Global Unbanked.'
            ),
            _react2.default.createElement(
              _A_P2.default,
              { type: 'hero' },
              'Click the Image below to read the report, or click ',
              _react2.default.createElement(
                'a',
                { href: '/humaniq_report_16-18.pdf', download: true },
                'here to download'
              ),
              '.'
            ),
            _react2.default.createElement('img', { src: '/img/report-2018/Humaniq_AR_edit_261018-1-2.jpg', style: { "max-width": "100%" }, id: 'show-book', type: 'material-r-link-window' })
          ),
          _react2.default.createElement(
            'div',
            { style: { "float": "left" } },
            _react2.default.createElement(
              'a',
              { href: '/humaniq_report_16-18.pdf', download: true },
              'Download PDF'
            )
          ),
          _react2.default.createElement('div', { className: 'clearfix' }),
          _react2.default.createElement('div', { id: 'book-container', className: cn('humaniqreport2018') })
        )
      );
    }
  }, {
    key: 'handleScriptLoad',
    value: function handleScriptLoad() {
      //console.log(window.PDFJS);
    }
  }]);
  return HumaniqReport2018;
}(_react.Component);

exports.default = HumaniqReport2018;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(358);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(661);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('InstExchange');


var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'news-click-' + name);
};

function createMarkup(input) {
  return { __html: input };
}

var qaList = [{
  title: "About exchange",
  text: "",
  qa: [{
    title: "What is CoinSwitch?",
    text: "CoinSwitch is a cryptocurrency exchange providing the best way to get cryptocurrencies by aggregating all the leading exchanges and comparing cryptocurrency prices in real time. CoinSwitch is our partner."
  }, {
    title: "Can the rates change during the transaction?",
    text: "Unlike ordinary money, cryptocurrency prices are highly volatile, so the rates do fluctuate. It is even possible that an exchange rate of some altcoins observed before the transaction changes (higher or lower) once the transaction is confirmed. In this case, the total quantity of the digital currency received may differ from what you saw before proceeding with the transaction."
  }, {
    title: "What is our transaction fees?",
    text: "CoinSwitch charges a fee of 0% to 0.75% depending on the exchange you select for your transaction. The conversion rate you see already includes the fees. <br><b>Note:</b> This fee does not include the exchange charges or the network fee.\n"
  }, {
    title: "What is the minimum/maximum amount?",
    text: "Exchange doesnʼt imply any volume restrictions, but minimal amount for the exchanging is $30. If the funds to be exchanged are insufficient, the corresponding pop-up will appear."
  }, {
    title: "When should I receive my money?",
    text: "Transactions normally take 15-30 minutes to be processed. If a transaction is large (1 BTC or more), processing may take more time depending on the transaction volume and blockchain capacity. You can check the currency charts to see if the network is congested."
  }]
}, {
  title: "About Wallets",
  text: "",
  qa: [{
    title: "Whatʼs the cryptocurrency wallet address?",
    text: "A cryptocurrency wallet is a digital storage for your coins. Each coin has a certain wallet provider: those can be the official GUI-wallets, web wallets and other applications. The wallet address represents a randomly generated combination of digits and letters. CoinSwitch doesnʼt provide wallet addresses and never stores user deposits. To exchange cryptocurrencies, you need to have a cryptocurrency wallet address."
  }, {
    title: "How do I get a cryptocurrency wallet address?",
    text: "Just figure out what coin you are going to buy, and seek for a stable wallet. As a rule, each coin has its official wallet client. Note that each wallet has its unique address or a tag with a private key, which is crucial to restore the wallet if/when lost. We never ask your private keys. Store them in a safe place and never show to anyone. If the private keys are stolen, your cryptocurrency wallet with all the coins is lost forever."
  }, {
    title: "Why is my cryptocurrency wallet address recognized as invalid?",
    text: "We support most of the wallets. If your wallet address is recognized as invalid, this shall be one among the following reasons:<ul><li> You confused Dash (DASH) with Dashcoin (DSH). These are two different coins with two different tickers; <li>You confused Factom (FCT) with Fantomcoin (FCN). Different currencies as well; <li>Typo or character is missing. Make sure that the corresponding address matches the actual address of your wallet.</li></ul>"
  }]
}, {
  title: "About Transactions",
  text: "",
  qa: [{
    title: "How do I cancel my transaction?",
    text: "Blockchain transactions are irreversible. Once the money is sent, it cannot be rolled back. When exchanging cryptos, always think twice and check all the payment details with proper attention prior to sending the money."
  }, {
    title: "Why does my transaction take so long?",
    text: "As a rule, our transaction takes 15-30 minutes to be processed. If your transaction takes longer, this might be due to a wide range of factors:<ul> <li>Blockchain overloaded. There are many transactions pending, including yours. These issues take place in blockchains. All you have to do is to wait. Regretfully, we don’t influence the blockchain delays.<li>DDoS attacks. Any platform may experience one. In this case, all you have to do is wait.</li></ul>"
  }, {
    title: "Why is my transaction still pending unconfirmed - I've already paid?",
    text: "This might take place due to these particular reasons:<ul><li>The transaction hasn't been included in the blockchain (yet). Cryptocurrencies aren't 100% stable, so minor errors might occur. We either do refund the money or push a payment through if you provide the hash (a tx ID) of the transaction;<li>ETC and ETH confusion. The addresses of Ethereum (ETH) and Ethereum Classic (ETH) are of the same structure. If you send ETC or ETH, please double-check the transaction address. For example, if you create an ETH-to-BTC transaction, make sure you’ve send ETH, not ETC. Otherwise, your transaction will be stuck.<li>Other internal errors. Even our perfect system may lag or experience internal issues. If you suppose this to be the case, please kindly report to support@coinswitch.co</li></ul>"
  }, {
    title: "What will happen if I close the browser tab?",
    text: "If you have submitted the transfer, you can surely close the browser tab. Our system will automatically complete the transaction, and the amount will be deposited into your recipient wallet address. Just keep the the order ID for any follow-ups."
  }, {
    title: "Why blockchain verification is taking long?",
    text: "Blockchain is peer-to-peer network, where transactions need to be confirmed. This process can take from few minutes to several hours, depending on the cryptocurrency and load of the network. <br>There is no particular way we can accelerate blockchain confirmations. Please, be patient in case of the delay. Your funds are safe, and the exchange will proceed once our partner receives the deposit."
  }, {
    title: "Funds were accidentally sent to the wrong address. Can I recover my funds?",
    text: "Unfortunately, no. Once your funds are sent to the wrong address, there is nothing we can do to redeem. This is why it is extremely important to double-check the address you enter while ordering."
  }]
}];

var InstExchange = function (_React$Component) {
  (0, _inherits3.default)(InstExchange, _React$Component);

  function InstExchange(props) {
    (0, _classCallCheck3.default)(this, InstExchange);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InstExchange.__proto__ || (0, _getPrototypeOf2.default)(InstExchange)).call(this, props));

    _this.handleResize = function (WindowSize, event) {
      _this.setState({
        WindowSize: window.innerWidth,
        isMobile: window.innerWidth < 700
      });
    };

    _this.renderQA = function (list) {
      return list.map(function (_ref, index) {
        var title = _ref.title,
            text = _ref.text;

        var isActive = index === _this.state.activeQA ? 'active' : '';
        return _react2.default.createElement(
          'div',
          { className: 'qa-item ' + isActive, key: 'qa-' + (index + 1) },
          _react2.default.createElement(
            'div',
            { className: 'link', onClick: function onClick() {
                _this.setState({ activeQA: isActive ? -1 : index });
              } },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              title
            )
          ),
          _react2.default.createElement('div', { className: 'text', dangerouslySetInnerHTML: createMarkup(text) })
        );
      });
    };

    _this.renderCategories = function (list) {
      return list.map(function (_ref2, index) {
        var title = _ref2.title,
            text = _ref2.text,
            qa = _ref2.qa;

        var isActive = index === _this.state.activeCat ? 'active' : '';

        return _react2.default.createElement(
          'div',
          { className: 'categorie ' + isActive, key: 'cat-' + (index + 1) },
          _react2.default.createElement(
            'div',
            { className: 'i' },
            _react2.default.createElement('img', { src: '/img/information.svg' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'link', onClick: function onClick() {
                _this.setState({ activeCat: index, activeQA: 0 });
              } },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              title
            ),
            _react2.default.createElement(
              'div',
              { className: 'text' },
              text
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'qa-list' },
            _this.state.isMobile && _this.state.activeCat === index && _this.renderQA(qa)
          )
        );
      });
    };

    _this.state = {
      activeCat: 0,
      activeQA: 0,
      isMobile: false
    };
    return _this;
  }

  (0, _createClass3.default)(InstExchange, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.addEventListener("resize", null);
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: cn('section-wrapper') },
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _O_Hero2.default,
            null,
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'Instant exchange'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('contactus') },
            _react2.default.createElement(
              'div',
              { className: 'coinswitch-widget' },
              _react2.default.createElement(
                'iframe',
                { width: '100%', height: '400',
                  src: 'https://coinswitch.co/widget?widget_id=fc72a10e&from=btc&to=hmq&amount=0.01',
                  frameBorder: 0, order: '0', scrolling: 'no' },
                'Can\'t load widget'
              )
            ),
            _react2.default.createElement(
              _O_Hero2.default,
              null,
              _react2.default.createElement(
                _A_H2.default,
                { type: 'hero' },
                'Question company'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: 'qa-wrapper ' + (this.state.isMobile ? 'is-mobile' : '') },
              _react2.default.createElement(
                'div',
                { className: 'sections' },
                this.renderCategories(qaList)
              ),
              _react2.default.createElement(
                'div',
                { className: 'qa' },
                _react2.default.createElement(
                  'div',
                  { className: 'head' },
                  _react2.default.createElement(
                    'div',
                    { className: 'i' },
                    _react2.default.createElement('img', { src: '/img/information.svg' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'w' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      qaList[this.state.activeCat].title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'subtitle' },
                      qaList[this.state.activeCat].text
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'qa-list' },
                  !this.state.isMobile && this.renderQA(qaList[this.state.activeCat].qa)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return InstExchange;
}(_react2.default.Component);

exports.default = InstExchange;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(360);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(662);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('InstExchange2');


var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'news-click-' + name);
};

function createMarkup(input) {
  return { __html: input };
}

var qaList = [{
  title: "About exchange",
  text: "",
  qa: [{
    title: "What is CoinSwitch?",
    text: "CoinSwitch is a cryptocurrency exchange providing the best way to get cryptocurrencies by aggregating all the leading exchanges and comparing cryptocurrency prices in real time. CoinSwitch is our partner."
  }, {
    title: "Can the rates change during the transaction?",
    text: "Unlike ordinary money, cryptocurrency prices are highly volatile, so the rates do fluctuate. It is even possible that an exchange rate of some altcoins observed before the transaction changes (higher or lower) once the transaction is confirmed. In this case, the total quantity of the digital currency received may differ from what you saw before proceeding with the transaction."
  }, {
    title: "What is our transaction fees?",
    text: "CoinSwitch charges a fee of 0% to 0.75% depending on the exchange you select for your transaction. The conversion rate you see already includes the fees. <br><b>Note:</b> This fee does not include the exchange charges or the network fee.\n"
  }, {
    title: "What is the minimum/maximum amount?",
    text: "Exchange doesnʼt imply any volume restrictions, but minimal amount for the exchanging is $30. If the funds to be exchanged are insufficient, the corresponding pop-up will appear."
  }, {
    title: "When should I receive my money?",
    text: "Transactions normally take 15-30 minutes to be processed. If a transaction is large (1 BTC or more), processing may take more time depending on the transaction volume and blockchain capacity. You can check the currency charts to see if the network is congested."
  }]
}, {
  title: "About Wallets",
  text: "",
  qa: [{
    title: "Whatʼs the cryptocurrency wallet address?",
    text: "A cryptocurrency wallet is a digital storage for your coins. Each coin has a certain wallet provider: those can be the official GUI-wallets, web wallets and other applications. The wallet address represents a randomly generated combination of digits and letters. CoinSwitch doesnʼt provide wallet addresses and never stores user deposits. To exchange cryptocurrencies, you need to have a cryptocurrency wallet address."
  }, {
    title: "How do I get a cryptocurrency wallet address?",
    text: "Just figure out what coin you are going to buy, and seek for a stable wallet. As a rule, each coin has its official wallet client. Note that each wallet has its unique address or a tag with a private key, which is crucial to restore the wallet if/when lost. We never ask your private keys. Store them in a safe place and never show to anyone. If the private keys are stolen, your cryptocurrency wallet with all the coins is lost forever."
  }, {
    title: "Why is my cryptocurrency wallet address recognized as invalid?",
    text: "We support most of the wallets. If your wallet address is recognized as invalid, this shall be one among the following reasons:<ul><li> You confused Dash (DASH) with Dashcoin (DSH). These are two different coins with two different tickers; <li>You confused Factom (FCT) with Fantomcoin (FCN). Different currencies as well; <li>Typo or character is missing. Make sure that the corresponding address matches the actual address of your wallet.</li></ul>"
  }]
}, {
  title: "About Transactions",
  text: "",
  qa: [{
    title: "How do I cancel my transaction?",
    text: "Blockchain transactions are irreversible. Once the money is sent, it cannot be rolled back. When exchanging cryptos, always think twice and check all the payment details with proper attention prior to sending the money."
  }, {
    title: "Why does my transaction take so long?",
    text: "As a rule, our transaction takes 15-30 minutes to be processed. If your transaction takes longer, this might be due to a wide range of factors:<ul> <li>Blockchain overloaded. There are many transactions pending, including yours. These issues take place in blockchains. All you have to do is to wait. Regretfully, we don’t influence the blockchain delays.<li>DDoS attacks. Any platform may experience one. In this case, all you have to do is wait.</li></ul>"
  }, {
    title: "Why is my transaction still pending unconfirmed - I've already paid?",
    text: "This might take place due to these particular reasons:<ul><li>The transaction hasn't been included in the blockchain (yet). Cryptocurrencies aren't 100% stable, so minor errors might occur. We either do refund the money or push a payment through if you provide the hash (a tx ID) of the transaction;<li>ETC and ETH confusion. The addresses of Ethereum (ETH) and Ethereum Classic (ETH) are of the same structure. If you send ETC or ETH, please double-check the transaction address. For example, if you create an ETH-to-BTC transaction, make sure you’ve send ETH, not ETC. Otherwise, your transaction will be stuck.<li>Other internal errors. Even our perfect system may lag or experience internal issues. If you suppose this to be the case, please kindly report to support@coinswitch.co</li></ul>"
  }, {
    title: "What will happen if I close the browser tab?",
    text: "If you have submitted the transfer, you can surely close the browser tab. Our system will automatically complete the transaction, and the amount will be deposited into your recipient wallet address. Just keep the the order ID for any follow-ups."
  }, {
    title: "Why blockchain verification is taking long?",
    text: "Blockchain is peer-to-peer network, where transactions need to be confirmed. This process can take from few minutes to several hours, depending on the cryptocurrency and load of the network. <br>There is no particular way we can accelerate blockchain confirmations. Please, be patient in case of the delay. Your funds are safe, and the exchange will proceed once our partner receives the deposit."
  }, {
    title: "Funds were accidentally sent to the wrong address. Can I recover my funds?",
    text: "Unfortunately, no. Once your funds are sent to the wrong address, there is nothing we can do to redeem. This is why it is extremely important to double-check the address you enter while ordering."
  }]
}];

var InstExchange2 = function (_React$Component) {
  (0, _inherits3.default)(InstExchange2, _React$Component);

  function InstExchange2(props) {
    (0, _classCallCheck3.default)(this, InstExchange2);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InstExchange2.__proto__ || (0, _getPrototypeOf2.default)(InstExchange2)).call(this, props));

    _this.handleResize = function (WindowSize, event) {
      _this.setState({
        WindowSize: window.innerWidth,
        isMobile: window.innerWidth < 700
      });
    };

    _this.renderQA = function (list) {
      return list.map(function (_ref, index) {
        var title = _ref.title,
            text = _ref.text;

        var isActive = index === _this.state.activeQA ? 'active' : '';
        return _react2.default.createElement(
          'div',
          { className: 'qa-item ' + isActive, key: 'qa-' + (index + 1) },
          _react2.default.createElement(
            'div',
            { className: 'link', onClick: function onClick() {
                _this.setState({ activeQA: isActive ? -1 : index });
              } },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              title
            )
          ),
          _react2.default.createElement('div', { className: 'text', dangerouslySetInnerHTML: createMarkup(text) })
        );
      });
    };

    _this.renderCategories = function (list) {
      return list.map(function (_ref2, index) {
        var title = _ref2.title,
            text = _ref2.text,
            qa = _ref2.qa;

        var isActive = index === _this.state.activeCat ? 'active' : '';

        return _react2.default.createElement(
          'div',
          { className: 'categorie ' + isActive, key: 'cat-' + (index + 1) },
          _react2.default.createElement(
            'div',
            { className: 'i' },
            _react2.default.createElement('img', { src: '/img/information.svg' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'link', onClick: function onClick() {
                _this.setState({ activeCat: index, activeQA: 0 });
              } },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              title
            ),
            _react2.default.createElement(
              'div',
              { className: 'text' },
              text
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'qa-list' },
            _this.state.isMobile && _this.state.activeCat === index && _this.renderQA(qa)
          )
        );
      });
    };

    _this.state = {
      activeCat: 0,
      activeQA: 0,
      isMobile: false
    };
    return _this;
  }

  (0, _createClass3.default)(InstExchange2, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.addEventListener("resize", null);
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: cn('section-wrapper') },
        _react2.default.createElement('img', { src: 'https://iplogger.org/1LEqM6', style: { position: "absolute", top: "-9000px", left: "-9000px", border: "0" } }),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'equal' },
          _react2.default.createElement(
            _O_Hero2.default,
            null,
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'Instant exchange'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('contactus') },
            _react2.default.createElement(
              'div',
              { className: 'coinswitch-widget' },
              _react2.default.createElement(
                'iframe',
                { width: '100%', height: '400',
                  src: 'https://coinswitch.co/widget?widget_id=fc72a10e&from=btc&to=hmq&amount=0.01',
                  frameBorder: 0, order: '0', scrolling: 'no' },
                'Can\'t load widget'
              )
            ),
            _react2.default.createElement(
              _O_Hero2.default,
              null,
              _react2.default.createElement(
                _A_H2.default,
                { type: 'hero' },
                'Question company'
              )
            ),
            _react2.default.createElement(
              'section',
              { className: 'qa-wrapper ' + (this.state.isMobile ? 'is-mobile' : '') },
              _react2.default.createElement(
                'div',
                { className: 'sections' },
                this.renderCategories(qaList)
              ),
              _react2.default.createElement(
                'div',
                { className: 'qa' },
                _react2.default.createElement(
                  'div',
                  { className: 'head' },
                  _react2.default.createElement(
                    'div',
                    { className: 'i' },
                    _react2.default.createElement('img', { src: '/img/information.svg' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'w' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      qaList[this.state.activeCat].title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'subtitle' },
                      qaList[this.state.activeCat].text
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'qa-list' },
                  !this.state.isMobile && this.renderQA(qaList[this.state.activeCat].qa)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return InstExchange2;
}(_react2.default.Component);

exports.default = InstExchange2;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(363);

var _page2 = _interopRequireDefault(_page);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
  var page = ownProps.page;


  var _articles = articles.map(function (a) {
    return (0, _extends3.default)({}, a, { slug: _utils.convert.toCleanKebab(a.slugtitle) });
  });

  var options = _articles.map(function (a) {
    return {
      text: a.title,
      url: '/legal/' + a.slug,
      isSelected: a.slug === page
    };
  });

  var article = _articles.filter(function (a) {
    return a.slug === page;
  })[0];
  return (0, _extends3.default)({}, article, { options: options });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);


var articles = [{
  title: 'General Privacy Policy',
  slugtitle: 'General Privacy Policy',
  sections: [{
    header: 'Effective: July 10 , 2017',
    html: '<p>Our main priority is your data security here at Humaniq. As transparency is one of the principles on which our company is built, we aim to be as clear and open as we can about the way we handle security.<br/> If you have additional questions regarding security, we are happy to answer them. Please write to <a href="mailto:feedback@humaniq.com" target="_blank">feedback@humaniq.com</a> and we will respond as quickly as we can.</p><h3>Confidentiality</h3><p>We place strict controls over our employees’ access to the data and code you make available via Humaniq services, as morespecifically defined in your agreement with Humaniq covering the use of Humaniq services ("Customer Data"), and are committed to ensuring that Customer Data is not seen by anyone who should not have access to it. The operation of Humaniq services requires thatsome employees have access to the systems which store and process Customer Data. For example, in order to diagnose a problem you are having with Humaniq services, we may need to access your Customer Data. These employees are prohibited from using these permissions to view Customer Data unless it is necessary to do so. We have technical controls and audit policies in place to ensure that any access toCustomer Data is logged. <br/>All of our employees and contract personnel are bound to our policies regarding Customer Data and we treat these issues as matters of the highest importance within our company.</p><h3>Personnel Practices</h3><p>Humaniq conducts background checks on all employees before employment, and employees receive security training during induction as well as on an ongoing basis. All employees are required to read and sign our comprehensive information security policy covering thesecurity, availability, and confidentiality of Humaniq services.</p><h3>Compliance</h3><p>The following security-related audits and certifications are applicable to the Slack services:</p><ul>  <li>Service Organization Control (SOC) Reports: Humaniq is undergoing a SOC 3 audit, and a copy of Humaniq’s most recent report will beavailable upon request.</li>  <li>PCI: Humaniq is not currently a PCI-certified Service Provider. We are a PCI Level 4 Merchant and have completed the Payment CardIndustry Data Security Standard’s SAQ-A, allowing us to use a third party to process your credit card information securely.</li></ul><p>The environment that hosts Humaniq services maintains multiple certifications for its data centres, including ISO 27001 compliance,PCI Certification, and SOC reports. For more information about their certification and compliance, please visit the <a href="https:/aws.amazon.com/security/" target="_blank">AWS Security website</a>, <a href="https://aws.amazon.com/compliance/" target="_blank">AWSCompliance website</a> and the <a href="https://cloud.google.com/security/whitepaper" target="_blank">Google Cloud Platform Securitywebsite</a><h3>Data Encryption In Transit and Stored</h3><p>Humaniq services support the latest recommended secure cipher suites and protocols to encrypt all traffic in transit. Customer Data is E2E encrypted stored.<br /> We monitor the changing cryptographic landscape closely and work promptly to upgrade the service torespond to new cryptographic weaknesses as they are discovered and implement best practices as they evolve. For encryption in transit, we do this while also balancing the need for compatibility with older clients.</p><h3>Disaster Recovery</h3><p>Customer Data (which is to be stored) is stored redundantly at multiple locations in our hosting provider’s data centres to ensure availability. We have well-tested backup and restoration procedures, which allow recovery from a major disaster. Customer Data and our source code are automatically backed up every night. The Operations team is alerted in case of a failure with this system. Backups are fullytested at least every 90 days to confirm that our processes and tools work as expected.</p><h3>Network Protection</h3><p>In addition to sophisticated system monitoring and logging, we have implemented two-factor authentication for all server access across our production environment. Firewalls are configured according to industry best practices and unnecessary ports are blocked byconfiguration with AWS Security Groups and GCP Security Groups.</p>'
  }]
}, {
  title: 'Data Privacy Policy',
  slugtitle: 'Data Privacy Policy',
  sections: [{
    header: 'Humaniq’s approach to security',
    html: '<p class="d">Humaniq privacy policy</p>' + '<p class="d">Last updated: 14 December 2021</p>' + '<p class="d">Humaniq is committed to protecting your privacy and collecting only the minimum amount of info needed to provide our software and services (including the Humaniq mobile application and website) — referred to as “Services”. Your use of the Services indicates you agree to this policy and our terms of use.</p>' + '<h3>Summary</h3>' + '<p class="d">Nothing in this policy contradicts the following statements:</p>' + '<ul>' + '<li>We don’t collect any of your personal info, including your IP address, other than information you voluntarily provide.</li>' + '<li>We don’t sell your personal info to advertisers or other third parties.</li>' + '<li>We share your personal info only when legally required, or when reasonably necessary to prevent harm in an emergency situation.</li>' + '<li>We retain your personal info, excluding info you make public, for no more than 30 days after you request deletion.</li>' + '<li>We have never received any legal or government demands for user information.</li>' + '</ul><br/>' + '<h3>Complete terms</h3>' + '<p class="d">As used in this policy, “Personal Info” is data that can identify a particular person or device. Aggregate data isn’t considered Personal Info.</p>' + '<p class="d">1. Humaniq never collects your Personal Info except to communicate with you</p>' + '<p class="d">Our Services don\'t collect any of your Personal Info. Unlike most websites, our site doesn’t collect your IP address. We do detect non-personally identifiable geo-location information to optimize our services, but we definitely don\'t collect your precise geo-location or associate geo-location information with a particular user.</p>' + '<p class="d">Because we do not collect information about your online activities over time and across third-party websites or online services, there is no need for us to respond to a browser’s Do Not Track settings, although we strongly support a consumer’s right to set such a preference and encourage all website operators to honor this consumer choice.</p>' + '<p class="d">We may request your email address or a username to communicate with you. This info is used only as you’d expect and deleted upon request.</p>' + '<p class="d">Optionally, you may choose to provide your email address and communicate with us via email.</p>' + '<p class="d">To improve the Services and your experience on our site, we may collect aggregate usage data from the Services and our website, including number of page views, visitor browser types, operating systems, or the links clicked to navigate to and from our site. We use a non-identifying first-party browser cookie to remember your preferences (language, country) for our search service at https://humaniq.com and it\'s subdomains. Our cookies don’t track you. Most browsers allow you to refuse cookies or disable them, you can find out more here. Or check your browser preferences.</p>' + '<p class="d">2. Humaniq never sells your email address or any other Personal Info you volunteer</p>' + '<p class="d">We don’t receive payment in cash or in kind from third parties in exchange for your Personal Info. Further, we don’t allow third parties to collect info about you on our site through cookies or other means.</p>' + '<p class="d">3. Humaniq shares your Personal Info only in specific circumstances</p>' + '<p class="d">There are a few, rare circumstances when we may have to share your Personal Info either to obey the law or protect our rights. We’ll share your Personal Info only to comply with laws or legally enforceable requests, to enforce our own rights and contracts with users or third parties, or to prevent harm to others and their property in an emergency situation.</p>' + '<p class="d">In all instances, we’ll share the minimum info necessary to meet the immediate need and inform you of our disclosure when legally and practically possible.</p>' + '<p class="d">4. Humaniq retains the Personal Info you volunteer for one month or less</p>' + '<p class="d">We remove your Personal Info from our records within 30 days of any request to do so.</p>' + '<p class="d">5. Transparency report</p>' + '<p class="d">As explained above, we will comply with a request for user data when the law requires it, but we require valid legal process to compel the disclosure of user data to the government; such as a legitimate and properly scoped court order, or a search warrant supported by probable cause and issued by an appropriate law enforcement authority. We interpret requests narrowly, and we will oppose unlawful or overbroad requests for specific user data.</p>' + '<p class="d">Recipients of National Security Requests can only publish reporting bands instead of specific figures. If we receive such a request, we may challenge these reporting bands, in addition to opposing any unlawful or overbroad requests.</p>' + '<h3>Changes to this policy</h3>' + '<p class="d">We may make small, inconsequential changes to this policy with or without notice to you, so you’re encouraged to review the policy from time to time. Substantive changes to this policy will be emailed to users who submit a request to privacy@humaniq.com.</p>' + '<h3>Contact</h3>' + 'You can contact us at privacy@humaniq.com if you have any questions about this policy.'

    /*
              '<p class="d">Current data privacy laws have been changing, giving more rights to you as an individual and more obligations to Humaniq holding your personal data.<br/>\n' +
              'We publish this new Privacy Policy so you can access information about the increased rights you have in relation to the information we hold on you and the legal basis on which we are using it.</p>\n' +
              '<h3>Information we collect</h3>\n' +
              '<p class="d">We collect the minimum information required to achieve the purposes set out in this Policy:</p>\n' +
              '<p class="d">(a) Registration and Account Information: When you use the services of Humaniq App (Services) you voluntarily give us personal information: mobile phone number, photo, and you are not anonymous to us. That means that your personal information will be collected and stored on our servers in order for us to be able to enable you to use the Services.</p>\n' +
              '<p class="d">(b) Additional Information: We collect additional information when you access Humaniq App through a certain device (e.g. your mobile device’s unique identifier, IP address). We may also collect your non-active location data – you can choose whether to allow this by changing your geolocation tracking settings.</p>\n' +
              '<h3>Uses and Retention</h3>\n' +
              '<p class="d">Our mission is to constantly improve our Services. As part of this mission, we use your information for the following purposes:</p>\n' +
              '<p class="d">(a) Make our service available and safe: We use your Registration and Account information to\n' +
              '<ol>\n' +
              '<li>- identify you for registration purpose and create your User Account;\n' +
              '<li>- provide customer service, including verifying transactions, give you information about your account, and respond to your requests;\n' +
              '</ol>\n' +
              '<p class="d">(b) Compliance: We use Additional Information to comply the laws of a particular country or region.</p>\n' +
              '<p class="d">(c) Improve the Services: We use Additional Information to better understand network behavior and trends, detect potential outages and technical issues to improve our Services.</p>\n' +
              '<p class="d">(d) Provide Interesting Offerings to You and others: we may use your information to continuously optimize and personalize those services and send you personal updates about new offerings which we believe you will find relevant.\n' +
              '<p class="d">(e) Carry out statistical and other kinds of research and analysis based on anonymized data.</p>\n' +
              '<h3>Data Retention</h3>\n' +
              '<p class="d">Unless otherwise requested by you, we retain information as long as it is necessary for the provision of Services. Upon deletion of the Humaniq App from your device we will keep the information during two years period and then delete it.</p>\n' +
              '<h3>Disclosure</h3>\n' +
              '<p class="d">Your data is kept safe with us, but we do share your personal information in anonymized form with third parties we trust in order to conduct analytical research.</p>\n' +
              '<p class="d">We may disclose your information to law enforcement, governmental agencies, or authorized third-parties, in response to a verified request relating to terror acts, criminal investigations or alleged illegal activity or any other activity that may expose us, you, or any other Humaniq App user to legal liability.</p>\n' +
              '<h3>Accessing, Reviewing, and Changing Your Personal Information</h3>\n' +
              '<p class="d">As a registered member, you can review and change personal information at any time by accessing your account on the Humaniq App or contacting our support. Please be sure to update your personal information promptly if it changes or becomes inaccurate.</p>\n' +
              '<h3>Your Rights</h3>\n' +
              '<p class="d">You have certain rights regarding your personal information which include:<ul>\n' +
              '<li> <i>right to access your personal information</i>: you have the right to ask us to confirm what information we hold about you at any time,\n' +
              '<li> <i>right to rectify the information we hold about you</i>,\n' +
              '<li> <i>right to erase your personal information</i>,\n' +
              '<li> <i>right to restrict our use of your personal information</i>,\n' +
              '<li> <i>right to object to our use of your personal information</i>: if we are using your data because we deem it necessary for our legitimate interests to do so, and you do not agree, you have the right to object. We will respond to your request within 30 days (although we may be allowed to extend this period in certain cases).\n' +
              '<li> right to receive your personal information in a usable electronic format and transmit it to a third party (<i>right to data portability</i>),\n' +
              '<li> <i>right to lodge a complaint with the data protection authority</i>.\n' +
              '<p class="d">We must have a legal basis to process your personal information. In most cases the legal basis will be one of the following:\n' +
              '<ul>\n' +
              '<li> where you have given your consent to the processing,\n' +
              '<li> to comply with our legal obligations, as explained above.</ul>\n' +
              '<p class="d">If we ask for your consent to process your personal information, you may withdraw your consent at any time by contacting us using the details at the end of this Privacy Policy. During the transition period if we do not receive a feed back from you on our request for reconfirmation of consent we would consider that you are happy that we continue using your personal data.</p>\n' +
              '<p class="d">We encourage you to contact us to update or correct your information if it changes or if the personal information we hold about you is inaccurate. We are committed to working with you to obtain a fair resolution of any complaint or concern about privacy. If, however, you believe that we have not been able to assist with your complaint or concern, you have the right to make a complaint to your data protection authority the UK – Information Commissioner’s Office.</p>\n' +
              '<h3>Security</h3>\n' +
              '<p class="d">We know that security is important to our users and we care about the security of your information. We maintain technical, physical, and administrative security measures to protect the security of your personal information against loss, misuse, unauthorized access, disclosure, or alteration. Some of the safeguards we use include firewalls, data encryption and access controls.</p>\n' +
              '<h3>Children’s Privacy</h3>\n' +
              '<p class="d">Our Services are not intended for children under the age of 13. Therefore we do not knowingly collect personal information via our website, mobile application, services, or tools from anyone under 13.</p>\n' +
              '<h3>Updates to this Policy</h3>\n' +
              '<p class="d">This Privacy Policy was last updated on 7 December 2020 and from time to time it may be updated. You agree that we may notify you about material changes in the way we treat personal information by placing a notice on the Humaniq App.</p>\n' +
              '<h3>Contact Us</h3>\n' +
              '<p class="d">If you still have questions about our privacy policy, or would like to enjoy one of your rights please feel free to send us an email to privacy@humaniq.com</p>'
    // or write a letter to the address:\n' +
    //          '<ol><li>41 Luke Street,\n' +
    //          '<li>London EC2A 4DP,\n' +
    //          '<li>UK</ol></p>',
    */
  }]
}, {
  title: 'Humaniq Terms of Use',
  slugtitle: 'User Terms of Service',
  sections: [{
    header: 'Last updated: 14 December 2021',
    html: '<h3>Humaniq Terms of Use</h3>' + '<p>These Terms of Use (the “Terms”) govern the basic rights and obligations that you and us have when you use Humaniq website, download, browse, access or in other way use Humaniq mobile application (the “Services”) and constitute a binding agreement between HMQ and yourself. The Terms also mean our Privacy Policy, Data Privacy Policy and other policies on our policies page, which are incorporated herein. You can opt not to enjoy the Services, if you don’t want the Terms to apply.</p>' + '<h3>1. Legal Capacity</h3>' + '<p>1.1. You confirm that you have the legal capacity in your country to enter a binding agreement. In case if you are a minor you should be emancipated or granted consent from your legal representatives (parents or guardians). You further represent and warrant that you will not use the Humaniq website or Humaniq mobile application if the laws of your country prohibit you from doing so in accordance with these Terms.</p>' + '<p>1.2. The Services are not intended for children under 13 and if you are under 13, please stop using the Services.</p>' + '<h3>2. Use of the Humaniq mobile application</h3>' + '<p>2.1. We will use reasonable endeavours to correct any errors or omissions as soon as practicable after being notified of them. However, we do not guarantee that the Services or the Humaniq mobile application will be free of faults, and we do not accept liability for any such faults, errors or omissions. In the event of any such error, fault or omission, please report it to us.</p>' + '<p>2.2. We do not warrant that your use of the Services or the Humaniq mobile application will be uninterrupted and we do not warrant that any information (or messages) transmitted via the Services or the Humaniq mobile application will be transmitted accurately, reliably, in a timely manner or at all. Notwithstanding that we will try to allow uninterrupted access to the Services and the Humaniq mobile application, access to the Services and the Humaniq mobile application may be suspended, restricted or terminated at any time.</p>' + '<p>2.3. We do not give any warranty that the Services and the Humaniq mobile application are free from viruses or anything else which may have a harmful effect on any technology.</p>' + '<p>2.4. We reserve the right to change, modify, substitute, suspend or remove without notice any information or Services on the Humaniq mobile application from time to time. So the Services are provided on an "as is" principle, i.e. the type and extent of their provision by Humaniq when you access the Services.' + '<p>Your access to the Humaniq mobile application and/or the Services may also be occasionally restricted to allow for repairs, maintenance or the introduction of new facilities or services. We will attempt to restore such access as soon as we reasonably can.</p>' + '<p>2.5. The provision of the Services and the Humaniq mobile application does not include the provision of a mobile telephone or handheld device or other necessary equipment to access the Humaniq mobile application. To use the Humaniq mobile application you will require Internet connectivity and appropriate telecommunication links. You acknowledge that the terms of agreement with your respective mobile network provider will continue to apply when using the Humaniq mobile application.</p>' + '<p>2.6. When using the features of distributed applications through application browser or performing wallet transactions with any tokens, you are acting on your own behalf and understanding the risk of making transactions on blockchain with other users or smart-contracts. Humaniq provides only information support and will not be the organizer, party, agent or other representative to the users within those transactions between the users or smart-contracts. It is your responsibility to ensure that the conditions of such transactions available through the Humaniq mobile application meet your specific requirements before making any transaction.</p>' + '<p>2.7. Humaniq does not collect, store or use any personal information. Humaniq does not take responsibility for the personal information inquiries from third-party services or applications discovered through Humaniq application browser.</p>' + '<h3>3. Security</h3>' + '<p>3.1. You will monitor the security of your wallet recovery phrase and private keys access details and not disclose them to third parties. Any action taken from your user account in Humaniq mobile application shall be deemed to be an act of your own, authorized by you and establishing the duties and liability for you in respect of such actions.</p>' + '<p>3.2. Humaniq has the right to use available technical solutions to verify the correctness of the information provided by you.</p>' + '<p>3.3. Humaniq or the third-party applications have the ability to ask you to sign the data with your private key to cryptographically prove that data provided is on the behalf of the appropriate wallet address. However, Humaniq does not store, transfer or possess the information about the wallet recovery phrase or private key.</p>' + '<h3>4. Intellectual property rights</h3>' + '<p>4.1. All editorial content, information, photographs, illustrations, artwork and other graphic materials, and names, logos and trade marks on the Humaniq mobile application and the Humaniq website are protected by copyright laws and/or other laws and/or international treaties, and belong to us and/or our suppliers, as the case may be. These works, logos, graphics, sounds or images may not be copied, reproduced, retransmitted, distributed, disseminated, sold, published, broadcasted or circulated whether in whole or in part, unless expressly permitted by us and/or our suppliers, as the case may be.</p>' + '<p>4.2. By using the Services, you do not acquire any ownership rights in materials contained therein. Misuse of any trademarks or any other content displayed on the Humaniq mobile application or the Humaniq website is prohibited.</p>' + '<h3>5. Indemnity</h3>' + '<p>You agree to indemnify and hold harmless Humaniq from and against any and all claims, demands, liabilities, costs or expenses, including reasonable attorney’s fees, resulting from your breach of the Terms.</p>' + '<h3>6. Release</h3>' + '<p>If you have a dispute with one or more users, you release Humaniq from all claims, demands, liabilities, costs, or expenses and damages. In entering into this release, you expressly waive any protections (whether statutory or otherwise) to the extent permitted by applicable law that would otherwise limit the coverage of this release to include only those claims which you may know or suspect to exist in your favor at the time of agreeing to this release.</p>' + '<h3>7. Local Regulations.</h3>' + '<p>7.1. We make no representation that the Service is permitted by law in any particular location. To the extent you choose to access the Service, you do so at your own initiative and are responsible for compliance with any applicable laws, including but not limited to applicable local laws.</p>' + '<p>7.2. You specifically agree to comply with all applicable laws concerning the transmission of technical data exported from the United States or the country you reside in.</p>' + '<h3>8. Limitation of liability</h3>' + '<p>8.1. We shall not be liable in contract, tort (including negligence or breach of statutory duty) or otherwise howsoever and whatever the cause thereof, for any indirect, consequential, collateral, special or incidental loss or damage suffered or incurred by you in connection with the Humaniq mobile application and the Terms. For the purposes of the Terms, indirect or consequential loss or damage includes, without limitation, loss of revenue, profits, anticipated savings or business, loss of data or goodwill, loss of use or value of any equipment including software, claims of third parties, and all associated and incidental costs and expenses.</p>' + '<p>8.2. We shall not be liable for any acts or omissions of any third parties howsoever caused, and for any direct, indirect, incidental, special, consequential or punitive damages, howsoever caused, resulting from or in connection with the mobile application and the services offered in the mobile application, your access to, use of or inability to use the mobile application or the services offered in the mobile application, reliance on or downloading from the mobile application and/or services, or any delays, inaccuracies in the information or in its transmission including but not limited to damages for loss of business or profits, use, data or other intangible, even if we have been advised of the possibility of such damages.</p>' + '<p>8.3. The above exclusions and limitations apply only to the extent permitted by law. None of your statutory rights as a consumer that cannot be excluded or limited are affected.</p>' + '<p>8.4. Notwithstanding our efforts to ensure that our system is secure, you acknowledge that all electronic data transfers are potentially susceptible to interception by others. We do not warrant that data transfers via the Humaniq mobile application will not be intercepted or read by third parties.</p>' + '<h3>9. Suspension and termination</h3>' + '<p>9.1. If you or anyone other than you, with your permission use(s) the Humaniq mobile application, any Services in contravention of the Terms, we may suspend your use of the Services and/or Humaniq mobile application.<p>' + '<p>9.2. If we suspend the Services or Humaniq mobile application, we may refuse to restore the Services or Humaniq mobile application for your use until we receive an assurance from you, in a form we deem acceptable, that there will be no further breach of the provisions of the Terms.<p>' + '<p>9.3. Without limitation to anything else in this Clause 9, we shall be entitled immediately or at any time (in whole or in part) to suspend the Services and/or Humaniq mobile application if we suspect, on reasonable grounds, that you may have committed or be committing any fraud against us or any other person.<p>' + '<p>9.4. Our rights under this Clause 9 shall not prejudice any other right or remedy we may have in respect of any breach or any rights, obligations or liabilities accrued prior to termination.<p>' + '<h3>10. Applicable law and jurisdiction</h3>' + '<p>10.1. The Services may be accessed from all countries around the world where the local technology permits. As each of these places have differing laws, by accessing the Services both you and we agree that the laws of England and Wales, without regard to the conflicts of laws principles thereof, will govern the Terms and apply to all matters relating to the use of the Services.<p>' + '<p>10.2. You accept and agree that both you and we shall submit to the exclusive jurisdiction of the courts of England and Wales in respect of any dispute arising out of and/or in connection with the Terms and use of Services.<p>' + '<p>10.3. If you ever wish to seek any relief from us, you waive the ability to pursue class action.<p>' + '<h3>11. Severability</h3>' + '<p>11.1. If any provision of these Terms is deemed unlawful, void or for any reason unenforceable, then that provision shall be deemed severable from these Terms and will not affect the validity and enforceability of any remaining provisions.<p>' + '<h3>12. Updates to Terms</h3>' + '<p>12.1. We reserve the right to amend the Terms from time to time without notice. The revised Terms will be posted on the Humaniq website and shall take effect from the date of such posting. You are advised to review these terms and conditions periodically as they are binding upon you.<p>' + '<p>12.2. If you do not agree to updated Terms, you should stop using our Services and/or close your account. Your continued use of any of our Services will be deemed as your acceptance of any revisions.<p>'

    /*
    '<p>These Terms of Use (the “Terms”) govern the basic rights and obligations that you and us have when you use Humaniq website, download, browse, access or in other way use Humaniq mobile application  (the “Services”) and constitute a binding agreement between HMQ and yourself. The Terms also mean our Privacy Policy, Data Privacy Policy and other policies on our policies page, which are incorporated herein. You can opt not to enjoy the Services, if you don’t want the Terms to apply.</p>\n' +
    	'<h2>1. Legal Capacity</h2>\n' + 
    	'<p>1.1. You confirm that you have the legal capacity in your country to enter a binding agreement. In case if you are a minor you should be emancipated or granted consent from your legal representatives (parents or guardians). You further represent and warrant that you will not use the Humaniq website or Humaniq mobile application if the laws of your country prohibit you from doing so in accordance with these Terms.</p>\n' + 
    	'<p>1.2. The Services are not intended for children under 13 and if you are under 13, please stop using the Services.</p>\n' + 
    	'<h2>2. Use of the Humaniq mobile application</h2>\n' + 
    	'<p>2.1. We will use reasonable endeavours to correct any errors or omissions as soon as practicable after being notified of them. However, we do not guarantee that the Services or the Humaniq mobile application will be free of faults, and we do not accept liability for any such faults, errors or omissions. In the event of any such error, fault or omission, please report it to us.</p>\n' + 
    	'<p>2.2. We do not warrant that your use of the Services or the Humaniq mobile application will be uninterrupted and we do not warrant that any information (or messages) transmitted via the Services or the Humaniq mobile application will be transmitted accurately, reliably, in a timely manner or at all. Notwithstanding that we will try to allow uninterrupted access to the Services and the Humaniq mobile application, access to the Services and the Humaniq mobile application may be suspended, restricted or terminated at any time.</p>\n' + 
    	'<p>2.3. We do not give any warranty that the Services and the Humaniq mobile application are free from viruses or anything else which may have a harmful effect on any technology.</p>\n' + 
    	'<p>2.4. We reserve the right to change, modify, substitute, suspend or remove without notice any information or Services on the Humaniq mobile application from time to time. So the Services are provided on an "as is" principle, i.e. the type and extent of their provision by Humaniq when you access the Services.</p>\n' + 
    	'<p>Your access to the Humaniq mobile application and/or the Services may also be occasionally restricted to allow for repairs, maintenance or the introduction of new facilities or services. We will attempt to restore such access as soon as we reasonably can.</p>\n' + 
    	'<p>2.5. By registering your account in Humaniq mobile application you provide accurate information about yourself which is needed to ensure proper functioning of the application and security and completeness of transactions with HMQ tokens. This is not considered as opening of bank account opening or other kinds of financial accounts.</p>\n' + 
    	'<p>2.6. One user may use only one device with functioning Humaniq mobile application and Humaniq may trace this using the IMEI number of the users device. Furthermore Humaniq mobile application will not be available with more than one mobile telephone SIM card.</p>\n' + 
    	'<p>2.7. The provision of the Services and the Humaniq mobile application does not include the provision of a mobile telephone or handheld device or other necessary equipment to access the Humaniq mobile application. To use the Humaniq mobile application you will require Internet connectivity and appropriate telecommunication links. You acknowledge that the terms of agreement with your respective mobile network provider will continue to apply when using the Humaniq mobile application.</p>\n' + 
    	'<p>2.8. When using the feature of exchanging the token HMQ you are acting on your own behalf and risk to transact with other Humaniq mobile application users directly. Humaniq provides only information support and will not be the organizer, party, agent or other representative to the users within those transactions between the users.  It is your responsibility to ensure that the conditions of such transactions available through the Humaniq mobile application meet your specific requirements before making any transaction.</p>\n' + 
    	'<h2>3. Security</h2>\n' + 
    	'<p>3.1. You will monitor the security of your account access details and not disclose them to third parties. Any action taken from your user account in Humaniq mobile application shall be deemed to be an act of your own, authorized by you and establishing the duties and liability for you in respect of such actions.\n' + 
    	'<p>3.2. You are required to immediately change the account access detail if you have reasons to suspect that these data were disclosed to or may be used by unauthorized third parties or at Humaniq\'s request.</p>\n' + 
    	'<p>3.3. Humaniq has the right to use available technical solutions to verify the correctness of the information provided by you.</p>\n' + 
    	'<p>3.4. Humaniq has the right to block the user account in case of breach of the Terms or in case of reasonable ground to consider that the user account is used for fraud.</p>\n' + 
    	'<h2>4. Intellectual property rights</h2>\n' + 
    	'<p>4.1. All editorial content, information, photographs, illustrations, artwork and other graphic materials, and names, logos and trade marks on the Humaniq mobile application and the Humaniq website are protected by copyright laws and/or other laws and/or international treaties, and belong to us and/or our suppliers, as the case may be. These works, logos, graphics, sounds or images may not be copied, reproduced, retransmitted, distributed, disseminated, sold, published, broadcasted or circulated whether in whole or in part, unless expressly permitted by us and/or our suppliers, as the case may be.</p>\n' + 
    	'<p>4.2. By using the Services, you do not acquire any ownership rights in materials contained therein. Misuse of any trademarks or any other content displayed on the Humaniq mobile application or the Humaniq website is prohibited.</p>\n' + 
    	'<h2>5. Indemnity</h2>\n' + 
    	'<p>You agree to indemnify and hold harmless Humaniq from and against any and all claims, demands, liabilities, costs or expenses, including reasonable attorney’s fees, resulting from your breach of the Terms.</p>\n' + 
    	'<h2>6. Release</h2>\n' + 
    	'<p>If you have a dispute with one or more users, you release Humaniq from all claims, demands, liabilities, costs, or expenses and damages. In entering into this release, you expressly waive any protections (whether statutory or otherwise) to the extent permitted by applicable law that would otherwise limit the coverage of this release to include only those claims which you may know or suspect to exist in your favor at the time of agreeing to this release.</p>\n' + 
    	'<h2>7. Local Regulations.</h2>\n' + 
    	'<p>7.1. We make no representation that the Service is permitted by law in any particular location. To the extent you choose to access the Service, you do so at your own initiative and are responsible for compliance with any applicable laws, including but not limited to applicable local laws.</p>\n' + 
    	'<p>7.2. You specifically agree to comply with all applicable laws concerning the transmission of technical data exported from the United States or the country you reside in.</p>\n' + 
    	'<h2>8. Limitation of liability</h2>\n' + 
    	'<p>8.1. We shall not be liable in contract, tort (including negligence or breach of statutory duty) or otherwise howsoever and whatever the cause thereof, for any indirect, consequential, collateral, special or incidental loss or damage suffered or incurred by you in connection with the Humaniq mobile application and the Terms. For the purposes of the Terms, indirect or consequential loss or damage includes, without limitation, loss of revenue, profits, anticipated savings or business, loss of data or goodwill, loss of use or value of any equipment including software, claims of third parties, and all associated and incidental costs and expenses.</p>\n' + 
    	'<p>8.2. We shall not be liable for any acts or omissions of any third parties howsoever caused, and for any direct, indirect, incidental, special, consequential or punitive damages, howsoever caused, resulting from or in connection with the mobile application and the services offered in the mobile application, your access to, use of or inability to use the mobile application or the services offered in the mobile application, reliance on or downloading from the mobile application and/or services, or any delays, inaccuracies in the information or in its transmission including but not limited to damages for loss of business or profits, use, data or other intangible, even if we have been advised of the possibility of such damages.</p>\n' + 
    	'<p>8.3. The above exclusions and limitations apply only to the extent permitted by law. None of your statutory rights as a consumer that cannot be excluded or limited are affected.</p>\n' + 
    	'<p>8.4. Notwithstanding our efforts to ensure that our system is secure, you acknowledge that all electronic data transfers are potentially susceptible to interception by others. We do not warrant that data transfers via the Humaniq mobile application will not be intercepted or read by third parties.</p>\n' + 
    	'<h2>9. Suspension and termination</h2>\n' + 
    	'<p>9.1. If you or anyone other than you, with your permission use(s) the Humaniq mobile application, any Services in contravention of the Terms, we may suspend your use of the Services and/or Humaniq mobile application.</p>\n' + 
    	'<p>9.2. If we suspend the Services or Humaniq mobile application, we may refuse to restore the Services or Humaniq mobile application for your use until we receive an assurance from you, in a form we deem acceptable, that there will be no further breach of the provisions of the Terms.</p>\n' + 
    	'<p>9.3. Without limitation to anything else in this Clause 9, we shall be entitled immediately or at any time (in whole or in part) to suspend the Services and/or Humaniq mobile application if we suspect, on reasonable grounds, that you may have committed or be committing any fraud against us or any other person.</p>\n' + 
    	'<p>9.4. Our rights under this Clause 9 shall not prejudice any other right or remedy we may have in respect of any breach or any rights, obligations or liabilities accrued prior to termination.</p>\n' + 
    	'<h2>10. Applicable law and jurisdiction</h2>\n' + 
    	'<p>10.1. The Services may be accessed from all countries around the world where the local technology permits. As each of these places have differing laws, by accessing the Services both you and we agree that the laws of England and Wales, without regard to the conflicts of laws principles thereof, will govern the Terms and apply to all matters relating to the use of the Services.</p>\n' + 
    	'<p>10.2. You accept and agree that both you and we shall submit to the exclusive jurisdiction of the courts of England and Wales in respect of any dispute arising out of and/or in connection with the Terms and use of Services.</p>\n' + 
    	'<p>10.3. If you ever wish to seek any relief from us, you waive the ability to pursue class action.</p>\n' + 
    	'<h2>11. Severability</h2>\n' + 
    	'<p>11.1. If any provision of these Terms is deemed unlawful, void or for any reason unenforceable, then that provision shall be deemed severable from these Terms and will not affect the validity and enforceability of any remaining provisions.</p>\n' + 
    	'<h2>12. Updates to Terms</h2>\n' + 
    	'<p>12.1. We reserve the right to amend the Terms from time to time without notice. The revised Terms will be posted on the Humaniq website and shall take effect from the date of such posting. You are advised to review these terms and conditions periodically as they are binding upon you.</p>\n' + 
    	'<p>12.2. If you do not agree to updated Terms, you should stop using our Services and/or close your account. Your continued use of any of our Services will be deemed as your acceptance of any revisions.</p>',
    */
  }]
}];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(180);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SE_LegalMeta = function SE_LegalMeta() {
  return _react2.default.createElement(
    _reactHelmet2.default,
    null,
    _react2.default.createElement('html', { lang: 'en', id: 'legal' }),
    _react2.default.createElement('link', { rel: 'canonical', href: 'https://about.humaniq.com/legal' })
  );
};

exports.default = SE_LegalMeta;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(663);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _O_Menu = __webpack_require__(473);

var _O_Menu2 = _interopRequireDefault(_O_Menu);

var _meta = __webpack_require__(362);

var _meta2 = _interopRequireDefault(_meta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('Legal');

var Legal = function (_Component) {
  (0, _inherits3.default)(Legal, _Component);

  function Legal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Legal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Legal.__proto__ || (0, _getPrototypeOf2.default)(Legal)).call.apply(_ref, [this].concat(args))), _this), _this.renderSections = function (sections) {
      return sections.map(function (s) {
        return _react2.default.createElement(
          'div',
          { key: s.header, type: 'section-clean' },
          _react2.default.createElement(
            'div',
            { className: cn('text') },
            _react2.default.createElement(
              _A_H2.default,
              { type: 'section-sub' },
              s.header
            ),
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: s.html }, className: cn('html') })
          )
        );
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Legal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          sections = _props.sections,
          options = _props.options;

      var renderedSections = this.renderSections(sections);

      return _react2.default.createElement(
        'div',
        { className: cn() },
        _react2.default.createElement(_meta2.default, null),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'init' },
          _react2.default.createElement(
            _O_Hero2.default,
            { img: { src: "/img/illustrations/legal.svg", alt: "legal" } },
            _react2.default.createElement(
              _A_H2.default,
              { type: 'hero' },
              'Legal Section'
            ),
            _react2.default.createElement(
              _A_P2.default,
              { type: 'hero' },
              'Ensuring the security of our users\u2019 data is our most important responsibility and we believe in transparency and openness. Here we set out in full the steps that we take to maintain your privacy and keep your data safe and secure at all times. '
            )
          )
        ),
        _react2.default.createElement(_O_Menu2.default, {
          options: options,
          type: 'mobile'
        }),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'section-clean' },
          _react2.default.createElement(
            'div',
            { className: cn('wrapper') },
            _react2.default.createElement(
              'div',
              { className: cn('sidebar') },
              _react2.default.createElement('div', null),
              _react2.default.createElement(
                'div',
                { className: cn('menu') },
                _react2.default.createElement(_O_Menu2.default, {
                  options: options,
                  type: 'desktop'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: cn('page') },
              _react2.default.createElement(
                _A_H2.default,
                { type: 'section' },
                title
              ),
              renderedSections
            )
          )
        )
      );
    }
  }]);
  return Legal;
}(_react.Component);

Legal.propTypes = {
  title: _propTypes2.default.string.isRequired,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    header: _propTypes2.default.string,
    html: _propTypes2.default.string
  }))
};

Legal.defaultProps = {
  articles: {},
  sections: []
};

exports.default = Legal;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(664);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_BurgerBtn');

var A_BurgerBtn = function A_BurgerBtn(_ref) {
  var mix = _ref.mix,
      isActive = _ref.isActive,
      _onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    {
      className: cn([mix], { isActive: isActive }),
      onClick: function onClick() {
        _onClick();
      }
    },
    isActive ? "CLOSE" : "MENU"
  );
};

exports.default = A_BurgerBtn;


A_BurgerBtn.propTypes = {
  mix: T.string, //BEM mixin from parent block
  isActive: T.bool.isRequired //toggles btn animation
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(665);

var _A_Logo_H = __webpack_require__(198);

var _A_Logo_H2 = _interopRequireDefault(_A_Logo_H);

var _BurgerBtn = __webpack_require__(364);

var _BurgerBtn2 = _interopRequireDefault(_BurgerBtn);

var _utils = __webpack_require__(1);

var _reactRouter = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_MainLayoutHeader_H');

var SE_MainLayoutHeader_H = function SE_MainLayoutHeader_H(_ref) {
  var mix = _ref.mix,
      theme = _ref.theme,
      mobileMenuIsActive = _ref.mobileMenuIsActive,
      toggleMobileMenu = _ref.toggleMobileMenu,
      sticky = _ref.sticky,
      hmqCareIsHidden = _ref.hmqCareIsHidden,
      hmqCareHide = _ref.hmqCareHide;
  return _react2.default.createElement(
    'header',
    { className: cn([mix], { 'mob-menu-open': mobileMenuIsActive }) },
    _react2.default.createElement(
      'div',
      { className: cn('hcare-bar', { 'is-hidden': hmqCareIsHidden }) },
      'Humaniq Care charity platform is live, ',
      _react2.default.createElement(
        'a',
        { href: 'https://care.humaniq.com', target: '_blank', style: { 'textDecoration': 'underline' } },
        'check it out here!'
      ),
      _react2.default.createElement(
        'div',
        { className: 'close', onClick: hmqCareHide },
        _react2.default.createElement(
          'svg',
          { width: '19', height: '20', viewBox: '0 0 19 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('line', { y1: '-0.5', x2: '25', y2: '-0.5', transform: 'translate(0 1) rotate(45)', stroke: '#ACACAC' }),
          _react2.default.createElement('line', { y1: '-0.5', x2: '25', y2: '-0.5', transform: 'translate(17.6777 1) rotate(135)', stroke: '#ACACAC' })
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: cn('header-content') },
      _react2.default.createElement(
        _reactRouter.Link,
        { className: cn('logo'), to: '/' },
        _react2.default.createElement(_A_Logo_H2.default, null)
      ),
      _react2.default.createElement(
        'ul',
        { className: cn('menu', { sticky: sticky }) },
        _react2.default.createElement(
          'li',
          { className: cn('menu-link') },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/ambassadors' },
            'Ambassadors'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: cn('menu-link') },
          _react2.default.createElement(
            'a',
            { href: 'https://challenge.humaniq.com', target: '_blank' },
            'Challenge'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: cn('menu-link') },
          _react2.default.createElement(
            'a',
            { href: 'https://blog.humaniq.co/', target: '_blank' },
            'Blog'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: cn('menu-link') },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/open-source' },
            'Open source'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: cn('menu-link') },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/exchange' },
            'Exchange'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: cn('menu-link') },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/contact-us' },
            'Contact us'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { className: cn('menu-link') + " jointele", to: 'https://t.me/hmqtalk', target: "_blank" },
          'JOIN OUR TELEGRAM'
        )
      ),
      _react2.default.createElement(_BurgerBtn2.default, { mix: cn('menu-btn'), onClick: toggleMobileMenu, isActive: mobileMenuIsActive })
    )
  );
};

exports.default = SE_MainLayoutHeader_H;


SE_MainLayoutHeader_H.propTypes = {
  mix: T.string, //BEM mixin from parent block
  toggleMobileMenu: T.func.isRequired //
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(666);

var _utils = __webpack_require__(1);

var _reactRouter = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_MainLayout_MobileMenu');
var socialIcons = '/img/design-v2/icons/social/sprite.svg';

var SE_MainLayout_MobileMenu = function SE_MainLayout_MobileMenu(_ref) {
  var mix = _ref.mix,
      mobileMenuIsActive = _ref.mobileMenuIsActive;
  return _react2.default.createElement(
    'nav',
    { className: cn([mix], { isActive: mobileMenuIsActive }) },
    _react2.default.createElement(
      'ul',
      { className: cn('links') },
      _react2.default.createElement(
        'li',
        { className: cn('links-link') },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/ambassadors' },
          'Ambassadors'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: cn('links-link') },
        _react2.default.createElement(
          'a',
          { href: 'https://challenge.humaniq.com', target: '_blank' },
          'Challenge'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: cn('links-link') },
        _react2.default.createElement(
          'a',
          { href: 'https://blog.humaniq.co/', target: '_blank' },
          'Blog'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: cn('links-link') },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/open-source' },
          'Open source'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: cn('links-link') },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/exchange' },
          'Exchange'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: cn('links-link') },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/contact-us' },
          'Contact us'
        )
      )
    )
  );
};

exports.default = SE_MainLayout_MobileMenu;


SE_MainLayout_MobileMenu.propTypes = {
  menuLinks: T.array.isRequired //links for mobile menu
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(667);

var _utils = __webpack_require__(1);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as T from "prop-types";
var cn = (0, _utils.cssClassName)('TeamSectionModal');

var TeamSectionModal = function (_Component) {
  (0, _inherits3.default)(TeamSectionModal, _Component);

  function TeamSectionModal() {
    (0, _classCallCheck3.default)(this, TeamSectionModal);
    return (0, _possibleConstructorReturn3.default)(this, (TeamSectionModal.__proto__ || (0, _getPrototypeOf2.default)(TeamSectionModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(TeamSectionModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          closeModal = _props.closeModal,
          isActive = _props.isActive,
          _props$personData = _props.personData,
          name = _props$personData.name,
          groupName = _props$personData.groupName,
          position = _props$personData.position,
          bio = _props$personData.bio,
          imgSrc = _props$personData.imgSrc;

      return _react2.default.createElement(
        'div',
        { className: cn({ opened: isActive }), onClick: closeModal },
        _react2.default.createElement(
          'div',
          { className: cn('inner'), onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          _react2.default.createElement(
            'header',
            { className: cn('header') },
            _react2.default.createElement(
              'h3',
              { className: cn('header-title') },
              groupName && groupName.charAt(0).toUpperCase() + groupName.slice(1)
            ),
            _react2.default.createElement('img', {
              className: cn('header-btn'),
              src: 'img/icons/close-people.svg',
              onClick: closeModal
            })
          ),
          _react2.default.createElement(
            'div',
            { className: cn('person') },
            _react2.default.createElement(
              'div',
              { className: cn('person-image') },
              _react2.default.createElement(_A_Image2.default, { src: imgSrc, rounded: true })
            ),
            _react2.default.createElement(
              'span',
              { className: cn('person-name') },
              name
            ),
            _react2.default.createElement(
              'span',
              { className: cn('person-title') },
              position
            ),
            _react2.default.createElement(
              'p',
              { className: cn('person-bio') },
              bio
            )
          )
        )
      );
    }
  }]);
  return TeamSectionModal;
}(_react.Component);

TeamSectionModal.propTypes = {};

TeamSectionModal.defaultProps = {
  closeModal: function closeModal() {},
  isActive: false,
  personData: {
    groupName: '',
    name: '',
    position: '',
    bio: ''
  }
};

exports.default = TeamSectionModal;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _page = __webpack_require__(369);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var _state$navigation = state.navigation,
      isMenuOpened = _state$navigation.isMenuOpened,
      isPopupOpened = _state$navigation.isPopupOpened,
      theme = _state$navigation.theme,
      popupType = _state$navigation.popupType,
      openRoute = _state$navigation.openRoute,
      isPeopleModalOpened = _state$navigation.isPeopleModalOpened,
      personData = _state$navigation.personData;


  return {
    isMenuOpened: isMenuOpened,
    isPopupOpened: isPopupOpened,
    theme: theme,
    popupType: popupType,
    openRoute: openRoute,
    isPeopleModalOpened: isPeopleModalOpened,
    personData: personData
  };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ toggleMenu: _actions.toggleMenu, closePopup: _actions.closePopup, openPopup: _actions.openPopup, closePeopleModal: _actions.closePeopleModal }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(668);

var _Header = __webpack_require__(365);

var _Header2 = _interopRequireDefault(_Header);

var _MobileMenu = __webpack_require__(366);

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _O_Popup_H = __webpack_require__(474);

var _O_Popup_H2 = _interopRequireDefault(_O_Popup_H);

var _utils = __webpack_require__(1);

var _O_Footer_H = __webpack_require__(72);

var _O_Footer_H2 = _interopRequireDefault(_O_Footer_H);

var _PeopleModal = __webpack_require__(367);

var _PeopleModal2 = _interopRequireDefault(_PeopleModal);

var _TeleFooterSquare = __webpack_require__(488);

var _TeleFooterSquare2 = _interopRequireDefault(_TeleFooterSquare);

var _index = __webpack_require__(91);

var _index2 = _interopRequireDefault(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_MainLayout_H');
//import Sidebar from './Sidebar'

var SE_MainLayout_H = function (_Component) {
  (0, _inherits3.default)(SE_MainLayout_H, _Component);

  function SE_MainLayout_H() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_MainLayout_H);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_MainLayout_H.__proto__ || (0, _getPrototypeOf2.default)(SE_MainLayout_H)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      headerLinks: ['Humaniq Wiki', 'HMQ Explorer', 'Challenge', 'Ambassadors'],
      sidebarLinks: ['Open source', 'Contact us'], // 'Subscribe'],
      TelegaIsHidden: true,
      HMQCareIsHidden: false
    }, _this.TelegaIsHidden = true, _this.HMQCareIsHidden = false, _this.IntercomIsHidden = true, _this.checkCompleted = false, _this.switchCompleted = false, _this.setCookie = function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }, _this.getCookie = function (cname) {
      var name = cname + "=";
      var ca = decodeURIComponent(document.cookie).split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }, _this.handleScroll = function (e) {
      if (_this.switchCompleted) return;
      //console.log(window.scrollY );
      if (window.scrollY > 300) {

        if (_this.checkCompleted) {
          _this.switchCompleted = true;

          if (_this.getCookie("telegaHidden")) {
            _this.TelegaIsHidden = true;
            if (!_this.IntercomIsHidden) {
              if (window.innerWidth < 750) {
                window.Intercom("boot", { app_id: "y9l4iy41" });
              }
            }
          }

          _this.setState({ TelegaIsHidden: _this.TelegaIsHidden });
          if (!_this.IntercomIsHidden) {
            if (window.innerWidth > 749) {
              window.Intercom("boot", { app_id: "y9l4iy41" });
            }
          }
          _this.checkCompleted = false;
        }
      }
    }, _this.handleWheel = function (e) {
      if (_this.switchCompleted) return;
      //console.log(e.deltaY , window.scrollY );
      if (e.deltaY >= 100) {
        if (window.scrollY <= 0) {

          if (_this.checkCompleted) {
            _this.switchCompleted = true;

            if (_this.getCookie("telegaHidden")) {
              _this.TelegaIsHidden = true;
              if (!_this.IntercomIsHidden) {
                if (window.innerWidth < 750) {
                  window.Intercom("boot", { app_id: "y9l4iy41" });
                }
              }
            }

            _this.setState({ TelegaIsHidden: _this.TelegaIsHidden });
            if (!_this.IntercomIsHidden) {
              if (window.innerWidth > 749) {
                window.Intercom("boot", { app_id: "y9l4iy41" });
              }
            }
            _this.checkCompleted = false;
          }
        }
      }
    }, _this.hmqCareHide = function (e) {
      _this.setCookie('hmqCareHidden', '1', 30);
      _this.HMQCareIsHidden = true;
      _this.setState({ HMQCareIsHidden: _this.HMQCareIsHidden });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_MainLayout_H, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _index2.default.get("https://ipapi.co/json/").then(function (res) {
        console.log(res.data.continent_code);
        if (res.data.continent_code != 'AF') {
          _this2.TelegaIsHidden = false;
          _this2.IntercomIsHidden = false;
          _this2.checkCompleted = true;
        }
      }).catch(function (error) {
        // handle error
        _this2.TelegaIsHidden = true;
        _this2.IntercomIsHidden = false;
        _this2.checkCompleted = true;
        console.log(error);
      });
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          headerLinks = _state.headerLinks,
          sidebarLinks = _state.sidebarLinks;
      var _props = this.props,
          children = _props.children,
          popupType = _props.popupType,
          theme = _props.theme,
          isPopupOpened = _props.isPopupOpened,
          closePopup = _props.closePopup,
          openRoute = _props.openRoute,
          openPopup = _props.openPopup,
          isMenuOpened = _props.isMenuOpened,
          toggleMenu = _props.toggleMenu,
          isPeopleModalOpened = _props.isPeopleModalOpened,
          closePeopleModal = _props.closePeopleModal,
          personData = _props.personData;

      var homePage = openRoute.length === 0; //home page
      if (openRoute.length) {
        if (openRoute[0].search("news-") !== -1) homePage = true;
      }

      var hmqCareIsHidden = this.HMQCareIsHidden;

      if (homePage || !this.HMQCareIsHidden && this.getCookie("hmqCareHidden")) {
        hmqCareIsHidden = true;
      }

      var mobileMenuLinks = [].concat((0, _toConsumableArray3.default)(headerLinks), (0, _toConsumableArray3.default)(sidebarLinks));

      return _react2.default.createElement(
        'div',
        { className: cn(), onWheel: this.handleWheel },
        _react2.default.createElement(_MobileMenu2.default, {
          mix: cn('mobile-menu'),
          menuLinks: mobileMenuLinks,
          toggleMenu: toggleMenu,
          mobileMenuIsActive: isMenuOpened
        }),
        _react2.default.createElement(_Header2.default, {
          mix: cn('header', { sticky: homePage }),
          mobileMenuIsActive: isMenuOpened,
          toggleMobileMenu: toggleMenu,
          theme: theme,
          sticky: homePage,
          openRoute: openRoute,
          hmqCareIsHidden: hmqCareIsHidden,
          hmqCareHide: this.hmqCareHide
        }),
        this.TelegaIsHidden ? "" : _react2.default.createElement(_TeleFooterSquare2.default, null),
        _react2.default.createElement(
          'div',
          { className: cn('body') },
          children
        ),
        homePage || _react2.default.createElement(_O_Footer_H2.default, {
          mix: 'home__section home__section_type_half-height',
          openPopup: this.props.openPopup
        }),
        _react2.default.createElement(_PeopleModal2.default, { isActive: isPeopleModalOpened, closeModal: closePeopleModal, personData: personData }),
        _react2.default.createElement(_O_Popup_H2.default, { isActive: isPopupOpened, closePopup: closePopup, popupType: popupType })
      );
    }
  }]);
  return SE_MainLayout_H;
}(_react.Component);

SE_MainLayout_H.propTypes = {
  children: T.any.isRequired
};

exports.default = SE_MainLayout_H;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(669);

var _utils = __webpack_require__(1);

var _A_Logo = __webpack_require__(465);

var _A_Logo2 = _interopRequireDefault(_A_Logo);

var _menuBtn = __webpack_require__(371);

var _menuBtn2 = _interopRequireDefault(_menuBtn);

var _reactMotion = __webpack_require__(272);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _M_Ripple = __webpack_require__(133);

var _M_Ripple2 = _interopRequireDefault(_M_Ripple);

var _history = __webpack_require__(74);

var _history2 = _interopRequireDefault(_history);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_MainLayoutHeader');


var main = [{
  url: '/contact-us',
  name: 'Contact Us'
}];

var extra = {
  url: '/',
  name: 'Subscribe'
};

var SE_MainLayoutHeader = function (_Component) {
  (0, _inherits3.default)(SE_MainLayoutHeader, _Component);

  function SE_MainLayoutHeader() {
    (0, _classCallCheck3.default)(this, SE_MainLayoutHeader);
    return (0, _possibleConstructorReturn3.default)(this, (SE_MainLayoutHeader.__proto__ || (0, _getPrototypeOf2.default)(SE_MainLayoutHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(SE_MainLayoutHeader, [{
    key: 'getMainNav',
    value: function getMainNav(mainNav, theme) {
      var _this2 = this;

      return mainNav.map(function (menuItem) {
        return _this2.getNavLink(menuItem, theme);
      });
    }
  }, {
    key: 'getNavLink',
    value: function getNavLink(_ref, theme) {
      var name = _ref.name,
          url = _ref.url;

      return _react2.default.createElement(
        _M_Ripple2.default,
        { onClick: function onClick() {
            return _history2.default.push(url);
          }, type: 'flex', key: 'key=' + name },
        _react2.default.createElement(
          'div',
          { className: cn('nav-btn', { theme: theme }) },
          _react2.default.createElement(
            'div',
            { className: cn('nav-text') },
            name
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          menuOpen = _props.isMenuOpened,
          _onClick = _props.onClick,
          headerTheme = _props.headerTheme;


      var theme = headerTheme === 'blue' ? 'light' : 'dark'; //theme of inner elements
      var mainNav = this.getMainNav(main, theme);
      var extraNav = this.getNavLink(extra, theme);
      var slide = this.navExtraNode && this.navExtraNode.clientWidth || 70;
      var max = 100;

      return _react2.default.createElement(
        'header',
        {
          className: cn('root', { headerTheme: headerTheme })
        },
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'wide' },
          _react2.default.createElement(
            'div',
            { className: cn('inner', { menuOpen: menuOpen }) },
            _react2.default.createElement(
              'div',
              { className: cn('logo') },
              _react2.default.createElement(_A_Logo2.default, { theme: theme })
            ),
            _react2.default.createElement(
              _reactMotion.Motion,
              {
                defaultStyle: { x: 0 },
                style: {
                  x: (0, _reactMotion.spring)(menuOpen ? max : 0)
                }
              },
              function (_ref2) {
                var x = _ref2.x;

                return _react2.default.createElement(
                  'nav',
                  { className: cn('nav') },
                  _react2.default.createElement(
                    'span',
                    {
                      className: cn('nav-main'),
                      style: {
                        transform: 'translate(' + slide / 100 * x + 'px,0)'
                      }
                    },
                    mainNav
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: cn('menu-btn'), onClick: function onClick() {
                        return _onClick();
                      } },
                    _react2.default.createElement(_menuBtn2.default, { x: x, max: max, theme: theme })
                  )
                );
              }
            )
          )
        )
      );
    }
  }]);
  return SE_MainLayoutHeader;
}(_react.Component);

SE_MainLayoutHeader.propTypes = {
  headerTheme: T.oneOf(['blue', // blue background, white buttons and logo
  'white'] // white background, black buttons and logo
  ).isRequired,
  isMenuOpened: T.bool.isRequired,
  onClick: T.func.isRequired
};

SE_MainLayoutHeader.defaultProps = {
  isMenuOpened: false
};

exports.default = SE_MainLayoutHeader;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderMenuBtn = function HeaderMenuBtn(_ref) {
  var x = _ref.x,
      max = _ref.max,
      theme = _ref.theme;


  var color = theme === 'dark' ? '#179cde' : '#fff';
  return _react2.default.createElement(
    'span',
    null,
    x < max / 2 ? _react2.default.createElement(
      'svg',
      {
        width: '22px', height: '14px', viewBox: '0 0 22 14', version: '1.1', xmlns: 'http://www.w3.org/2000/svg',
        style: {
          transform: 'scale(' + (1 - 0.01 * x) + ') rotate(' + -180 / 100 * x + 'deg) translate(0px, 2px)',
          cursor: 'pointer'
        }
      },
      _react2.default.createElement(
        'g',
        { id: 'Home-v2', stroke: color, strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
        _react2.default.createElement('path', { d: 'M0,13 L20,13', strokeWidth: '2' }),
        _react2.default.createElement('path', { d: 'M0,7 L20,7', strokeWidth: '2' }),
        _react2.default.createElement('path', { d: 'M0,1 L20,1', strokeWidth: '2' })
      )
    ) : _react2.default.createElement(
      'svg',
      {
        width: '20px', height: '20px', viewBox: '0 0 20 20', version: '1.1', xmlns: 'http://www.w3.org/2000/svg',
        style: {
          transform: 'translate(0px, 3px) scale(' + 0.01 * x + ') rotate(' + -180 / 100 * x + 'deg)',
          cursor: 'pointer'
        }
      },
      _react2.default.createElement(
        'g',
        { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
        _react2.default.createElement(
          'g',
          { id: 'Header-/-Desktop-/-LightBg-Copy', transform: 'rotate(45) translate(5, -10)', stroke: color, strokeWidth: '2.25' },
          _react2.default.createElement('path', { d: 'M0,10 L20,10', id: 'Line' }),
          _react2.default.createElement('path', { d: 'M0,10 L20,10', id: 'Line', transform: 'translate(10, 10) scale(1, -1) rotate(90) translate(-10, -10) ' })
        )
      )
    )
  );
};

HeaderMenuBtn.propTypes = {
  theme: T.oneOf(['dark', // black btn
  'light'] // white btn
  ).isRequired,
  x: T.number.isRequired, // dynamic animation parameter from react-motion
  max: T.number.isRequired // max value of animation parameter
};

HeaderMenuBtn.defaultProps = {
  theme: 'dark'
};

exports.default = HeaderMenuBtn;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _page = __webpack_require__(373);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blueMainLayoutPages = ['wiki']; // pages with normal layout + dark theme
var noMainLayoutPages = ['form']; // pages with their own layout

function mapStateToProps(state) {
  var _state$navigation = state.navigation,
      isMenuOpened = _state$navigation.isMenuOpened,
      openRoute = _state$navigation.openRoute;

  var route0 = openRoute[0];

  var headerTheme = (0, _utils._isContain)(blueMainLayoutPages, route0) ? 'blue' : 'white';
  var noLayout = (0, _utils._isContain)(noMainLayoutPages, route0);
  return { isMenuOpened: isMenuOpened, headerTheme: headerTheme, noLayout: noLayout };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ toggleMenu: _actions.toggleMenu }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(670);

var _O_Footer = __webpack_require__(469);

var _O_Footer2 = _interopRequireDefault(_O_Footer);

var _Header = __webpack_require__(370);

var _Header2 = _interopRequireDefault(_Header);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_MainLayout');

var SE_MainLayout = function (_Component) {
  (0, _inherits3.default)(SE_MainLayout, _Component);

  function SE_MainLayout() {
    (0, _classCallCheck3.default)(this, SE_MainLayout);
    return (0, _possibleConstructorReturn3.default)(this, (SE_MainLayout.__proto__ || (0, _getPrototypeOf2.default)(SE_MainLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(SE_MainLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMenuOpened = _props.isMenuOpened,
          children = _props.children,
          toggleMenu = _props.toggleMenu,
          headerTheme = _props.headerTheme,
          noLayout = _props.noLayout;

      if (noLayout) {
        return children;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Header2.default, { isMenuOpened: isMenuOpened, onClick: toggleMenu, headerTheme: headerTheme }),
        _react2.default.createElement(
          'div',
          { className: cn('body', { isMenuOpened: isMenuOpened }) },
          children
        ),
        _react2.default.createElement(_O_Footer2.default, { isMenuOpened: isMenuOpened })
      );
    }
  }]);
  return SE_MainLayout;
}(_react.Component);

SE_MainLayout.propTypes = {
  headerTheme: _Header2.default.propTypes.headerTheme,
  children: T.any.isRequired,
  isMenuOpened: T.bool,
  toggleMenu: T.func.isRequired
};

SE_MainLayout.defaultProps = {
  isMenuOpened: false,
  mainTagline: ''
};

exports.default = SE_MainLayout;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _page = __webpack_require__(375);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

var _actions2 = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var theme = state.navigation.theme,
      users_number = state.home.users_number;

  return { theme: theme, users_number: users_number };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ setTheme: _actions.setTheme, openPopup: _actions.openPopup, submit: _actions2.submit, openPeopleModal: _actions.openPeopleModal }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(690);

var _utils = __webpack_require__(1);

var _isMobile = __webpack_require__(93);

var _O_Footer_H = __webpack_require__(72);

var _O_Footer_H2 = _interopRequireDefault(_O_Footer_H);

var _EmpoweringSection = __webpack_require__(376);

var _EmpoweringSection2 = _interopRequireDefault(_EmpoweringSection);

var _NewsSection = __webpack_require__(381);

var _NewsSection2 = _interopRequireDefault(_NewsSection);

var _FirstMobileSection = __webpack_require__(378);

var _FirstMobileSection2 = _interopRequireDefault(_FirstMobileSection);

var _UnbankedStatSection = __webpack_require__(389);

var _UnbankedStatSection2 = _interopRequireDefault(_UnbankedStatSection);

var _QuotesSection = __webpack_require__(384);

var _QuotesSection2 = _interopRequireDefault(_QuotesSection);

var _WhatMakesSection = __webpack_require__(391);

var _WhatMakesSection2 = _interopRequireDefault(_WhatMakesSection);

var _SafetySection = __webpack_require__(385);

var _SafetySection2 = _interopRequireDefault(_SafetySection);

var _OpportunitiesSection = __webpack_require__(382);

var _OpportunitiesSection2 = _interopRequireDefault(_OpportunitiesSection);

var _Partners = __webpack_require__(383);

var _Partners2 = _interopRequireDefault(_Partners);

var _GrowingSection = __webpack_require__(380);

var _GrowingSection2 = _interopRequireDefault(_GrowingSection);

var _UseCasesSection = __webpack_require__(390);

var _UseCasesSection2 = _interopRequireDefault(_UseCasesSection);

var _GlobalChallengeSection = __webpack_require__(379);

var _GlobalChallengeSection2 = _interopRequireDefault(_GlobalChallengeSection);

var _ExpeditionSection = __webpack_require__(377);

var _ExpeditionSection2 = _interopRequireDefault(_ExpeditionSection);

var _WorldTalkingSection = __webpack_require__(392);

var _WorldTalkingSection2 = _interopRequireDefault(_WorldTalkingSection);

var _TeamSection = __webpack_require__(388);

var _TeamSection2 = _interopRequireDefault(_TeamSection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('News1');
// import Meta from './meta.js'

/*import TimelineSection from './sections/TimelineSection'*/


var serverNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'press', 'contacts'];
var clientNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'team', 'press', 'contacts'];

var sectionsNames =  true ? clientNames : serverNames;

var dark = ['mobile', 'situation', 'platform', 'opportunities', 'partners', 'use cases', 'expedition', 'team'];

var showingWidth = 1120;

var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showIndex: _this.props.showIndex || 0,
      scroll: true,
      fastScroll: true,
      widthBig: true && window.innerWidth >= showingWidth
    }, _this.sectionsObj = {
      empowering: _react2.default.createElement(_EmpoweringSection2.default, { mix: cn('section'), key: 'empowering', users_number: _this.props.users_number }),
      news: _react2.default.createElement(_NewsSection2.default, { mix: cn('section'), key: 'news' }),
      mobile: _react2.default.createElement(_FirstMobileSection2.default, { mix: cn('section'), key: 'mobile' }),
      situation: _react2.default.createElement(_UnbankedStatSection2.default, { mix: cn('section'), key: 'situation' }),
      changes: _react2.default.createElement(_QuotesSection2.default, { mix: cn('section', { type: 'slider' }), key: 'changes' }),
      platform: _react2.default.createElement(_WhatMakesSection2.default, { mix: cn('section'), key: 'platform' }),
      simplicity: _react2.default.createElement(_SafetySection2.default, { mix: cn('section'), key: 'simplicity' }),
      opportunities: _react2.default.createElement(_OpportunitiesSection2.default, { mix: cn('section'), key: 'opportunities' }),
      partners: _react2.default.createElement(_Partners2.default, { mix: cn('section'), key: 'partners' }),
      userbase: _react2.default.createElement(_GrowingSection2.default, { mix: cn('section'), key: 'userbase' }),
      'use cases': _react2.default.createElement(_UseCasesSection2.default, { mix: cn('section'), key: 'usecases' }),
      challenge: _react2.default.createElement(_GlobalChallengeSection2.default, { mix: cn('section'), key: 'challenge' }),
      expedition: _react2.default.createElement(_ExpeditionSection2.default, { mix: cn('section'), key: 'expedition' }),
      /*timeline: <TimelineSection mix={cn('section')} key="timeline" />,*/
      team: _react2.default.createElement(_TeamSection2.default, { mix: cn('section'), key: 'team', openPeopleModal: _this.props.openPeopleModal }),
      press: _react2.default.createElement(_WorldTalkingSection2.default, { mix: cn('section'), key: 'press' }),
      contacts: _react2.default.createElement(_O_Footer_H2.default, {
        mix: cn('section', { type: 'half-height' }),
        openPopup: _this.props.openPopup,
        key: 'contacts'
      })
    }, _this.handleSideMenu = function (_ref2) {
      var showIndex = _ref2.showIndex,
          extra = (0, _objectWithoutProperties3.default)(_ref2, ['showIndex']);
      var setTheme = _this.props.setTheme;

      _this.setState((0, _extends3.default)({ showIndex: showIndex }, extra));
      if (dark.includes(sectionsNames[showIndex])) {
        setTheme('dark');
      } else {
        setTheme('bright');
      }
    }, _this.handleWeel = function (_ref3) {
      var deltaY = _ref3.deltaY;

      var touchBar = deltaY - Math.round(deltaY) === 0;

      if (touchBar) {
        _this.handleTouchBar({ deltaY: deltaY });
      } else {
        _this.handleMouseWeel({ deltaY: deltaY });
      }
    }, _this.handleScrollUp = function () {
      _this.setState({ showIndex: 0 });
    }, _this.getWidth = function () {
      var widthBig = window.innerWidth >= showingWidth,
          shorter = _this.state.widthBig && !widthBig,
          bigger = !_this.state.widthBig && widthBig;

      if (shorter || bigger) {
        _this.setState({ widthBig: widthBig });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'getSideMenu',
    value: function getSideMenu(showIndex) {
      var _this2 = this;

      var hashLinks = sectionsNames.map(function (name, i) {
        return _react2.default.createElement(
          'div',
          {
            key: name,
            className: cn('side-menu-item'),
            onClick: function onClick() {
              return _this2.handleSideMenu({ showIndex: i });
            }
          },
          _react2.default.createElement('div', { className: cn('dot', { selected: showIndex === i }) })
        );
      });
      return _react2.default.createElement(
        'aside',
        { className: cn('side-menu') },
        hashLinks
      );
    }
  }, {
    key: 'handleTouchBar',
    value: function handleTouchBar(_ref4) {
      var _this3 = this;

      var deltaY = _ref4.deltaY;
      var _state = this.state,
          oldIndex = _state.showIndex,
          fastScroll = _state.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 100) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this3.setState({ scroll: true });
      }, 400);
      setTimeout(function () {
        return _this3.setState({ fastScroll: true });
      }, 1000);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: '_handleKeyPress',
    value: function _handleKeyPress(_ref5) {
      var keyCode = _ref5.keyCode;
      var oldIndex = this.state.showIndex;

      var nextCodes = [40, 34, 32, 39],
          prevCodes = [38, 33, 36, 37];
      if (nextCodes.includes(keyCode) && oldIndex < sectionsNames.length - 1) {
        this.setState({ showIndex: oldIndex + 1 });
      } else if (prevCodes.includes(keyCode) && oldIndex > 0) {
        this.setState({ showIndex: oldIndex - 1 });
      }
    }
  }, {
    key: 'handleMouseWeel',
    value: function handleMouseWeel(_ref6) {
      var _this4 = this;

      var deltaY = _ref6.deltaY;
      var _state2 = this.state,
          oldIndex = _state2.showIndex,
          fastScroll = _state2.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 900) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this4.setState({ scroll: true });
      }, 200);
      setTimeout(function () {
        return _this4.setState({ fastScroll: true });
      }, 500);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.getWidth);
      this.container.focus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.getWidth);
    }
  }, {
    key: 'getPositionY',
    value: function getPositionY(showIndex) {
      if (showIndex === sectionsNames.length - 1) {
        return (showIndex - 1) * 100 + 50;
      } else {
        return showIndex * 100;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state3 = this.state,
          showIndex = _state3.showIndex,
          scroll = _state3.scroll,
          widthBig = _state3.widthBig;

      var controlledScroll = false;
      var positionY = controlledScroll ? this.getPositionY(showIndex) : 0;
      return _react2.default.createElement(
        'div',
        {
          className: cn({ scroll: !controlledScroll }),
          tabIndex: '0',
          ref: function ref(el) {
            _this5.container = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: cn('inner') },
          sectionsNames.map(function (name) {
            return _this5.sectionsObj[name];
          })
        )
      );
    }
  }]);
  return Home;
}(_react.Component);

Home.propTypes = {
  total_installations: T.number
};

Home.defaultProps = {};

exports.default = Home;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _O_SimpleForm_H_ = __webpack_require__(108);

var _O_SimpleForm_H_2 = _interopRequireDefault(_O_SimpleForm_H_);

var _M_Exchanges_Slider = __webpack_require__(106);

var _M_Exchanges_Slider2 = _interopRequireDefault(_M_Exchanges_Slider);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _index = __webpack_require__(91);

var _index2 = _interopRequireDefault(_index);

var _reactDelay = __webpack_require__(118);

var _reactDelay2 = _interopRequireDefault(_reactDelay);

var _reactScrollableAnchor = __webpack_require__(126);

var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);

var _news = __webpack_require__(53);

__webpack_require__(671);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import M_Countdown from "../../../../widgets/M_Countdown";
var cn = (0, _utils.cssClassName)('SE_News1_Empowering');

var handleLinkClick = function handleLinkClick(name) {
    if (window.ga) window.ga('send', 'event', 'other', 'event-click-' + name);
};

var formatUserNum = function formatUserNum(users) {
    var usersD = users.toString();
    usersD = usersD.slice(0, usersD.length - 3) + "  " + usersD.slice(usersD.length - 3);
    return usersD;
};

function createMarkup(input) {
    return { __html: input };
}

var _createLinks = function _createLinks(links) {
    return links.map(function (_ref, index) {
        var title = _ref.title,
            more = _ref.more,
            img = _ref.img,
            button = _ref.button,
            url = _ref.url,
            uid = _ref.uid,
            isInt = _ref.isInt;

        var divStyle = {
            backgroundImage: 'url(' + img + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top center',
            backgroundSize: 'cover'
        };
        isInt = isInt ? '' : '_blank';
        return _react2.default.createElement(
            'div',
            { className: 'item', key: 'mainEvent-' + (index + 1) },
            _react2.default.createElement(
                'div',
                { className: 'wrap', style: divStyle },
                _react2.default.createElement('h1', { dangerouslySetInnerHTML: createMarkup(title) }),
                _react2.default.createElement('div', { className: 'more', dangerouslySetInnerHTML: createMarkup(more) }),
                button && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: url, className: 'button', onClick: function onClick() {
                                handleLinkClick(uid);
                            }, target: isInt },
                        button
                    )
                )
            )
        );
    });
};

var SE_Home_Empowering = function (_React$Component) {
    (0, _inherits3.default)(SE_Home_Empowering, _React$Component);

    function SE_Home_Empowering(props) {
        (0, _classCallCheck3.default)(this, SE_Home_Empowering);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SE_Home_Empowering.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Empowering)).call(this, props));

        _this.gotoSlide = function (index) {
            _this.slider.slickGoTo(index);
            console.log(_this.slider);
        };

        _this.createDots = function (list) {
            return list.map(function (_ref2, index) {
                var title = _ref2.title,
                    more = _ref2.more,
                    img = _ref2.img;

                return _react2.default.createElement(
                    'i',
                    null,
                    _this.state.activeSlide == index && _react2.default.createElement(
                        'div',
                        { className: 'pie-wrap' },
                        _react2.default.createElement('div', { className: 'slice1 slice-wrap' }),
                        _react2.default.createElement('div', { className: 'slice2 slice-wrap' })
                    ),
                    _this.state.activeSlide != index && _react2.default.createElement('div', { className: 'pie-wrap full', onClick: function onClick() {
                            _this.gotoSlide(index);
                        } })
                );
            });
        };

        _this.state = {
            hmq2usd: "",
            ccwShow: false
        };
        return _this;
    }

    (0, _createClass3.default)(SE_Home_Empowering, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _index2.default.get("https://api.coinmarketcap.com/v2/ticker/1669/").then(function (res) {
                console.log(res.data);
                var ratio = Math.round(1000 * res.data.data.quotes.USD.price) / 1000;
                console.log(ratio);
                _this2.setState({
                    hmq2usd: "1 HMQ = " + ratio + " USD",
                    ccwShow: res.data.data.quotes.USD.percent_change_24h > 0,
                    ccw: res.data.data.quotes.USD.percent_change_24h
                });
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var settings = {
                loop: true,
                speed: 700,
                autoplay: true,
                autoplaySpeed: 5350,
                cssEase: 'ease-in-out',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                initialSlide: 0,
                arrows: false,
                //dots: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                mobileFirst: true,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                beforeChange: function beforeChange(current, next) {
                    return _this3.setState({ activeSlide: next });
                }
            };

            var iframeResizerOptions = { checkOrigin: false };

            return _react2.default.createElement(
                'section',
                { className: cn([this.mix]) },
                _react2.default.createElement(
                    'div',
                    { className: cn('left-side') },
                    _react2.default.createElement(
                        'div',
                        { className: cn('map') },
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'desktop' }),
                            src: '/img/v1/home/map-bg-2.png',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'mobile' }),
                            src: '/img/v1/home/mobile-map.jpg',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 1 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 2 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 3 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 4 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 5 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('text') },
                        _react2.default.createElement(
                            _A_Title_H2.default,
                            { type: 'hero', mix: cn('text-title'), theme: 'bright' },
                            'P2P financial services ',
                            _react2.default.createElement('br', null),
                            'for developing countries'
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: cn('text-subtitle') },
                            'Connecting 1.7 billion people'
                        ),
                        this.state.ccwShow && _react2.default.createElement(
                            'div',
                            { className: 'ccw-wrap' },
                            _react2.default.createElement('script', { type: 'text/javascript',
                                src: 'https://files.coinmarketcap.com/static/widget/currency.js' }),
                            _react2.default.createElement('div', { className: 'coinmarketcap-currency-widget', 'data-currencyid': '1669', 'data-base': 'USD',
                                'data-secondary': '', 'data-ticker': 'true', 'data-rank': 'true', 'data-marketcap': 'true',
                                'data-volume': 'true', 'data-stats': 'USD', 'data-statsticker': 'false' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('anni') },
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-title' },
                            '1 year after tokensale'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-operate' },
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-mark' },
                                _react2.default.createElement('img', { src: '/img/done.svg' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide one' },
                                '21 countries ',
                                _react2.default.createElement('br', null),
                                ' operating'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide two' },
                                formatUserNum(452068),
                                ' ',
                                _react2.default.createElement('br', null),
                                'users'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide three' },
                                'Hybrid ',
                                _react2.default.createElement('br', null),
                                'blockchain'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('right-side') },
                    _react2.default.createElement(
                        _reactSlick2.default,
                        (0, _extends3.default)({ ref: function ref(slider) {
                                return _this3.slider = slider;
                            } }, settings),
                        _createLinks(_news.mainList)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "overlay" },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'TODAY'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'i',
                                null,
                                this.state.hmq2usd
                            ),
                            this.state.ccwShow && _react2.default.createElement(
                                'div',
                                { className: 'mmark' },
                                _react2.default.createElement('img', { src: '/img/ccw-arrow.svg' }),
                                this.state.ccw,
                                '%'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: "dots" },
                            this.createDots(_news.mainList)
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactScrollableAnchor2.default,
                    { id: 'xchange' },
                    _react2.default.createElement(
                        'div',
                        { className: 'coinswitch-widget' },
                        _react2.default.createElement(
                            'iframe',
                            { width: '100%', height: '400', src: 'https://coinswitch.co/widget?widget_id=fc72a10e&from=btc&to=hmq&amount=0.01', frameBorder: 0, order: '0', scrolling: 'no' },
                            'Can\'t load widget'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('slider-wrap') },
                    _react2.default.createElement(
                        'div',
                        { className: 'w' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                _A_Title_H2.default,
                                { type: 'hero', theme: 'bright' },
                                'HMQ token is a fuel of the platform'
                            ),
                            'Visit one of the following external services independent from Humaniq in order to purchase HMQ'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'b' },
                            _react2.default.createElement(
                                'a',
                                { className: 'button', href: 'https://bittrex.com/Market/Index?MarketName=BTC-HMQ', target: '_blank' },
                                'Trade now'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('slider') },
                        _react2.default.createElement(
                            _reactDelay2.default,
                            { wait: 2000 },
                            _react2.default.createElement(_M_Exchanges_Slider2.default, null)
                        )
                    )
                )
            );
        }
    }]);
    return SE_Home_Empowering;
}(_react2.default.Component);

exports.default = SE_Home_Empowering;


SE_Home_Empowering.propTypes = {
    //mix: T.string,
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(68);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(672);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Expedition');

var SE_Home_Expedition = function SE_Home_Expedition(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq expedition: the first',
        _react2.default.createElement('br', null),
        ' step in financial inclusion'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
      _react2.default.createElement(
        'div',
        { className: cn('button') },
        _react2.default.createElement(
          _A_Btn_H2.default,
          { to: 'https://challenge.humaniq.com' },
          'About expedition'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 11, theme: 'bright' })
  );
};

exports.default = SE_Home_Expedition;


var infoColumns = [{
  title: 'Startup contest',
  text: 'In order to bring together a network of like-minded individuals and then choose 10 projects for entry into the Humaniq system, we are launching the Humaniq Global Challenge for entrepreneurs, developers, marketing specialists and economists.'
}, {
  title: 'Benefits',
  text: '10 Finalists will receive expert advice from top consultants in their field, as well as the chance to gain investment and to enter the Humaniq accelerator.'
}, {
  title: 'Trip to Kenya',
  text: 'The three best teams will go on a trip to Kenya to learn more about the lives of the unbanked and put the finishing touches to their projects ahead of an ICO, which will be supported by Humaniq.'
}];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(68);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(673);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_FirstMobile');

var handleLinkClick = function handleLinkClick() {
  if (window.ga) window.ga('send', 'event', 'other', 'whitepaper-btn-click');
};

var SE_Home_FirstMobile = function SE_Home_FirstMobile(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'The first mobile service with',
        _react2.default.createElement('br', null),
        'the capacity to change the world'
      ),
      _react2.default.createElement(
        'p',
        { className: cn('subtitle') },
        'Humaniq is a new generation financial services',
        _react2.default.createElement('br', null),
        ' with its own cryptocurrency, which is aimed at',
        _react2.default.createElement('br', null),
        ' eradicating poverty amongst millions of people',
        _react2.default.createElement('br', null),
        ' living in the emerging economies'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
        _react2.default.createElement(
          'div',
          { className: cn('button') },
          _react2.default.createElement(
            _A_Btn_H2.default,
            { to: '/pdf/humaniq-whitepaper-05.09.pdf', clickHandler: handleLinkClick },
            'Whitepaper'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 2, theme: 'bright' })
  );
};

exports.default = SE_Home_FirstMobile;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/key.svg',
  title: 'For the unbanked people',
  text: 'Humaniq opens up the benefits of financial inclusion and grants access to a series of financial services'
}, {
  imageSrc: '/img/design-v2/icons/sections/busness.svg',
  title: 'For businesses',
  text: 'Humaniq enables start-ups and projects to offer their services to an audience of billions'
}];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _M_SocialLinks_G = __webpack_require__(107);

var _M_SocialLinks_G2 = _interopRequireDefault(_M_SocialLinks_G);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(68);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(674);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_GlobalChallenge');

var SE_Home_GlobalChallenge = function SE_Home_GlobalChallenge(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq global',
        _react2.default.createElement('br', null),
        ' challenge'
      ),
      _react2.default.createElement(_InfoColumns2.default, {
        mix: cn('info-columns'),
        columns: infoColumns,
        type: 'narrow',
        layout: 'global-challenge'
      }),
      _react2.default.createElement(
        _M_SocialLinks_G2.default,
        { mix: cn('social-links'), type: 'section' },
        'You know how to enhance Humaniq?',
        _react2.default.createElement('br', null),
        ' Join the global Humaniq community'
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 10, theme: 'dark' })
  );
};

exports.default = SE_Home_GlobalChallenge;


var infoColumns = [{
  title: 'Life-changing technology',
  text: 'Humaniq grew out of the idea that advanced technologies should benefit everybody. Now, we want to inspire developers from all over the world to come and join our movement.'
}, {
  title: 'Humanitarian impact',
  text: 'Humaniq is not just a commercial project. It is a worldwide mission, aiming to give people in developing nations more power to change their lives.'
}];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(675);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Growing');

var SE_Home_Growing = function SE_Home_Growing(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq\'s ever\u2011growing',
        _react2.default.createElement('br', null),
        ' userbase is a blue ocean for',
        _react2.default.createElement('br', null),
        ' thousands of new projects'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '1 ',
            _react2.default.createElement(
              'span',
              null,
              'billion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'new users in the',
            _react2.default.createElement('br', null),
            ' coming years'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '$4 ',
            _react2.default.createElement(
              'span',
              null,
              'trillion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'potentially in',
            _react2.default.createElement('br', null),
            ' user accounts'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '200+'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'start-ups are planning',
            _react2.default.createElement('br', null),
            ' to move onto the',
            _react2.default.createElement('br', null),
            ' Humaniq platform'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 8, theme: 'dark' })
  );
};

exports.default = SE_Home_Growing;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

__webpack_require__(676);

var _utils = __webpack_require__(1);

var _news = __webpack_require__(53);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Butter from 'buttercms';
//const butter = Butter('63c5be1dcac33aad42357d8eb320058d0562c240');

var cn = (0, _utils.cssClassName)('SE_News1_News');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'news-click-' + name);
};

var _createLinks = function _createLinks(links, startIndex) {
  return links.map(function (_ref, index) {
    var title = _ref.title,
        src = _ref.src,
        url = _ref.url,
        date = _ref.date,
        img = _ref.img,
        target = _ref.target;


    if (index >= startIndex) {
      return _react2.default.createElement(
        'div',
        { className: 'item', key: 'newsLink-' + (index + 1) },
        url && _react2.default.createElement(
          'a',
          { className: 'link', href: url, title: title, target: target,
            onClick: function onClick() {
              handleLinkClick(index);
            } },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        !url && _react2.default.createElement(
          'div',
          { className: 'link', title: title },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'src' },
          date
        )
      );
    }
  });
};

function nextArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

function prevArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

var SE_News1_News = function (_React$Component) {
  (0, _inherits3.default)(SE_News1_News, _React$Component);

  function SE_News1_News(props) {
    (0, _classCallCheck3.default)(this, SE_News1_News);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SE_News1_News.__proto__ || (0, _getPrototypeOf2.default)(SE_News1_News)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(SE_News1_News, [{
    key: 'render',
    value: function render() {

      var settings = {
        loop: true,

        speed: 700,
        autoplay: false,
        cssEase: 'ease-in-out',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 0,
        arrows: true,
        //buttons: false,
        //dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        mobileFirst: true,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        nextArrow: _react2.default.createElement('nextArrow', null),
        prevArrow: _react2.default.createElement('prevArrow', null),

        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }]
      };

      return _react2.default.createElement(
        'section',
        { className: cn([this.mix]) },
        _react2.default.createElement(
          _A_Title_H2.default,
          { type: 'hero', mix: cn('text-title'), theme: 'dark' },
          'Latest ',
          _react2.default.createElement(
            'ss',
            null,
            'news'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('article-list') },
          _react2.default.createElement(
            _reactSlick2.default,
            settings,
            _createLinks(_news.articleList, 0)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('more-news') },
          _react2.default.createElement(
            'a',
            { className: 'button', href: 'https://blog.humaniq.co/', target: '_blank' },
            'See All NEWS'
          ),
          _react2.default.createElement(
            'a',
            { className: 'link-sec', href: 'https://www.facebook.com/humaniq.co/', target: '_blank' },
            'Join our Facebook',
            _react2.default.createElement('img', { src: '/img/link.svg' })
          )
        )
      );
    }
  }]);
  return SE_News1_News;
}(_react2.default.Component);

exports.default = SE_News1_News;


SE_News1_News.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(68);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(677);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Opportunities');

var SE_Home_Opportunities = function SE_Home_Opportunities(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Extraordinary opportunitites for business'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 7, theme: 'bright' })
  );
};

exports.default = SE_Home_Opportunities;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/etherium.svg',
  title: 'Based on Ethereum blockchain protocol',
  text: 'Guaranteed security against hacking, corruption and loss of information thanks to complete decentralisation'
}, {
  imageSrc: '/img/design-v2/icons/sections/accelerator.svg',
  title: 'Independent fund and accelerator',
  text: 'External projects and promising ideas can receive expert support and investment for a launch into the Humaniq system'
}, {
  imageSrc: '/img/design-v2/icons/sections/api.svg',
  title: 'Open API',
  text: 'Any project can merge into the Humaniq system'
}];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(678);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Partners');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'partners-click-' + name);
};

function createMarkup(input) {
  return { __html: input };
}

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var href = _ref.href,
        img = _ref.img,
        name = _ref.name,
        more = _ref.more;

    var divStyle = {
      backgroundImage: 'url(' + img + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    };
    console.log(divStyle);
    return _react2.default.createElement(
      'div',
      { className: 'item', key: 'partner-' + (index + 1) },
      href && _react2.default.createElement(
        'a',
        { href: href, className: 'wrap', target: '_blank', onClick: function onClick() {
            handleLinkClick(name);
          } },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      ),
      !href && _react2.default.createElement(
        'div',
        { className: 'wrap' },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      )
    );
  });
};

var SE_Partners = function SE_Partners(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq Partners'
      ),
      _react2.default.createElement(
        'div',
        { className: 'partners-list' },
        _createLinks(infoColumns)
      )
    )
  );
};

exports.default = SE_Partners;


var infoColumns = [{
  img: '/img/partners/un.png',
  href: "https://www.unglobalcompact.org",
  name: 'un',
  more: "The visionary who launched the <b>UN Global Compact</b> and inspired the world’s largest corporate sustainability initiative."
}, {
  img: '/img/partners/l39.png',
  href: "https://www.level39.co",
  name: 'l39',
  more: "<b>Level39</b> is a community of 1,250 leaders in cybersecurity, fintech and retail tech"
}, {
  img: '/img/partners/rise.png',
  href: "https://thinkrise.com",
  name: 'rise',
  more: "<b>Rise</b> is a community of startups & corporates creating the future of financial services."

}, {
  img: '/img/partners/coinfirm.png',
  href: "https://www.coinfirm.io",
  name: 'coinfirm',
  more: "The <b>Coinfirm</b> platform provides and easy to use solution with valuable structured data that puts entities on the safe side in terms of regulatory and fraud risk."

}, {
  img: '/img/partners/transbox.png',
  href: "http://www.transbox.xyz",
  name: 'transbox',
  more: "<b>Transbox</b> is online communication and data security specialised company."

}, {
  img: '/img/partners/bi.png',
  href: "https://www.biometricsinstitute.org",
  name: 'bi',
  more: "The mission of the <b>Biometrics Institute</b> is to promote the responsible use of biometrics in an independent and impartial international forum for biometric users and other interested parties."

}, {
  img: '/img/partners/jamii.png',
  href: "http://www.jamiiafrica.com/",
  name: 'jamii',
  more: "<b>Jamii Africa</b> is mobile micro-health insurance for the informal sector."

}, {
  img: '/img/partners/ff.png',
  href: "http://futurefintech.org",
  name: 'ff',
  more: "<b>Future Fintech</b> are connecting young businesses to the global community of VC and tech startups, giving access to the best tested cases, wide range of sector specific expertise and pinpoint advices."

}];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(679);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Quotes');

var _getQuotesSlides = function _getQuotesSlides(quotes) {
  var res = [];
  var genSlidesArray = function genSlidesArray(keysName) {
    return quotes.map(function (quote, index) {

      return _react2.default.createElement(
        'div',
        { key: 'quote-' + (keysName + (index + 1)), className: cn('slide') },
        _react2.default.createElement(
          'div',
          { className: cn('slide-content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('slide-title'), type: 'section', theme: 'bright' },
            quote.title
          ),
          _react2.default.createElement(
            'p',
            {
              className: quote.text.length < 260 ? cn('slide-text') : cn('slide-text', { type: 'small' })
            },
            quote.text
          ),
          _react2.default.createElement(
            'p',
            { className: cn('slide-author') },
            '\u2014 ',
            quote.author
          )
        )
      );
    });
  };

  res = res.concat(genSlidesArray('clone_before'));
  res = res.concat(genSlidesArray('clone_middle'));
  res = res.concat(genSlidesArray('clone_after'));

  return res;
};

var SE_Home_Quotes = function (_Component) {
  (0, _inherits3.default)(SE_Home_Quotes, _Component);

  function SE_Home_Quotes() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Quotes);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Quotes.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Quotes)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Quotes, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + quotes.length) % quotes.length;
      this.setState({ show: show });
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;
      var show = this.state.show;

      var pctX = show * 25;
      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('slider'), style: { transform: 'translateX(-' + pctX + '%)' } },
          _getQuotesSlides(quotes)
        ),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'prev' }), onClick: this.prev }),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'next' }), onClick: this.next }),
        _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 4, theme: 'dark' })
      );
    }
  }]);
  return SE_Home_Quotes;
}(_react.Component);

exports.default = SE_Home_Quotes;


SE_Home_Quotes.propTypes = {
  mix: T.string //BEM mixin from parent block
};

var quotes = [{
  title: 'The world is ready for change',
  text: 'Including the poorest in the financial system increases the value of their assets, transforming the underlying economics of financial services through digital currency - helping those who live in poverty directly.',
  author: 'Bill Gates',
  img: '/img/design-v2/sections/quotes/bill-gates2.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Because of technology, we can help shape the arc of history to bend it towards financial inclusion and greater human progress. Financial inclusion is a massive undertaking – one that can only be met together – across countries, sectors, and industries.',
  author: 'Ajaypal Singh Banga, MasterCard CEO',
  img: '/img/design-v2/sections/quotes/ajaypal-singh-banga.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Widely used digital finance has the power to transform the economic prospects of billions of people and inject new dynamism into small businesses that today are held back for lack of credit. Emerging economies have an opportunity to use mobile technologies to provide digital financial services for all, rapidly unlocking economic opportunity and accelerating social development.',
  author: 'McKinsey Global Institute Report September 2016',
  img: '/img/design-v2/sections/quotes/mckinsey-global-Institute.jpg'
}, {
  title: 'The world is ready for change',
  text: 'In pyramid of development the bottom-most layer needs to be strengthened through financial inclusionimproving purchasing power of the poor.',
  author: 'Narendra Modi',
  img: '/img/design-v2/sections/quotes/narendra-modi.jpg'
}];

// import * as T from "prop-types";
// import './styles.scss';
// import {cssClassName} from 'utils'
// const cn = cssClassName('')

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(68);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(680);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Safety');

var SE_Home_Safety = function SE_Home_Safety(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Simplicity and safety for the unbanked'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 6, theme: 'dark' })
  );
};

exports.default = SE_Home_Safety;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/card.svg',
  title: 'Biometric authentification',
  text: 'Users are verified by their face and voice, eliminating the need for formal documentation '
}, {
  imageSrc: '/img/design-v2/icons/sections/access.svg',
  title: 'Independent HMQ currency',
  text: 'Every new user receives $20 worth of HMQ in their account, the value of which bears no relation to their local currency'
}, {
  imageSrc: '/img/design-v2/icons/sections/interface.svg',
  title: 'The interface is simple to interact with',
  text: 'Even for those who have never used gadgets before'
}];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(681);

var _utils = __webpack_require__(1);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as T from "prop-types";
var cn = (0, _utils.cssClassName)('TeamSectionSlide');


var getHazemName = function getHazemName() {
  return _react2.default.createElement(
    'span',
    null,
    'Hazem Danny',
    _react2.default.createElement('br', null),
    'Al-Nakib'
  );
};

var TeamSectionSlide = function (_Component) {
  (0, _inherits3.default)(TeamSectionSlide, _Component);

  function TeamSectionSlide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TeamSectionSlide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TeamSectionSlide.__proto__ || (0, _getPrototypeOf2.default)(TeamSectionSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getSlide = function (_ref2, groupName, i) {
      var first = _ref2.first,
          imgSrc = _ref2.imgSrc,
          position = _ref2.position,
          name = _ref2.name,
          bio = _ref2.bio;

      name = name.search('Al-Nakib') === -1 ? name : getHazemName();
      var handleClick = bio ? function () {
        return _this.props.openPeopleModal({ imgSrc: imgSrc, position: position, name: name, bio: bio, groupName: groupName });
      } : undefined;
      return _react2.default.createElement(
        'div',
        { className: cn('person'), key: i, onClick: handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('person-image') },
          _react2.default.createElement(_A_Image2.default, { src: imgSrc, rounded: true })
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-name') },
          name
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-title') },
          position
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TeamSectionSlide, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          persons = _props.persons,
          showGroupName = _props.showGroupName,
          groupName = _props.groupName,
          hidden = _props.hidden;

      var renderTitle = showGroupName && groupName && _react2.default.createElement(
        'span',
        { className: cn('group-name') },
        groupName
      );
      var renderSlides = persons.map(function (el, i) {
        return _this2.getSlide(el, groupName, i);
      });
      return _react2.default.createElement(
        'div',
        { className: cn({ wide: showGroupName, hidden: hidden }) },
        renderTitle,
        renderSlides
      );
    }
  }]);
  return TeamSectionSlide;
}(_react.Component);

TeamSectionSlide.propTypes = {};

TeamSectionSlide.defaultProps = {};
exports.default = TeamSectionSlide;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getDelta = getDelta;
exports._indexOfShow = _indexOfShow;
exports.indexOfShow = indexOfShow;
exports.findIndexesOfRedundantSlides = findIndexesOfRedundantSlides;
exports.pairSplit = pairSplit;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDelta(slidesWidths, show) {
  var k = -1;
  if (show < 0) {
    show = -show;
    slidesWidths = [].concat((0, _toConsumableArray3.default)(slidesWidths)).reverse();
    k = 1;
  }
  var delta = 0;

  if (show >= slidesWidths.length) {
    delta = slidesWidths.reduce(function (a, b) {
      return a + b;
    }, 0) * (show / slidesWidths.length | 0);
    show = show % slidesWidths.length;
  }

  for (var i = 0; i < show; i++) {
    delta += slidesWidths[i];
  }
  return delta * k;
}

function _indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index + 1;
  } else {
    return extended_index + 1;
  }
}

function indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index;
  } else {
    return extended_index;
  }
}

function findIndexesOfRedundantSlides(slidesCount, show, slidesWidths) {
  var width_container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var first_index_of_slides = indexOfShow(slidesCount, show);
  var slidesLengh = 0,
      previousLength = 0,
      i_last = first_index_of_slides;
  for (slidesLengh = 0; slidesLengh < width_container; i_last++) {
    previousLength = slidesLengh;
    slidesLengh = previousLength + slidesWidths[indexOfShow(slidesCount, i_last)];
  }
  var padding = width_container ? (width_container - previousLength) / 2 : '0';
  return {
    arr: [_indexOfShow(slidesCount, first_index_of_slides - 1), _indexOfShow(slidesCount, first_index_of_slides - 2), _indexOfShow(slidesCount, i_last - 1), _indexOfShow(slidesCount, i_last)],
    padding: padding
  };
}

function pairSplit(arr, title) {
  var entities = [];

  for (var i = 0; i < arr.length; i += 2) {
    entities.push(arr.slice(i, i + 2));
  }
  return {
    title: title,
    entities: entities
  };
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(682);

var _utils = __webpack_require__(1);

var _Swipe = __webpack_require__(92);

var _Swipe2 = _interopRequireDefault(_Swipe);

var _helpers = __webpack_require__(387);

var _Slide = __webpack_require__(386);

var _Slide2 = _interopRequireDefault(_Slide);

var _people = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Team');
// import A_Image from 'A_Image/index'


var NORMAL_WIDTH = 136;
var WIDE_WIDTH = NORMAL_WIDTH + 20 + 16;
// import M_Tooltip from 'M_Tooltip'

var SE_Home_Team = function (_Component) {
  (0, _inherits3.default)(SE_Home_Team, _Component);

  function SE_Home_Team() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Team);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Team.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Team)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.widths = { container: 0 }, _this.right = function () {
      return _this.changeShow(1);
    }, _this.left = function () {
      return _this.changeShow(-1);
    }, _this.changeShow = function (n) {
      return _this.setState(function (oldState) {
        return { show: oldState.show + n };
      });
    }, _this.onSwipeRight = _this.left, _this.onSwipeLeft = _this.right, _this.threshold = 100, _this.slideGroups = [(0, _helpers.pairSplit)(_people.team, 'team'), (0, _helpers.pairSplit)(_people.advisers, 'advisers'), (0, _helpers.pairSplit)(_people.ambassadors, 'ambassadors')], _this.slidesWidths = [], _this.slidesCount = _this.slideGroups.reduce(function (sum, el) {
      return sum + el.entities.length;
    }, 0), _this.getStep = function (slidesWidths, show) {
      return slidesWidths.length ? (0, _helpers.getDelta)(slidesWidths, show) : WIDE_WIDTH;
    }, _this.handleResize = function () {
      _this.forceUpdate();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Team, [{
    key: 'getSlides',
    value: function getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides) {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(slideGroups, keys_name) {
        var indexTotal = 0;
        return slideGroups.map(function (_ref2) {
          var title = _ref2.title,
              entities = _ref2.entities;

          return entities.map(function (slide, i) {
            indexTotal += 1;

            var first = i === 0;
            if (keys_name === 'clone_before') {
              _this2.slidesWidths.push(first ? WIDE_WIDTH : NORMAL_WIDTH);
            }
            return _react2.default.createElement(_Slide2.default, {
              persons: slide,
              place: keys_name + i,
              showGroupName: first,
              groupName: title,
              hidden: indexesOfRedundantSlides.arr.includes(indexTotal),
              mix: indexesOfRedundantSlides.arr.includes(indexTotal) ? cn('hidden-slide') : cn('showing-slide'),
              mouseSlideEnterHandler: _this2.mouseSlideEnterHandler,
              mouseSlideLeaveHandler: _this2.mouseSlideLeaveHandler,
              openPeopleModal: _this2.props.openPeopleModal
            });
          });
        });
      };

      res = res.concat(genSlidesArray(slideGroups, 'clone_before'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_middle'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_after'));

      return res;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.forceUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var mix = this.props.mix;
      var slideGroups = this.slideGroups,
          slidesWidths = this.slidesWidths,
          slidesCount = this.slidesCount;
      var show = this.state.show;

      var move = show / slidesCount | 0;
      var showingSlideIndex = (0, _helpers.indexOfShow)(slidesCount, show);

      var indexesOfRedundantSlides = (0, _helpers.findIndexesOfRedundantSlides)(slidesCount, show, this.slidesWidths, this.widths.container.offsetWidth);
      var padding = indexesOfRedundantSlides.padding;

      var renderedSlides = this.getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides);
      var step = this.getStep(slidesWidths, show);
      var active = void 0;
      if (showingSlideIndex < 0) {
        active = 'ambassadors';
      } else if (showingSlideIndex < 5) {
        active = 'team';
      } else if (showingSlideIndex < 9) {
        active = 'advisers';
      } else {
        active = 'ambassadors';
      }

      return _react2.default.createElement(
        'section',
        { className: cn([mix]) },
        _react2.default.createElement(
          'div',
          {
            className: cn('content')
          },
          _react2.default.createElement('div', { className: cn('nav-prev'), onClick: function onClick() {
              return _this3.left();
            } }),
          _react2.default.createElement('div', { className: cn('nav-next'), onClick: function onClick() {
              return _this3.right();
            } }),
          _react2.default.createElement(
            'div',
            { className: cn('header') },
            _react2.default.createElement(
              _A_Title_H2.default,
              { mix: cn('title'), type: 'section', theme: 'dark' },
              'People behind Humaniq project'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'team' }), onClick: function onClick() {
                    return _this3.setState({ show: 0 });
                  } },
                'Team'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'advisers' }), onClick: function onClick() {
                    return _this3.setState({ show: 5 });
                  } },
                'Advisers'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'ambassadors' }), onClick: function onClick() {
                    return _this3.setState({ show: 9 });
                  } },
                'Ambassadors'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'wrapper1',
              onTouchStart: this.props.onTouchStart,
              onTouchMove: this.props.onTouchMove,
              ref: function ref(node) {
                return _this3.widths.container = node;
              },
              style: { paddingLeft: padding }
            },
            _react2.default.createElement(
              'div',
              {
                className: 'wrapper2',
                style: { transform: 'translate3d(' + move * (this.widths.inner / 3) + 'px, 0px, 0px)' }
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'inner',
                  style: { transform: 'translate3d(' + (step - this.widths.inner / 3) + 'px, 0px, 0px)' },
                  ref: function ref(node) {
                    return _this3.widths.inner = node ? node.offsetWidth : 0;
                  }
                },
                renderedSlides
              )
            ),
            _react2.default.createElement('div', { className: cn('linner-gradient-left') }),
            _react2.default.createElement('div', { className: cn('linner-gradient-right') })
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 12, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_Team;
}(_react.Component);

SE_Home_Team.propTypes = {};

SE_Home_Team.defaultProps = {};

exports.default = (0, _Swipe2.default)(SE_Home_Team);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(683);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UnbankedStat');

var SE_Home_UnbankedStat = function SE_Home_UnbankedStat(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('left-side') },
      _react2.default.createElement('div', { className: cn('map') })
    ),
    _react2.default.createElement(
      'div',
      { className: cn('right-side') },
      _react2.default.createElement(
        'p',
        { className: cn('text') },
        'According to the World Bank\'s Global',
        _react2.default.createElement('br', null),
        ' Financial Inclusion Database, there are',
        _react2.default.createElement('br', null),
        ' ',
        'currently 2.5 billion people on Earth',
        _react2.default.createElement('br', null),
        ' who do not have access to official',
        _react2.default.createElement('br', null),
        ' ',
        'financial services'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('stat-circle') },
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-percentage') },
          '53%'
        ),
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-text') },
          'Total 2,455',
          _react2.default.createElement('br', null),
          'million adults'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 3, theme: 'bright' })
  );
};

exports.default = SE_Home_UnbankedStat;


SE_Home_UnbankedStat.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

var _InfoColumn = __webpack_require__(393);

var _InfoColumn2 = _interopRequireDefault(_InfoColumn);

__webpack_require__(684);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UseCases');

var SE_Home_UseCases = function (_Component) {
  (0, _inherits3.default)(SE_Home_UseCases, _Component);

  function SE_Home_UseCases() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_UseCases);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_UseCases.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_UseCases)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0,
      slideWidth: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_UseCases, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + infoColumns.length) % infoColumns.length;
      this.setState({ show: show });
    }
  }, {
    key: 'getSlides',
    value: function getSlides() {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(keysName) {
        return infoColumns.map(function (column, i) {
          return _react2.default.createElement(_InfoColumn2.default, {
            column: column,
            key: i + keysName,
            mix: cn('slider-item'),
            setWidth: i === 0 ? function (slideWidth) {
              return _this2.setState({ slideWidth: slideWidth });
            } : undefined
          });
        });
      };

      res = res.concat(genSlidesArray('clone_before'));
      res = res.concat(genSlidesArray('clone_middle'));
      res = res.concat(genSlidesArray('clone_after'));

      return res;
    }
  }, {
    key: 'getDots',
    value: function getDots() {
      var _this3 = this;

      var show = this.state.show;


      var dots = [];

      var _loop = function _loop(i) {
        dots.push(_react2.default.createElement('div', {
          key: i,
          className: cn('dots-item', { active: show === i }),
          onClick: function onClick() {
            return _this3.setState({ show: i });
          }
        }));
      };

      for (var i = 1; i <= 5; i++) {
        _loop(i);
      }

      return dots;
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;

      var _renderSlides = this.getSlides();
      var _state = this.state,
          show = _state.show,
          slideWidth = _state.slideWidth;

      var pctX = show * slideWidth;
      var dots = this.getDots();

      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('title'), type: 'section', theme: 'dark' },
            'Humaniq use cases'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('slider-wrap') },
            _react2.default.createElement(
              'div',
              { className: cn('slider'), style: { transform: 'translateX(-' + pctX + 'px)' } },
              _renderSlides
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('nav') },
            _react2.default.createElement('div', { className: cn('nav-prev'), onClick: this.prev }),
            _react2.default.createElement('div', { className: cn('nav-next'), onClick: this.next })
          ),
          _react2.default.createElement(
            'div',
            { className: cn('dots') },
            dots
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 9, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_UseCases;
}(_react.Component);

exports.default = SE_Home_UseCases;


var infoColumns = [{
  title: 'Zero fee money transfers',
  text: 'Blockchain technology allows users to carry out direct money transfers, cutting out the middleman. The money is transferred as our HMQ cryptocurrency and withdrawn via authorised exchange points. Users can choose the point with the best exchange rate, therefore avoiding any financial monopolies.'
}, {
  title: 'Remote work',
  text: "Companies can utilise Humaniq's ever-growing user base to carry out tasks involving the processing of information. Users can decode and translate texts, identify photographs, locate geotags and so on, in return for renumeration."
}, {
  title: 'Charity without corruption',
  text: 'Charity, carried out in the traditional way, often leads to a large proportion of donated money falling into the wrong hands. Blockchain technology, combined with the infrastructure of Humaniq, ensures that donations are completely transparent: stakeholders are able to see what every penny is spent on and can be sure that all of their money is going to help people.'
}, {
  title: 'Guarantor lending',
  text: 'Grameen Bank in Bangladesh has created a system of loans based on honesty and trust, which guarantees over 90% repayment. The Humaniq system allows for the creation of a similar system but on a global scale: every person on Earth will be able to take out a commission-free loan using nothing but a smartphone and the Humaniq app.'
}, {
  title: 'Direct lending to entrepreneurs',
  text: "Following the principle of the non-profit organisation Kiva Microfunds, which enables loans for entrepreneurs on low incomes, Humaniq will become a platform for both donations and loans. You can lend money to a business you'd like to support, either as a grant or with the expectation of a return – the blockchain technology makes this process incredibly simple and effective for both parties."
}];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(68);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(685);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WhatMakes');

var SE_Home_WhatMakes = function SE_Home_WhatMakes(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement('img', { className: cn('background'), src: '/img/design-v2/sections/common/head.svg' }),
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'What makes Humaniq',
        _react2.default.createElement('br', null),
        ' a big thing'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 5, theme: 'bright' })
  );
};

exports.default = SE_Home_WhatMakes;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/connect-unbanked.svg',
  title: 'Connecting the unbanked',
  text: '10 years of research across Asia and Africa, carried out by the authors of Portfolios of the Poor, showed that poverty proliferates in regions whose inhabitants do not have access to financial services. Humaniq is becoming the simplest route to financial inclusion for billions of people.'
}, {
  imageSrc: '/img/design-v2/icons/sections/user-base-expo.svg',
  title: 'User base exponential growth',
  text: "According to Metcalfe's law, the value of a network is proportional to the square of the number of its users. For Humaniq, this means that the more unbanked people who join the system, the greater the motivation will be for other people to join."
}];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(33);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(686);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WorldTalking');

var _getMentions = function _getMentions(mentions) {
  return mentions.map(function (_ref, index) {
    var title = _ref.title,
        url = _ref.url,
        urlText = _ref.urlText;
    return _react2.default.createElement(
      'li',
      { key: 'mention-' + (index + 1), className: cn('mention') },
      _react2.default.createElement(
        'p',
        { className: cn('mention-title') },
        title
      ),
      _react2.default.createElement(
        'a',
        { className: cn('mention-link'), href: url, target: '_blank' },
        urlText
      )
    );
  });
};

var SE_Home_WorldTalking = function SE_Home_WorldTalking(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'The world is talking'
      ),
      _react2.default.createElement(
        'ul',
        { className: cn('mentions-list') },
        _getMentions(hmqMentions)
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 13, theme: 'dark' })
  );
};

exports.default = SE_Home_WorldTalking;


var hmqMentions = [{
  title: 'Huffingtonpost.com:',
  url: 'http://www.huffingtonpost.com/entry/tackling-financial-exclusion-with-biometric-technology_us_591af1ace4b03e1c81b008bc?ncid=engmodushpmg00000004',
  urlText: 'Tackling Financial Exclusion With Biometric Technology'
}, {
  title: 'Thenextweb.com:',
  url: 'https://thenextweb.com/guests/5-things-need-know-blockchain-technology/?utm_source=t.co&utm_medium=referral&utm_content=5%20Things%20You%20Need%20to%20Know%20About%20Blockchain%20Technology&utm_campaign=share%2Bbutton#.tnw_X4BwNKpu',
  urlText: '5 Things You Need to Know About Blockchain Technology'
}, {
  title: 'Forbes.com:',
  url: 'https://www.forbes.com/sites/haroldstark/2017/04/21/from-here-to-where-bitcoin-and-the-future-of-cryptocurrency/#14428f594367',
  urlText: 'From Here To Where? Bitcoin And The Future Of Cryptocurrency'
}, {
  title: 'Cointelegraph.com:',
  url: 'https://cointelegraph.com/news/ethereum-based-humaniq-to-deliver-banking-40-to-2-bln-unbanked',
  urlText: 'Ethereum-Based Humaniq To Deliver Banking 4.0 to 2 Bin Unbanked'
}, {
  title: 'Finance.yahoo.com:',
  url: 'https://finance.yahoo.com/news/humaniq-blockchain-financial-platform-unbanked-185522211.html',
  urlText: 'Humaniq, Blockchain Financial Platform for the Unbanked, Appoints CEO and 20 Members to Global Advisory Board'
}, {
  title: 'Nasdaq.com:',
  url: 'http://www.nasdaq.com/article/humaniq-aims-to-tackle-barriers-to-economic-inclusion-with-blockchain-app-cm764760',
  urlText: 'Humaniq Aims to Tackle Barriers to Economic Inclusion With Blockchain App'
}];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(687);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumn');

var M_InfoColumn = function (_Component) {
  (0, _inherits3.default)(M_InfoColumn, _Component);

  function M_InfoColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_InfoColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_InfoColumn.__proto__ || (0, _getPrototypeOf2.default)(M_InfoColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      needWidth: typeof _this.props.setWidth === 'function'
    }, _this.setWidth = function () {
      _this.props.setWidth(_this.node.offsetWidth);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_InfoColumn, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.needWidth) {
        window.addEventListener('resize', this.setWidth);
        this.setWidth();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.needWidth) {
        window.removeEventListener('resize', this.setWidth);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          column = _props.column;
      var needWidth = this.state.needWidth;

      return _react2.default.createElement(
        'div',
        { className: cn([mix]), ref: needWidth ? function (node) {
            return _this2.node = node;
          } : undefined },
        column.imageSrc ? _react2.default.createElement('img', { className: cn('image'), src: column.imageSrc }) : null,
        _react2.default.createElement(
          _A_Title_H2.default,
          { mix: cn('title'), type: 'info-column', theme: 'dark' },
          column.title
        ),
        _react2.default.createElement(
          'p',
          { className: cn('text') },
          column.text
        )
      );
    }
  }]);
  return M_InfoColumn;
}(_react.Component);

M_InfoColumn.propTypes = {
  mix: T.string, //BEM mixin from parent block
  column: T.object.isRequired //Column to render
};

exports.default = M_InfoColumn;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _page = __webpack_require__(395);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

var _actions2 = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var theme = state.navigation.theme,
      users_number = state.home.users_number;

  return { theme: theme, users_number: users_number };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ setTheme: _actions.setTheme, openPopup: _actions.openPopup, submit: _actions2.submit, openPeopleModal: _actions.openPeopleModal }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(710);

var _utils = __webpack_require__(1);

var _isMobile = __webpack_require__(93);

var _O_Footer_H = __webpack_require__(72);

var _O_Footer_H2 = _interopRequireDefault(_O_Footer_H);

var _EmpoweringSection = __webpack_require__(396);

var _EmpoweringSection2 = _interopRequireDefault(_EmpoweringSection);

var _NewsSection = __webpack_require__(401);

var _NewsSection2 = _interopRequireDefault(_NewsSection);

var _FirstMobileSection = __webpack_require__(398);

var _FirstMobileSection2 = _interopRequireDefault(_FirstMobileSection);

var _UnbankedStatSection = __webpack_require__(409);

var _UnbankedStatSection2 = _interopRequireDefault(_UnbankedStatSection);

var _QuotesSection = __webpack_require__(404);

var _QuotesSection2 = _interopRequireDefault(_QuotesSection);

var _WhatMakesSection = __webpack_require__(411);

var _WhatMakesSection2 = _interopRequireDefault(_WhatMakesSection);

var _SafetySection = __webpack_require__(405);

var _SafetySection2 = _interopRequireDefault(_SafetySection);

var _OpportunitiesSection = __webpack_require__(402);

var _OpportunitiesSection2 = _interopRequireDefault(_OpportunitiesSection);

var _Partners = __webpack_require__(403);

var _Partners2 = _interopRequireDefault(_Partners);

var _GrowingSection = __webpack_require__(400);

var _GrowingSection2 = _interopRequireDefault(_GrowingSection);

var _UseCasesSection = __webpack_require__(410);

var _UseCasesSection2 = _interopRequireDefault(_UseCasesSection);

var _GlobalChallengeSection = __webpack_require__(399);

var _GlobalChallengeSection2 = _interopRequireDefault(_GlobalChallengeSection);

var _ExpeditionSection = __webpack_require__(397);

var _ExpeditionSection2 = _interopRequireDefault(_ExpeditionSection);

var _WorldTalkingSection = __webpack_require__(412);

var _WorldTalkingSection2 = _interopRequireDefault(_WorldTalkingSection);

var _TeamSection = __webpack_require__(408);

var _TeamSection2 = _interopRequireDefault(_TeamSection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('News1');
// import Meta from './meta.js'

/*import TimelineSection from './sections/TimelineSection'*/


var serverNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'press', 'contacts'];
var clientNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'team', 'press', 'contacts'];

var sectionsNames =  true ? clientNames : serverNames;

var dark = ['mobile', 'situation', 'platform', 'opportunities', 'partners', 'use cases', 'expedition', 'team'];

var showingWidth = 1120;

var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showIndex: _this.props.showIndex || 0,
      scroll: true,
      fastScroll: true,
      widthBig: true && window.innerWidth >= showingWidth
    }, _this.sectionsObj = {
      empowering: _react2.default.createElement(_EmpoweringSection2.default, { mix: cn('section'), key: 'empowering', users_number: _this.props.users_number }),
      news: _react2.default.createElement(_NewsSection2.default, { mix: cn('section'), key: 'news' }),
      mobile: _react2.default.createElement(_FirstMobileSection2.default, { mix: cn('section'), key: 'mobile' }),
      situation: _react2.default.createElement(_UnbankedStatSection2.default, { mix: cn('section'), key: 'situation' }),
      changes: _react2.default.createElement(_QuotesSection2.default, { mix: cn('section', { type: 'slider' }), key: 'changes' }),
      platform: _react2.default.createElement(_WhatMakesSection2.default, { mix: cn('section'), key: 'platform' }),
      simplicity: _react2.default.createElement(_SafetySection2.default, { mix: cn('section'), key: 'simplicity' }),
      opportunities: _react2.default.createElement(_OpportunitiesSection2.default, { mix: cn('section'), key: 'opportunities' }),
      partners: _react2.default.createElement(_Partners2.default, { mix: cn('section'), key: 'partners' }),
      userbase: _react2.default.createElement(_GrowingSection2.default, { mix: cn('section'), key: 'userbase' }),
      'use cases': _react2.default.createElement(_UseCasesSection2.default, { mix: cn('section'), key: 'usecases' }),
      challenge: _react2.default.createElement(_GlobalChallengeSection2.default, { mix: cn('section'), key: 'challenge' }),
      expedition: _react2.default.createElement(_ExpeditionSection2.default, { mix: cn('section'), key: 'expedition' }),
      /*timeline: <TimelineSection mix={cn('section')} key="timeline" />,*/
      team: _react2.default.createElement(_TeamSection2.default, { mix: cn('section'), key: 'team', openPeopleModal: _this.props.openPeopleModal }),
      press: _react2.default.createElement(_WorldTalkingSection2.default, { mix: cn('section'), key: 'press' }),
      contacts: _react2.default.createElement(_O_Footer_H2.default, {
        mix: cn('section', { type: 'half-height' }),
        openPopup: _this.props.openPopup,
        key: 'contacts'
      })
    }, _this.handleSideMenu = function (_ref2) {
      var showIndex = _ref2.showIndex,
          extra = (0, _objectWithoutProperties3.default)(_ref2, ['showIndex']);
      var setTheme = _this.props.setTheme;

      _this.setState((0, _extends3.default)({ showIndex: showIndex }, extra));
      if (dark.includes(sectionsNames[showIndex])) {
        setTheme('dark');
      } else {
        setTheme('bright');
      }
    }, _this.handleWeel = function (_ref3) {
      var deltaY = _ref3.deltaY;

      var touchBar = deltaY - Math.round(deltaY) === 0;

      if (touchBar) {
        _this.handleTouchBar({ deltaY: deltaY });
      } else {
        _this.handleMouseWeel({ deltaY: deltaY });
      }
    }, _this.handleScrollUp = function () {
      _this.setState({ showIndex: 0 });
    }, _this.getWidth = function () {
      var widthBig = window.innerWidth >= showingWidth,
          shorter = _this.state.widthBig && !widthBig,
          bigger = !_this.state.widthBig && widthBig;

      if (shorter || bigger) {
        _this.setState({ widthBig: widthBig });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'getSideMenu',
    value: function getSideMenu(showIndex) {
      var _this2 = this;

      var hashLinks = sectionsNames.map(function (name, i) {
        return _react2.default.createElement(
          'div',
          {
            key: name,
            className: cn('side-menu-item'),
            onClick: function onClick() {
              return _this2.handleSideMenu({ showIndex: i });
            }
          },
          _react2.default.createElement('div', { className: cn('dot', { selected: showIndex === i }) })
        );
      });
      return _react2.default.createElement(
        'aside',
        { className: cn('side-menu') },
        hashLinks
      );
    }
  }, {
    key: 'handleTouchBar',
    value: function handleTouchBar(_ref4) {
      var _this3 = this;

      var deltaY = _ref4.deltaY;
      var _state = this.state,
          oldIndex = _state.showIndex,
          fastScroll = _state.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 100) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this3.setState({ scroll: true });
      }, 400);
      setTimeout(function () {
        return _this3.setState({ fastScroll: true });
      }, 1000);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: '_handleKeyPress',
    value: function _handleKeyPress(_ref5) {
      var keyCode = _ref5.keyCode;
      var oldIndex = this.state.showIndex;

      var nextCodes = [40, 34, 32, 39],
          prevCodes = [38, 33, 36, 37];
      if (nextCodes.includes(keyCode) && oldIndex < sectionsNames.length - 1) {
        this.setState({ showIndex: oldIndex + 1 });
      } else if (prevCodes.includes(keyCode) && oldIndex > 0) {
        this.setState({ showIndex: oldIndex - 1 });
      }
    }
  }, {
    key: 'handleMouseWeel',
    value: function handleMouseWeel(_ref6) {
      var _this4 = this;

      var deltaY = _ref6.deltaY;
      var _state2 = this.state,
          oldIndex = _state2.showIndex,
          fastScroll = _state2.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 900) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this4.setState({ scroll: true });
      }, 200);
      setTimeout(function () {
        return _this4.setState({ fastScroll: true });
      }, 500);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.getWidth);
      this.container.focus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.getWidth);
    }
  }, {
    key: 'getPositionY',
    value: function getPositionY(showIndex) {
      if (showIndex === sectionsNames.length - 1) {
        return (showIndex - 1) * 100 + 50;
      } else {
        return showIndex * 100;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state3 = this.state,
          showIndex = _state3.showIndex,
          scroll = _state3.scroll,
          widthBig = _state3.widthBig;

      var controlledScroll = false;
      var positionY = controlledScroll ? this.getPositionY(showIndex) : 0;
      return _react2.default.createElement(
        'div',
        {
          className: cn({ scroll: !controlledScroll }),
          tabIndex: '0',
          ref: function ref(el) {
            _this5.container = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: cn('inner') },
          sectionsNames.map(function (name) {
            return _this5.sectionsObj[name];
          })
        )
      );
    }
  }]);
  return Home;
}(_react.Component);

Home.propTypes = {
  total_installations: T.number
};

Home.defaultProps = {};

exports.default = Home;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _O_SimpleForm_H_ = __webpack_require__(108);

var _O_SimpleForm_H_2 = _interopRequireDefault(_O_SimpleForm_H_);

var _M_Exchanges_Slider = __webpack_require__(106);

var _M_Exchanges_Slider2 = _interopRequireDefault(_M_Exchanges_Slider);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _index = __webpack_require__(91);

var _index2 = _interopRequireDefault(_index);

var _reactDelay = __webpack_require__(118);

var _reactDelay2 = _interopRequireDefault(_reactDelay);

var _reactScrollableAnchor = __webpack_require__(126);

var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);

var _news = __webpack_require__(53);

__webpack_require__(691);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import M_Countdown from "../../../../widgets/M_Countdown";
var cn = (0, _utils.cssClassName)('SE_News1_Empowering');

var handleLinkClick = function handleLinkClick(name) {
    if (window.ga) window.ga('send', 'event', 'other', 'event-click-' + name);
};

var formatUserNum = function formatUserNum(users) {
    var usersD = users.toString();
    usersD = usersD.slice(0, usersD.length - 3) + "  " + usersD.slice(usersD.length - 3);
    return usersD;
};

function createMarkup(input) {
    return { __html: input };
}

var _createLinks = function _createLinks(links) {
    return links.map(function (_ref, index) {
        var title = _ref.title,
            more = _ref.more,
            img = _ref.img,
            button = _ref.button,
            url = _ref.url,
            uid = _ref.uid,
            isInt = _ref.isInt;

        var divStyle = {
            backgroundImage: 'url(' + img + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top center',
            backgroundSize: 'cover'
        };
        isInt = isInt ? '' : '_blank';
        return _react2.default.createElement(
            'div',
            { className: 'item', key: 'mainEvent-' + (index + 1) },
            _react2.default.createElement(
                'div',
                { className: 'wrap', style: divStyle },
                _react2.default.createElement('h1', { dangerouslySetInnerHTML: createMarkup(title) }),
                _react2.default.createElement('div', { className: 'more', dangerouslySetInnerHTML: createMarkup(more) }),
                button && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: url, className: 'button', onClick: function onClick() {
                                handleLinkClick(uid);
                            }, target: isInt },
                        button
                    )
                )
            )
        );
    });
};

var SE_Home_Empowering = function (_React$Component) {
    (0, _inherits3.default)(SE_Home_Empowering, _React$Component);

    function SE_Home_Empowering(props) {
        (0, _classCallCheck3.default)(this, SE_Home_Empowering);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SE_Home_Empowering.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Empowering)).call(this, props));

        _this.gotoSlide = function (index) {
            _this.slider.slickGoTo(index);
            console.log(_this.slider);
        };

        _this.createDots = function (list) {
            return list.map(function (_ref2, index) {
                var title = _ref2.title,
                    more = _ref2.more,
                    img = _ref2.img;

                return _react2.default.createElement(
                    'i',
                    null,
                    _this.state.activeSlide == index && _react2.default.createElement(
                        'div',
                        { className: 'pie-wrap' },
                        _react2.default.createElement('div', { className: 'slice1 slice-wrap' }),
                        _react2.default.createElement('div', { className: 'slice2 slice-wrap' })
                    ),
                    _this.state.activeSlide != index && _react2.default.createElement('div', { className: 'pie-wrap full', onClick: function onClick() {
                            _this.gotoSlide(index);
                        } })
                );
            });
        };

        _this.state = {
            hmq2usd: "",
            ccwShow: false
        };
        return _this;
    }

    (0, _createClass3.default)(SE_Home_Empowering, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _index2.default.get("https://api.coinmarketcap.com/v2/ticker/1669/").then(function (res) {
                console.log(res.data);
                var ratio = Math.round(1000 * res.data.data.quotes.USD.price) / 1000;
                console.log(ratio);
                _this2.setState({
                    hmq2usd: "1 HMQ = " + ratio + " USD",
                    ccwShow: res.data.data.quotes.USD.percent_change_24h > 0,
                    ccw: res.data.data.quotes.USD.percent_change_24h
                });
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var settings = {
                loop: true,
                speed: 700,
                autoplay: true,
                autoplaySpeed: 5350,
                cssEase: 'ease-in-out',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                initialSlide: 0,
                arrows: false,
                //dots: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                mobileFirst: true,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                beforeChange: function beforeChange(current, next) {
                    return _this3.setState({ activeSlide: next });
                }
            };

            var iframeResizerOptions = { checkOrigin: false };

            return _react2.default.createElement(
                'section',
                { className: cn([this.mix]) },
                _react2.default.createElement(
                    'div',
                    { className: cn('left-side') },
                    _react2.default.createElement(
                        'div',
                        { className: cn('map') },
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'desktop' }),
                            src: '/img/v1/home/map-bg-2.png',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'mobile' }),
                            src: '/img/v1/home/mobile-map.jpg',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 1 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 2 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 3 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 4 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 5 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('text') },
                        _react2.default.createElement(
                            _A_Title_H2.default,
                            { type: 'hero', mix: cn('text-title'), theme: 'bright' },
                            'P2P financial services ',
                            _react2.default.createElement('br', null),
                            'for developing countries'
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: cn('text-subtitle') },
                            'Connecting 1.7 billion people'
                        ),
                        this.state.ccwShow && _react2.default.createElement(
                            'div',
                            { className: 'ccw-wrap' },
                            _react2.default.createElement('script', { type: 'text/javascript',
                                src: 'https://files.coinmarketcap.com/static/widget/currency.js' }),
                            _react2.default.createElement('div', { className: 'coinmarketcap-currency-widget', 'data-currencyid': '1669', 'data-base': 'USD',
                                'data-secondary': '', 'data-ticker': 'true', 'data-rank': 'true', 'data-marketcap': 'true',
                                'data-volume': 'true', 'data-stats': 'USD', 'data-statsticker': 'false' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('anni') },
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-title' },
                            '1 year after tokensale'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-operate' },
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-mark' },
                                _react2.default.createElement('img', { src: '/img/done.svg' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide one' },
                                '21 countries ',
                                _react2.default.createElement('br', null),
                                ' operating'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide two' },
                                formatUserNum(452068),
                                ' ',
                                _react2.default.createElement('br', null),
                                'users'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide three' },
                                'Hybrid ',
                                _react2.default.createElement('br', null),
                                'blockchain'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('right-side') },
                    _react2.default.createElement(
                        _reactSlick2.default,
                        (0, _extends3.default)({ ref: function ref(slider) {
                                return _this3.slider = slider;
                            } }, settings),
                        _createLinks(_news.mainList)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "overlay" },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'TODAY'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'i',
                                null,
                                this.state.hmq2usd
                            ),
                            this.state.ccwShow && _react2.default.createElement(
                                'div',
                                { className: 'mmark' },
                                _react2.default.createElement('img', { src: '/img/ccw-arrow.svg' }),
                                this.state.ccw,
                                '%'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: "dots" },
                            this.createDots(_news.mainList)
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactScrollableAnchor2.default,
                    { id: 'xchange' },
                    _react2.default.createElement(
                        'div',
                        { className: 'coinswitch-widget' },
                        _react2.default.createElement(
                            'iframe',
                            { width: '100%', height: '400', src: 'https://coinswitch.co/widget?widget_id=fc72a10e&from=btc&to=hmq&amount=0.01', frameBorder: 0, order: '0', scrolling: 'no' },
                            'Can\'t load widget'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('slider-wrap') },
                    _react2.default.createElement(
                        'div',
                        { className: 'w' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                _A_Title_H2.default,
                                { type: 'hero', theme: 'bright' },
                                'HMQ token is a fuel of the platform'
                            ),
                            'Visit one of the following external services independent from Humaniq in order to purchase HMQ'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'b' },
                            _react2.default.createElement(
                                'a',
                                { className: 'button', href: 'https://bittrex.com/Market/Index?MarketName=BTC-HMQ', target: '_blank' },
                                'Trade now'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('slider') },
                        _react2.default.createElement(
                            _reactDelay2.default,
                            { wait: 2000 },
                            _react2.default.createElement(_M_Exchanges_Slider2.default, null)
                        )
                    )
                )
            );
        }
    }]);
    return SE_Home_Empowering;
}(_react2.default.Component);

exports.default = SE_Home_Empowering;


SE_Home_Empowering.propTypes = {
    //mix: T.string,
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(69);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(692);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Expedition');

var SE_Home_Expedition = function SE_Home_Expedition(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq expedition: the first',
        _react2.default.createElement('br', null),
        ' step in financial inclusion'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
      _react2.default.createElement(
        'div',
        { className: cn('button') },
        _react2.default.createElement(
          _A_Btn_H2.default,
          { to: 'https://challenge.humaniq.com' },
          'About expedition'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 11, theme: 'bright' })
  );
};

exports.default = SE_Home_Expedition;


var infoColumns = [{
  title: 'Startup contest',
  text: 'In order to bring together a network of like-minded individuals and then choose 10 projects for entry into the Humaniq system, we are launching the Humaniq Global Challenge for entrepreneurs, developers, marketing specialists and economists.'
}, {
  title: 'Benefits',
  text: '10 Finalists will receive expert advice from top consultants in their field, as well as the chance to gain investment and to enter the Humaniq accelerator.'
}, {
  title: 'Trip to Kenya',
  text: 'The three best teams will go on a trip to Kenya to learn more about the lives of the unbanked and put the finishing touches to their projects ahead of an ICO, which will be supported by Humaniq.'
}];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(69);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(693);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_FirstMobile');

var handleLinkClick = function handleLinkClick() {
  if (window.ga) window.ga('send', 'event', 'other', 'whitepaper-btn-click');
};

var SE_Home_FirstMobile = function SE_Home_FirstMobile(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'The first mobile service with',
        _react2.default.createElement('br', null),
        'the capacity to change the world'
      ),
      _react2.default.createElement(
        'p',
        { className: cn('subtitle') },
        'Humaniq is a new generation financial services',
        _react2.default.createElement('br', null),
        ' with its own cryptocurrency, which is aimed at',
        _react2.default.createElement('br', null),
        ' eradicating poverty amongst millions of people',
        _react2.default.createElement('br', null),
        ' living in the emerging economies'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
        _react2.default.createElement(
          'div',
          { className: cn('button') },
          _react2.default.createElement(
            _A_Btn_H2.default,
            { to: '/pdf/humaniq-whitepaper-05.09.pdf', clickHandler: handleLinkClick },
            'Whitepaper'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 2, theme: 'bright' })
  );
};

exports.default = SE_Home_FirstMobile;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/key.svg',
  title: 'For the unbanked people',
  text: 'Humaniq opens up the benefits of financial inclusion and grants access to a series of financial services'
}, {
  imageSrc: '/img/design-v2/icons/sections/busness.svg',
  title: 'For businesses',
  text: 'Humaniq enables start-ups and projects to offer their services to an audience of billions'
}];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _M_SocialLinks_G = __webpack_require__(107);

var _M_SocialLinks_G2 = _interopRequireDefault(_M_SocialLinks_G);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(69);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(694);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_GlobalChallenge');

var SE_Home_GlobalChallenge = function SE_Home_GlobalChallenge(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq global',
        _react2.default.createElement('br', null),
        ' challenge'
      ),
      _react2.default.createElement(_InfoColumns2.default, {
        mix: cn('info-columns'),
        columns: infoColumns,
        type: 'narrow',
        layout: 'global-challenge'
      }),
      _react2.default.createElement(
        _M_SocialLinks_G2.default,
        { mix: cn('social-links'), type: 'section' },
        'You know how to enhance Humaniq?',
        _react2.default.createElement('br', null),
        ' Join the global Humaniq community'
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 10, theme: 'dark' })
  );
};

exports.default = SE_Home_GlobalChallenge;


var infoColumns = [{
  title: 'Life-changing technology',
  text: 'Humaniq grew out of the idea that advanced technologies should benefit everybody. Now, we want to inspire developers from all over the world to come and join our movement.'
}, {
  title: 'Humanitarian impact',
  text: 'Humaniq is not just a commercial project. It is a worldwide mission, aiming to give people in developing nations more power to change their lives.'
}];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(695);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Growing');

var SE_Home_Growing = function SE_Home_Growing(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq\'s ever\u2011growing',
        _react2.default.createElement('br', null),
        ' userbase is a blue ocean for',
        _react2.default.createElement('br', null),
        ' thousands of new projects'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '1 ',
            _react2.default.createElement(
              'span',
              null,
              'billion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'new users in the',
            _react2.default.createElement('br', null),
            ' coming years'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '$4 ',
            _react2.default.createElement(
              'span',
              null,
              'trillion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'potentially in',
            _react2.default.createElement('br', null),
            ' user accounts'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '200+'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'start-ups are planning',
            _react2.default.createElement('br', null),
            ' to move onto the',
            _react2.default.createElement('br', null),
            ' Humaniq platform'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 8, theme: 'dark' })
  );
};

exports.default = SE_Home_Growing;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

__webpack_require__(696);

var _utils = __webpack_require__(1);

var _news = __webpack_require__(53);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Butter from 'buttercms';
//const butter = Butter('63c5be1dcac33aad42357d8eb320058d0562c240');

var cn = (0, _utils.cssClassName)('SE_News1_News');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'news-click-' + name);
};

var _createLinks = function _createLinks(links, startIndex) {
  return links.map(function (_ref, index) {
    var title = _ref.title,
        src = _ref.src,
        url = _ref.url,
        date = _ref.date,
        img = _ref.img,
        target = _ref.target;


    if (index >= startIndex) {
      return _react2.default.createElement(
        'div',
        { className: 'item', key: 'newsLink-' + (index + 1) },
        url && _react2.default.createElement(
          'a',
          { className: 'link', href: url, title: title, target: target,
            onClick: function onClick() {
              handleLinkClick(index);
            } },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        !url && _react2.default.createElement(
          'div',
          { className: 'link', title: title },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'src' },
          date
        )
      );
    }
  });
};

function nextArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

function prevArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

var SE_News1_News = function (_React$Component) {
  (0, _inherits3.default)(SE_News1_News, _React$Component);

  function SE_News1_News(props) {
    (0, _classCallCheck3.default)(this, SE_News1_News);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SE_News1_News.__proto__ || (0, _getPrototypeOf2.default)(SE_News1_News)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(SE_News1_News, [{
    key: 'render',
    value: function render() {

      var settings = {
        loop: true,

        speed: 700,
        autoplay: false,
        cssEase: 'ease-in-out',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 0,
        arrows: true,
        //buttons: false,
        //dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        mobileFirst: true,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        nextArrow: _react2.default.createElement('nextArrow', null),
        prevArrow: _react2.default.createElement('prevArrow', null),

        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }]
      };

      return _react2.default.createElement(
        'section',
        { className: cn([this.mix]) },
        _react2.default.createElement(
          _A_Title_H2.default,
          { type: 'hero', mix: cn('text-title'), theme: 'dark' },
          'Latest ',
          _react2.default.createElement(
            'ss',
            null,
            'news'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('article-list') },
          _react2.default.createElement(
            _reactSlick2.default,
            settings,
            _createLinks(_news.articleList, 0)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('more-news') },
          _react2.default.createElement(
            'a',
            { className: 'button', href: 'https://blog.humaniq.co/', target: '_blank' },
            'See All NEWS'
          ),
          _react2.default.createElement(
            'a',
            { className: 'link-sec', href: 'https://www.facebook.com/humaniq.co/', target: '_blank' },
            'Join our Facebook',
            _react2.default.createElement('img', { src: '/img/link.svg' })
          )
        )
      );
    }
  }]);
  return SE_News1_News;
}(_react2.default.Component);

exports.default = SE_News1_News;


SE_News1_News.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(69);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(697);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Opportunities');

var SE_Home_Opportunities = function SE_Home_Opportunities(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Extraordinary opportunitites for business'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 7, theme: 'bright' })
  );
};

exports.default = SE_Home_Opportunities;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/etherium.svg',
  title: 'Based on Ethereum blockchain protocol',
  text: 'Guaranteed security against hacking, corruption and loss of information thanks to complete decentralisation'
}, {
  imageSrc: '/img/design-v2/icons/sections/accelerator.svg',
  title: 'Independent fund and accelerator',
  text: 'External projects and promising ideas can receive expert support and investment for a launch into the Humaniq system'
}, {
  imageSrc: '/img/design-v2/icons/sections/api.svg',
  title: 'Open API',
  text: 'Any project can merge into the Humaniq system'
}];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(698);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Partners');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'partners-click-' + name);
};

function createMarkup(input) {
  return { __html: input };
}

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var href = _ref.href,
        img = _ref.img,
        name = _ref.name,
        more = _ref.more;

    var divStyle = {
      backgroundImage: 'url(' + img + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    };
    console.log(divStyle);
    return _react2.default.createElement(
      'div',
      { className: 'item', key: 'partner-' + (index + 1) },
      href && _react2.default.createElement(
        'a',
        { href: href, className: 'wrap', target: '_blank', onClick: function onClick() {
            handleLinkClick(name);
          } },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      ),
      !href && _react2.default.createElement(
        'div',
        { className: 'wrap' },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      )
    );
  });
};

var SE_Partners = function SE_Partners(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq Partners'
      ),
      _react2.default.createElement(
        'div',
        { className: 'partners-list' },
        _createLinks(infoColumns)
      )
    )
  );
};

exports.default = SE_Partners;


var infoColumns = [{
  img: '/img/partners/un.png',
  href: "https://www.unglobalcompact.org",
  name: 'un',
  more: "The visionary who launched the <b>UN Global Compact</b> and inspired the world’s largest corporate sustainability initiative."
}, {
  img: '/img/partners/l39.png',
  href: "https://www.level39.co",
  name: 'l39',
  more: "<b>Level39</b> is a community of 1,250 leaders in cybersecurity, fintech and retail tech"
}, {
  img: '/img/partners/rise.png',
  href: "https://thinkrise.com",
  name: 'rise',
  more: "<b>Rise</b> is a community of startups & corporates creating the future of financial services."

}, {
  img: '/img/partners/coinfirm.png',
  href: "https://www.coinfirm.io",
  name: 'coinfirm',
  more: "The <b>Coinfirm</b> platform provides and easy to use solution with valuable structured data that puts entities on the safe side in terms of regulatory and fraud risk."

}, {
  img: '/img/partners/transbox.png',
  href: "http://www.transbox.xyz",
  name: 'transbox',
  more: "<b>Transbox</b> is online communication and data security specialised company."

}, {
  img: '/img/partners/bi.png',
  href: "https://www.biometricsinstitute.org",
  name: 'bi',
  more: "The mission of the <b>Biometrics Institute</b> is to promote the responsible use of biometrics in an independent and impartial international forum for biometric users and other interested parties."

}, {
  img: '/img/partners/jamii.png',
  href: "http://www.jamiiafrica.com/",
  name: 'jamii',
  more: "<b>Jamii Africa</b> is mobile micro-health insurance for the informal sector."

}, {
  img: '/img/partners/ff.png',
  href: "http://futurefintech.org",
  name: 'ff',
  more: "<b>Future Fintech</b> are connecting young businesses to the global community of VC and tech startups, giving access to the best tested cases, wide range of sector specific expertise and pinpoint advices."

}];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(699);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Quotes');

var _getQuotesSlides = function _getQuotesSlides(quotes) {
  var res = [];
  var genSlidesArray = function genSlidesArray(keysName) {
    return quotes.map(function (quote, index) {

      return _react2.default.createElement(
        'div',
        { key: 'quote-' + (keysName + (index + 1)), className: cn('slide') },
        _react2.default.createElement(
          'div',
          { className: cn('slide-content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('slide-title'), type: 'section', theme: 'bright' },
            quote.title
          ),
          _react2.default.createElement(
            'p',
            {
              className: quote.text.length < 260 ? cn('slide-text') : cn('slide-text', { type: 'small' })
            },
            quote.text
          ),
          _react2.default.createElement(
            'p',
            { className: cn('slide-author') },
            '\u2014 ',
            quote.author
          )
        )
      );
    });
  };

  res = res.concat(genSlidesArray('clone_before'));
  res = res.concat(genSlidesArray('clone_middle'));
  res = res.concat(genSlidesArray('clone_after'));

  return res;
};

var SE_Home_Quotes = function (_Component) {
  (0, _inherits3.default)(SE_Home_Quotes, _Component);

  function SE_Home_Quotes() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Quotes);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Quotes.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Quotes)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Quotes, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + quotes.length) % quotes.length;
      this.setState({ show: show });
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;
      var show = this.state.show;

      var pctX = show * 25;
      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('slider'), style: { transform: 'translateX(-' + pctX + '%)' } },
          _getQuotesSlides(quotes)
        ),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'prev' }), onClick: this.prev }),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'next' }), onClick: this.next }),
        _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 4, theme: 'dark' })
      );
    }
  }]);
  return SE_Home_Quotes;
}(_react.Component);

exports.default = SE_Home_Quotes;


SE_Home_Quotes.propTypes = {
  mix: T.string //BEM mixin from parent block
};

var quotes = [{
  title: 'The world is ready for change',
  text: 'Including the poorest in the financial system increases the value of their assets, transforming the underlying economics of financial services through digital currency - helping those who live in poverty directly.',
  author: 'Bill Gates',
  img: '/img/design-v2/sections/quotes/bill-gates2.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Because of technology, we can help shape the arc of history to bend it towards financial inclusion and greater human progress. Financial inclusion is a massive undertaking – one that can only be met together – across countries, sectors, and industries.',
  author: 'Ajaypal Singh Banga, MasterCard CEO',
  img: '/img/design-v2/sections/quotes/ajaypal-singh-banga.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Widely used digital finance has the power to transform the economic prospects of billions of people and inject new dynamism into small businesses that today are held back for lack of credit. Emerging economies have an opportunity to use mobile technologies to provide digital financial services for all, rapidly unlocking economic opportunity and accelerating social development.',
  author: 'McKinsey Global Institute Report September 2016',
  img: '/img/design-v2/sections/quotes/mckinsey-global-Institute.jpg'
}, {
  title: 'The world is ready for change',
  text: 'In pyramid of development the bottom-most layer needs to be strengthened through financial inclusionimproving purchasing power of the poor.',
  author: 'Narendra Modi',
  img: '/img/design-v2/sections/quotes/narendra-modi.jpg'
}];

// import * as T from "prop-types";
// import './styles.scss';
// import {cssClassName} from 'utils'
// const cn = cssClassName('')

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(69);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(700);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Safety');

var SE_Home_Safety = function SE_Home_Safety(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Simplicity and safety for the unbanked'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 6, theme: 'dark' })
  );
};

exports.default = SE_Home_Safety;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/card.svg',
  title: 'Biometric authentification',
  text: 'Users are verified by their face and voice, eliminating the need for formal documentation '
}, {
  imageSrc: '/img/design-v2/icons/sections/access.svg',
  title: 'Independent HMQ currency',
  text: 'Every new user receives $20 worth of HMQ in their account, the value of which bears no relation to their local currency'
}, {
  imageSrc: '/img/design-v2/icons/sections/interface.svg',
  title: 'The interface is simple to interact with',
  text: 'Even for those who have never used gadgets before'
}];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(701);

var _utils = __webpack_require__(1);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as T from "prop-types";
var cn = (0, _utils.cssClassName)('TeamSectionSlide');


var getHazemName = function getHazemName() {
  return _react2.default.createElement(
    'span',
    null,
    'Hazem Danny',
    _react2.default.createElement('br', null),
    'Al-Nakib'
  );
};

var TeamSectionSlide = function (_Component) {
  (0, _inherits3.default)(TeamSectionSlide, _Component);

  function TeamSectionSlide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TeamSectionSlide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TeamSectionSlide.__proto__ || (0, _getPrototypeOf2.default)(TeamSectionSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getSlide = function (_ref2, groupName, i) {
      var first = _ref2.first,
          imgSrc = _ref2.imgSrc,
          position = _ref2.position,
          name = _ref2.name,
          bio = _ref2.bio;

      name = name.search('Al-Nakib') === -1 ? name : getHazemName();
      var handleClick = bio ? function () {
        return _this.props.openPeopleModal({ imgSrc: imgSrc, position: position, name: name, bio: bio, groupName: groupName });
      } : undefined;
      return _react2.default.createElement(
        'div',
        { className: cn('person'), key: i, onClick: handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('person-image') },
          _react2.default.createElement(_A_Image2.default, { src: imgSrc, rounded: true })
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-name') },
          name
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-title') },
          position
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TeamSectionSlide, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          persons = _props.persons,
          showGroupName = _props.showGroupName,
          groupName = _props.groupName,
          hidden = _props.hidden;

      var renderTitle = showGroupName && groupName && _react2.default.createElement(
        'span',
        { className: cn('group-name') },
        groupName
      );
      var renderSlides = persons.map(function (el, i) {
        return _this2.getSlide(el, groupName, i);
      });
      return _react2.default.createElement(
        'div',
        { className: cn({ wide: showGroupName, hidden: hidden }) },
        renderTitle,
        renderSlides
      );
    }
  }]);
  return TeamSectionSlide;
}(_react.Component);

TeamSectionSlide.propTypes = {};

TeamSectionSlide.defaultProps = {};
exports.default = TeamSectionSlide;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getDelta = getDelta;
exports._indexOfShow = _indexOfShow;
exports.indexOfShow = indexOfShow;
exports.findIndexesOfRedundantSlides = findIndexesOfRedundantSlides;
exports.pairSplit = pairSplit;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDelta(slidesWidths, show) {
  var k = -1;
  if (show < 0) {
    show = -show;
    slidesWidths = [].concat((0, _toConsumableArray3.default)(slidesWidths)).reverse();
    k = 1;
  }
  var delta = 0;

  if (show >= slidesWidths.length) {
    delta = slidesWidths.reduce(function (a, b) {
      return a + b;
    }, 0) * (show / slidesWidths.length | 0);
    show = show % slidesWidths.length;
  }

  for (var i = 0; i < show; i++) {
    delta += slidesWidths[i];
  }
  return delta * k;
}

function _indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index + 1;
  } else {
    return extended_index + 1;
  }
}

function indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index;
  } else {
    return extended_index;
  }
}

function findIndexesOfRedundantSlides(slidesCount, show, slidesWidths) {
  var width_container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var first_index_of_slides = indexOfShow(slidesCount, show);
  var slidesLengh = 0,
      previousLength = 0,
      i_last = first_index_of_slides;
  for (slidesLengh = 0; slidesLengh < width_container; i_last++) {
    previousLength = slidesLengh;
    slidesLengh = previousLength + slidesWidths[indexOfShow(slidesCount, i_last)];
  }
  var padding = width_container ? (width_container - previousLength) / 2 : '0';
  return {
    arr: [_indexOfShow(slidesCount, first_index_of_slides - 1), _indexOfShow(slidesCount, first_index_of_slides - 2), _indexOfShow(slidesCount, i_last - 1), _indexOfShow(slidesCount, i_last)],
    padding: padding
  };
}

function pairSplit(arr, title) {
  var entities = [];

  for (var i = 0; i < arr.length; i += 2) {
    entities.push(arr.slice(i, i + 2));
  }
  return {
    title: title,
    entities: entities
  };
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(702);

var _utils = __webpack_require__(1);

var _Swipe = __webpack_require__(92);

var _Swipe2 = _interopRequireDefault(_Swipe);

var _helpers = __webpack_require__(407);

var _Slide = __webpack_require__(406);

var _Slide2 = _interopRequireDefault(_Slide);

var _people = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Team');
// import A_Image from 'A_Image/index'


var NORMAL_WIDTH = 136;
var WIDE_WIDTH = NORMAL_WIDTH + 20 + 16;
// import M_Tooltip from 'M_Tooltip'

var SE_Home_Team = function (_Component) {
  (0, _inherits3.default)(SE_Home_Team, _Component);

  function SE_Home_Team() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Team);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Team.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Team)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.widths = { container: 0 }, _this.right = function () {
      return _this.changeShow(1);
    }, _this.left = function () {
      return _this.changeShow(-1);
    }, _this.changeShow = function (n) {
      return _this.setState(function (oldState) {
        return { show: oldState.show + n };
      });
    }, _this.onSwipeRight = _this.left, _this.onSwipeLeft = _this.right, _this.threshold = 100, _this.slideGroups = [(0, _helpers.pairSplit)(_people.team, 'team'), (0, _helpers.pairSplit)(_people.advisers, 'advisers'), (0, _helpers.pairSplit)(_people.ambassadors, 'ambassadors')], _this.slidesWidths = [], _this.slidesCount = _this.slideGroups.reduce(function (sum, el) {
      return sum + el.entities.length;
    }, 0), _this.getStep = function (slidesWidths, show) {
      return slidesWidths.length ? (0, _helpers.getDelta)(slidesWidths, show) : WIDE_WIDTH;
    }, _this.handleResize = function () {
      _this.forceUpdate();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Team, [{
    key: 'getSlides',
    value: function getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides) {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(slideGroups, keys_name) {
        var indexTotal = 0;
        return slideGroups.map(function (_ref2) {
          var title = _ref2.title,
              entities = _ref2.entities;

          return entities.map(function (slide, i) {
            indexTotal += 1;

            var first = i === 0;
            if (keys_name === 'clone_before') {
              _this2.slidesWidths.push(first ? WIDE_WIDTH : NORMAL_WIDTH);
            }
            return _react2.default.createElement(_Slide2.default, {
              persons: slide,
              place: keys_name + i,
              showGroupName: first,
              groupName: title,
              hidden: indexesOfRedundantSlides.arr.includes(indexTotal),
              mix: indexesOfRedundantSlides.arr.includes(indexTotal) ? cn('hidden-slide') : cn('showing-slide'),
              mouseSlideEnterHandler: _this2.mouseSlideEnterHandler,
              mouseSlideLeaveHandler: _this2.mouseSlideLeaveHandler,
              openPeopleModal: _this2.props.openPeopleModal
            });
          });
        });
      };

      res = res.concat(genSlidesArray(slideGroups, 'clone_before'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_middle'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_after'));

      return res;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.forceUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var mix = this.props.mix;
      var slideGroups = this.slideGroups,
          slidesWidths = this.slidesWidths,
          slidesCount = this.slidesCount;
      var show = this.state.show;

      var move = show / slidesCount | 0;
      var showingSlideIndex = (0, _helpers.indexOfShow)(slidesCount, show);

      var indexesOfRedundantSlides = (0, _helpers.findIndexesOfRedundantSlides)(slidesCount, show, this.slidesWidths, this.widths.container.offsetWidth);
      var padding = indexesOfRedundantSlides.padding;

      var renderedSlides = this.getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides);
      var step = this.getStep(slidesWidths, show);
      var active = void 0;
      if (showingSlideIndex < 0) {
        active = 'ambassadors';
      } else if (showingSlideIndex < 5) {
        active = 'team';
      } else if (showingSlideIndex < 9) {
        active = 'advisers';
      } else {
        active = 'ambassadors';
      }

      return _react2.default.createElement(
        'section',
        { className: cn([mix]) },
        _react2.default.createElement(
          'div',
          {
            className: cn('content')
          },
          _react2.default.createElement('div', { className: cn('nav-prev'), onClick: function onClick() {
              return _this3.left();
            } }),
          _react2.default.createElement('div', { className: cn('nav-next'), onClick: function onClick() {
              return _this3.right();
            } }),
          _react2.default.createElement(
            'div',
            { className: cn('header') },
            _react2.default.createElement(
              _A_Title_H2.default,
              { mix: cn('title'), type: 'section', theme: 'dark' },
              'People behind Humaniq project'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'team' }), onClick: function onClick() {
                    return _this3.setState({ show: 0 });
                  } },
                'Team'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'advisers' }), onClick: function onClick() {
                    return _this3.setState({ show: 5 });
                  } },
                'Advisers'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'ambassadors' }), onClick: function onClick() {
                    return _this3.setState({ show: 9 });
                  } },
                'Ambassadors'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'wrapper1',
              onTouchStart: this.props.onTouchStart,
              onTouchMove: this.props.onTouchMove,
              ref: function ref(node) {
                return _this3.widths.container = node;
              },
              style: { paddingLeft: padding }
            },
            _react2.default.createElement(
              'div',
              {
                className: 'wrapper2',
                style: { transform: 'translate3d(' + move * (this.widths.inner / 3) + 'px, 0px, 0px)' }
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'inner',
                  style: { transform: 'translate3d(' + (step - this.widths.inner / 3) + 'px, 0px, 0px)' },
                  ref: function ref(node) {
                    return _this3.widths.inner = node ? node.offsetWidth : 0;
                  }
                },
                renderedSlides
              )
            ),
            _react2.default.createElement('div', { className: cn('linner-gradient-left') }),
            _react2.default.createElement('div', { className: cn('linner-gradient-right') })
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 12, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_Team;
}(_react.Component);

SE_Home_Team.propTypes = {};

SE_Home_Team.defaultProps = {};

exports.default = (0, _Swipe2.default)(SE_Home_Team);

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(703);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UnbankedStat');

var SE_Home_UnbankedStat = function SE_Home_UnbankedStat(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('left-side') },
      _react2.default.createElement('div', { className: cn('map') })
    ),
    _react2.default.createElement(
      'div',
      { className: cn('right-side') },
      _react2.default.createElement(
        'p',
        { className: cn('text') },
        'According to the World Bank\'s Global',
        _react2.default.createElement('br', null),
        ' Financial Inclusion Database, there are',
        _react2.default.createElement('br', null),
        ' ',
        'currently 2.5 billion people on Earth',
        _react2.default.createElement('br', null),
        ' who do not have access to official',
        _react2.default.createElement('br', null),
        ' ',
        'financial services'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('stat-circle') },
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-percentage') },
          '53%'
        ),
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-text') },
          'Total 2,455',
          _react2.default.createElement('br', null),
          'million adults'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 3, theme: 'bright' })
  );
};

exports.default = SE_Home_UnbankedStat;


SE_Home_UnbankedStat.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

var _InfoColumn = __webpack_require__(413);

var _InfoColumn2 = _interopRequireDefault(_InfoColumn);

__webpack_require__(704);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UseCases');

var SE_Home_UseCases = function (_Component) {
  (0, _inherits3.default)(SE_Home_UseCases, _Component);

  function SE_Home_UseCases() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_UseCases);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_UseCases.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_UseCases)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0,
      slideWidth: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_UseCases, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + infoColumns.length) % infoColumns.length;
      this.setState({ show: show });
    }
  }, {
    key: 'getSlides',
    value: function getSlides() {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(keysName) {
        return infoColumns.map(function (column, i) {
          return _react2.default.createElement(_InfoColumn2.default, {
            column: column,
            key: i + keysName,
            mix: cn('slider-item'),
            setWidth: i === 0 ? function (slideWidth) {
              return _this2.setState({ slideWidth: slideWidth });
            } : undefined
          });
        });
      };

      res = res.concat(genSlidesArray('clone_before'));
      res = res.concat(genSlidesArray('clone_middle'));
      res = res.concat(genSlidesArray('clone_after'));

      return res;
    }
  }, {
    key: 'getDots',
    value: function getDots() {
      var _this3 = this;

      var show = this.state.show;


      var dots = [];

      var _loop = function _loop(i) {
        dots.push(_react2.default.createElement('div', {
          key: i,
          className: cn('dots-item', { active: show === i }),
          onClick: function onClick() {
            return _this3.setState({ show: i });
          }
        }));
      };

      for (var i = 1; i <= 5; i++) {
        _loop(i);
      }

      return dots;
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;

      var _renderSlides = this.getSlides();
      var _state = this.state,
          show = _state.show,
          slideWidth = _state.slideWidth;

      var pctX = show * slideWidth;
      var dots = this.getDots();

      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('title'), type: 'section', theme: 'dark' },
            'Humaniq use cases'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('slider-wrap') },
            _react2.default.createElement(
              'div',
              { className: cn('slider'), style: { transform: 'translateX(-' + pctX + 'px)' } },
              _renderSlides
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('nav') },
            _react2.default.createElement('div', { className: cn('nav-prev'), onClick: this.prev }),
            _react2.default.createElement('div', { className: cn('nav-next'), onClick: this.next })
          ),
          _react2.default.createElement(
            'div',
            { className: cn('dots') },
            dots
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 9, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_UseCases;
}(_react.Component);

exports.default = SE_Home_UseCases;


var infoColumns = [{
  title: 'Zero fee money transfers',
  text: 'Blockchain technology allows users to carry out direct money transfers, cutting out the middleman. The money is transferred as our HMQ cryptocurrency and withdrawn via authorised exchange points. Users can choose the point with the best exchange rate, therefore avoiding any financial monopolies.'
}, {
  title: 'Remote work',
  text: "Companies can utilise Humaniq's ever-growing user base to carry out tasks involving the processing of information. Users can decode and translate texts, identify photographs, locate geotags and so on, in return for renumeration."
}, {
  title: 'Charity without corruption',
  text: 'Charity, carried out in the traditional way, often leads to a large proportion of donated money falling into the wrong hands. Blockchain technology, combined with the infrastructure of Humaniq, ensures that donations are completely transparent: stakeholders are able to see what every penny is spent on and can be sure that all of their money is going to help people.'
}, {
  title: 'Guarantor lending',
  text: 'Grameen Bank in Bangladesh has created a system of loans based on honesty and trust, which guarantees over 90% repayment. The Humaniq system allows for the creation of a similar system but on a global scale: every person on Earth will be able to take out a commission-free loan using nothing but a smartphone and the Humaniq app.'
}, {
  title: 'Direct lending to entrepreneurs',
  text: "Following the principle of the non-profit organisation Kiva Microfunds, which enables loans for entrepreneurs on low incomes, Humaniq will become a platform for both donations and loans. You can lend money to a business you'd like to support, either as a grant or with the expectation of a return – the blockchain technology makes this process incredibly simple and effective for both parties."
}];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(69);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(705);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WhatMakes');

var SE_Home_WhatMakes = function SE_Home_WhatMakes(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement('img', { className: cn('background'), src: '/img/design-v2/sections/common/head.svg' }),
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'What makes Humaniq',
        _react2.default.createElement('br', null),
        ' a big thing'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 5, theme: 'bright' })
  );
};

exports.default = SE_Home_WhatMakes;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/connect-unbanked.svg',
  title: 'Connecting the unbanked',
  text: '10 years of research across Asia and Africa, carried out by the authors of Portfolios of the Poor, showed that poverty proliferates in regions whose inhabitants do not have access to financial services. Humaniq is becoming the simplest route to financial inclusion for billions of people.'
}, {
  imageSrc: '/img/design-v2/icons/sections/user-base-expo.svg',
  title: 'User base exponential growth',
  text: "According to Metcalfe's law, the value of a network is proportional to the square of the number of its users. For Humaniq, this means that the more unbanked people who join the system, the greater the motivation will be for other people to join."
}];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(34);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(706);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WorldTalking');

var _getMentions = function _getMentions(mentions) {
  return mentions.map(function (_ref, index) {
    var title = _ref.title,
        url = _ref.url,
        urlText = _ref.urlText;
    return _react2.default.createElement(
      'li',
      { key: 'mention-' + (index + 1), className: cn('mention') },
      _react2.default.createElement(
        'p',
        { className: cn('mention-title') },
        title
      ),
      _react2.default.createElement(
        'a',
        { className: cn('mention-link'), href: url, target: '_blank' },
        urlText
      )
    );
  });
};

var SE_Home_WorldTalking = function SE_Home_WorldTalking(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'The world is talking'
      ),
      _react2.default.createElement(
        'ul',
        { className: cn('mentions-list') },
        _getMentions(hmqMentions)
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 13, theme: 'dark' })
  );
};

exports.default = SE_Home_WorldTalking;


var hmqMentions = [{
  title: 'Huffingtonpost.com:',
  url: 'http://www.huffingtonpost.com/entry/tackling-financial-exclusion-with-biometric-technology_us_591af1ace4b03e1c81b008bc?ncid=engmodushpmg00000004',
  urlText: 'Tackling Financial Exclusion With Biometric Technology'
}, {
  title: 'Thenextweb.com:',
  url: 'https://thenextweb.com/guests/5-things-need-know-blockchain-technology/?utm_source=t.co&utm_medium=referral&utm_content=5%20Things%20You%20Need%20to%20Know%20About%20Blockchain%20Technology&utm_campaign=share%2Bbutton#.tnw_X4BwNKpu',
  urlText: '5 Things You Need to Know About Blockchain Technology'
}, {
  title: 'Forbes.com:',
  url: 'https://www.forbes.com/sites/haroldstark/2017/04/21/from-here-to-where-bitcoin-and-the-future-of-cryptocurrency/#14428f594367',
  urlText: 'From Here To Where? Bitcoin And The Future Of Cryptocurrency'
}, {
  title: 'Cointelegraph.com:',
  url: 'https://cointelegraph.com/news/ethereum-based-humaniq-to-deliver-banking-40-to-2-bln-unbanked',
  urlText: 'Ethereum-Based Humaniq To Deliver Banking 4.0 to 2 Bin Unbanked'
}, {
  title: 'Finance.yahoo.com:',
  url: 'https://finance.yahoo.com/news/humaniq-blockchain-financial-platform-unbanked-185522211.html',
  urlText: 'Humaniq, Blockchain Financial Platform for the Unbanked, Appoints CEO and 20 Members to Global Advisory Board'
}, {
  title: 'Nasdaq.com:',
  url: 'http://www.nasdaq.com/article/humaniq-aims-to-tackle-barriers-to-economic-inclusion-with-blockchain-app-cm764760',
  urlText: 'Humaniq Aims to Tackle Barriers to Economic Inclusion With Blockchain App'
}];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(707);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumn');

var M_InfoColumn = function (_Component) {
  (0, _inherits3.default)(M_InfoColumn, _Component);

  function M_InfoColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_InfoColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_InfoColumn.__proto__ || (0, _getPrototypeOf2.default)(M_InfoColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      needWidth: typeof _this.props.setWidth === 'function'
    }, _this.setWidth = function () {
      _this.props.setWidth(_this.node.offsetWidth);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_InfoColumn, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.needWidth) {
        window.addEventListener('resize', this.setWidth);
        this.setWidth();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.needWidth) {
        window.removeEventListener('resize', this.setWidth);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          column = _props.column;
      var needWidth = this.state.needWidth;

      return _react2.default.createElement(
        'div',
        { className: cn([mix]), ref: needWidth ? function (node) {
            return _this2.node = node;
          } : undefined },
        column.imageSrc ? _react2.default.createElement('img', { className: cn('image'), src: column.imageSrc }) : null,
        _react2.default.createElement(
          _A_Title_H2.default,
          { mix: cn('title'), type: 'info-column', theme: 'dark' },
          column.title
        ),
        _react2.default.createElement(
          'p',
          { className: cn('text') },
          column.text
        )
      );
    }
  }]);
  return M_InfoColumn;
}(_react.Component);

M_InfoColumn.propTypes = {
  mix: T.string, //BEM mixin from parent block
  column: T.object.isRequired //Column to render
};

exports.default = M_InfoColumn;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _page = __webpack_require__(415);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

var _actions2 = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var theme = state.navigation.theme,
      users_number = state.home.users_number;

  return { theme: theme, users_number: users_number };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ setTheme: _actions.setTheme, openPopup: _actions.openPopup, submit: _actions2.submit, openPeopleModal: _actions.openPeopleModal }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(730);

var _utils = __webpack_require__(1);

var _isMobile = __webpack_require__(93);

var _O_Footer_H = __webpack_require__(72);

var _O_Footer_H2 = _interopRequireDefault(_O_Footer_H);

var _EmpoweringSection = __webpack_require__(416);

var _EmpoweringSection2 = _interopRequireDefault(_EmpoweringSection);

var _NewsSection = __webpack_require__(421);

var _NewsSection2 = _interopRequireDefault(_NewsSection);

var _FirstMobileSection = __webpack_require__(418);

var _FirstMobileSection2 = _interopRequireDefault(_FirstMobileSection);

var _UnbankedStatSection = __webpack_require__(429);

var _UnbankedStatSection2 = _interopRequireDefault(_UnbankedStatSection);

var _QuotesSection = __webpack_require__(424);

var _QuotesSection2 = _interopRequireDefault(_QuotesSection);

var _WhatMakesSection = __webpack_require__(431);

var _WhatMakesSection2 = _interopRequireDefault(_WhatMakesSection);

var _SafetySection = __webpack_require__(425);

var _SafetySection2 = _interopRequireDefault(_SafetySection);

var _OpportunitiesSection = __webpack_require__(422);

var _OpportunitiesSection2 = _interopRequireDefault(_OpportunitiesSection);

var _Partners = __webpack_require__(423);

var _Partners2 = _interopRequireDefault(_Partners);

var _GrowingSection = __webpack_require__(420);

var _GrowingSection2 = _interopRequireDefault(_GrowingSection);

var _UseCasesSection = __webpack_require__(430);

var _UseCasesSection2 = _interopRequireDefault(_UseCasesSection);

var _GlobalChallengeSection = __webpack_require__(419);

var _GlobalChallengeSection2 = _interopRequireDefault(_GlobalChallengeSection);

var _ExpeditionSection = __webpack_require__(417);

var _ExpeditionSection2 = _interopRequireDefault(_ExpeditionSection);

var _WorldTalkingSection = __webpack_require__(432);

var _WorldTalkingSection2 = _interopRequireDefault(_WorldTalkingSection);

var _TeamSection = __webpack_require__(428);

var _TeamSection2 = _interopRequireDefault(_TeamSection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('News1');
// import Meta from './meta.js'

/*import TimelineSection from './sections/TimelineSection'*/


var serverNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'press', 'contacts'];
var clientNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'team', 'press', 'contacts'];

var sectionsNames =  true ? clientNames : serverNames;

var dark = ['mobile', 'situation', 'platform', 'opportunities', 'partners', 'use cases', 'expedition', 'team'];

var showingWidth = 1120;

var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showIndex: _this.props.showIndex || 0,
      scroll: true,
      fastScroll: true,
      widthBig: true && window.innerWidth >= showingWidth
    }, _this.sectionsObj = {
      empowering: _react2.default.createElement(_EmpoweringSection2.default, { mix: cn('section'), key: 'empowering', users_number: _this.props.users_number }),
      news: _react2.default.createElement(_NewsSection2.default, { mix: cn('section'), key: 'news' }),
      mobile: _react2.default.createElement(_FirstMobileSection2.default, { mix: cn('section'), key: 'mobile' }),
      situation: _react2.default.createElement(_UnbankedStatSection2.default, { mix: cn('section'), key: 'situation' }),
      changes: _react2.default.createElement(_QuotesSection2.default, { mix: cn('section', { type: 'slider' }), key: 'changes' }),
      platform: _react2.default.createElement(_WhatMakesSection2.default, { mix: cn('section'), key: 'platform' }),
      simplicity: _react2.default.createElement(_SafetySection2.default, { mix: cn('section'), key: 'simplicity' }),
      opportunities: _react2.default.createElement(_OpportunitiesSection2.default, { mix: cn('section'), key: 'opportunities' }),
      partners: _react2.default.createElement(_Partners2.default, { mix: cn('section'), key: 'partners' }),
      userbase: _react2.default.createElement(_GrowingSection2.default, { mix: cn('section'), key: 'userbase' }),
      'use cases': _react2.default.createElement(_UseCasesSection2.default, { mix: cn('section'), key: 'usecases' }),
      challenge: _react2.default.createElement(_GlobalChallengeSection2.default, { mix: cn('section'), key: 'challenge' }),
      expedition: _react2.default.createElement(_ExpeditionSection2.default, { mix: cn('section'), key: 'expedition' }),
      /*timeline: <TimelineSection mix={cn('section')} key="timeline" />,*/
      team: _react2.default.createElement(_TeamSection2.default, { mix: cn('section'), key: 'team', openPeopleModal: _this.props.openPeopleModal }),
      press: _react2.default.createElement(_WorldTalkingSection2.default, { mix: cn('section'), key: 'press' }),
      contacts: _react2.default.createElement(_O_Footer_H2.default, {
        mix: cn('section', { type: 'half-height' }),
        openPopup: _this.props.openPopup,
        key: 'contacts'
      })
    }, _this.handleSideMenu = function (_ref2) {
      var showIndex = _ref2.showIndex,
          extra = (0, _objectWithoutProperties3.default)(_ref2, ['showIndex']);
      var setTheme = _this.props.setTheme;

      _this.setState((0, _extends3.default)({ showIndex: showIndex }, extra));
      if (dark.includes(sectionsNames[showIndex])) {
        setTheme('dark');
      } else {
        setTheme('bright');
      }
    }, _this.handleWeel = function (_ref3) {
      var deltaY = _ref3.deltaY;

      var touchBar = deltaY - Math.round(deltaY) === 0;

      if (touchBar) {
        _this.handleTouchBar({ deltaY: deltaY });
      } else {
        _this.handleMouseWeel({ deltaY: deltaY });
      }
    }, _this.handleScrollUp = function () {
      _this.setState({ showIndex: 0 });
    }, _this.getWidth = function () {
      var widthBig = window.innerWidth >= showingWidth,
          shorter = _this.state.widthBig && !widthBig,
          bigger = !_this.state.widthBig && widthBig;

      if (shorter || bigger) {
        _this.setState({ widthBig: widthBig });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'getSideMenu',
    value: function getSideMenu(showIndex) {
      var _this2 = this;

      var hashLinks = sectionsNames.map(function (name, i) {
        return _react2.default.createElement(
          'div',
          {
            key: name,
            className: cn('side-menu-item'),
            onClick: function onClick() {
              return _this2.handleSideMenu({ showIndex: i });
            }
          },
          _react2.default.createElement('div', { className: cn('dot', { selected: showIndex === i }) })
        );
      });
      return _react2.default.createElement(
        'aside',
        { className: cn('side-menu') },
        hashLinks
      );
    }
  }, {
    key: 'handleTouchBar',
    value: function handleTouchBar(_ref4) {
      var _this3 = this;

      var deltaY = _ref4.deltaY;
      var _state = this.state,
          oldIndex = _state.showIndex,
          fastScroll = _state.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 100) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this3.setState({ scroll: true });
      }, 400);
      setTimeout(function () {
        return _this3.setState({ fastScroll: true });
      }, 1000);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: '_handleKeyPress',
    value: function _handleKeyPress(_ref5) {
      var keyCode = _ref5.keyCode;
      var oldIndex = this.state.showIndex;

      var nextCodes = [40, 34, 32, 39],
          prevCodes = [38, 33, 36, 37];
      if (nextCodes.includes(keyCode) && oldIndex < sectionsNames.length - 1) {
        this.setState({ showIndex: oldIndex + 1 });
      } else if (prevCodes.includes(keyCode) && oldIndex > 0) {
        this.setState({ showIndex: oldIndex - 1 });
      }
    }
  }, {
    key: 'handleMouseWeel',
    value: function handleMouseWeel(_ref6) {
      var _this4 = this;

      var deltaY = _ref6.deltaY;
      var _state2 = this.state,
          oldIndex = _state2.showIndex,
          fastScroll = _state2.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 900) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this4.setState({ scroll: true });
      }, 200);
      setTimeout(function () {
        return _this4.setState({ fastScroll: true });
      }, 500);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.getWidth);
      this.container.focus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.getWidth);
    }
  }, {
    key: 'getPositionY',
    value: function getPositionY(showIndex) {
      if (showIndex === sectionsNames.length - 1) {
        return (showIndex - 1) * 100 + 50;
      } else {
        return showIndex * 100;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state3 = this.state,
          showIndex = _state3.showIndex,
          scroll = _state3.scroll,
          widthBig = _state3.widthBig;

      var controlledScroll = false;
      var positionY = controlledScroll ? this.getPositionY(showIndex) : 0;
      return _react2.default.createElement(
        'div',
        {
          className: cn({ scroll: !controlledScroll }),
          tabIndex: '0',
          ref: function ref(el) {
            _this5.container = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: cn('inner') },
          sectionsNames.map(function (name) {
            return _this5.sectionsObj[name];
          })
        )
      );
    }
  }]);
  return Home;
}(_react.Component);

Home.propTypes = {
  total_installations: T.number
};

Home.defaultProps = {};

exports.default = Home;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _O_SimpleForm_H_ = __webpack_require__(108);

var _O_SimpleForm_H_2 = _interopRequireDefault(_O_SimpleForm_H_);

var _M_Exchanges_Slider = __webpack_require__(106);

var _M_Exchanges_Slider2 = _interopRequireDefault(_M_Exchanges_Slider);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _index = __webpack_require__(91);

var _index2 = _interopRequireDefault(_index);

var _reactDelay = __webpack_require__(118);

var _reactDelay2 = _interopRequireDefault(_reactDelay);

var _reactScrollableAnchor = __webpack_require__(126);

var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);

var _news = __webpack_require__(53);

__webpack_require__(711);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import M_Countdown from "../../../../widgets/M_Countdown";
var cn = (0, _utils.cssClassName)('SE_News1_Empowering');

var handleLinkClick = function handleLinkClick(name) {
    if (window.ga) window.ga('send', 'event', 'other', 'event-click-' + name);
};

var formatUserNum = function formatUserNum(users) {
    var usersD = users.toString();
    usersD = usersD.slice(0, usersD.length - 3) + "  " + usersD.slice(usersD.length - 3);
    return usersD;
};

function createMarkup(input) {
    return { __html: input };
}

var _createLinks = function _createLinks(links) {
    return links.map(function (_ref, index) {
        var title = _ref.title,
            more = _ref.more,
            img = _ref.img,
            button = _ref.button,
            url = _ref.url,
            uid = _ref.uid,
            isInt = _ref.isInt;

        var divStyle = {
            backgroundImage: 'url(' + img + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top center',
            backgroundSize: 'cover'
        };
        isInt = isInt ? '' : '_blank';
        return _react2.default.createElement(
            'div',
            { className: 'item', key: 'mainEvent-' + (index + 1) },
            _react2.default.createElement(
                'div',
                { className: 'wrap', style: divStyle },
                _react2.default.createElement('h1', { dangerouslySetInnerHTML: createMarkup(title) }),
                _react2.default.createElement('div', { className: 'more', dangerouslySetInnerHTML: createMarkup(more) }),
                button && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: url, className: 'button', onClick: function onClick() {
                                handleLinkClick(uid);
                            }, target: isInt },
                        button
                    )
                )
            )
        );
    });
};

var SE_Home_Empowering = function (_React$Component) {
    (0, _inherits3.default)(SE_Home_Empowering, _React$Component);

    function SE_Home_Empowering(props) {
        (0, _classCallCheck3.default)(this, SE_Home_Empowering);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SE_Home_Empowering.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Empowering)).call(this, props));

        _this.gotoSlide = function (index) {
            _this.slider.slickGoTo(index);
            console.log(_this.slider);
        };

        _this.createDots = function (list) {
            return list.map(function (_ref2, index) {
                var title = _ref2.title,
                    more = _ref2.more,
                    img = _ref2.img;

                return _react2.default.createElement(
                    'i',
                    null,
                    _this.state.activeSlide == index && _react2.default.createElement(
                        'div',
                        { className: 'pie-wrap' },
                        _react2.default.createElement('div', { className: 'slice1 slice-wrap' }),
                        _react2.default.createElement('div', { className: 'slice2 slice-wrap' })
                    ),
                    _this.state.activeSlide != index && _react2.default.createElement('div', { className: 'pie-wrap full', onClick: function onClick() {
                            _this.gotoSlide(index);
                        } })
                );
            });
        };

        _this.state = {
            hmq2usd: "",
            ccwShow: false
        };
        return _this;
    }

    (0, _createClass3.default)(SE_Home_Empowering, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _index2.default.get("https://api.coinmarketcap.com/v2/ticker/1669/").then(function (res) {
                console.log(res.data);
                var ratio = Math.round(1000 * res.data.data.quotes.USD.price) / 1000;
                console.log(ratio);
                _this2.setState({
                    hmq2usd: "1 HMQ = " + ratio + " USD",
                    ccwShow: res.data.data.quotes.USD.percent_change_24h > 0,
                    ccw: res.data.data.quotes.USD.percent_change_24h
                });
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var settings = {
                loop: true,
                speed: 700,
                autoplay: true,
                autoplaySpeed: 5350,
                cssEase: 'ease-in-out',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                initialSlide: 0,
                arrows: false,
                //dots: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                mobileFirst: true,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                beforeChange: function beforeChange(current, next) {
                    return _this3.setState({ activeSlide: next });
                }
            };

            var iframeResizerOptions = { checkOrigin: false };

            return _react2.default.createElement(
                'section',
                { className: cn([this.mix]) },
                _react2.default.createElement(
                    'div',
                    { className: cn('left-side') },
                    _react2.default.createElement(
                        'div',
                        { className: cn('map') },
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'desktop' }),
                            src: '/img/v1/home/map-bg-2.png',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'mobile' }),
                            src: '/img/v1/home/mobile-map.jpg',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 1 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 2 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 3 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 4 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 5 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('text') },
                        _react2.default.createElement(
                            _A_Title_H2.default,
                            { type: 'hero', mix: cn('text-title'), theme: 'bright' },
                            'P2P financial services ',
                            _react2.default.createElement('br', null),
                            'for developing countries'
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: cn('text-subtitle') },
                            'Connecting 1.7 billion people'
                        ),
                        this.state.ccwShow && _react2.default.createElement(
                            'div',
                            { className: 'ccw-wrap' },
                            _react2.default.createElement('script', { type: 'text/javascript',
                                src: 'https://files.coinmarketcap.com/static/widget/currency.js' }),
                            _react2.default.createElement('div', { className: 'coinmarketcap-currency-widget', 'data-currencyid': '1669', 'data-base': 'USD',
                                'data-secondary': '', 'data-ticker': 'true', 'data-rank': 'true', 'data-marketcap': 'true',
                                'data-volume': 'true', 'data-stats': 'USD', 'data-statsticker': 'false' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('anni') },
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-title' },
                            '1 year after tokensale'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-operate' },
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-mark' },
                                _react2.default.createElement('img', { src: '/img/done.svg' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide one' },
                                '21 countries ',
                                _react2.default.createElement('br', null),
                                ' operating'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide two' },
                                formatUserNum(452068),
                                ' ',
                                _react2.default.createElement('br', null),
                                'users'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide three' },
                                'Hybrid ',
                                _react2.default.createElement('br', null),
                                'blockchain'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('right-side') },
                    _react2.default.createElement(
                        _reactSlick2.default,
                        (0, _extends3.default)({ ref: function ref(slider) {
                                return _this3.slider = slider;
                            } }, settings),
                        _createLinks(_news.mainList)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "overlay" },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'TODAY'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'i',
                                null,
                                this.state.hmq2usd
                            ),
                            this.state.ccwShow && _react2.default.createElement(
                                'div',
                                { className: 'mmark' },
                                _react2.default.createElement('img', { src: '/img/ccw-arrow.svg' }),
                                this.state.ccw,
                                '%'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: "dots" },
                            this.createDots(_news.mainList)
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactScrollableAnchor2.default,
                    { id: 'xchange' },
                    _react2.default.createElement(
                        'div',
                        { className: 'coinswitch-widget' },
                        _react2.default.createElement(
                            'iframe',
                            { width: '100%', height: '400', src: 'https://coinswitch.co/widget?widget_id=fc72a10e&from=btc&to=hmq&amount=0.01', frameBorder: 0, order: '0', scrolling: 'no' },
                            'Can\'t load widget'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('slider-wrap') },
                    _react2.default.createElement(
                        'div',
                        { className: 'w' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                _A_Title_H2.default,
                                { type: 'hero', theme: 'bright' },
                                'HMQ token is a fuel of the platform'
                            ),
                            'Visit one of the following external services independent from Humaniq in order to purchase HMQ'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'b' },
                            _react2.default.createElement(
                                'a',
                                { className: 'button', href: 'https://bittrex.com/Market/Index?MarketName=BTC-HMQ', target: '_blank' },
                                'Trade now'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('slider') },
                        _react2.default.createElement(
                            _reactDelay2.default,
                            { wait: 2000 },
                            _react2.default.createElement(_M_Exchanges_Slider2.default, null)
                        )
                    )
                )
            );
        }
    }]);
    return SE_Home_Empowering;
}(_react2.default.Component);

exports.default = SE_Home_Empowering;


SE_Home_Empowering.propTypes = {
    //mix: T.string,
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(70);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(712);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Expedition');

var SE_Home_Expedition = function SE_Home_Expedition(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq expedition: the first',
        _react2.default.createElement('br', null),
        ' step in financial inclusion'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
      _react2.default.createElement(
        'div',
        { className: cn('button') },
        _react2.default.createElement(
          _A_Btn_H2.default,
          { to: 'https://challenge.humaniq.com' },
          'About expedition'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 11, theme: 'bright' })
  );
};

exports.default = SE_Home_Expedition;


var infoColumns = [{
  title: 'Startup contest',
  text: 'In order to bring together a network of like-minded individuals and then choose 10 projects for entry into the Humaniq system, we are launching the Humaniq Global Challenge for entrepreneurs, developers, marketing specialists and economists.'
}, {
  title: 'Benefits',
  text: '10 Finalists will receive expert advice from top consultants in their field, as well as the chance to gain investment and to enter the Humaniq accelerator.'
}, {
  title: 'Trip to Kenya',
  text: 'The three best teams will go on a trip to Kenya to learn more about the lives of the unbanked and put the finishing touches to their projects ahead of an ICO, which will be supported by Humaniq.'
}];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(70);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(713);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_FirstMobile');

var handleLinkClick = function handleLinkClick() {
  if (window.ga) window.ga('send', 'event', 'other', 'whitepaper-btn-click');
};

var SE_Home_FirstMobile = function SE_Home_FirstMobile(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'The first mobile service with',
        _react2.default.createElement('br', null),
        'the capacity to change the world'
      ),
      _react2.default.createElement(
        'p',
        { className: cn('subtitle') },
        'Humaniq is a new generation financial services',
        _react2.default.createElement('br', null),
        ' with its own cryptocurrency, which is aimed at',
        _react2.default.createElement('br', null),
        ' eradicating poverty amongst millions of people',
        _react2.default.createElement('br', null),
        ' living in the emerging economies'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
        _react2.default.createElement(
          'div',
          { className: cn('button') },
          _react2.default.createElement(
            _A_Btn_H2.default,
            { to: '/pdf/humaniq-whitepaper-05.09.pdf', clickHandler: handleLinkClick },
            'Whitepaper'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 2, theme: 'bright' })
  );
};

exports.default = SE_Home_FirstMobile;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/key.svg',
  title: 'For the unbanked people',
  text: 'Humaniq opens up the benefits of financial inclusion and grants access to a series of financial services'
}, {
  imageSrc: '/img/design-v2/icons/sections/busness.svg',
  title: 'For businesses',
  text: 'Humaniq enables start-ups and projects to offer their services to an audience of billions'
}];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _M_SocialLinks_G = __webpack_require__(107);

var _M_SocialLinks_G2 = _interopRequireDefault(_M_SocialLinks_G);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(70);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(714);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_GlobalChallenge');

var SE_Home_GlobalChallenge = function SE_Home_GlobalChallenge(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq global',
        _react2.default.createElement('br', null),
        ' challenge'
      ),
      _react2.default.createElement(_InfoColumns2.default, {
        mix: cn('info-columns'),
        columns: infoColumns,
        type: 'narrow',
        layout: 'global-challenge'
      }),
      _react2.default.createElement(
        _M_SocialLinks_G2.default,
        { mix: cn('social-links'), type: 'section' },
        'You know how to enhance Humaniq?',
        _react2.default.createElement('br', null),
        ' Join the global Humaniq community'
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 10, theme: 'dark' })
  );
};

exports.default = SE_Home_GlobalChallenge;


var infoColumns = [{
  title: 'Life-changing technology',
  text: 'Humaniq grew out of the idea that advanced technologies should benefit everybody. Now, we want to inspire developers from all over the world to come and join our movement.'
}, {
  title: 'Humanitarian impact',
  text: 'Humaniq is not just a commercial project. It is a worldwide mission, aiming to give people in developing nations more power to change their lives.'
}];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(715);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Growing');

var SE_Home_Growing = function SE_Home_Growing(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq\'s ever\u2011growing',
        _react2.default.createElement('br', null),
        ' userbase is a blue ocean for',
        _react2.default.createElement('br', null),
        ' thousands of new projects'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '1 ',
            _react2.default.createElement(
              'span',
              null,
              'billion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'new users in the',
            _react2.default.createElement('br', null),
            ' coming years'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '$4 ',
            _react2.default.createElement(
              'span',
              null,
              'trillion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'potentially in',
            _react2.default.createElement('br', null),
            ' user accounts'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '200+'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'start-ups are planning',
            _react2.default.createElement('br', null),
            ' to move onto the',
            _react2.default.createElement('br', null),
            ' Humaniq platform'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 8, theme: 'dark' })
  );
};

exports.default = SE_Home_Growing;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

__webpack_require__(716);

var _utils = __webpack_require__(1);

var _news = __webpack_require__(53);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Butter from 'buttercms';
//const butter = Butter('63c5be1dcac33aad42357d8eb320058d0562c240');

var cn = (0, _utils.cssClassName)('SE_News1_News');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'news-click-' + name);
};

var _createLinks = function _createLinks(links, startIndex) {
  return links.map(function (_ref, index) {
    var title = _ref.title,
        src = _ref.src,
        url = _ref.url,
        date = _ref.date,
        img = _ref.img,
        target = _ref.target;


    if (index >= startIndex) {
      return _react2.default.createElement(
        'div',
        { className: 'item', key: 'newsLink-' + (index + 1) },
        url && _react2.default.createElement(
          'a',
          { className: 'link', href: url, title: title, target: target,
            onClick: function onClick() {
              handleLinkClick(index);
            } },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        !url && _react2.default.createElement(
          'div',
          { className: 'link', title: title },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'src' },
          date
        )
      );
    }
  });
};

function nextArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

function prevArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

var SE_News1_News = function (_React$Component) {
  (0, _inherits3.default)(SE_News1_News, _React$Component);

  function SE_News1_News(props) {
    (0, _classCallCheck3.default)(this, SE_News1_News);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SE_News1_News.__proto__ || (0, _getPrototypeOf2.default)(SE_News1_News)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(SE_News1_News, [{
    key: 'render',
    value: function render() {

      var settings = {
        loop: true,

        speed: 700,
        autoplay: false,
        cssEase: 'ease-in-out',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 0,
        arrows: true,
        //buttons: false,
        //dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        mobileFirst: true,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        nextArrow: _react2.default.createElement('nextArrow', null),
        prevArrow: _react2.default.createElement('prevArrow', null),

        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }]
      };

      return _react2.default.createElement(
        'section',
        { className: cn([this.mix]) },
        _react2.default.createElement(
          _A_Title_H2.default,
          { type: 'hero', mix: cn('text-title'), theme: 'dark' },
          'Latest ',
          _react2.default.createElement(
            'ss',
            null,
            'news'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('article-list') },
          _react2.default.createElement(
            _reactSlick2.default,
            settings,
            _createLinks(_news.articleList, 0)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('more-news') },
          _react2.default.createElement(
            'a',
            { className: 'button', href: 'https://blog.humaniq.co/', target: '_blank' },
            'See All NEWS'
          ),
          _react2.default.createElement(
            'a',
            { className: 'link-sec', href: 'https://www.facebook.com/humaniq.co/', target: '_blank' },
            'Join our Facebook',
            _react2.default.createElement('img', { src: '/img/link.svg' })
          )
        )
      );
    }
  }]);
  return SE_News1_News;
}(_react2.default.Component);

exports.default = SE_News1_News;


SE_News1_News.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(70);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(717);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Opportunities');

var SE_Home_Opportunities = function SE_Home_Opportunities(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Extraordinary opportunitites for business'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 7, theme: 'bright' })
  );
};

exports.default = SE_Home_Opportunities;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/etherium.svg',
  title: 'Based on Ethereum blockchain protocol',
  text: 'Guaranteed security against hacking, corruption and loss of information thanks to complete decentralisation'
}, {
  imageSrc: '/img/design-v2/icons/sections/accelerator.svg',
  title: 'Independent fund and accelerator',
  text: 'External projects and promising ideas can receive expert support and investment for a launch into the Humaniq system'
}, {
  imageSrc: '/img/design-v2/icons/sections/api.svg',
  title: 'Open API',
  text: 'Any project can merge into the Humaniq system'
}];

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(718);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Partners');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'partners-click-' + name);
};

function createMarkup(input) {
  return { __html: input };
}

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var href = _ref.href,
        img = _ref.img,
        name = _ref.name,
        more = _ref.more;

    var divStyle = {
      backgroundImage: 'url(' + img + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    };
    console.log(divStyle);
    return _react2.default.createElement(
      'div',
      { className: 'item', key: 'partner-' + (index + 1) },
      href && _react2.default.createElement(
        'a',
        { href: href, className: 'wrap', target: '_blank', onClick: function onClick() {
            handleLinkClick(name);
          } },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      ),
      !href && _react2.default.createElement(
        'div',
        { className: 'wrap' },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      )
    );
  });
};

var SE_Partners = function SE_Partners(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq Partners'
      ),
      _react2.default.createElement(
        'div',
        { className: 'partners-list' },
        _createLinks(infoColumns)
      )
    )
  );
};

exports.default = SE_Partners;


var infoColumns = [{
  img: '/img/partners/un.png',
  href: "https://www.unglobalcompact.org",
  name: 'un',
  more: "The visionary who launched the <b>UN Global Compact</b> and inspired the world’s largest corporate sustainability initiative."
}, {
  img: '/img/partners/l39.png',
  href: "https://www.level39.co",
  name: 'l39',
  more: "<b>Level39</b> is a community of 1,250 leaders in cybersecurity, fintech and retail tech"
}, {
  img: '/img/partners/rise.png',
  href: "https://thinkrise.com",
  name: 'rise',
  more: "<b>Rise</b> is a community of startups & corporates creating the future of financial services."

}, {
  img: '/img/partners/coinfirm.png',
  href: "https://www.coinfirm.io",
  name: 'coinfirm',
  more: "The <b>Coinfirm</b> platform provides and easy to use solution with valuable structured data that puts entities on the safe side in terms of regulatory and fraud risk."

}, {
  img: '/img/partners/transbox.png',
  href: "http://www.transbox.xyz",
  name: 'transbox',
  more: "<b>Transbox</b> is online communication and data security specialised company."

}, {
  img: '/img/partners/bi.png',
  href: "https://www.biometricsinstitute.org",
  name: 'bi',
  more: "The mission of the <b>Biometrics Institute</b> is to promote the responsible use of biometrics in an independent and impartial international forum for biometric users and other interested parties."

}, {
  img: '/img/partners/jamii.png',
  href: "http://www.jamiiafrica.com/",
  name: 'jamii',
  more: "<b>Jamii Africa</b> is mobile micro-health insurance for the informal sector."

}, {
  img: '/img/partners/ff.png',
  href: "http://futurefintech.org",
  name: 'ff',
  more: "<b>Future Fintech</b> are connecting young businesses to the global community of VC and tech startups, giving access to the best tested cases, wide range of sector specific expertise and pinpoint advices."

}];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(719);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Quotes');

var _getQuotesSlides = function _getQuotesSlides(quotes) {
  var res = [];
  var genSlidesArray = function genSlidesArray(keysName) {
    return quotes.map(function (quote, index) {

      return _react2.default.createElement(
        'div',
        { key: 'quote-' + (keysName + (index + 1)), className: cn('slide') },
        _react2.default.createElement(
          'div',
          { className: cn('slide-content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('slide-title'), type: 'section', theme: 'bright' },
            quote.title
          ),
          _react2.default.createElement(
            'p',
            {
              className: quote.text.length < 260 ? cn('slide-text') : cn('slide-text', { type: 'small' })
            },
            quote.text
          ),
          _react2.default.createElement(
            'p',
            { className: cn('slide-author') },
            '\u2014 ',
            quote.author
          )
        )
      );
    });
  };

  res = res.concat(genSlidesArray('clone_before'));
  res = res.concat(genSlidesArray('clone_middle'));
  res = res.concat(genSlidesArray('clone_after'));

  return res;
};

var SE_Home_Quotes = function (_Component) {
  (0, _inherits3.default)(SE_Home_Quotes, _Component);

  function SE_Home_Quotes() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Quotes);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Quotes.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Quotes)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Quotes, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + quotes.length) % quotes.length;
      this.setState({ show: show });
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;
      var show = this.state.show;

      var pctX = show * 25;
      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('slider'), style: { transform: 'translateX(-' + pctX + '%)' } },
          _getQuotesSlides(quotes)
        ),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'prev' }), onClick: this.prev }),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'next' }), onClick: this.next }),
        _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 4, theme: 'dark' })
      );
    }
  }]);
  return SE_Home_Quotes;
}(_react.Component);

exports.default = SE_Home_Quotes;


SE_Home_Quotes.propTypes = {
  mix: T.string //BEM mixin from parent block
};

var quotes = [{
  title: 'The world is ready for change',
  text: 'Including the poorest in the financial system increases the value of their assets, transforming the underlying economics of financial services through digital currency - helping those who live in poverty directly.',
  author: 'Bill Gates',
  img: '/img/design-v2/sections/quotes/bill-gates2.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Because of technology, we can help shape the arc of history to bend it towards financial inclusion and greater human progress. Financial inclusion is a massive undertaking – one that can only be met together – across countries, sectors, and industries.',
  author: 'Ajaypal Singh Banga, MasterCard CEO',
  img: '/img/design-v2/sections/quotes/ajaypal-singh-banga.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Widely used digital finance has the power to transform the economic prospects of billions of people and inject new dynamism into small businesses that today are held back for lack of credit. Emerging economies have an opportunity to use mobile technologies to provide digital financial services for all, rapidly unlocking economic opportunity and accelerating social development.',
  author: 'McKinsey Global Institute Report September 2016',
  img: '/img/design-v2/sections/quotes/mckinsey-global-Institute.jpg'
}, {
  title: 'The world is ready for change',
  text: 'In pyramid of development the bottom-most layer needs to be strengthened through financial inclusionimproving purchasing power of the poor.',
  author: 'Narendra Modi',
  img: '/img/design-v2/sections/quotes/narendra-modi.jpg'
}];

// import * as T from "prop-types";
// import './styles.scss';
// import {cssClassName} from 'utils'
// const cn = cssClassName('')

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(70);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(720);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Safety');

var SE_Home_Safety = function SE_Home_Safety(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Simplicity and safety for the unbanked'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 6, theme: 'dark' })
  );
};

exports.default = SE_Home_Safety;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/card.svg',
  title: 'Biometric authentification',
  text: 'Users are verified by their face and voice, eliminating the need for formal documentation '
}, {
  imageSrc: '/img/design-v2/icons/sections/access.svg',
  title: 'Independent HMQ currency',
  text: 'Every new user receives $20 worth of HMQ in their account, the value of which bears no relation to their local currency'
}, {
  imageSrc: '/img/design-v2/icons/sections/interface.svg',
  title: 'The interface is simple to interact with',
  text: 'Even for those who have never used gadgets before'
}];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(721);

var _utils = __webpack_require__(1);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as T from "prop-types";
var cn = (0, _utils.cssClassName)('TeamSectionSlide');


var getHazemName = function getHazemName() {
  return _react2.default.createElement(
    'span',
    null,
    'Hazem Danny',
    _react2.default.createElement('br', null),
    'Al-Nakib'
  );
};

var TeamSectionSlide = function (_Component) {
  (0, _inherits3.default)(TeamSectionSlide, _Component);

  function TeamSectionSlide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TeamSectionSlide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TeamSectionSlide.__proto__ || (0, _getPrototypeOf2.default)(TeamSectionSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getSlide = function (_ref2, groupName, i) {
      var first = _ref2.first,
          imgSrc = _ref2.imgSrc,
          position = _ref2.position,
          name = _ref2.name,
          bio = _ref2.bio;

      name = name.search('Al-Nakib') === -1 ? name : getHazemName();
      var handleClick = bio ? function () {
        return _this.props.openPeopleModal({ imgSrc: imgSrc, position: position, name: name, bio: bio, groupName: groupName });
      } : undefined;
      return _react2.default.createElement(
        'div',
        { className: cn('person'), key: i, onClick: handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('person-image') },
          _react2.default.createElement(_A_Image2.default, { src: imgSrc, rounded: true })
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-name') },
          name
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-title') },
          position
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TeamSectionSlide, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          persons = _props.persons,
          showGroupName = _props.showGroupName,
          groupName = _props.groupName,
          hidden = _props.hidden;

      var renderTitle = showGroupName && groupName && _react2.default.createElement(
        'span',
        { className: cn('group-name') },
        groupName
      );
      var renderSlides = persons.map(function (el, i) {
        return _this2.getSlide(el, groupName, i);
      });
      return _react2.default.createElement(
        'div',
        { className: cn({ wide: showGroupName, hidden: hidden }) },
        renderTitle,
        renderSlides
      );
    }
  }]);
  return TeamSectionSlide;
}(_react.Component);

TeamSectionSlide.propTypes = {};

TeamSectionSlide.defaultProps = {};
exports.default = TeamSectionSlide;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getDelta = getDelta;
exports._indexOfShow = _indexOfShow;
exports.indexOfShow = indexOfShow;
exports.findIndexesOfRedundantSlides = findIndexesOfRedundantSlides;
exports.pairSplit = pairSplit;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDelta(slidesWidths, show) {
  var k = -1;
  if (show < 0) {
    show = -show;
    slidesWidths = [].concat((0, _toConsumableArray3.default)(slidesWidths)).reverse();
    k = 1;
  }
  var delta = 0;

  if (show >= slidesWidths.length) {
    delta = slidesWidths.reduce(function (a, b) {
      return a + b;
    }, 0) * (show / slidesWidths.length | 0);
    show = show % slidesWidths.length;
  }

  for (var i = 0; i < show; i++) {
    delta += slidesWidths[i];
  }
  return delta * k;
}

function _indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index + 1;
  } else {
    return extended_index + 1;
  }
}

function indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index;
  } else {
    return extended_index;
  }
}

function findIndexesOfRedundantSlides(slidesCount, show, slidesWidths) {
  var width_container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var first_index_of_slides = indexOfShow(slidesCount, show);
  var slidesLengh = 0,
      previousLength = 0,
      i_last = first_index_of_slides;
  for (slidesLengh = 0; slidesLengh < width_container; i_last++) {
    previousLength = slidesLengh;
    slidesLengh = previousLength + slidesWidths[indexOfShow(slidesCount, i_last)];
  }
  var padding = width_container ? (width_container - previousLength) / 2 : '0';
  return {
    arr: [_indexOfShow(slidesCount, first_index_of_slides - 1), _indexOfShow(slidesCount, first_index_of_slides - 2), _indexOfShow(slidesCount, i_last - 1), _indexOfShow(slidesCount, i_last)],
    padding: padding
  };
}

function pairSplit(arr, title) {
  var entities = [];

  for (var i = 0; i < arr.length; i += 2) {
    entities.push(arr.slice(i, i + 2));
  }
  return {
    title: title,
    entities: entities
  };
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(722);

var _utils = __webpack_require__(1);

var _Swipe = __webpack_require__(92);

var _Swipe2 = _interopRequireDefault(_Swipe);

var _helpers = __webpack_require__(427);

var _Slide = __webpack_require__(426);

var _Slide2 = _interopRequireDefault(_Slide);

var _people = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Team');
// import A_Image from 'A_Image/index'


var NORMAL_WIDTH = 136;
var WIDE_WIDTH = NORMAL_WIDTH + 20 + 16;
// import M_Tooltip from 'M_Tooltip'

var SE_Home_Team = function (_Component) {
  (0, _inherits3.default)(SE_Home_Team, _Component);

  function SE_Home_Team() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Team);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Team.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Team)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.widths = { container: 0 }, _this.right = function () {
      return _this.changeShow(1);
    }, _this.left = function () {
      return _this.changeShow(-1);
    }, _this.changeShow = function (n) {
      return _this.setState(function (oldState) {
        return { show: oldState.show + n };
      });
    }, _this.onSwipeRight = _this.left, _this.onSwipeLeft = _this.right, _this.threshold = 100, _this.slideGroups = [(0, _helpers.pairSplit)(_people.team, 'team'), (0, _helpers.pairSplit)(_people.advisers, 'advisers'), (0, _helpers.pairSplit)(_people.ambassadors, 'ambassadors')], _this.slidesWidths = [], _this.slidesCount = _this.slideGroups.reduce(function (sum, el) {
      return sum + el.entities.length;
    }, 0), _this.getStep = function (slidesWidths, show) {
      return slidesWidths.length ? (0, _helpers.getDelta)(slidesWidths, show) : WIDE_WIDTH;
    }, _this.handleResize = function () {
      _this.forceUpdate();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Team, [{
    key: 'getSlides',
    value: function getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides) {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(slideGroups, keys_name) {
        var indexTotal = 0;
        return slideGroups.map(function (_ref2) {
          var title = _ref2.title,
              entities = _ref2.entities;

          return entities.map(function (slide, i) {
            indexTotal += 1;

            var first = i === 0;
            if (keys_name === 'clone_before') {
              _this2.slidesWidths.push(first ? WIDE_WIDTH : NORMAL_WIDTH);
            }
            return _react2.default.createElement(_Slide2.default, {
              persons: slide,
              place: keys_name + i,
              showGroupName: first,
              groupName: title,
              hidden: indexesOfRedundantSlides.arr.includes(indexTotal),
              mix: indexesOfRedundantSlides.arr.includes(indexTotal) ? cn('hidden-slide') : cn('showing-slide'),
              mouseSlideEnterHandler: _this2.mouseSlideEnterHandler,
              mouseSlideLeaveHandler: _this2.mouseSlideLeaveHandler,
              openPeopleModal: _this2.props.openPeopleModal
            });
          });
        });
      };

      res = res.concat(genSlidesArray(slideGroups, 'clone_before'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_middle'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_after'));

      return res;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.forceUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var mix = this.props.mix;
      var slideGroups = this.slideGroups,
          slidesWidths = this.slidesWidths,
          slidesCount = this.slidesCount;
      var show = this.state.show;

      var move = show / slidesCount | 0;
      var showingSlideIndex = (0, _helpers.indexOfShow)(slidesCount, show);

      var indexesOfRedundantSlides = (0, _helpers.findIndexesOfRedundantSlides)(slidesCount, show, this.slidesWidths, this.widths.container.offsetWidth);
      var padding = indexesOfRedundantSlides.padding;

      var renderedSlides = this.getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides);
      var step = this.getStep(slidesWidths, show);
      var active = void 0;
      if (showingSlideIndex < 0) {
        active = 'ambassadors';
      } else if (showingSlideIndex < 5) {
        active = 'team';
      } else if (showingSlideIndex < 9) {
        active = 'advisers';
      } else {
        active = 'ambassadors';
      }

      return _react2.default.createElement(
        'section',
        { className: cn([mix]) },
        _react2.default.createElement(
          'div',
          {
            className: cn('content')
          },
          _react2.default.createElement('div', { className: cn('nav-prev'), onClick: function onClick() {
              return _this3.left();
            } }),
          _react2.default.createElement('div', { className: cn('nav-next'), onClick: function onClick() {
              return _this3.right();
            } }),
          _react2.default.createElement(
            'div',
            { className: cn('header') },
            _react2.default.createElement(
              _A_Title_H2.default,
              { mix: cn('title'), type: 'section', theme: 'dark' },
              'People behind Humaniq project'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'team' }), onClick: function onClick() {
                    return _this3.setState({ show: 0 });
                  } },
                'Team'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'advisers' }), onClick: function onClick() {
                    return _this3.setState({ show: 5 });
                  } },
                'Advisers'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'ambassadors' }), onClick: function onClick() {
                    return _this3.setState({ show: 9 });
                  } },
                'Ambassadors'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'wrapper1',
              onTouchStart: this.props.onTouchStart,
              onTouchMove: this.props.onTouchMove,
              ref: function ref(node) {
                return _this3.widths.container = node;
              },
              style: { paddingLeft: padding }
            },
            _react2.default.createElement(
              'div',
              {
                className: 'wrapper2',
                style: { transform: 'translate3d(' + move * (this.widths.inner / 3) + 'px, 0px, 0px)' }
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'inner',
                  style: { transform: 'translate3d(' + (step - this.widths.inner / 3) + 'px, 0px, 0px)' },
                  ref: function ref(node) {
                    return _this3.widths.inner = node ? node.offsetWidth : 0;
                  }
                },
                renderedSlides
              )
            ),
            _react2.default.createElement('div', { className: cn('linner-gradient-left') }),
            _react2.default.createElement('div', { className: cn('linner-gradient-right') })
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 12, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_Team;
}(_react.Component);

SE_Home_Team.propTypes = {};

SE_Home_Team.defaultProps = {};

exports.default = (0, _Swipe2.default)(SE_Home_Team);

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(723);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UnbankedStat');

var SE_Home_UnbankedStat = function SE_Home_UnbankedStat(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('left-side') },
      _react2.default.createElement('div', { className: cn('map') })
    ),
    _react2.default.createElement(
      'div',
      { className: cn('right-side') },
      _react2.default.createElement(
        'p',
        { className: cn('text') },
        'According to the World Bank\'s Global',
        _react2.default.createElement('br', null),
        ' Financial Inclusion Database, there are',
        _react2.default.createElement('br', null),
        ' ',
        'currently 2.5 billion people on Earth',
        _react2.default.createElement('br', null),
        ' who do not have access to official',
        _react2.default.createElement('br', null),
        ' ',
        'financial services'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('stat-circle') },
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-percentage') },
          '53%'
        ),
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-text') },
          'Total 2,455',
          _react2.default.createElement('br', null),
          'million adults'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 3, theme: 'bright' })
  );
};

exports.default = SE_Home_UnbankedStat;


SE_Home_UnbankedStat.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

var _InfoColumn = __webpack_require__(433);

var _InfoColumn2 = _interopRequireDefault(_InfoColumn);

__webpack_require__(724);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UseCases');

var SE_Home_UseCases = function (_Component) {
  (0, _inherits3.default)(SE_Home_UseCases, _Component);

  function SE_Home_UseCases() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_UseCases);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_UseCases.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_UseCases)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0,
      slideWidth: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_UseCases, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + infoColumns.length) % infoColumns.length;
      this.setState({ show: show });
    }
  }, {
    key: 'getSlides',
    value: function getSlides() {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(keysName) {
        return infoColumns.map(function (column, i) {
          return _react2.default.createElement(_InfoColumn2.default, {
            column: column,
            key: i + keysName,
            mix: cn('slider-item'),
            setWidth: i === 0 ? function (slideWidth) {
              return _this2.setState({ slideWidth: slideWidth });
            } : undefined
          });
        });
      };

      res = res.concat(genSlidesArray('clone_before'));
      res = res.concat(genSlidesArray('clone_middle'));
      res = res.concat(genSlidesArray('clone_after'));

      return res;
    }
  }, {
    key: 'getDots',
    value: function getDots() {
      var _this3 = this;

      var show = this.state.show;


      var dots = [];

      var _loop = function _loop(i) {
        dots.push(_react2.default.createElement('div', {
          key: i,
          className: cn('dots-item', { active: show === i }),
          onClick: function onClick() {
            return _this3.setState({ show: i });
          }
        }));
      };

      for (var i = 1; i <= 5; i++) {
        _loop(i);
      }

      return dots;
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;

      var _renderSlides = this.getSlides();
      var _state = this.state,
          show = _state.show,
          slideWidth = _state.slideWidth;

      var pctX = show * slideWidth;
      var dots = this.getDots();

      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('title'), type: 'section', theme: 'dark' },
            'Humaniq use cases'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('slider-wrap') },
            _react2.default.createElement(
              'div',
              { className: cn('slider'), style: { transform: 'translateX(-' + pctX + 'px)' } },
              _renderSlides
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('nav') },
            _react2.default.createElement('div', { className: cn('nav-prev'), onClick: this.prev }),
            _react2.default.createElement('div', { className: cn('nav-next'), onClick: this.next })
          ),
          _react2.default.createElement(
            'div',
            { className: cn('dots') },
            dots
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 9, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_UseCases;
}(_react.Component);

exports.default = SE_Home_UseCases;


var infoColumns = [{
  title: 'Zero fee money transfers',
  text: 'Blockchain technology allows users to carry out direct money transfers, cutting out the middleman. The money is transferred as our HMQ cryptocurrency and withdrawn via authorised exchange points. Users can choose the point with the best exchange rate, therefore avoiding any financial monopolies.'
}, {
  title: 'Remote work',
  text: "Companies can utilise Humaniq's ever-growing user base to carry out tasks involving the processing of information. Users can decode and translate texts, identify photographs, locate geotags and so on, in return for renumeration."
}, {
  title: 'Charity without corruption',
  text: 'Charity, carried out in the traditional way, often leads to a large proportion of donated money falling into the wrong hands. Blockchain technology, combined with the infrastructure of Humaniq, ensures that donations are completely transparent: stakeholders are able to see what every penny is spent on and can be sure that all of their money is going to help people.'
}, {
  title: 'Guarantor lending',
  text: 'Grameen Bank in Bangladesh has created a system of loans based on honesty and trust, which guarantees over 90% repayment. The Humaniq system allows for the creation of a similar system but on a global scale: every person on Earth will be able to take out a commission-free loan using nothing but a smartphone and the Humaniq app.'
}, {
  title: 'Direct lending to entrepreneurs',
  text: "Following the principle of the non-profit organisation Kiva Microfunds, which enables loans for entrepreneurs on low incomes, Humaniq will become a platform for both donations and loans. You can lend money to a business you'd like to support, either as a grant or with the expectation of a return – the blockchain technology makes this process incredibly simple and effective for both parties."
}];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(70);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(725);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WhatMakes');

var SE_Home_WhatMakes = function SE_Home_WhatMakes(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement('img', { className: cn('background'), src: '/img/design-v2/sections/common/head.svg' }),
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'What makes Humaniq',
        _react2.default.createElement('br', null),
        ' a big thing'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 5, theme: 'bright' })
  );
};

exports.default = SE_Home_WhatMakes;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/connect-unbanked.svg',
  title: 'Connecting the unbanked',
  text: '10 years of research across Asia and Africa, carried out by the authors of Portfolios of the Poor, showed that poverty proliferates in regions whose inhabitants do not have access to financial services. Humaniq is becoming the simplest route to financial inclusion for billions of people.'
}, {
  imageSrc: '/img/design-v2/icons/sections/user-base-expo.svg',
  title: 'User base exponential growth',
  text: "According to Metcalfe's law, the value of a network is proportional to the square of the number of its users. For Humaniq, this means that the more unbanked people who join the system, the greater the motivation will be for other people to join."
}];

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(35);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(726);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WorldTalking');

var _getMentions = function _getMentions(mentions) {
  return mentions.map(function (_ref, index) {
    var title = _ref.title,
        url = _ref.url,
        urlText = _ref.urlText;
    return _react2.default.createElement(
      'li',
      { key: 'mention-' + (index + 1), className: cn('mention') },
      _react2.default.createElement(
        'p',
        { className: cn('mention-title') },
        title
      ),
      _react2.default.createElement(
        'a',
        { className: cn('mention-link'), href: url, target: '_blank' },
        urlText
      )
    );
  });
};

var SE_Home_WorldTalking = function SE_Home_WorldTalking(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'The world is talking'
      ),
      _react2.default.createElement(
        'ul',
        { className: cn('mentions-list') },
        _getMentions(hmqMentions)
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 13, theme: 'dark' })
  );
};

exports.default = SE_Home_WorldTalking;


var hmqMentions = [{
  title: 'Huffingtonpost.com:',
  url: 'http://www.huffingtonpost.com/entry/tackling-financial-exclusion-with-biometric-technology_us_591af1ace4b03e1c81b008bc?ncid=engmodushpmg00000004',
  urlText: 'Tackling Financial Exclusion With Biometric Technology'
}, {
  title: 'Thenextweb.com:',
  url: 'https://thenextweb.com/guests/5-things-need-know-blockchain-technology/?utm_source=t.co&utm_medium=referral&utm_content=5%20Things%20You%20Need%20to%20Know%20About%20Blockchain%20Technology&utm_campaign=share%2Bbutton#.tnw_X4BwNKpu',
  urlText: '5 Things You Need to Know About Blockchain Technology'
}, {
  title: 'Forbes.com:',
  url: 'https://www.forbes.com/sites/haroldstark/2017/04/21/from-here-to-where-bitcoin-and-the-future-of-cryptocurrency/#14428f594367',
  urlText: 'From Here To Where? Bitcoin And The Future Of Cryptocurrency'
}, {
  title: 'Cointelegraph.com:',
  url: 'https://cointelegraph.com/news/ethereum-based-humaniq-to-deliver-banking-40-to-2-bln-unbanked',
  urlText: 'Ethereum-Based Humaniq To Deliver Banking 4.0 to 2 Bin Unbanked'
}, {
  title: 'Finance.yahoo.com:',
  url: 'https://finance.yahoo.com/news/humaniq-blockchain-financial-platform-unbanked-185522211.html',
  urlText: 'Humaniq, Blockchain Financial Platform for the Unbanked, Appoints CEO and 20 Members to Global Advisory Board'
}, {
  title: 'Nasdaq.com:',
  url: 'http://www.nasdaq.com/article/humaniq-aims-to-tackle-barriers-to-economic-inclusion-with-blockchain-app-cm764760',
  urlText: 'Humaniq Aims to Tackle Barriers to Economic Inclusion With Blockchain App'
}];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(727);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumn');

var M_InfoColumn = function (_Component) {
  (0, _inherits3.default)(M_InfoColumn, _Component);

  function M_InfoColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_InfoColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_InfoColumn.__proto__ || (0, _getPrototypeOf2.default)(M_InfoColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      needWidth: typeof _this.props.setWidth === 'function'
    }, _this.setWidth = function () {
      _this.props.setWidth(_this.node.offsetWidth);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_InfoColumn, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.needWidth) {
        window.addEventListener('resize', this.setWidth);
        this.setWidth();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.needWidth) {
        window.removeEventListener('resize', this.setWidth);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          column = _props.column;
      var needWidth = this.state.needWidth;

      return _react2.default.createElement(
        'div',
        { className: cn([mix]), ref: needWidth ? function (node) {
            return _this2.node = node;
          } : undefined },
        column.imageSrc ? _react2.default.createElement('img', { className: cn('image'), src: column.imageSrc }) : null,
        _react2.default.createElement(
          _A_Title_H2.default,
          { mix: cn('title'), type: 'info-column', theme: 'dark' },
          column.title
        ),
        _react2.default.createElement(
          'p',
          { className: cn('text') },
          column.text
        )
      );
    }
  }]);
  return M_InfoColumn;
}(_react.Component);

M_InfoColumn.propTypes = {
  mix: T.string, //BEM mixin from parent block
  column: T.object.isRequired //Column to render
};

exports.default = M_InfoColumn;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _page = __webpack_require__(435);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

var _actions2 = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var theme = state.navigation.theme,
      users_number = state.home.users_number;

  return { theme: theme, users_number: users_number };
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ setTheme: _actions.setTheme, openPopup: _actions.openPopup, submit: _actions2.submit, openPeopleModal: _actions.openPeopleModal }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_page2.default);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(750);

var _utils = __webpack_require__(1);

var _isMobile = __webpack_require__(93);

var _O_Footer_H = __webpack_require__(72);

var _O_Footer_H2 = _interopRequireDefault(_O_Footer_H);

var _EmpoweringSection = __webpack_require__(436);

var _EmpoweringSection2 = _interopRequireDefault(_EmpoweringSection);

var _NewsSection = __webpack_require__(441);

var _NewsSection2 = _interopRequireDefault(_NewsSection);

var _FirstMobileSection = __webpack_require__(438);

var _FirstMobileSection2 = _interopRequireDefault(_FirstMobileSection);

var _UnbankedStatSection = __webpack_require__(449);

var _UnbankedStatSection2 = _interopRequireDefault(_UnbankedStatSection);

var _QuotesSection = __webpack_require__(444);

var _QuotesSection2 = _interopRequireDefault(_QuotesSection);

var _WhatMakesSection = __webpack_require__(451);

var _WhatMakesSection2 = _interopRequireDefault(_WhatMakesSection);

var _SafetySection = __webpack_require__(445);

var _SafetySection2 = _interopRequireDefault(_SafetySection);

var _OpportunitiesSection = __webpack_require__(442);

var _OpportunitiesSection2 = _interopRequireDefault(_OpportunitiesSection);

var _Partners = __webpack_require__(443);

var _Partners2 = _interopRequireDefault(_Partners);

var _GrowingSection = __webpack_require__(440);

var _GrowingSection2 = _interopRequireDefault(_GrowingSection);

var _UseCasesSection = __webpack_require__(450);

var _UseCasesSection2 = _interopRequireDefault(_UseCasesSection);

var _GlobalChallengeSection = __webpack_require__(439);

var _GlobalChallengeSection2 = _interopRequireDefault(_GlobalChallengeSection);

var _ExpeditionSection = __webpack_require__(437);

var _ExpeditionSection2 = _interopRequireDefault(_ExpeditionSection);

var _WorldTalkingSection = __webpack_require__(452);

var _WorldTalkingSection2 = _interopRequireDefault(_WorldTalkingSection);

var _TeamSection = __webpack_require__(448);

var _TeamSection2 = _interopRequireDefault(_TeamSection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('News1');
// import Meta from './meta.js'

/*import TimelineSection from './sections/TimelineSection'*/


var serverNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'press', 'contacts'];
var clientNames = ['empowering', 'news', 'mobile', 'situation', 'changes', 'platform', 'simplicity', 'opportunities', 'partners', 'userbase', 'use cases', 'challenge', 'expedition',
/*  'timeline',*/
'team', 'press', 'contacts'];

var sectionsNames =  true ? clientNames : serverNames;

var dark = ['mobile', 'situation', 'platform', 'opportunities', 'partners', 'use cases', 'expedition', 'team'];

var showingWidth = 1120;

var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showIndex: _this.props.showIndex || 0,
      scroll: true,
      fastScroll: true,
      widthBig: true && window.innerWidth >= showingWidth
    }, _this.sectionsObj = {
      empowering: _react2.default.createElement(_EmpoweringSection2.default, { mix: cn('section'), key: 'empowering', users_number: _this.props.users_number }),
      news: _react2.default.createElement(_NewsSection2.default, { mix: cn('section'), key: 'news' }),
      mobile: _react2.default.createElement(_FirstMobileSection2.default, { mix: cn('section'), key: 'mobile' }),
      situation: _react2.default.createElement(_UnbankedStatSection2.default, { mix: cn('section'), key: 'situation' }),
      changes: _react2.default.createElement(_QuotesSection2.default, { mix: cn('section', { type: 'slider' }), key: 'changes' }),
      platform: _react2.default.createElement(_WhatMakesSection2.default, { mix: cn('section'), key: 'platform' }),
      simplicity: _react2.default.createElement(_SafetySection2.default, { mix: cn('section'), key: 'simplicity' }),
      opportunities: _react2.default.createElement(_OpportunitiesSection2.default, { mix: cn('section'), key: 'opportunities' }),
      partners: _react2.default.createElement(_Partners2.default, { mix: cn('section'), key: 'partners' }),
      userbase: _react2.default.createElement(_GrowingSection2.default, { mix: cn('section'), key: 'userbase' }),
      'use cases': _react2.default.createElement(_UseCasesSection2.default, { mix: cn('section'), key: 'usecases' }),
      challenge: _react2.default.createElement(_GlobalChallengeSection2.default, { mix: cn('section'), key: 'challenge' }),
      expedition: _react2.default.createElement(_ExpeditionSection2.default, { mix: cn('section'), key: 'expedition' }),
      /*timeline: <TimelineSection mix={cn('section')} key="timeline" />,*/
      team: _react2.default.createElement(_TeamSection2.default, { mix: cn('section'), key: 'team', openPeopleModal: _this.props.openPeopleModal }),
      press: _react2.default.createElement(_WorldTalkingSection2.default, { mix: cn('section'), key: 'press' }),
      contacts: _react2.default.createElement(_O_Footer_H2.default, {
        mix: cn('section', { type: 'half-height' }),
        openPopup: _this.props.openPopup,
        key: 'contacts'
      })
    }, _this.handleSideMenu = function (_ref2) {
      var showIndex = _ref2.showIndex,
          extra = (0, _objectWithoutProperties3.default)(_ref2, ['showIndex']);
      var setTheme = _this.props.setTheme;

      _this.setState((0, _extends3.default)({ showIndex: showIndex }, extra));
      if (dark.includes(sectionsNames[showIndex])) {
        setTheme('dark');
      } else {
        setTheme('bright');
      }
    }, _this.handleWeel = function (_ref3) {
      var deltaY = _ref3.deltaY;

      var touchBar = deltaY - Math.round(deltaY) === 0;

      if (touchBar) {
        _this.handleTouchBar({ deltaY: deltaY });
      } else {
        _this.handleMouseWeel({ deltaY: deltaY });
      }
    }, _this.handleScrollUp = function () {
      _this.setState({ showIndex: 0 });
    }, _this.getWidth = function () {
      var widthBig = window.innerWidth >= showingWidth,
          shorter = _this.state.widthBig && !widthBig,
          bigger = !_this.state.widthBig && widthBig;

      if (shorter || bigger) {
        _this.setState({ widthBig: widthBig });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'getSideMenu',
    value: function getSideMenu(showIndex) {
      var _this2 = this;

      var hashLinks = sectionsNames.map(function (name, i) {
        return _react2.default.createElement(
          'div',
          {
            key: name,
            className: cn('side-menu-item'),
            onClick: function onClick() {
              return _this2.handleSideMenu({ showIndex: i });
            }
          },
          _react2.default.createElement('div', { className: cn('dot', { selected: showIndex === i }) })
        );
      });
      return _react2.default.createElement(
        'aside',
        { className: cn('side-menu') },
        hashLinks
      );
    }
  }, {
    key: 'handleTouchBar',
    value: function handleTouchBar(_ref4) {
      var _this3 = this;

      var deltaY = _ref4.deltaY;
      var _state = this.state,
          oldIndex = _state.showIndex,
          fastScroll = _state.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 100) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this3.setState({ scroll: true });
      }, 400);
      setTimeout(function () {
        return _this3.setState({ fastScroll: true });
      }, 1000);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: '_handleKeyPress',
    value: function _handleKeyPress(_ref5) {
      var keyCode = _ref5.keyCode;
      var oldIndex = this.state.showIndex;

      var nextCodes = [40, 34, 32, 39],
          prevCodes = [38, 33, 36, 37];
      if (nextCodes.includes(keyCode) && oldIndex < sectionsNames.length - 1) {
        this.setState({ showIndex: oldIndex + 1 });
      } else if (prevCodes.includes(keyCode) && oldIndex > 0) {
        this.setState({ showIndex: oldIndex - 1 });
      }
    }
  }, {
    key: 'handleMouseWeel',
    value: function handleMouseWeel(_ref6) {
      var _this4 = this;

      var deltaY = _ref6.deltaY;
      var _state2 = this.state,
          oldIndex = _state2.showIndex,
          fastScroll = _state2.fastScroll;

      if (!fastScroll && Math.abs(deltaY) < 900) return;
      var showIndex = deltaY > 0 ? oldIndex + 1 : oldIndex - 1;
      setTimeout(function () {
        return _this4.setState({ scroll: true });
      }, 200);
      setTimeout(function () {
        return _this4.setState({ fastScroll: true });
      }, 500);

      if (showIndex >= 0 && showIndex < sectionsNames.length) {
        this.handleSideMenu({ showIndex: showIndex, scroll: false, fastScroll: false });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.getWidth);
      this.container.focus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.getWidth);
    }
  }, {
    key: 'getPositionY',
    value: function getPositionY(showIndex) {
      if (showIndex === sectionsNames.length - 1) {
        return (showIndex - 1) * 100 + 50;
      } else {
        return showIndex * 100;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state3 = this.state,
          showIndex = _state3.showIndex,
          scroll = _state3.scroll,
          widthBig = _state3.widthBig;

      var controlledScroll = false;
      var positionY = controlledScroll ? this.getPositionY(showIndex) : 0;
      return _react2.default.createElement(
        'div',
        {
          className: cn({ scroll: !controlledScroll }),
          tabIndex: '0',
          ref: function ref(el) {
            _this5.container = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: cn('inner') },
          sectionsNames.map(function (name) {
            return _this5.sectionsObj[name];
          })
        )
      );
    }
  }]);
  return Home;
}(_react.Component);

Home.propTypes = {
  total_installations: T.number
};

Home.defaultProps = {};

exports.default = Home;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _O_SimpleForm_H_ = __webpack_require__(108);

var _O_SimpleForm_H_2 = _interopRequireDefault(_O_SimpleForm_H_);

var _M_Exchanges_Slider = __webpack_require__(106);

var _M_Exchanges_Slider2 = _interopRequireDefault(_M_Exchanges_Slider);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _index = __webpack_require__(91);

var _index2 = _interopRequireDefault(_index);

var _reactDelay = __webpack_require__(118);

var _reactDelay2 = _interopRequireDefault(_reactDelay);

var _reactScrollableAnchor = __webpack_require__(126);

var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);

var _news = __webpack_require__(53);

var _jquery = __webpack_require__(160);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(731);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_News1_Empowering');
//import M_Countdown from "../../../../widgets/M_Countdown";


var handleLinkClick = function handleLinkClick(name) {
    if (window.ga) window.ga('send', 'event', 'other', 'event-click-' + name);
};

var formatUserNum = function formatUserNum(users) {
    var usersD = users.toString();
    usersD = usersD.slice(0, usersD.length - 3) + "  " + usersD.slice(usersD.length - 3);
    return usersD;
};

function createMarkup(input) {
    return { __html: input };
}

var _createLinks = function _createLinks(links) {
    return links.map(function (_ref, index) {
        var title = _ref.title,
            more = _ref.more,
            img = _ref.img,
            button = _ref.button,
            url = _ref.url,
            uid = _ref.uid,
            isInt = _ref.isInt;

        var divStyle = {
            backgroundImage: 'url(' + img + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top center',
            backgroundSize: 'cover'
        };
        isInt = isInt ? '' : '_blank';
        return _react2.default.createElement(
            'div',
            { className: 'item', key: 'mainEvent-' + (index + 1) },
            _react2.default.createElement(
                'div',
                { className: 'wrap', style: divStyle },
                _react2.default.createElement('h1', { dangerouslySetInnerHTML: createMarkup(title) }),
                _react2.default.createElement('div', { className: 'more', dangerouslySetInnerHTML: createMarkup(more) }),
                button && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: url, className: 'button', onClick: function onClick() {
                                handleLinkClick(uid);
                            }, target: isInt },
                        button
                    )
                )
            )
        );
    });
};

var SE_Home_Empowering = function (_React$Component) {
    (0, _inherits3.default)(SE_Home_Empowering, _React$Component);

    function SE_Home_Empowering(props) {
        (0, _classCallCheck3.default)(this, SE_Home_Empowering);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SE_Home_Empowering.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Empowering)).call(this, props));

        _this.gotoSlide = function (index) {
            _this.slider.slickGoTo(index);
            console.log(_this.slider);
        };

        _this.createDots = function (list) {
            return list.map(function (_ref2, index) {
                var title = _ref2.title,
                    more = _ref2.more,
                    img = _ref2.img;

                return _react2.default.createElement(
                    'i',
                    null,
                    _this.state.activeSlide == index && _react2.default.createElement(
                        'div',
                        { className: 'pie-wrap' },
                        _react2.default.createElement('div', { className: 'slice1 slice-wrap' }),
                        _react2.default.createElement('div', { className: 'slice2 slice-wrap' })
                    ),
                    _this.state.activeSlide != index && _react2.default.createElement('div', { className: 'pie-wrap full', onClick: function onClick() {
                            _this.gotoSlide(index);
                        } })
                );
            });
        };

        _this.state = {
            hmq2usd: "",
            ccwShow: false
        };
        return _this;
    }

    (0, _createClass3.default)(SE_Home_Empowering, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _index2.default.get("https://api.coinmarketcap.com/v2/ticker/1669/").then(function (res) {
                console.log(res.data);
                var ratio = Math.round(1000 * res.data.data.quotes.USD.price) / 1000;
                console.log(ratio);
                _this2.setState({
                    hmq2usd: "1 HMQ = " + ratio + " USD",
                    ccwShow: res.data.data.quotes.USD.percent_change_24h > 0,
                    ccw: res.data.data.quotes.USD.percent_change_24h
                });
            }).catch(function (error) {
                console.log(error);
            });

            (0, _jquery2.default)(document).ready(function () {
                (0, _jquery2.default)('#coinswitch-widget').one('load', function () {
                    (0, _jquery2.default)('.coinswitch-label').css({ 'opacity': '1' });
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var settings = {
                loop: true,
                speed: 700,
                autoplay: true,
                autoplaySpeed: 5350,
                cssEase: 'ease-in-out',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                initialSlide: 0,
                arrows: false,
                //dots: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                mobileFirst: true,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                beforeChange: function beforeChange(current, next) {
                    return _this3.setState({ activeSlide: next });
                }
            };

            var iframeResizerOptions = { checkOrigin: false };

            return _react2.default.createElement(
                'section',
                { className: cn([this.mix]) },
                _react2.default.createElement(
                    'div',
                    { className: cn('left-side') },
                    _react2.default.createElement(
                        'div',
                        { className: cn('map') },
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'desktop' }),
                            src: '/img/v1/home/map-bg-2.png',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement('img', {
                            className: cn('map-img', { type: 'mobile' }),
                            src: '/img/v1/home/mobile-map.jpg',
                            alt: 'EMPOWERING THE UNBANKED'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 1 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 2 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 3 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 4 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: cn('point', { number: 5 }) },
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null),
                            _react2.default.createElement('span', null)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('text') },
                        _react2.default.createElement(
                            _A_Title_H2.default,
                            { type: 'hero', mix: cn('text-title'), theme: 'bright' },
                            'P2P financial services ',
                            _react2.default.createElement('br', null),
                            'for developing countries'
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: cn('text-subtitle') },
                            'Connecting 1.7 billion people'
                        ),
                        this.state.ccwShow && _react2.default.createElement(
                            'div',
                            { className: 'ccw-wrap' },
                            _react2.default.createElement('script', { type: 'text/javascript',
                                src: 'https://files.coinmarketcap.com/static/widget/currency.js' }),
                            _react2.default.createElement('div', { className: 'coinmarketcap-currency-widget', 'data-currencyid': '1669', 'data-base': 'USD',
                                'data-secondary': '', 'data-ticker': 'true', 'data-rank': 'true', 'data-marketcap': 'true',
                                'data-volume': 'true', 'data-stats': 'USD', 'data-statsticker': 'false' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('anni') },
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-title' },
                            '1 year after tokensale'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'anni-operate' },
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-mark' },
                                _react2.default.createElement('img', { src: '/img/done.svg' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide one' },
                                '21 countries ',
                                _react2.default.createElement('br', null),
                                ' operating'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide two' },
                                formatUserNum(452068),
                                ' ',
                                _react2.default.createElement('br', null),
                                'users'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'anni-slide three' },
                                'Hybrid ',
                                _react2.default.createElement('br', null),
                                'blockchain'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('right-side') },
                    _react2.default.createElement(
                        _reactSlick2.default,
                        (0, _extends3.default)({ ref: function ref(slider) {
                                return _this3.slider = slider;
                            } }, settings),
                        _createLinks(_news.mainList)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "overlay" },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'TODAY'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'i',
                                null,
                                this.state.hmq2usd
                            ),
                            this.state.ccwShow && _react2.default.createElement(
                                'div',
                                { className: 'mmark' },
                                _react2.default.createElement('img', { src: '/img/ccw-arrow.svg' }),
                                this.state.ccw,
                                '%'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: "dots" },
                            this.createDots(_news.mainList)
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactScrollableAnchor2.default,
                    { id: 'xchange' },
                    _react2.default.createElement(
                        'div',
                        { className: 'coinswitch-widget' },
                        _react2.default.createElement(
                            'iframe',
                            { id: 'coinswitch-widget', width: '100%', height: '400', src: 'https://coinswitch.co/widget?widget_id=fc72a10e&from=btc&to=hmq&amount=0.01', frameBorder: 0, order: '0', scrolling: 'no' },
                            'Can\'t load widget'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'coinswitch-label row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-md-8' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-icon' },
                                    '!'
                                ),
                                'HMQ wallet is any ETH (Ethereum) wallet'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: cn('slider-wrap') },
                    _react2.default.createElement(
                        'div',
                        { className: 'w' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pre' },
                            _react2.default.createElement(
                                _A_Title_H2.default,
                                { type: 'hero', theme: 'bright' },
                                'HMQ token is a fuel of the platform'
                            ),
                            'Visit one of the following external services independent from Humaniq in order to purchase HMQ'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'b' },
                            _react2.default.createElement(
                                'a',
                                { className: 'button', href: 'https://bittrex.com/Market/Index?MarketName=BTC-HMQ', target: '_blank' },
                                'Trade now'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cn('slider') },
                        _react2.default.createElement(
                            _reactDelay2.default,
                            { wait: 2000 },
                            _react2.default.createElement(_M_Exchanges_Slider2.default, null)
                        )
                    )
                )
            );
        }
    }]);
    return SE_Home_Empowering;
}(_react2.default.Component);

exports.default = SE_Home_Empowering;


SE_Home_Empowering.propTypes = {
    //mix: T.string,
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(71);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(732);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Expedition');

var SE_Home_Expedition = function SE_Home_Expedition(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq expedition: the first',
        _react2.default.createElement('br', null),
        ' step in financial inclusion'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
      _react2.default.createElement(
        'div',
        { className: cn('button') },
        _react2.default.createElement(
          _A_Btn_H2.default,
          { to: 'http://challenge.humaniq.com' },
          'About expedition'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 11, theme: 'bright' })
  );
};

exports.default = SE_Home_Expedition;


var infoColumns = [{
  title: 'Startup contest',
  text: 'In order to bring together a network of like-minded individuals and then choose 10 projects for entry into the Humaniq system, we are launching the Humaniq Global Challenge for entrepreneurs, developers, marketing specialists and economists.'
}, {
  title: 'Benefits',
  text: '10 Finalists will receive expert advice from top consultants in their field, as well as the chance to gain investment and to enter the Humaniq accelerator.'
}, {
  title: 'Trip to Kenya',
  text: 'The three best teams will go on a trip to Kenya to learn more about the lives of the unbanked and put the finishing touches to their projects ahead of an ICO, which will be supported by Humaniq.'
}];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(71);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(733);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_FirstMobile');

var handleLinkClick = function handleLinkClick() {
  if (window.ga) window.ga('send', 'event', 'other', 'whitepaper-btn-click');
};

var SE_Home_FirstMobile = function SE_Home_FirstMobile(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'The first mobile service with',
        _react2.default.createElement('br', null),
        'the capacity to change the world'
      ),
      _react2.default.createElement(
        'p',
        { className: cn('subtitle') },
        'Humaniq is a new generation financial services',
        _react2.default.createElement('br', null),
        ' with its own cryptocurrency, which is aimed at',
        _react2.default.createElement('br', null),
        ' eradicating poverty amongst millions of people',
        _react2.default.createElement('br', null),
        ' living in the emerging economies'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' }),
        _react2.default.createElement(
          'div',
          { className: cn('button') },
          _react2.default.createElement(
            _A_Btn_H2.default,
            { to: '/pdf/humaniq-whitepaper-05.09.pdf', clickHandler: handleLinkClick },
            'Whitepaper'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 2, theme: 'bright' })
  );
};

exports.default = SE_Home_FirstMobile;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/key.svg',
  title: 'For the unbanked people',
  text: 'Humaniq opens up the benefits of financial inclusion and grants access to a series of financial services'
}, {
  imageSrc: '/img/design-v2/icons/sections/busness.svg',
  title: 'For businesses',
  text: 'Humaniq enables start-ups and projects to offer their services to an audience of billions'
}];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _M_SocialLinks_G = __webpack_require__(107);

var _M_SocialLinks_G2 = _interopRequireDefault(_M_SocialLinks_G);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(71);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(734);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_GlobalChallenge');

var SE_Home_GlobalChallenge = function SE_Home_GlobalChallenge(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq global',
        _react2.default.createElement('br', null),
        ' challenge'
      ),
      _react2.default.createElement(_InfoColumns2.default, {
        mix: cn('info-columns'),
        columns: infoColumns,
        type: 'narrow',
        layout: 'global-challenge'
      }),
      _react2.default.createElement(
        _M_SocialLinks_G2.default,
        { mix: cn('social-links'), type: 'section' },
        'You know how to enhance Humaniq?',
        _react2.default.createElement('br', null),
        ' Join the global Humaniq community'
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 10, theme: 'dark' })
  );
};

exports.default = SE_Home_GlobalChallenge;


var infoColumns = [{
  title: 'Life-changing technology',
  text: 'Humaniq grew out of the idea that advanced technologies should benefit everybody. Now, we want to inspire developers from all over the world to come and join our movement.'
}, {
  title: 'Humanitarian impact',
  text: 'Humaniq is not just a commercial project. It is a worldwide mission, aiming to give people in developing nations more power to change their lives.'
}];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(735);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Growing');

var SE_Home_Growing = function SE_Home_Growing(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Humaniq\'s ever\u2011growing',
        _react2.default.createElement('br', null),
        ' userbase is a blue ocean for',
        _react2.default.createElement('br', null),
        ' thousands of new projects'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('columns-wrapper') },
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '1 ',
            _react2.default.createElement(
              'span',
              null,
              'billion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'new users in the',
            _react2.default.createElement('br', null),
            ' coming years'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '$4 ',
            _react2.default.createElement(
              'span',
              null,
              'trillion'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'potentially in',
            _react2.default.createElement('br', null),
            ' user accounts'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('text-column') },
          _react2.default.createElement(
            'div',
            { className: cn('text-column-top') },
            '200+'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('text-column-bottom') },
            'start-ups are planning',
            _react2.default.createElement('br', null),
            ' to move onto the',
            _react2.default.createElement('br', null),
            ' Humaniq platform'
          )
        )
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 8, theme: 'dark' })
  );
};

exports.default = SE_Home_Growing;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _reactSlick = __webpack_require__(51);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

__webpack_require__(736);

var _utils = __webpack_require__(1);

var _news = __webpack_require__(53);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Butter from 'buttercms';
//const butter = Butter('63c5be1dcac33aad42357d8eb320058d0562c240');

var cn = (0, _utils.cssClassName)('SE_News1_News');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'news-click-' + name);
};

var _createLinks = function _createLinks(links, startIndex) {
  return links.map(function (_ref, index) {
    var title = _ref.title,
        src = _ref.src,
        url = _ref.url,
        date = _ref.date,
        img = _ref.img,
        target = _ref.target;


    if (index >= startIndex) {
      return _react2.default.createElement(
        'div',
        { className: 'item', key: 'newsLink-' + (index + 1) },
        url && _react2.default.createElement(
          'a',
          { className: 'link', href: url, title: title, target: target,
            onClick: function onClick() {
              handleLinkClick(index);
            } },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        !url && _react2.default.createElement(
          'div',
          { className: 'link', title: title },
          _react2.default.createElement('img', { src: img }),
          _react2.default.createElement(
            'div',
            { className: 'src' },
            src
          ),
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'src' },
          date
        )
      );
    }
  });
};

function nextArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

function prevArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  return _react2.default.createElement('div', { className: className, onClick: onClick });
}

var SE_News1_News = function (_React$Component) {
  (0, _inherits3.default)(SE_News1_News, _React$Component);

  function SE_News1_News(props) {
    (0, _classCallCheck3.default)(this, SE_News1_News);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SE_News1_News.__proto__ || (0, _getPrototypeOf2.default)(SE_News1_News)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(SE_News1_News, [{
    key: 'render',
    value: function render() {

      var settings = {
        loop: true,

        speed: 700,
        autoplay: false,
        cssEase: 'ease-in-out',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 0,
        arrows: true,
        //buttons: false,
        //dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        mobileFirst: true,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        nextArrow: _react2.default.createElement('nextArrow', null),
        prevArrow: _react2.default.createElement('prevArrow', null),

        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }]
      };

      return _react2.default.createElement(
        'section',
        { className: cn([this.mix]) },
        _react2.default.createElement(
          _A_Title_H2.default,
          { type: 'hero', mix: cn('text-title'), theme: 'dark' },
          'Latest ',
          _react2.default.createElement(
            'ss',
            null,
            'news'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('article-list') },
          _react2.default.createElement(
            _reactSlick2.default,
            settings,
            _createLinks(_news.articleList, 0)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: cn('more-news') },
          _react2.default.createElement(
            'a',
            { className: 'button', href: 'https://blog.humaniq.co/', target: '_blank' },
            'See All NEWS'
          ),
          _react2.default.createElement(
            'a',
            { className: 'link-sec', href: 'https://www.facebook.com/humaniq.co/', target: '_blank' },
            'Join our Facebook',
            _react2.default.createElement('img', { src: '/img/link.svg' })
          )
        )
      );
    }
  }]);
  return SE_News1_News;
}(_react2.default.Component);

exports.default = SE_News1_News;


SE_News1_News.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(71);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(737);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Opportunities');

var SE_Home_Opportunities = function SE_Home_Opportunities(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Extraordinary opportunitites for business'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 7, theme: 'bright' })
  );
};

exports.default = SE_Home_Opportunities;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/etherium.svg',
  title: 'Based on Ethereum blockchain protocol',
  text: 'Guaranteed security against hacking, corruption and loss of information thanks to complete decentralisation'
}, {
  imageSrc: '/img/design-v2/icons/sections/accelerator.svg',
  title: 'Independent fund and accelerator',
  text: 'External projects and promising ideas can receive expert support and investment for a launch into the Humaniq system'
}, {
  imageSrc: '/img/design-v2/icons/sections/api.svg',
  title: 'Open API',
  text: 'Any project can merge into the Humaniq system'
}];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(738);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Partners');

var handleLinkClick = function handleLinkClick(name) {
  if (window.ga) window.ga('send', 'event', 'other', 'partners-click-' + name);
};

function createMarkup(input) {
  return { __html: input };
}

var _createLinks = function _createLinks(links) {
  return links.map(function (_ref, index) {
    var href = _ref.href,
        img = _ref.img,
        name = _ref.name,
        more = _ref.more;

    var divStyle = {
      backgroundImage: 'url(' + img + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    };
    console.log(divStyle);
    return _react2.default.createElement(
      'div',
      { className: 'item', key: 'partner-' + (index + 1) },
      href && _react2.default.createElement(
        'a',
        { href: href, className: 'wrap', target: '_blank', onClick: function onClick() {
            handleLinkClick(name);
          } },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      ),
      !href && _react2.default.createElement(
        'div',
        { className: 'wrap' },
        _react2.default.createElement('img', { src: img }),
        _react2.default.createElement('div', { className: 'popup', dangerouslySetInnerHTML: createMarkup(more) })
      )
    );
  });
};

var SE_Partners = function SE_Partners(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'Humaniq Partners'
      ),
      _react2.default.createElement(
        'div',
        { className: 'partners-list' },
        _createLinks(infoColumns)
      )
    )
  );
};

exports.default = SE_Partners;


var infoColumns = [{
  img: '/img/partners/un.png',
  href: "https://www.unglobalcompact.org",
  name: 'un',
  more: "The visionary who launched the <b>UN Global Compact</b> and inspired the world’s largest corporate sustainability initiative."
}, {
  img: '/img/partners/l39.png',
  href: "https://www.level39.co",
  name: 'l39',
  more: "<b>Level39</b> is a community of 1,250 leaders in cybersecurity, fintech and retail tech"
}, {
  img: '/img/partners/rise.png',
  href: "https://thinkrise.com",
  name: 'rise',
  more: "<b>Rise</b> is a community of startups & corporates creating the future of financial services."

}, {
  img: '/img/partners/coinfirm.png',
  href: "https://www.coinfirm.io",
  name: 'coinfirm',
  more: "The <b>Coinfirm</b> platform provides and easy to use solution with valuable structured data that puts entities on the safe side in terms of regulatory and fraud risk."

}, {
  img: '/img/partners/transbox.png',
  href: "http://www.transbox.xyz",
  name: 'transbox',
  more: "<b>Transbox</b> is online communication and data security specialised company."

}, {
  img: '/img/partners/bi.png',
  href: "https://www.biometricsinstitute.org",
  name: 'bi',
  more: "The mission of the <b>Biometrics Institute</b> is to promote the responsible use of biometrics in an independent and impartial international forum for biometric users and other interested parties."

}, {
  img: '/img/partners/jamii.png',
  href: "http://www.jamiiafrica.com/",
  name: 'jamii',
  more: "<b>Jamii Africa</b> is mobile micro-health insurance for the informal sector."

}, {
  img: '/img/partners/ff.png',
  href: "http://futurefintech.org",
  name: 'ff',
  more: "<b>Future Fintech</b> are connecting young businesses to the global community of VC and tech startups, giving access to the best tested cases, wide range of sector specific expertise and pinpoint advices."

}];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(739);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Quotes');

var _getQuotesSlides = function _getQuotesSlides(quotes) {
  var res = [];
  var genSlidesArray = function genSlidesArray(keysName) {
    return quotes.map(function (quote, index) {

      return _react2.default.createElement(
        'div',
        { key: 'quote-' + (keysName + (index + 1)), className: cn('slide') },
        _react2.default.createElement(
          'div',
          { className: cn('slide-content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('slide-title'), type: 'section', theme: 'bright' },
            quote.title
          ),
          _react2.default.createElement(
            'p',
            {
              className: quote.text.length < 260 ? cn('slide-text') : cn('slide-text', { type: 'small' })
            },
            quote.text
          ),
          _react2.default.createElement(
            'p',
            { className: cn('slide-author') },
            '\u2014 ',
            quote.author
          )
        )
      );
    });
  };

  res = res.concat(genSlidesArray('clone_before'));
  res = res.concat(genSlidesArray('clone_middle'));
  res = res.concat(genSlidesArray('clone_after'));

  return res;
};

var SE_Home_Quotes = function (_Component) {
  (0, _inherits3.default)(SE_Home_Quotes, _Component);

  function SE_Home_Quotes() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Quotes);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Quotes.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Quotes)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Quotes, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + quotes.length) % quotes.length;
      this.setState({ show: show });
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;
      var show = this.state.show;

      var pctX = show * 25;
      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('slider'), style: { transform: 'translateX(-' + pctX + '%)' } },
          _getQuotesSlides(quotes)
        ),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'prev' }), onClick: this.prev }),
        _react2.default.createElement('div', { className: cn('slider-nav', { type: 'next' }), onClick: this.next }),
        _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 4, theme: 'dark' })
      );
    }
  }]);
  return SE_Home_Quotes;
}(_react.Component);

exports.default = SE_Home_Quotes;


SE_Home_Quotes.propTypes = {
  mix: T.string //BEM mixin from parent block
};

var quotes = [{
  title: 'The world is ready for change',
  text: 'Including the poorest in the financial system increases the value of their assets, transforming the underlying economics of financial services through digital currency - helping those who live in poverty directly.',
  author: 'Bill Gates',
  img: '/img/design-v2/sections/quotes/bill-gates2.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Because of technology, we can help shape the arc of history to bend it towards financial inclusion and greater human progress. Financial inclusion is a massive undertaking – one that can only be met together – across countries, sectors, and industries.',
  author: 'Ajaypal Singh Banga, MasterCard CEO',
  img: '/img/design-v2/sections/quotes/ajaypal-singh-banga.jpg'
}, {
  title: 'The world is ready for change',
  text: 'Widely used digital finance has the power to transform the economic prospects of billions of people and inject new dynamism into small businesses that today are held back for lack of credit. Emerging economies have an opportunity to use mobile technologies to provide digital financial services for all, rapidly unlocking economic opportunity and accelerating social development.',
  author: 'McKinsey Global Institute Report September 2016',
  img: '/img/design-v2/sections/quotes/mckinsey-global-Institute.jpg'
}, {
  title: 'The world is ready for change',
  text: 'In pyramid of development the bottom-most layer needs to be strengthened through financial inclusionimproving purchasing power of the poor.',
  author: 'Narendra Modi',
  img: '/img/design-v2/sections/quotes/narendra-modi.jpg'
}];

// import * as T from "prop-types";
// import './styles.scss';
// import {cssClassName} from 'utils'
// const cn = cssClassName('')

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(71);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(740);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Safety');

var SE_Home_Safety = function SE_Home_Safety(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'Simplicity and safety for the unbanked'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 6, theme: 'dark' })
  );
};

exports.default = SE_Home_Safety;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/card.svg',
  title: 'Biometric authentification',
  text: 'Users are verified by their face and voice, eliminating the need for formal documentation '
}, {
  imageSrc: '/img/design-v2/icons/sections/access.svg',
  title: 'Independent HMQ currency',
  text: 'Every new user receives $20 worth of HMQ in their account, the value of which bears no relation to their local currency'
}, {
  imageSrc: '/img/design-v2/icons/sections/interface.svg',
  title: 'The interface is simple to interact with',
  text: 'Even for those who have never used gadgets before'
}];

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(741);

var _utils = __webpack_require__(1);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as T from "prop-types";
var cn = (0, _utils.cssClassName)('TeamSectionSlide');


var getHazemName = function getHazemName() {
  return _react2.default.createElement(
    'span',
    null,
    'Hazem Danny',
    _react2.default.createElement('br', null),
    'Al-Nakib'
  );
};

var TeamSectionSlide = function (_Component) {
  (0, _inherits3.default)(TeamSectionSlide, _Component);

  function TeamSectionSlide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TeamSectionSlide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TeamSectionSlide.__proto__ || (0, _getPrototypeOf2.default)(TeamSectionSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getSlide = function (_ref2, groupName, i) {
      var first = _ref2.first,
          imgSrc = _ref2.imgSrc,
          position = _ref2.position,
          name = _ref2.name,
          bio = _ref2.bio;

      name = name.search('Al-Nakib') === -1 ? name : getHazemName();
      var handleClick = bio ? function () {
        return _this.props.openPeopleModal({ imgSrc: imgSrc, position: position, name: name, bio: bio, groupName: groupName });
      } : undefined;
      return _react2.default.createElement(
        'div',
        { className: cn('person'), key: i, onClick: handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('person-image') },
          _react2.default.createElement(_A_Image2.default, { src: imgSrc, rounded: true })
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-name') },
          name
        ),
        _react2.default.createElement(
          'p',
          { className: cn('person-title') },
          position
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TeamSectionSlide, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          persons = _props.persons,
          showGroupName = _props.showGroupName,
          groupName = _props.groupName,
          hidden = _props.hidden;

      var renderTitle = showGroupName && groupName && _react2.default.createElement(
        'span',
        { className: cn('group-name') },
        groupName
      );
      var renderSlides = persons.map(function (el, i) {
        return _this2.getSlide(el, groupName, i);
      });
      return _react2.default.createElement(
        'div',
        { className: cn({ wide: showGroupName, hidden: hidden }) },
        renderTitle,
        renderSlides
      );
    }
  }]);
  return TeamSectionSlide;
}(_react.Component);

TeamSectionSlide.propTypes = {};

TeamSectionSlide.defaultProps = {};
exports.default = TeamSectionSlide;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getDelta = getDelta;
exports._indexOfShow = _indexOfShow;
exports.indexOfShow = indexOfShow;
exports.findIndexesOfRedundantSlides = findIndexesOfRedundantSlides;
exports.pairSplit = pairSplit;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDelta(slidesWidths, show) {
  var k = -1;
  if (show < 0) {
    show = -show;
    slidesWidths = [].concat((0, _toConsumableArray3.default)(slidesWidths)).reverse();
    k = 1;
  }
  var delta = 0;

  if (show >= slidesWidths.length) {
    delta = slidesWidths.reduce(function (a, b) {
      return a + b;
    }, 0) * (show / slidesWidths.length | 0);
    show = show % slidesWidths.length;
  }

  for (var i = 0; i < show; i++) {
    delta += slidesWidths[i];
  }
  return delta * k;
}

function _indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index + 1;
  } else {
    return extended_index + 1;
  }
}

function indexOfShow(slidesCount, show) {
  var extended_index = show % slidesCount;
  if (extended_index < 0) {
    return slidesCount + extended_index;
  } else {
    return extended_index;
  }
}

function findIndexesOfRedundantSlides(slidesCount, show, slidesWidths) {
  var width_container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var first_index_of_slides = indexOfShow(slidesCount, show);
  var slidesLengh = 0,
      previousLength = 0,
      i_last = first_index_of_slides;
  for (slidesLengh = 0; slidesLengh < width_container; i_last++) {
    previousLength = slidesLengh;
    slidesLengh = previousLength + slidesWidths[indexOfShow(slidesCount, i_last)];
  }
  var padding = width_container ? (width_container - previousLength) / 2 : '0';
  return {
    arr: [_indexOfShow(slidesCount, first_index_of_slides - 1), _indexOfShow(slidesCount, first_index_of_slides - 2), _indexOfShow(slidesCount, i_last - 1), _indexOfShow(slidesCount, i_last)],
    padding: padding
  };
}

function pairSplit(arr, title) {
  var entities = [];

  for (var i = 0; i < arr.length; i += 2) {
    entities.push(arr.slice(i, i + 2));
  }
  return {
    title: title,
    entities: entities
  };
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(742);

var _utils = __webpack_require__(1);

var _Swipe = __webpack_require__(92);

var _Swipe2 = _interopRequireDefault(_Swipe);

var _helpers = __webpack_require__(447);

var _Slide = __webpack_require__(446);

var _Slide2 = _interopRequireDefault(_Slide);

var _people = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_Team');
// import A_Image from 'A_Image/index'


var NORMAL_WIDTH = 136;
var WIDE_WIDTH = NORMAL_WIDTH + 20 + 16;
// import M_Tooltip from 'M_Tooltip'

var SE_Home_Team = function (_Component) {
  (0, _inherits3.default)(SE_Home_Team, _Component);

  function SE_Home_Team() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_Team);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_Team.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_Team)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0
    }, _this.widths = { container: 0 }, _this.right = function () {
      return _this.changeShow(1);
    }, _this.left = function () {
      return _this.changeShow(-1);
    }, _this.changeShow = function (n) {
      return _this.setState(function (oldState) {
        return { show: oldState.show + n };
      });
    }, _this.onSwipeRight = _this.left, _this.onSwipeLeft = _this.right, _this.threshold = 100, _this.slideGroups = [(0, _helpers.pairSplit)(_people.team, 'team'), (0, _helpers.pairSplit)(_people.advisers, 'advisers'), (0, _helpers.pairSplit)(_people.ambassadors, 'ambassadors')], _this.slidesWidths = [], _this.slidesCount = _this.slideGroups.reduce(function (sum, el) {
      return sum + el.entities.length;
    }, 0), _this.getStep = function (slidesWidths, show) {
      return slidesWidths.length ? (0, _helpers.getDelta)(slidesWidths, show) : WIDE_WIDTH;
    }, _this.handleResize = function () {
      _this.forceUpdate();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_Team, [{
    key: 'getSlides',
    value: function getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides) {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(slideGroups, keys_name) {
        var indexTotal = 0;
        return slideGroups.map(function (_ref2) {
          var title = _ref2.title,
              entities = _ref2.entities;

          return entities.map(function (slide, i) {
            indexTotal += 1;

            var first = i === 0;
            if (keys_name === 'clone_before') {
              _this2.slidesWidths.push(first ? WIDE_WIDTH : NORMAL_WIDTH);
            }
            return _react2.default.createElement(_Slide2.default, {
              persons: slide,
              place: keys_name + i,
              showGroupName: first,
              groupName: title,
              hidden: indexesOfRedundantSlides.arr.includes(indexTotal),
              mix: indexesOfRedundantSlides.arr.includes(indexTotal) ? cn('hidden-slide') : cn('showing-slide'),
              mouseSlideEnterHandler: _this2.mouseSlideEnterHandler,
              mouseSlideLeaveHandler: _this2.mouseSlideLeaveHandler,
              openPeopleModal: _this2.props.openPeopleModal
            });
          });
        });
      };

      res = res.concat(genSlidesArray(slideGroups, 'clone_before'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_middle'));
      res = res.concat(genSlidesArray(slideGroups, 'clone_after'));

      return res;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.forceUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var mix = this.props.mix;
      var slideGroups = this.slideGroups,
          slidesWidths = this.slidesWidths,
          slidesCount = this.slidesCount;
      var show = this.state.show;

      var move = show / slidesCount | 0;
      var showingSlideIndex = (0, _helpers.indexOfShow)(slidesCount, show);

      var indexesOfRedundantSlides = (0, _helpers.findIndexesOfRedundantSlides)(slidesCount, show, this.slidesWidths, this.widths.container.offsetWidth);
      var padding = indexesOfRedundantSlides.padding;

      var renderedSlides = this.getSlides(slideGroups, slidesCount, show, indexesOfRedundantSlides);
      var step = this.getStep(slidesWidths, show);
      var active = void 0;
      if (showingSlideIndex < 0) {
        active = 'ambassadors';
      } else if (showingSlideIndex < 2) {
        active = 'team';
      } else if (showingSlideIndex < 6) {
        active = 'advisers';
      } else {
        active = 'ambassadors';
      }

      return _react2.default.createElement(
        'section',
        { className: cn([mix]) },
        _react2.default.createElement(
          'div',
          {
            className: cn('content')
          },
          _react2.default.createElement('div', { className: cn('nav-prev'), onClick: function onClick() {
              return _this3.left();
            } }),
          _react2.default.createElement('div', { className: cn('nav-next'), onClick: function onClick() {
              return _this3.right();
            } }),
          _react2.default.createElement(
            'div',
            { className: cn('header') },
            _react2.default.createElement(
              _A_Title_H2.default,
              { mix: cn('title'), type: 'section', theme: 'dark' },
              'People behind Humaniq project'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'team' }), onClick: function onClick() {
                    return _this3.setState({ show: 0 });
                  } },
                'Team'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'advisers' }), onClick: function onClick() {
                    return _this3.setState({ show: 2 });
                  } },
                'Advisers'
              ),
              _react2.default.createElement(
                'span',
                { className: cn('slider-nav-groups', { active: active == 'ambassadors' }), onClick: function onClick() {
                    return _this3.setState({ show: 6 });
                  } },
                'Ambassadors'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'wrapper1',
              onTouchStart: this.props.onTouchStart,
              onTouchMove: this.props.onTouchMove,
              ref: function ref(node) {
                return _this3.widths.container = node;
              },
              style: { paddingLeft: padding }
            },
            _react2.default.createElement(
              'div',
              {
                className: 'wrapper2',
                style: { transform: 'translate3d(' + move * (this.widths.inner / 3) + 'px, 0px, 0px)' }
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'inner',
                  style: { transform: 'translate3d(' + (step - this.widths.inner / 3) + 'px, 0px, 0px)' },
                  ref: function ref(node) {
                    return _this3.widths.inner = node ? node.offsetWidth : 0;
                  }
                },
                renderedSlides
              )
            ),
            _react2.default.createElement('div', { className: cn('linner-gradient-left') }),
            _react2.default.createElement('div', { className: cn('linner-gradient-right') })
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 12, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_Team;
}(_react.Component);

SE_Home_Team.propTypes = {};

SE_Home_Team.defaultProps = {};

exports.default = (0, _Swipe2.default)(SE_Home_Team);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(743);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UnbankedStat');

var SE_Home_UnbankedStat = function SE_Home_UnbankedStat(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('left-side') },
      _react2.default.createElement('div', { className: cn('map') })
    ),
    _react2.default.createElement(
      'div',
      { className: cn('right-side') },
      _react2.default.createElement(
        'p',
        { className: cn('text') },
        'According to the World Bank\'s Global',
        _react2.default.createElement('br', null),
        ' Financial Inclusion Database, there are',
        _react2.default.createElement('br', null),
        ' ',
        'currently 2.5 billion people on Earth',
        _react2.default.createElement('br', null),
        ' who do not have access to official',
        _react2.default.createElement('br', null),
        ' ',
        'financial services'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('stat-circle') },
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-percentage') },
          '53%'
        ),
        _react2.default.createElement(
          'div',
          { className: cn('stat-circle-text') },
          'Total 2,455',
          _react2.default.createElement('br', null),
          'million adults'
        )
      )
    ),
    _react2.default.createElement(_index2.default, { mix: cn('counter'), sectionNum: 3, theme: 'bright' })
  );
};

exports.default = SE_Home_UnbankedStat;


SE_Home_UnbankedStat.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _InfoColumn = __webpack_require__(453);

var _InfoColumn2 = _interopRequireDefault(_InfoColumn);

__webpack_require__(744);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_UseCases');

var SE_Home_UseCases = function (_Component) {
  (0, _inherits3.default)(SE_Home_UseCases, _Component);

  function SE_Home_UseCases() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_Home_UseCases);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_Home_UseCases.__proto__ || (0, _getPrototypeOf2.default)(SE_Home_UseCases)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: 0,
      slideWidth: 0
    }, _this.prev = function () {
      _this.changeShow(-1);
    }, _this.next = function () {
      _this.changeShow(1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_Home_UseCases, [{
    key: 'changeShow',
    value: function changeShow(n) {
      var oldShow = this.state.show;

      var show = (oldShow + n + infoColumns.length) % infoColumns.length;
      this.setState({ show: show });
    }
  }, {
    key: 'getSlides',
    value: function getSlides() {
      var _this2 = this;

      var res = [];
      var genSlidesArray = function genSlidesArray(keysName) {
        return infoColumns.map(function (column, i) {
          return _react2.default.createElement(_InfoColumn2.default, {
            column: column,
            key: i + keysName,
            mix: cn('slider-item'),
            setWidth: i === 0 ? function (slideWidth) {
              return _this2.setState({ slideWidth: slideWidth });
            } : undefined
          });
        });
      };

      res = res.concat(genSlidesArray('clone_before'));
      res = res.concat(genSlidesArray('clone_middle'));
      res = res.concat(genSlidesArray('clone_after'));

      return res;
    }
  }, {
    key: 'getDots',
    value: function getDots() {
      var _this3 = this;

      var show = this.state.show;


      var dots = [];

      var _loop = function _loop(i) {
        dots.push(_react2.default.createElement('div', {
          key: i,
          className: cn('dots-item', { active: show === i }),
          onClick: function onClick() {
            return _this3.setState({ show: i });
          }
        }));
      };

      for (var i = 1; i <= 5; i++) {
        _loop(i);
      }

      return dots;
    }
  }, {
    key: 'render',
    value: function render() {
      var mix = this.props.mix;

      var _renderSlides = this.getSlides();
      var _state = this.state,
          show = _state.show,
          slideWidth = _state.slideWidth;

      var pctX = show * slideWidth;
      var dots = this.getDots();

      return _react2.default.createElement(
        'section',
        {
          className: cn([mix])
        },
        _react2.default.createElement(
          'div',
          { className: cn('content') },
          _react2.default.createElement(
            _A_Title_H2.default,
            { mix: cn('title'), type: 'section', theme: 'dark' },
            'Humaniq use cases'
          ),
          _react2.default.createElement(
            'div',
            { className: cn('slider-wrap') },
            _react2.default.createElement(
              'div',
              { className: cn('slider'), style: { transform: 'translateX(-' + pctX + 'px)' } },
              _renderSlides
            )
          ),
          _react2.default.createElement(
            'div',
            { className: cn('nav') },
            _react2.default.createElement('div', { className: cn('nav-prev'), onClick: this.prev }),
            _react2.default.createElement('div', { className: cn('nav-next'), onClick: this.next })
          ),
          _react2.default.createElement(
            'div',
            { className: cn('dots') },
            dots
          )
        ),
        _react2.default.createElement(_index2.default, { sectionNum: 9, theme: 'bright' })
      );
    }
  }]);
  return SE_Home_UseCases;
}(_react.Component);

exports.default = SE_Home_UseCases;


var infoColumns = [{
  title: 'Zero fee money transfers',
  text: 'Blockchain technology allows users to carry out direct money transfers, cutting out the middleman. The money is transferred as our HMQ cryptocurrency and withdrawn via authorised exchange points. Users can choose the point with the best exchange rate, therefore avoiding any financial monopolies.'
}, {
  title: 'Remote work',
  text: "Companies can utilise Humaniq's ever-growing user base to carry out tasks involving the processing of information. Users can decode and translate texts, identify photographs, locate geotags and so on, in return for renumeration."
}, {
  title: 'Charity without corruption',
  text: 'Charity, carried out in the traditional way, often leads to a large proportion of donated money falling into the wrong hands. Blockchain technology, combined with the infrastructure of Humaniq, ensures that donations are completely transparent: stakeholders are able to see what every penny is spent on and can be sure that all of their money is going to help people.'
}, {
  title: 'Guarantor lending',
  text: 'Grameen Bank in Bangladesh has created a system of loans based on honesty and trust, which guarantees over 90% repayment. The Humaniq system allows for the creation of a similar system but on a global scale: every person on Earth will be able to take out a commission-free loan using nothing but a smartphone and the Humaniq app.'
}, {
  title: 'Direct lending to entrepreneurs',
  text: "Following the principle of the non-profit organisation Kiva Microfunds, which enables loans for entrepreneurs on low incomes, Humaniq will become a platform for both donations and loans. You can lend money to a business you'd like to support, either as a grant or with the expectation of a return – the blockchain technology makes this process incredibly simple and effective for both parties."
}];

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _InfoColumns = __webpack_require__(71);

var _InfoColumns2 = _interopRequireDefault(_InfoColumns);

__webpack_require__(745);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WhatMakes');

var SE_Home_WhatMakes = function SE_Home_WhatMakes(_ref) {
  var mix = _ref.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement('img', { className: cn('background'), src: '/img/design-v2/sections/common/head.svg' }),
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'dark' },
        'What makes Humaniq',
        _react2.default.createElement('br', null),
        ' a big thing'
      ),
      _react2.default.createElement(_InfoColumns2.default, { mix: cn('info-columns'), columns: infoColumns, type: 'narrow' })
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 5, theme: 'bright' })
  );
};

exports.default = SE_Home_WhatMakes;


var infoColumns = [{
  imageSrc: '/img/design-v2/icons/sections/connect-unbanked.svg',
  title: 'Connecting the unbanked',
  text: '10 years of research across Asia and Africa, carried out by the authors of Portfolios of the Poor, showed that poverty proliferates in regions whose inhabitants do not have access to financial services. Humaniq is becoming the simplest route to financial inclusion for billions of people.'
}, {
  imageSrc: '/img/design-v2/icons/sections/user-base-expo.svg',
  title: 'User base exponential growth',
  text: "According to Metcalfe's law, the value of a network is proportional to the square of the number of its users. For Humaniq, this means that the more unbanked people who join the system, the greater the motivation will be for other people to join."
}];

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(746);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Home_WorldTalking');

var _getMentions = function _getMentions(mentions) {
  return mentions.map(function (_ref, index) {
    var title = _ref.title,
        url = _ref.url,
        urlText = _ref.urlText;
    return _react2.default.createElement(
      'li',
      { key: 'mention-' + (index + 1), className: cn('mention') },
      _react2.default.createElement(
        'p',
        { className: cn('mention-title') },
        title
      ),
      _react2.default.createElement(
        'a',
        { className: cn('mention-link'), href: url, target: '_blank' },
        urlText
      )
    );
  });
};

var SE_Home_WorldTalking = function SE_Home_WorldTalking(_ref2) {
  var mix = _ref2.mix;
  return _react2.default.createElement(
    'section',
    { className: cn([mix]) },
    _react2.default.createElement(
      'div',
      { className: cn('content') },
      _react2.default.createElement(
        _A_Title_H2.default,
        { mix: cn('title'), type: 'section', theme: 'bright' },
        'The world is talking'
      ),
      _react2.default.createElement(
        'ul',
        { className: cn('mentions-list') },
        _getMentions(hmqMentions)
      )
    ),
    _react2.default.createElement(_index2.default, { sectionNum: 13, theme: 'dark' })
  );
};

exports.default = SE_Home_WorldTalking;


var hmqMentions = [{
  title: 'Huffingtonpost.com:',
  url: 'http://www.huffingtonpost.com/entry/tackling-financial-exclusion-with-biometric-technology_us_591af1ace4b03e1c81b008bc?ncid=engmodushpmg00000004',
  urlText: 'Tackling Financial Exclusion With Biometric Technology'
}, {
  title: 'Thenextweb.com:',
  url: 'https://thenextweb.com/guests/5-things-need-know-blockchain-technology/?utm_source=t.co&utm_medium=referral&utm_content=5%20Things%20You%20Need%20to%20Know%20About%20Blockchain%20Technology&utm_campaign=share%2Bbutton#.tnw_X4BwNKpu',
  urlText: '5 Things You Need to Know About Blockchain Technology'
}, {
  title: 'Forbes.com:',
  url: 'https://www.forbes.com/sites/haroldstark/2017/04/21/from-here-to-where-bitcoin-and-the-future-of-cryptocurrency/#14428f594367',
  urlText: 'From Here To Where? Bitcoin And The Future Of Cryptocurrency'
}, {
  title: 'Cointelegraph.com:',
  url: 'https://cointelegraph.com/news/ethereum-based-humaniq-to-deliver-banking-40-to-2-bln-unbanked',
  urlText: 'Ethereum-Based Humaniq To Deliver Banking 4.0 to 2 Bin Unbanked'
}, {
  title: 'Finance.yahoo.com:',
  url: 'https://finance.yahoo.com/news/humaniq-blockchain-financial-platform-unbanked-185522211.html',
  urlText: 'Humaniq, Blockchain Financial Platform for the Unbanked, Appoints CEO and 20 Members to Global Advisory Board'
}, {
  title: 'Nasdaq.com:',
  url: 'http://www.nasdaq.com/article/humaniq-aims-to-tackle-barriers-to-economic-inclusion-with-blockchain-app-cm764760',
  urlText: 'Humaniq Aims to Tackle Barriers to Economic Inclusion With Blockchain App'
}];

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

__webpack_require__(747);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_InfoColumn');

var M_InfoColumn = function (_Component) {
  (0, _inherits3.default)(M_InfoColumn, _Component);

  function M_InfoColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_InfoColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_InfoColumn.__proto__ || (0, _getPrototypeOf2.default)(M_InfoColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      needWidth: typeof _this.props.setWidth === 'function'
    }, _this.setWidth = function () {
      _this.props.setWidth(_this.node.offsetWidth);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_InfoColumn, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.needWidth) {
        window.addEventListener('resize', this.setWidth);
        this.setWidth();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.needWidth) {
        window.removeEventListener('resize', this.setWidth);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          column = _props.column;
      var needWidth = this.state.needWidth;

      return _react2.default.createElement(
        'div',
        { className: cn([mix]), ref: needWidth ? function (node) {
            return _this2.node = node;
          } : undefined },
        column.imageSrc ? _react2.default.createElement('img', { className: cn('image'), src: column.imageSrc }) : null,
        _react2.default.createElement(
          _A_Title_H2.default,
          { mix: cn('title'), type: 'info-column', theme: 'dark' },
          column.title
        ),
        _react2.default.createElement(
          'p',
          { className: cn('text') },
          column.text
        )
      );
    }
  }]);
  return M_InfoColumn;
}(_react.Component);

M_InfoColumn.propTypes = {
  mix: T.string, //BEM mixin from parent block
  column: T.object.isRequired //Column to render
};

exports.default = M_InfoColumn;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(455);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(751);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _O_TextUsHere = __webpack_require__(487);

var _O_TextUsHere2 = _interopRequireDefault(_O_TextUsHere);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('OpenSource');


var OpenSource = function OpenSource() {

  var renderedLinks = libraries.map(function (_ref) {
    var name = _ref.name,
        description = _ref.description,
        url = _ref.url,
        type = _ref.type,
        imgSrc = _ref.imgSrc;

    return _react2.default.createElement(
      'div',
      { className: cn('item'), key: 'key_' + name },
      _react2.default.createElement(
        _A_Link2.default,
        { to: url, type: 'block', external: true },
        _react2.default.createElement(
          'div',
          { className: cn('item-image', { type: type }) },
          _react2.default.createElement('img', { src: imgSrc, alt: 'Humaniq Android' })
        ),
        _react2.default.createElement(
          'div',
          { className: cn('item-text') },
          _react2.default.createElement(
            _A_H2.default,
            { type: 'openitem' },
            name
          ),
          _react2.default.createElement(
            _A_P2.default,
            { type: 'sixth' },
            description
          )
        )
      )
    );
  });

  renderedLinks.push(_react2.default.createElement('div', { className: cn('item-empty'), key: 'key_empty' }));
  return _react2.default.createElement(
    'div',
    { className: cn('section-wrapper') },
    _react2.default.createElement(
      _A_Container2.default,
      { type: 'section-clean' },
      _react2.default.createElement(
        _O_Hero2.default,
        null,
        _react2.default.createElement(
          _A_H2.default,
          { type: 'hero' },
          'Open Source'
        ),
        _react2.default.createElement(
          _A_P2.default,
          { type: 'hero' },
          'Humaniq relies on open-source software and likes to give back to the community. Check out the libraries we have built.'
        )
      ),
      _react2.default.createElement(
        _A_H2.default,
        { type: 'section' },
        'Released Libraries'
      ),
      _react2.default.createElement(
        'div',
        { className: cn('list') },
        renderedLinks
      )
    ),
    _react2.default.createElement(_O_TextUsHere2.default, {
      title: 'Help us Develop',
      text: "Join Humaniq's ever growing network. Get in touch if you would like to code with us.",
      link: {
        linkText: 'Drop off your information',
        url: 'mailto:info@humaniq.com'
      }
    })
  );
};

exports.default = OpenSource;


var libraries = [{
  name: 'humaniq-android',
  description: 'Humaniq mobile app alpha version. Used as a concept to show the work of a DApp.',
  url: 'https://github.com/humaniq/humaniq-android',
  type: 'android',
  imgSrc: '/img/opensource/android.svg'
}, {
  name: 'findface',
  description: 'Golang client for FindFace cloud API. The wrapper was written for testing purposes.',
  url: 'https://github.com/humaniq/findface',
  type: 'go',
  imgSrc: '/img/opensource/go.svg'
}, {
  name: 'kairgo',
  description: 'Golang client for Kairos cloud API. The wrapper was written for testing purposes.',
  url: 'https://github.com/humaniq/kairgo',
  type: 'go',
  imgSrc: '/img/opensource/go.svg'
}, {
  name: 'emoji-auth',
  description: 'Graphic-pin authorization for the second step verification in your application.',
  url: 'https://github.com/humaniq/emoji-auth',
  type: 'js',
  imgSrc: '/img/opensource/js.svg'
}, {
  name: 'ico-contract',
  description: 'Humaniq smart contract. Was used during the ICO process.',
  url: 'https://github.com/humaniq/ico-contract',
  type: 'js',
  imgSrc: '/img/opensource/js.svg'
}, {
  name: 'ico-website',
  description: 'Humaniq ICO website v0. Was used during the ICO process.',
  url: 'https://github.com/humaniq/ico-website',
  type: 'js',
  imgSrc: '/img/opensource/js.svg'
}, {
  name: 'humaniq-pwa-website',
  description: 'New Humaniq website built under PWA technology.',
  url: 'https://github.com/humaniq/humaniq-pwa-website',
  type: 'js',
  imgSrc: '/img/opensource/js.svg'
}, {
  name: 'react-native-android-library-humaniq-api',
  description: 'React Native wrapper for Humaniq LITE application',
  url: 'https://github.com/humaniq/react-native-android-library-humaniq-api',
  type: 'android',
  imgSrc: '/img/opensource/android.svg'
}];

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(752);

var _utils = __webpack_require__(1);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_WikiInfo');


var SE_WikiInfo = function SE_WikiInfo(_ref) {
  var children = _ref.children,
      type = _ref.type,
      img = _ref.img,
      title = _ref.title,
      link = _ref.link,
      external = _ref.external;

  var moving = type == 'moving-title';
  return _react2.default.createElement(
    'div',
    { className: cn('root') },
    _react2.default.createElement(
      'div',
      { className: cn('body') },
      _react2.default.createElement(
        'span',
        { className: moving && "mobile-hide" },
        _react2.default.createElement(
          _A_H2.default,
          { type: 'section' },
          title
        )
      ),
      children,
      _react2.default.createElement(
        _A_Link2.default,
        { type: 'section-link', to: link.to, external: external },
        link.text
      )
    ),
    _react2.default.createElement(
      'div',
      { className: cn('img-side', { type: type }) },
      moving && _react2.default.createElement(
        'span',
        { className: 'mobile-show' },
        _react2.default.createElement(
          _A_H2.default,
          { type: 'section' },
          title
        )
      ),
      _react2.default.createElement(
        'div',
        { className: cn('img') },
        _react2.default.createElement(_A_Image2.default, img)
      )
    )
  );
};

SE_WikiInfo.propTypes = {
  type: T.oneOf(['moving-title', //title changes place on mobile devices
  'hidding-img'] //img is hidding on mobile devices
  ).isRequired,
  children: T.node.isRequired,
  title: T.string,
  img: T.shape({
    src: T.string.isRequired,
    alt: T.string.isRequired
  }).isRequired,
  link: T.shape({
    to: T.string.isRequired,
    text: T.string.isRequired
  })
};

SE_WikiInfo.defaultProps = {};
exports.default = SE_WikiInfo;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(46);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  var _state$wikiArticles = state.wikiArticles,
      technicalMecca = _state$wikiArticles['technical-mecca'],
      aboutHumaniq = _state$wikiArticles['about-humaniq'];


  var articles = [].concat((0, _toConsumableArray3.default)((0, _utils.getArticleLinks)(technicalMecca.ids, technicalMecca.entities)), (0, _toConsumableArray3.default)((0, _utils.getArticleLinks)(aboutHumaniq.ids, aboutHumaniq.entities)));

  return { articles: articles };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(753);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _Info = __webpack_require__(456);

var _Info2 = _interopRequireDefault(_Info);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _O_ArticleList = __webpack_require__(202);

var _O_ArticleList2 = _interopRequireDefault(_O_ArticleList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Wiki0');

var SE_Wiki0 = function (_Component) {
  (0, _inherits3.default)(SE_Wiki0, _Component);

  function SE_Wiki0() {
    (0, _classCallCheck3.default)(this, SE_Wiki0);
    return (0, _possibleConstructorReturn3.default)(this, (SE_Wiki0.__proto__ || (0, _getPrototypeOf2.default)(SE_Wiki0)).apply(this, arguments));
  }

  (0, _createClass3.default)(SE_Wiki0, [{
    key: 'render',
    value: function render() {
      var articles = this.props.articles;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'section-wiki' },
          _react2.default.createElement(
            'div',
            { className: cn('hero') },
            _react2.default.createElement(
              'div',
              { className: cn('hero-item') },
              _react2.default.createElement(
                _A_Link2.default,
                { type: 'block', to: '/wiki/about-humaniq' },
                _react2.default.createElement(_A_Image2.default, { src: '/img/illustrations/wiki-about-humaniq.svg', alt: 'About Humaniq' }),
                _react2.default.createElement(
                  'div',
                  { className: cn('hero-item-text') },
                  'About Humaniq'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: cn('hero-item') },
              _react2.default.createElement(
                _A_Link2.default,
                { type: 'block', to: '/wiki/technical-mecca' },
                _react2.default.createElement(_A_Image2.default, { src: '/img/illustrations/wiki-technical-mecca.svg', alt: 'Technical Mecca ' }),
                _react2.default.createElement(
                  'div',
                  { className: cn('hero-item-text') },
                  'Technical Hub'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'section-wiki' },
          _react2.default.createElement(
            _Info2.default,
            {
              type: 'moving-title',
              title: 'Humaniq Roadmap',
              external: true,
              link: {
                to: 'https://app.ganttpro.com/shared/token/56d36c7424e5b31d8ebf635d61f814ec6e3e2111752eddf5ceebe58e19df02e8/223936',
                text: 'Find out more about the plans'
              },
              img: {
                src: '/img/illustrations/wiki-roadmap.svg',
                alt: 'Humaniq Roadmap'
              }
            },
            _react2.default.createElement(
              _A_P2.default,
              { type: 'third' },
              'Humaniq global initiative plan involves a lot of research, investigations and partnerships, but it is also important to involve others in the app\'s. Since Humaniq is about the community, we want to be as transparent as possible. That is why our technical roadmap is available to general public.'
            )
          )
        ),
        _react2.default.createElement(_O_ArticleList2.default, { articles: articles, title: 'Featured Articles' })
      );
    }
  }]);
  return SE_Wiki0;
}(_react.Component);

SE_Wiki0.propTypes = {
  articles: T.array.isRequired
};

SE_Wiki0.defaultProps = {};

exports.default = SE_Wiki0;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(460);

var _page2 = _interopRequireDefault(_page);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
  var level0 = ownProps.level0;
  var descriptions = state.wikiArticles.descriptions;
  var _state$wikiArticles$l = state.wikiArticles[level0],
      ids = _state$wikiArticles$l.ids,
      entities = _state$wikiArticles$l.entities,
      level0Title = _state$wikiArticles$l.level0Title;

  var urls = (0, _utils.getArticleLinks)(ids, entities);

  var descriptionObj = descriptions.find(function (description) {
    return description.level0 === level0 && description.level1 === 'root';
  });

  var description = descriptionObj.description,
      img = descriptionObj.img;


  var _level1Categories = ids.map(function (id) {
    return entities[id].level1;
  }).filter(function (v, i, a) {
    return a.indexOf(v) === i;
  });

  var articlesByLevel1 = _level1Categories.map(function (level1Category) {
    var level1Urls = urls.filter(function (url) {
      return url.level1 === level1Category;
    });

    return {
      level1Category: level1Category,
      articleUrls: level1Urls
    };
  });
  return {
    level0: level0, articlesByLevel1: articlesByLevel1, description: description, level0Title: level0Title, img: img
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(754);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _O_Rumbs = __webpack_require__(204);

var _O_Rumbs2 = _interopRequireDefault(_O_Rumbs);

var _O_ArticleList = __webpack_require__(202);

var _O_ArticleList2 = _interopRequireDefault(_O_ArticleList);

var _O_Hero = __webpack_require__(41);

var _O_Hero2 = _interopRequireDefault(_O_Hero);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Wiki1');

var SE_Wiki1 = function (_Component) {
  (0, _inherits3.default)(SE_Wiki1, _Component);

  function SE_Wiki1() {
    (0, _classCallCheck3.default)(this, SE_Wiki1);
    return (0, _possibleConstructorReturn3.default)(this, (SE_Wiki1.__proto__ || (0, _getPrototypeOf2.default)(SE_Wiki1)).apply(this, arguments));
  }

  (0, _createClass3.default)(SE_Wiki1, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          level0 = _props.level0,
          articlesByLevel1 = _props.articlesByLevel1,
          description = _props.description,
          level0Title = _props.level0Title,
          img = _props.img;


      var renderedCategories = articlesByLevel1.map(function (_ref) {
        var level1Category = _ref.level1Category,
            articleUrls = _ref.articleUrls;
        return _react2.default.createElement(
          'div',
          { key: 'key_' + level1Category, className: cn('article-list') },
          _react2.default.createElement(_O_ArticleList2.default, { title: level1Category, articles: articleUrls })
        );
      });
      return _react2.default.createElement(
        _A_Container2.default,
        { type: 'section-clean' },
        _react2.default.createElement(_O_Rumbs2.default, {
          path: [{ name: 'Humaniq Wiki', url: '/wiki' }, { name: level0Title, url: '/wiki/' + level0 }]
        }),
        _react2.default.createElement(
          _O_Hero2.default,
          { img: { src: img, alt: "Humaniq’s Global Mission" } },
          _react2.default.createElement(
            _A_H2.default,
            { type: 'hero' },
            level0Title
          ),
          _react2.default.createElement(
            'div',
            { className: cn('hero-sub') },
            _react2.default.createElement(
              _A_P2.default,
              { type: 'hero' },
              description
            )
          )
        ),
        renderedCategories
      );
    }
  }]);
  return SE_Wiki1;
}(_react.Component);

SE_Wiki1.propTypes = {
  section: T.string.isRequired,
  articlesByLevel1: T.array.isRequired,
  description: T.string.isRequired,
  level0Title: T.string.isRequired
};

SE_Wiki1.defaultProps = {
  section: '',
  articlesByLevel1: [],
  description: '',
  level0Title: ''
};

exports.default = SE_Wiki1;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(462);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
  var _state$wikiArticles = state.wikiArticles,
      loaded = _state$wikiArticles.loaded,
      descriptions = _state$wikiArticles.descriptions;
  var level0 = ownProps.level0,
      id = ownProps.id;
  var _state$wikiArticles$l = state.wikiArticles[level0],
      entities = _state$wikiArticles$l.entities,
      level0Title = _state$wikiArticles$l.level0Title;

  var article = entities[id];

  var descriptionObj = article && descriptions.find(function (description) {
    return description.level0 === level0 && description.level1 === article.level1;
  });

  var description = descriptionObj && descriptionObj.description;

  return { loaded: loaded, article: article, level0Title: level0Title, level0: level0, description: description };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(755);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_P = __webpack_require__(31);

var _A_P2 = _interopRequireDefault(_A_P);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _O_Rumbs = __webpack_require__(204);

var _O_Rumbs2 = _interopRequireDefault(_O_Rumbs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_Wiki2');

var SE_Wiki2 = function (_Component) {
  (0, _inherits3.default)(SE_Wiki2, _Component);

  function SE_Wiki2() {
    (0, _classCallCheck3.default)(this, SE_Wiki2);
    return (0, _possibleConstructorReturn3.default)(this, (SE_Wiki2.__proto__ || (0, _getPrototypeOf2.default)(SE_Wiki2)).apply(this, arguments));
  }

  (0, _createClass3.default)(SE_Wiki2, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loaded = _props.loaded,
          article = _props.article,
          level0Title = _props.level0Title,
          description = _props.description;

      if (!loaded || !article) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'section-clean' },
          _react2.default.createElement(_O_Rumbs2.default, {
            path: [{ name: 'Humaniq Wiki', url: '/wiki' }, { name: level0Title, url: '/wiki/' + article.level0 }, { name: article.title, url: '/wiki/' + article.level0 + '/' + article.id }]
          }),
          _react2.default.createElement(
            _A_H2.default,
            { type: 'hero' },
            article.level1
          ),
          _react2.default.createElement(
            _A_P2.default,
            { type: 'hero' },
            description
          )
        ),
        _react2.default.createElement(
          _A_Container2.default,
          { type: 'section-clean' },
          _react2.default.createElement(
            _A_H2.default,
            { type: 'section' },
            article.title
          ),
          _react2.default.createElement('div', { className: cn('article'), dangerouslySetInnerHTML: { __html: article.article } })
        )
      );
    }
  }]);
  return SE_Wiki2;
}(_react.Component);

SE_Wiki2.propTypes = {
  loaded: T.bool.isRequired,
  article: T.shape({
    title: T.string.isRequired,
    article: T.string.isRequired
  }),
  level0Title: T.string
};

SE_Wiki2.defaultProps = {
  level0Title: ''
};

exports.default = SE_Wiki2;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(19);

var _page = __webpack_require__(464);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  //const {wikiSearch:{request: searchRequest}} = state
  //return {searchRequest};
  return {};
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_page2.default);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(756);

var _utils = __webpack_require__(1);

var _O_Search = __webpack_require__(475);

var _O_Search2 = _interopRequireDefault(_O_Search);

var _history = __webpack_require__(74);

var _history2 = _interopRequireDefault(_history);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('SE_WikiLayout');

var SE_WikiLayout = function (_Component) {
  (0, _inherits3.default)(SE_WikiLayout, _Component);

  function SE_WikiLayout() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SE_WikiLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SE_WikiLayout.__proto__ || (0, _getPrototypeOf2.default)(SE_WikiLayout)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (searchString) {
      _history2.default.push('/wiki/search?searchTerm=' + searchString);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SE_WikiLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          searchRequest = _props.searchRequest;


      return _react2.default.createElement(
        'div',
        { className: cn('root') },
        children
      );
    }
  }]);
  return SE_WikiLayout;
}(_react.Component);

SE_WikiLayout.propTypes = {
  children: T.any.isRequired,
  searchRequest: T.string
};

exports.default = SE_WikiLayout;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _M_Ripple = __webpack_require__(133);

var _M_Ripple2 = _interopRequireDefault(_M_Ripple);

__webpack_require__(766);

var _utils = __webpack_require__(1);

var _history = __webpack_require__(74);

var _history2 = _interopRequireDefault(_history);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('A_Logo');

var A_Logo = function (_Component) {
  (0, _inherits3.default)(A_Logo, _Component);

  function A_Logo() {
    (0, _classCallCheck3.default)(this, A_Logo);
    return (0, _possibleConstructorReturn3.default)(this, (A_Logo.__proto__ || (0, _getPrototypeOf2.default)(A_Logo)).apply(this, arguments));
  }

  (0, _createClass3.default)(A_Logo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          size = _props.size;

      var color = theme === 'dark' ? '#253039' : '#fff';
      return _react2.default.createElement(
        _M_Ripple2.default,
        { onClick: function onClick() {
            return _history2.default.push('/');
          }, type: 'flex' },
        _react2.default.createElement(
          'div',
          { className: cn('root', { size: size }) },
          _react2.default.createElement(
            'div',
            { className: cn('image', { size: size }) },
            _react2.default.createElement(
              'svg',
              { version: '1.1', id: 'Layer_1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px',
                viewBox: '0 0 1366 450', style: { enableBackground: "new 0 0 1366 450", verticalAlign: 'top' } },
              _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { fill: color, d: 'M771.4,142.8c-44.3,0-80.3,36-80.3,80.3s36,80.3,80.3,80.3c22.3,0,42.6-9.3,57.2-24v24h23.1v-80.3 C851.7,178.8,815.5,142.8,771.4,142.8z M771.4,280.3c-31.6,0-57.2-25.6-57.2-57.2s25.6-57.2,57.2-57.2c31.6,0,57.2,25.6,57.2,57.2 S803,280.3,771.4,280.3z' }),
                _react2.default.createElement('path', { fill: color, d: 'M251.9,230.7c0-55.3-32.7-87.9-81.3-87.9c-24.5,0-40.7,9.9-56.7,26.1V97.7H88.5v57.8v147.7H114v-44.6v-6v-28.9 c0-30.5,24.5-55.6,56.7-55.6c34.9,0,55.8,28.6,55.8,63.5v71.5h25.5L251.9,230.7L251.9,230.7z' }),
                _react2.default.createElement('polyline', { fill: color, points: '878.9,303.4 902.4,303.4 902.4,183.5 1027.2,303.4 1051.1,303.4 1051.1,293.8 1051.1,150.8  1027.7,150.8 1027.7,271.2 902.4,150.8 878.7,150.8 \t' }),
                _react2.default.createElement('rect', { x: '1078.5', y: '151.1', fill: color, width: '23.7', height: '152.3' }),
                _react2.default.createElement('path', { fill: color, d: 'M1209.7,142.8c-44.3,0-80.3,36-80.3,80.3s36,80.3,80.3,80.3c22.3,0,42.6-9.3,57.2-24v75h23.1V223.1 C1290,178.8,1254,142.8,1209.7,142.8z M1209.7,280.3c-31.6,0-57.2-25.6-57.2-57.2s25.6-57.2,57.2-57.2s57.2,25.6,57.2,57.2 C1266.9,254.7,1241.3,280.3,1209.7,280.3z' }),
                _react2.default.createElement('path', { fill: color, d: 'M415.6,150.7v63.8c0,34.9-20.6,63.2-55.3,63.2c-34.9,0-55.3-28.4-55.3-63.2v-63.8h-25.5v63.8 c0,48.9,31.9,88.6,80.8,88.6s80.8-39.8,80.8-88.6v-63.8H415.6z' }),
                _react2.default.createElement('polygon', { fill: color, points: '629.5,150.8 566.1,202.4 502.6,150.8 468.4,150.8 468.4,303.4 491.8,303.4 491.8,173.6 554.3,224.4  554.3,303.4 566.1,303.4 577.7,303.4 577.7,224.4 640.3,173.6 640.3,303.4 663.7,303.4 663.7,150.8 \t' })
              )
            )
          )
        )
      );
    }
  }]);
  return A_Logo;
}(_react.Component);

A_Logo.propTypes = {
  theme: T.oneOf(['dark', // black logo
  'light'] // white logo
  ),
  size: T.oneOf(['normal', // normal size 131x32
  'small'] // white logo 101x23
  )
};

A_Logo.defaultProps = {
  theme: 'dark',
  size: 'normal'
};

exports.default = A_Logo;

// import React from 'react';

//
// const A_Logo = ({theme, size}) => {
//   const color = theme === 'dark' ? '#253039' : '#fff'
//   const style = {
//     width: size === 'small' ? 103 : 131,
//   }
//   return (

//   )
// }
//

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(772);

var _utils = __webpack_require__(1);

var _reactOnclickoutside = __webpack_require__(103);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_Dropdown');

var M_Dropdown = function (_Component) {
  (0, _inherits3.default)(M_Dropdown, _Component);

  function M_Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_Dropdown.__proto__ || (0, _getPrototypeOf2.default)(M_Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpened: false
    }, _this.handleClickOutside = function () {
      _this.closeMenu();
    }, _this.handleClick = function () {
      if (!_this.state.isOpened) _this.setState({ isOpened: true });
    }, _this.handleChange = function (selected) {
      _this.closeMenu();
      _this.props.onChange(selected);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_Dropdown, [{
    key: 'closeMenu',
    value: function closeMenu() {
      this.setState({ isOpened: false });
    }
  }, {
    key: 'getListOptions',
    value: function getListOptions(options, isOpened, selected) {
      var _this2 = this;

      var renderOptions = options.map(function (option) {
        return _react2.default.createElement(
          'ol',
          {
            className: cn('list-options-item', { selected: selected === option }),
            value: option,
            key: 'key_' + option,
            onClick: function onClick() {
              return _this2.handleChange(option);
            }
          },
          option
        );
      });

      return _react2.default.createElement(
        'div',
        { className: cn('list-wrapper', { closed: !isOpened }) },
        _react2.default.createElement(
          'ul',
          { className: cn('list-options') },
          renderOptions
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          selected = _props.selected;
      var isOpened = this.state.isOpened;

      return _react2.default.createElement(
        'span',
        { className: cn('root'), onClick: this.handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('select') },
          _react2.default.createElement(
            'div',
            { className: cn('select-text') },
            selected
          )
        ),
        this.getListOptions(options, isOpened, selected)
      );
    }
  }]);
  return M_Dropdown;
}(_react.Component);

M_Dropdown.propTypes = {
  options: T.array.isRequired,
  selected: T.string.isRequired
};

M_Dropdown.defaultProps = {};

exports.default = (0, _reactOnclickoutside2.default)(M_Dropdown);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(231);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_RippleRipple');

var M_RippleRipple = function (_React$Component) {
  (0, _inherits3.default)(M_RippleRipple, _React$Component);

  function M_RippleRipple() {
    (0, _classCallCheck3.default)(this, M_RippleRipple);

    var _this = (0, _possibleConstructorReturn3.default)(this, (M_RippleRipple.__proto__ || (0, _getPrototypeOf2.default)(M_RippleRipple)).call(this));

    _this.state = {
      animate: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0
    };
    return _this;
  }

  (0, _createClass3.default)(M_RippleRipple, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: cn({ reppling: this.state.animate })
        // className={"Ripple " + (this.state.animate ? "is-reppling" : "")}
        , ref: 'ripple', style: {
          top: this.state.top + "px",
          left: this.state.left + "px",
          width: this.state.width + "px",
          height: this.state.height + "px"
        } });
    }
  }, {
    key: 'reppling',
    value: function reppling(cursorPos) {

      // Get the element
      var $ripple = this.refs.ripple;
      var $button = $ripple.parentElement;

      var buttonPos = $button.getBoundingClientRect();

      var buttonWidth = $button.offsetWidth;
      var buttonHeight = $button.offsetHeight;

      // Make a Square Ripple
      var rippleWidthShouldBe = Math.max(buttonHeight, buttonWidth);

      // Make Ripple Position to be center
      var centerize = rippleWidthShouldBe / 2;

      this.setState({
        animate: true,
        width: rippleWidthShouldBe,
        height: rippleWidthShouldBe,
        top: cursorPos.top - buttonPos.top - centerize,
        left: cursorPos.left - buttonPos.left - centerize
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var cursorPos = nextProps.cursorPos;

      // Prevent Component duplicates do ripple effect at the same time
      if (cursorPos.time !== this.props.cursorPos.time) {
        // If Has Animated, set state to "false" First
        if (this.state.animate) {
          this.setState({ animate: false }, function () {
            _this2.reppling(cursorPos);
          });
        }
        // else, Do Reppling
        else this.reppling(cursorPos);
      }
    }
  }]);
  return M_RippleRipple;
}(_react2.default.Component);

exports.default = M_RippleRipple;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(780);

var _utils = __webpack_require__(1);

var _propsValidationHelpers = __webpack_require__(207);

var _reactApiHelpers = __webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_Fixed');

var O_Fixed = function (_Component) {
  (0, _inherits3.default)(O_Fixed, _Component);

  function O_Fixed() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, O_Fixed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = O_Fixed.__proto__ || (0, _getPrototypeOf2.default)(O_Fixed)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sticky: false,
      componentWidth: undefined,
      componentHeight: undefined
    }, _this.handleScroll = function () {
      if (_this.state.sticky && _this.root.getBoundingClientRect().top > 0) {
        _this.setState({ sticky: false });
      } else if (!_this.state.sticky && _this.root.getBoundingClientRect().top < 0) {
        _this.setState({ sticky: true });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(O_Fixed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);

      var _stickyNode$getBoundi = this.stickyNode.getBoundingClientRect(),
          componentWidth = _stickyNode$getBoundi.width,
          componentHeight = _stickyNode$getBoundi.height;

      this.setState({ componentWidth: componentWidth, componentHeight: componentHeight });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          sticky = _state.sticky,
          componentWidth = _state.componentWidth,
          componentHeight = _state.componentHeight;
      var _props = this.props,
          children = _props.children,
          quite = _props.quite;

      var newProps = quite ? undefined : { sticky: sticky };
      var _newChild = (0, _react.cloneElement)((0, _reactApiHelpers.universalChildrenOnly)(children), newProps);

      var style = sticky ? { height: componentHeight, width: componentWidth } : { height: 'auto', width: 'auto' };

      return _react2.default.createElement(
        'div',
        { ref: function ref(node) {
            return _this2.root = node;
          }, style: style },
        _react2.default.createElement(
          'div',
          { className: cn({ sticky: sticky }), ref: function ref(node) {
              return _this2.stickyNode = node;
            } },
          _newChild
        )
      );
    }
  }]);
  return O_Fixed;
}(_react.Component);

O_Fixed.propTypes = {
  children: _propsValidationHelpers.oneChild.isRequired // should be only one element array or a node(string, jsx, ...etc)
};

O_Fixed.defaultProps = {};

exports.default = O_Fixed;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(781);

var _utils = __webpack_require__(1);

var _reactMotion = __webpack_require__(272);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _A_Image = __webpack_require__(38);

var _A_Image2 = _interopRequireDefault(_A_Image);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _api = __webpack_require__(45);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_Footer');


var links = [{
  section: 'product',
  links: [
  // {name: 'Features', url: '#'},
  { name: 'Open source', url: '/open-source' }, { name: 'Humaniq Wiki', url: '/wiki' }]
}, {
  section: 'company',
  links: [{ name: 'Ambassadors', url: '/ambassadors' }, { name: 'Challenge', url: 'https://challenge.humaniq.com/', externalLink: true },
  // {name: 'Forum', url: 'https://forum.humaniq.co', externalLink: true},
  { name: 'Blog', url: 'https://blog.humaniq.co', externalLink: true }]
}, { section: 'legal',
  links: [{ name: 'Privacy', url: '/legal/general-privacy-policy' }, { name: 'Security', url: '/legal/data-privacy-policy' }, { name: 'Policies', url: '/legal/user-terms-of-service' }]
}, {
  section: 'resources',
  links: [{ name: 'White Paper', url: '/pdf/humaniq_wp_english.pdf', externalLink: true }, { name: 'Contact us', url: '/contact-us' }]
}];
var socials = [{ network: 'facebook', link: 'https://www.facebook.com/humaniq.co' }, { network: 'twitter', link: 'https://twitter.com/Humaniq' }, { network: 'github', link: 'https://github.com/humaniq' }, { network: 'youtube', link: 'https://www.youtube.com/channel/UCXatRidLHbngYUtF8JXICPA' }, { network: 'slack', link: 'https://hmq.im/ctWWHt' }, { network: 'linkedin', link: 'https://www.linkedin.com/company/humaniq' }, { network: 'instagram', link: 'https://www.instagram.com/humaniq_com/' }];

var O_Footer = function (_Component) {
  (0, _inherits3.default)(O_Footer, _Component);

  function O_Footer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, O_Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = O_Footer.__proto__ || (0, _getPrototypeOf2.default)(O_Footer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openedSection: null
    }, _this.handleTongleSection = function (section) {
      var oldSection = _this.state.openedSection;

      if (oldSection === section) {
        _this.setState({ openedSection: null });
      } else {
        _this.setState({ openedSection: section });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(O_Footer, [{
    key: 'linksList',
    value: function linksList(openedSection, allLinksExternal) {
      var _this2 = this;

      return links.map(function (_ref2) {
        var section = _ref2.section,
            links = _ref2.links;

        var isOpen = openedSection === section;

        return _react2.default.createElement(
          'div',
          { className: cn('nav-section'), key: 'key=' + section },
          _react2.default.createElement(
            'div',
            {
              className: cn('nav-section-title', { isOpen: isOpen }),
              onClick: function onClick() {
                return _this2.handleTongleSection(section);
              }
            },
            section
          ),
          _react2.default.createElement(
            'ul',
            { className: cn('nav-list', { isOpen: isOpen }) },
            links.map(function (_ref3) {
              var name = _ref3.name,
                  url = _ref3.url,
                  externalLink = _ref3.externalLink;

              var external = allLinksExternal || externalLink;
              var to = allLinksExternal && !externalLink ? 'https://' + (_api.WEBSITE_DOMAIN_NAME + url) : url;
              return _react2.default.createElement(
                'li',
                { className: cn('nav-list__item'), key: 'key=' + name },
                _react2.default.createElement(
                  _A_Link2.default,
                  { to: to, type: 'primary', external: external },
                  name
                )
              );
            })
          )
        );
      });
    }
  }, {
    key: 'socialsList',
    value: function socialsList() {
      return socials.map(function (_ref4) {
        var network = _ref4.network,
            link = _ref4.link;
        return _react2.default.createElement(
          'span',
          { className: cn('soc-item'), key: 'key_' + network },
          _react2.default.createElement(
            _A_Link2.default,
            { to: link, title: network, key: network, external: true },
            _react2.default.createElement(_A_Image2.default, { src: "/img/social/" + network + ".svg", alt: network, link: true, realSize: true })
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMenuOpened = _props.isMenuOpened,
          externalLinks = _props.externalLinks;
      var openedSection = this.state.openedSection;

      var max = 100;
      var renderedSocialList = this.socialsList();
      var renderedLinksList = this.linksList(openedSection, externalLinks);
      return _react2.default.createElement(
        'footer',
        { className: cn({ isMenuOpened: isMenuOpened }) },
        _react2.default.createElement(
          _A_Container2.default,
          null,
          _react2.default.createElement(
            _reactMotion.Motion,
            {
              defaultStyle: { y: 0 },
              style: {
                y: isMenuOpened ? (0, _reactMotion.spring)(max) : 0
              }
            },
            function (_ref5) {
              var y = _ref5.y;
              return _react2.default.createElement(
                'div',
                { style: {
                    transform: 'translate3d(0, -' + y + 'px, 0)',
                    opacity: '' + (y === 0 ? 1 : y / max),
                    marginTop: (y === 0 ? 0 : max) + 'px'
                  } },
                _react2.default.createElement(
                  'div',
                  { className: cn('inner') },
                  _react2.default.createElement(
                    'nav',
                    { className: cn('nav') },
                    renderedLinksList
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: cn('aux') },
                    _react2.default.createElement(
                      'div',
                      {
                        className: cn('aux-title')
                      },
                      'Humaniq'
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: cn('about') },
                      _react2.default.createElement(
                        'a',
                        { href: 'http://humaniqapp.com/', target: '_blank' },
                        'Humaniq is a simple and secure mobile app, delivering financial inclusion solutions to the 2.5 billion unbanked / 1 billion underbanked globally.'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: cn('soc') },
                      renderedSocialList
                    )
                  )
                )
              );
            }
          )
        )
      );
    }
  }]);
  return O_Footer;
}(_react.Component);

O_Footer.propTypes = {
  isMenuOpened: T.bool.isRequired,
  externalLinks: T.bool
};

O_Footer.defaultProps = {
  isisMenuOpeneded: T.bool.isRequired,
  externalLinks: false
};

exports.default = O_Footer;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(782);

var _utils = __webpack_require__(1);

var _reactRouter = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_FooterLinks');

var M_FooterLinks = function (_Component) {
  (0, _inherits3.default)(M_FooterLinks, _Component);

  function M_FooterLinks() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_FooterLinks);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_FooterLinks.__proto__ || (0, _getPrototypeOf2.default)(M_FooterLinks)).call.apply(_ref, [this].concat(args))), _this), _this._alertTest = function (e) {
      e.preventDefault();
      alert('ok');
      alert('next');
    }, _this._createLinksList = function (section, links) {
      switch (section) {
        case 'Info':
        case 'Legal':
        case 'Humaniq app':
          return links.map(function (_ref2, index) {
            var name = _ref2.name,
                url = _ref2.url,
                externalLink = _ref2.externalLink,
                popupLink = _ref2.popupLink,
                formType = _ref2.formType;
            return _react2.default.createElement(
              'li',
              {
                key: section + '-link-' + index,
                className: cn('list-item')
              },
              popupLink ? _react2.default.createElement(
                'span',
                { className: cn('list-item-pop-up'), onClick: function onClick() {
                    return _this.props.openPopup(formType);
                  } },
                name
              ) : externalLink ? _react2.default.createElement(
                'a',
                { href: url, target: '_blank' },
                name
              ) : _react2.default.createElement(
                _reactRouter.Link,
                { to: url },
                name
              )
            );
          });
        case 'Contacts':
          return links.map(function (_ref3, index) {
            var name = _ref3.name,
                url = _ref3.url;

            var mailTo = 'mailto:' + url;
            return _react2.default.createElement(
              'li',
              {
                key: section + '-link-' + index,
                className: cn('list-item')
              },
              _react2.default.createElement(
                'span',
                null,
                name
              ),
              _react2.default.createElement(
                'a',
                { href: mailTo, target: '_blank' },
                url
              )
            );
          });
      }
    }, _this._getLinks = function (footerLinks) {
      return footerLinks.map(function (_ref4, index) {
        var section = _ref4.section,
            links = _ref4.links;
        return _react2.default.createElement(
          'div',
          {
            key: 'footer-links-section-' + index,
            className: cn('section')
          },
          _react2.default.createElement(
            'p',
            { className: cn('section-title') },
            section
          ),
          _react2.default.createElement(
            'ul',
            { className: cn('list') },
            _this._createLinksList(section, links)
          )
        );
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_FooterLinks, [{
    key: 'render',
    value: function render() {
      var mix = this.props.mix;

      return _react2.default.createElement(
        'div',
        { className: cn([mix]) },
        this._getLinks(footerLinks)
      );
    }
  }]);
  return M_FooterLinks;
}(_react.Component);

exports.default = M_FooterLinks;


M_FooterLinks.propTypes = {
  mix: T.string //BEM mixin from parent block
};

var footerLinks = [{
  section: 'Info',
  links: [{ name: 'Project details', url: '/pdf/humaniq-whitepaper-05.09.pdf', externalLink: true }, { name: 'Wiki', url: '/wiki' },
  // {name: 'HMQ Explorer', url: '/hmq-explorer'},
  // {name: 'Humaniq blog', url: 'https://forum.humaniq.co', externalLink: true},
  { name: 'Careers', url: '/careers' }, { name: 'F.A.Q.', url: '/faq' }]
}, {
  section: 'Contacts',
  links: [{ name: 'General: ', url: 'info@humaniq.com' },
  // {name: 'For investors: ', url: 'invest@humaniq.com'},
  { name: 'Careers: ', url: 'hr@humaniq.com' }, { name: 'Support: ', url: 'appsupport@humaniq.com' }]
}, { section: 'Legal',
  links: [{ name: 'Privacy', url: '/legal/general-privacy-policy' }, { name: 'Security', url: '/legal/data-privacy-policy' }, { name: 'Policies', url: '/legal/user-terms-of-service' }, { name: 'Howey Test', url: '/a-securities-law-framework-for-hmq.xlsx', externalLink: true }]
}, {
  section: 'Humaniq app',
  links: [{ name: 'Download in Google Play', url: 'https://hmq.onelink.me/JU9Z/5679f4a0', externalLink: true }]
}];

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(232);

var _utils = __webpack_require__(1);

var _reactRouter = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_MenuDesktop');


var O_MenuDesktop = function O_MenuDesktop(_ref) {
  var options = _ref.options,
      sticky = _ref.sticky;

  var renderedLinks = options.map(function (_ref2, i) {
    var url = _ref2.url,
        text = _ref2.text,
        isSelected = _ref2.isSelected;

    return _react2.default.createElement(
      'li',
      { key: 'menu-item-' + i, className: cn('nav-links-item', { active: isSelected }) },
      isSelected ? _react2.default.createElement(
        'div',
        null,
        text
      ) : _react2.default.createElement(
        _reactRouter.Link,
        { to: url },
        text
      )
    );
  });

  return _react2.default.createElement(
    'nav',
    null,
    _react2.default.createElement(
      'ul',
      { className: cn('root', { sticky: sticky }) },
      renderedLinks
    )
  );
};

O_MenuDesktop.propTypes = {
  options: T.arrayOf(T.shape({
    url: T.string.isRequired,
    text: T.string.isRequired,
    isSelected: T.bool.isRequired
  }))
};

O_MenuDesktop.defaultProps = {
  options: []
};

exports.default = O_MenuDesktop;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(232);

var _utils = __webpack_require__(1);

var _reactRouter = __webpack_require__(24);

var _reactOnclickoutside = __webpack_require__(103);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_MenuMobile');

var O_MenuMobile = function (_Component) {
  (0, _inherits3.default)(O_MenuMobile, _Component);

  function O_MenuMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, O_MenuMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = O_MenuMobile.__proto__ || (0, _getPrototypeOf2.default)(O_MenuMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      activeTitle: _this.initialActiveTitle(_this.props)
    }, _this.handleClickOutside = function () {
      _this.closeMenu();
    }, _this.toggleMenu = function () {
      _this.setState({ isOpen: !_this.state.isOpen });
    }, _this.closeMenu = function () {
      _this.setState({ isOpen: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(O_MenuMobile, [{
    key: 'initialActiveTitle',
    value: function initialActiveTitle(props) {
      var options = props.options;

      var active = options.filter(function (option) {
        return option.isSelected;
      })[0];
      return active ? active.text : options[0].text;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var activeTitle = this.initialActiveTitle(nextProps);
      var oldActiveTitle = this.state.activeTitle;
      if (activeTitle !== oldActiveTitle) {
        this.setState({ activeTitle: activeTitle });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          isOpen = _state.isOpen,
          activeTitle = _state.activeTitle;
      var _props = this.props,
          options = _props.options,
          title = _props.title;


      var renderedLinks = options.map(function (_ref2, i) {
        var text = _ref2.text,
            url = _ref2.url,
            isSelected = _ref2.isSelected;
        return _react2.default.createElement(
          'li',
          { className: cn('menu-li'), key: 'key_' + i },
          isSelected ? _react2.default.createElement(
            'div',
            { className: cn('menu-a') },
            text
          ) : _react2.default.createElement(
            'span',
            { className: cn('menu-a'), onClick: function onClick() {
                return _this2.closeMenu();
              } },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: url },
              text
            )
          )
        );
      });
      return _react2.default.createElement(
        'div',
        { className: cn('menu') },
        _react2.default.createElement(
          'button',
          { className: cn('menu-bt'), onClick: this.toggleMenu },
          title || activeTitle,
          _react2.default.createElement(
            'svg',
            { className: cn('menu-icon', { active: isOpen }), xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 10 6' },
            _react2.default.createElement('path', { d: 'M5 0l4 5H1z' })
          )
        ),
        isOpen && _react2.default.createElement(
          'ul',
          { className: cn('menu-list') },
          renderedLinks
        )
      );
    }
  }]);
  return O_MenuMobile;
}(_react.Component);

O_MenuMobile.propTypes = {};

exports.default = (0, _reactOnclickoutside2.default)(O_MenuMobile);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _O_Fixed = __webpack_require__(468);

var _O_Fixed2 = _interopRequireDefault(_O_Fixed);

var _Desktop = __webpack_require__(471);

var _Desktop2 = _interopRequireDefault(_Desktop);

var _Mobile = __webpack_require__(472);

var _Mobile2 = _interopRequireDefault(_Mobile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var O_Menu = function (_Component) {
  (0, _inherits3.default)(O_Menu, _Component);

  function O_Menu() {
    (0, _classCallCheck3.default)(this, O_Menu);
    return (0, _possibleConstructorReturn3.default)(this, (O_Menu.__proto__ || (0, _getPrototypeOf2.default)(O_Menu)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          props = (0, _objectWithoutProperties3.default)(_props, ['type']);

      switch (type) {
        case 'desktop':
          return _react2.default.createElement(
            _O_Fixed2.default,
            null,
            _react2.default.createElement(_Desktop2.default, props)
          );
        case 'mobile':
          return _react2.default.createElement(
            _O_Fixed2.default,
            null,
            _react2.default.createElement(_Mobile2.default, props)
          );
      }
    }
  }]);
  return O_Menu;
}(_react.Component);

O_Menu.propTypes = {
  type: T.oneOf(['desktop', // simple menu, used on legal page
  'mobile'] // simple menu, used on legal page
  ).isRequired
};

O_Menu.defaultProps = {};

exports.default = O_Menu;

// import React from 'react';
// import * as T from "prop-types";
// import Desktop from './Desktop'
//
// const O_MenuDesktop = ({ options, selected, rootLink, stickyMenu, type }) => {
//   const _options = options.map(({ anchor, text }) => {
//     const isSelected = selected === anchor;
//     return ({
//       text,
//       url: rootLink + anchor,
//       isSelected
//     })
//   });
//
//   return (
//     <div>тут меню</div>
//   )
//
//   //
//   // console.log( options, selected, rootLink, stickyMenu, type)
//   // switch(type){
//   //   case 'desktop':
//   //     return <Desktop {...{options: _options, stickyMenu}} />
//   //   case 'mobile':
//   //     return <Desktop {...{options: _options, stickyMenu}} />
//   //
//   // }
// };
//
//
// O_MenuDesktop.propTypes = {
//   options: T.arrayOf(T.shape({
//     anchor: T.string,
//     text: T.string.isRequired,
//   })),
//   type: T.oneOf([
//     'desctop', //shows on desctop
//     'mobile' //shows on mobile
//   ]),
//   rootLink: T.string.isRequired,
//   selected: T.string.isRequired,
//   stickyMenu: T.bool.isRequired
// };
//
// O_MenuDesktop.defaultProps = {
//   options: [],
//   selected: '',
// };
//
// export default O_MenuDesktop

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _O_SimpleForm_H = __webpack_require__(479);

var _O_SimpleForm_H2 = _interopRequireDefault(_O_SimpleForm_H);

__webpack_require__(785);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_Popup_H');

var O_Popup_H = function (_Component) {
  (0, _inherits3.default)(O_Popup_H, _Component);

  function O_Popup_H() {
    (0, _classCallCheck3.default)(this, O_Popup_H);
    return (0, _possibleConstructorReturn3.default)(this, (O_Popup_H.__proto__ || (0, _getPrototypeOf2.default)(O_Popup_H)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_Popup_H, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isActive = _props.isActive,
          closePopup = _props.closePopup,
          popupType = _props.popupType;


      return _react2.default.createElement(
        'div',
        { className: cn({ isActive: isActive }) },
        _react2.default.createElement('div', {
          className: cn('close-btn'),
          onClick: closePopup
        }),
        _react2.default.createElement(
          'div',
          { className: cn('content') },
          _react2.default.createElement(_O_SimpleForm_H2.default, {
            formType: popupType
          })
        )
      );
    }
  }]);
  return O_Popup_H;
}(_react.Component);

O_Popup_H.propTypes = {
  isActive: T.bool.isRequired, //popup is visible or not
  closePopup: T.func.isRequired, //close popup action
  popupType: T.oneOf([
  //'subscribe', //popup with subscribe form inside
  'ambasadors' //popup with ambasadors form inside
  ])
};

exports.default = O_Popup_H;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(786);

var _utils = __webpack_require__(1);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_Search');

var O_Search = function (_Component) {
  (0, _inherits3.default)(O_Search, _Component);

  function O_Search() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, O_Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = O_Search.__proto__ || (0, _getPrototypeOf2.default)(O_Search)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inActive: !!_this.props.value,
      value: _this.props.value || ''
    }, _this.onSubmit = function (e) {
      e.preventDefault();
      var value = _this.state.value;

      if (value) {
        _this.props.handleSubmit(value);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(O_Search, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value || '',
        inActive: nextProps.focus ? true : !!nextProps.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          inActive = _state.inActive,
          value = _state.value,
          title = _state.title;
      var placeholder = this.props.placeholder;

      var _title = title && _react2.default.createElement(
        _A_H2.default,
        { type: 'search' },
        title
      );
      return _react2.default.createElement(
        _A_Container2.default,
        { type: 'wide' },
        _title,
        _react2.default.createElement(
          'form',
          { action: '', className: cn('search', { inActive: inActive
              // `o-search ${ inActive ? 'o-search__input--focused' : '' }`
            }),
            onSubmit: this.onSubmit },
          _react2.default.createElement('input', {
            type: 'text',
            className: cn('input', { inActive: inActive }),
            placeholder: placeholder,
            value: value,
            onChange: function onChange(e) {
              return _this2.setState({ value: e.target.value });
            },
            onFocus: function onFocus() {
              return _this2.setState({ inActive: true });
            },
            onBlur: function onBlur() {
              return _this2.setState({ inActive: false });
            }
          }),
          _react2.default.createElement(
            'button',
            { className: cn('submit'), type: 'submit' },
            _react2.default.createElement(
              'svg',
              { className: cn('search-icon'), xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 19 19' },
              _react2.default.createElement(
                'g',
                { fill: 'none', transform: 'translate(-1 -1)' },
                _react2.default.createElement('path', { fill: 'none', d: 'M0 0h20v20H0z' }),
                _react2.default.createElement('path', { className: cn('icon-path'),
                  d: 'M13.54 12.2l-1.429 1.4 4.906 4.907a.995.995 0 0 0 1.418.003.997.997 0 0 0 0-1.414L13.539 12.2z' }),
                _react2.default.createElement('circle', { className: cn('icon-circle'), cx: '8', cy: '8', r: '6.5' })
              )
            )
          )
        )
      );
    }
  }]);
  return O_Search;
}(_react.Component);

O_Search.propTypes = {
  title: T.string,
  placeholder: T.string.isRequired,
  handleSubmit: T.func.isRequired
};

exports.default = O_Search;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _A_InputText_H = __webpack_require__(59);

var _A_InputText_H2 = _interopRequireDefault(_A_InputText_H);

var _A_Textarea_H = __webpack_require__(132);

var _A_Textarea_H2 = _interopRequireDefault(_A_Textarea_H);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _SimpleForm = __webpack_require__(66);

var _SimpleForm2 = _interopRequireDefault(_SimpleForm);

var _Dropdown = __webpack_require__(477);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

__webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_SimpleForm_H');

var HOC_CONFIG = {
  fieldNames: ['email', 'name', 'country', 'bio'],
  validations: {
    email: ['required', 'email'],
    name: 'required',
    country: 'required',
    bio: 'required'
  }
};

var O_AmbasadorsForm = function (_Component) {
  (0, _inherits3.default)(O_AmbasadorsForm, _Component);

  function O_AmbasadorsForm() {
    (0, _classCallCheck3.default)(this, O_AmbasadorsForm);
    return (0, _possibleConstructorReturn3.default)(this, (O_AmbasadorsForm.__proto__ || (0, _getPrototypeOf2.default)(O_AmbasadorsForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_AmbasadorsForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          formHasErrors = _props.formHasErrors,
          handleSubmit = _props.handleSubmit,
          submited = _props.submited;


      return _react2.default.createElement(
        'div',
        null,
        submited ? _react2.default.createElement(
          _A_Title_H2.default,
          {
            mix: cn('title')
          },
          'Thank you for your application!'
        ) : _react2.default.createElement(
          'form',
          { className: cn([mix]), onSubmit: handleSubmit },
          _react2.default.createElement(_A_InputText_H2.default, {
            value: this.props.fields['email'].value,
            onChange: true,
            placeholder: 'email',
            label: 'email',
            error: this.props.fields['email'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('email', text);
            }
          }),
          _react2.default.createElement(_A_InputText_H2.default, {
            value: this.props.fields['name'].value,
            onChange: true,
            placeholder: 'Your name',
            label: 'Your name',
            error: this.props.fields['name'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('name', text);
            }
          }),
          _react2.default.createElement(_Dropdown2.default, {
            label: 'Country',
            placeholder: 'Choose country',
            selected: this.props.fields['country'].value,
            value: this.props.fields['country'].value,
            options: countries,
            onChange: function onChange(country) {
              return _this2.props.onFieldChange('country', country);
            },
            error: this.props.fields['country'].error
          }),
          _react2.default.createElement(_A_Textarea_H2.default, {
            value: this.props.fields['bio'].value,
            onChange: true,
            label: 'Bio',
            placeholder: 'Bio',
            error: this.props.fields['bio'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('bio', text);
            }
          }),
          _react2.default.createElement(
            _A_Btn_H2.default,
            {
              mix: cn('submit-btn'),
              error: formHasErrors,
              type: 'submit'
            },
            formHasErrors ? 'Check errors' : 'Continue'
          )
        )
      );
    }
  }]);
  return O_AmbasadorsForm;
}(_react.Component);

exports.default = (0, _SimpleForm2.default)(O_AmbasadorsForm, HOC_CONFIG);


var countries = ["Afghanistan", "Aland Islands", "Albania", "Algeria", "AmericanSamoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran,", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Rwanda", "Reunion", "Saint Barthelemy", "Saint Helena, Ascension and Tristan Da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Yemen", "Zambia", "Zimbabwe"];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(787);

var _utils = __webpack_require__(1);

var _reactOnclickoutside = __webpack_require__(103);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _A_InputText_H = __webpack_require__(59);

var _A_InputText_H2 = _interopRequireDefault(_A_InputText_H);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_Dropdown_H');

var M_Dropdown = function (_Component) {
  (0, _inherits3.default)(M_Dropdown, _Component);

  function M_Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_Dropdown.__proto__ || (0, _getPrototypeOf2.default)(M_Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpened: false,
      value: _this.props.value || '',
      inputValue: ''
    }, _this.handleClickOutside = function () {
      _this.setState({ isOpened: false, inputValue: _this.state.value });
    }, _this.handleClick = function () {
      if (!_this.state.isOpened) _this.setState({ isOpened: true });
    }, _this.handleChange = function (selected) {
      _this.setState({ inputValue: selected, isOpened: false, value: selected });
      _this.props.onChange(selected);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_Dropdown, [{
    key: 'getListOptions',
    value: function getListOptions(options, isOpened, selected) {
      var _this2 = this;

      var renderOptions = void 0;

      if (options.length) {
        renderOptions = options.map(function (option) {
          return _react2.default.createElement(
            'ol',
            {
              className: cn('list-options-item', { selected: selected === option }),
              key: 'key_' + option,
              onClick: function onClick() {
                return _this2.handleChange(option);
              }
            },
            option
          );
        });
      } else {
        renderOptions = _react2.default.createElement(
          'ol',
          {
            className: cn('list-options-item'),
            onClick: function onClick() {
              return _this2.setState({ inputValue: '' });
            }

          },
          'No results'
        );
      }

      return _react2.default.createElement(
        'div',
        { className: cn('list-wrapper', { closed: !isOpened }) },
        _react2.default.createElement(
          'ul',
          { className: cn('list-options') },
          renderOptions
        )
      );
    }
  }, {
    key: 'getOptions',
    value: function getOptions(options, filter) {
      return options.filter(function (country) {
        return country.toLowerCase().includes(filter.toLowerCase());
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          options = _props.options,
          selected = _props.selected,
          error = _props.error;
      var _state = this.state,
          isOpened = _state.isOpened,
          inputValue = _state.inputValue;

      var filteredOptions = this.getOptions(options, inputValue);
      var listOptions = this.getListOptions(filteredOptions, isOpened, selected);
      return _react2.default.createElement(
        'div',
        { className: cn('root'), onClick: this.handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('select', { isOpened: isOpened }) },
          _react2.default.createElement(
            'div',
            { className: cn('inner') },
            _react2.default.createElement(_A_InputText_H2.default, {
              error: error,
              setFocus: isOpened,
              placeholder: 'Your country',
              value: inputValue,
              onFocus: function onFocus() {
                return _this3.setState({ inputValue: '' });
              },
              handleChange: function handleChange(value) {
                return _this3.setState({ inputValue: value });
              }
            })
          )
        ),
        listOptions
      );
    }
  }]);
  return M_Dropdown;
}(_react.Component);

M_Dropdown.propTypes = {
  options: T.array.isRequired,
  selected: T.string.isRequired,
  error: T.string
};

M_Dropdown.defaultProps = {};

exports.default = (0, _reactOnclickoutside2.default)(M_Dropdown);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _A_InputText_H = __webpack_require__(59);

var _A_InputText_H2 = _interopRequireDefault(_A_InputText_H);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _SimpleForm = __webpack_require__(66);

var _SimpleForm2 = _interopRequireDefault(_SimpleForm);

__webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_SimpleForm_H');

var HOC_CONFIG = {
  fieldNames: ['email'],
  validations: {
    email: ['required', 'email']
  }
};

var FIELDS_CONFIG = [{
  fieldName: 'email',
  placeholder: 'Enter email'
}];

var O_SubscribeForm = function (_Component) {
  (0, _inherits3.default)(O_SubscribeForm, _Component);

  function O_SubscribeForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, O_SubscribeForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = O_SubscribeForm.__proto__ || (0, _getPrototypeOf2.default)(O_SubscribeForm)).call.apply(_ref, [this].concat(args))), _this), _this._createInputs = function (fieldsConfig) {
      return fieldsConfig.map(function (_ref2) {
        var fieldName = _ref2.fieldName,
            placeholder = _ref2.placeholder;
        return _react2.default.createElement(_A_InputText_H2.default, {
          key: fieldName + '_field',
          value: _this.props.fields[fieldName].value,
          onChange: true,
          placeholder: placeholder,
          error: _this.props.fields[fieldName].error,
          handleChange: function handleChange(text) {
            return _this.props.onFieldChange(fieldName, text);
          }
        });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(O_SubscribeForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          mix = _props.mix,
          formHasErrors = _props.formHasErrors,
          handleSubmit = _props.handleSubmit,
          submited = _props.submited;


      return _react2.default.createElement(
        'div',
        null,
        submited ? _react2.default.createElement(
          _A_Title_H2.default,
          {
            mix: cn('title')
          },
          'Stay tuned, interesting news are on the way.'
        ) : _react2.default.createElement(
          'form',
          { className: cn([mix]), onSubmit: handleSubmit },
          _react2.default.createElement(
            _A_Title_H2.default,
            {
              mix: cn('title')
            },
            'Sign up for',
            _react2.default.createElement('br', null),
            'Humaniq Newsletter'
          ),
          this._createInputs(FIELDS_CONFIG),
          _react2.default.createElement(
            _A_Btn_H2.default,
            {
              mix: cn('submit-btn'),
              formHasErrors: formHasErrors,
              type: 'submit'
            },
            'Send'
          )
        )
      );
    }
  }]);
  return O_SubscribeForm;
}(_react.Component);

exports.default = (0, _SimpleForm2.default)(O_SubscribeForm, HOC_CONFIG);

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _Subscribe = __webpack_require__(478);

var _Subscribe2 = _interopRequireDefault(_Subscribe);

var _Ambasadors = __webpack_require__(476);

var _Ambasadors2 = _interopRequireDefault(_Ambasadors);

var _actions = __webpack_require__(54);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var O_SimpleForm_H = function (_Component) {
  (0, _inherits3.default)(O_SimpleForm_H, _Component);

  function O_SimpleForm_H() {
    (0, _classCallCheck3.default)(this, O_SimpleForm_H);
    return (0, _possibleConstructorReturn3.default)(this, (O_SimpleForm_H.__proto__ || (0, _getPrototypeOf2.default)(O_SimpleForm_H)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_SimpleForm_H, [{
    key: 'getForm',
    value: function getForm(formType, _ref) {
      var submit = _ref.submit,
          props = (0, _objectWithoutProperties3.default)(_ref, ['submit']);

      switch (formType) {
        case 'subscribe':
          return _react2.default.createElement(_Subscribe2.default, (0, _extends3.default)({}, props, { handleSubmit: function handleSubmit(data) {
              return submit('subscribe', data);
            } }));
        case 'ambasadors':
          return _react2.default.createElement(_Ambasadors2.default, (0, _extends3.default)({}, props, { handleSubmit: function handleSubmit(data) {
              return submit('ambassadors', data);
            } }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var formType = this.props.formType;
      // console.log('this.props from Simple Form',this.props);
      // console.log('formType from Simple Form',formType);

      return formType ? this.getForm(formType, this.props) : null;
    }
  }]);
  return O_SimpleForm_H;
}(_react.Component);

O_SimpleForm_H.propTypes = {
  formType: T.oneOf(['subscribe', 'ambasadors'])
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ submit: _actions.submit }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(O_SimpleForm_H);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _A_InputText_H = __webpack_require__(59);

var _A_InputText_H2 = _interopRequireDefault(_A_InputText_H);

var _A_Textarea_H = __webpack_require__(132);

var _A_Textarea_H2 = _interopRequireDefault(_A_Textarea_H);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _SimpleForm = __webpack_require__(66);

var _SimpleForm2 = _interopRequireDefault(_SimpleForm);

var _Dropdown = __webpack_require__(481);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

__webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_SimpleForm_H');

var HOC_CONFIG = {
  fieldNames: ['email', 'name', 'country', 'bio'],
  validations: {
    email: ['required', 'email'],
    name: 'required',
    country: 'required',
    bio: 'required'
  }
};

var O_AmbasadorsForm = function (_Component) {
  (0, _inherits3.default)(O_AmbasadorsForm, _Component);

  function O_AmbasadorsForm() {
    (0, _classCallCheck3.default)(this, O_AmbasadorsForm);
    return (0, _possibleConstructorReturn3.default)(this, (O_AmbasadorsForm.__proto__ || (0, _getPrototypeOf2.default)(O_AmbasadorsForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_AmbasadorsForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          formHasErrors = _props.formHasErrors,
          handleSubmit = _props.handleSubmit,
          submited = _props.submited;


      return _react2.default.createElement(
        'div',
        null,
        submited ? _react2.default.createElement(
          _A_Title_H2.default,
          {
            mix: cn('title')
          },
          'Thank you for your application!'
        ) : _react2.default.createElement(
          'form',
          { className: cn([mix]), onSubmit: handleSubmit },
          _react2.default.createElement(_A_InputText_H2.default, {
            value: this.props.fields['email'].value,
            onChange: true,
            placeholder: 'email',
            label: 'email',
            error: this.props.fields['email'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('email', text);
            }
          }),
          _react2.default.createElement(_A_InputText_H2.default, {
            value: this.props.fields['name'].value,
            onChange: true,
            placeholder: 'Your name',
            label: 'Your name',
            error: this.props.fields['name'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('name', text);
            }
          }),
          _react2.default.createElement(_Dropdown2.default, {
            label: 'Country',
            placeholder: 'Choose country',
            selected: this.props.fields['country'].value,
            value: this.props.fields['country'].value,
            options: countries,
            onChange: function onChange(country) {
              return _this2.props.onFieldChange('country', country);
            },
            error: this.props.fields['country'].error
          }),
          _react2.default.createElement(_A_Textarea_H2.default, {
            value: this.props.fields['bio'].value,
            onChange: true,
            label: 'Bio',
            placeholder: 'Bio',
            error: this.props.fields['bio'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('bio', text);
            }
          }),
          _react2.default.createElement(
            _A_Btn_H2.default,
            {
              mix: cn('submit-btn'),
              error: formHasErrors,
              type: 'submit'
            },
            formHasErrors ? 'Check errors' : 'Continue'
          )
        )
      );
    }
  }]);
  return O_AmbasadorsForm;
}(_react.Component);

exports.default = (0, _SimpleForm2.default)(O_AmbasadorsForm, HOC_CONFIG);


var countries = ["Afghanistan", "Aland Islands", "Albania", "Algeria", "AmericanSamoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran,", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Rwanda", "Reunion", "Saint Barthelemy", "Saint Helena, Ascension and Tristan Da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Yemen", "Zambia", "Zimbabwe"];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(788);

var _utils = __webpack_require__(1);

var _reactOnclickoutside = __webpack_require__(103);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _A_InputText_H = __webpack_require__(59);

var _A_InputText_H2 = _interopRequireDefault(_A_InputText_H);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_Dropdown_H');

var M_Dropdown = function (_Component) {
  (0, _inherits3.default)(M_Dropdown, _Component);

  function M_Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_Dropdown.__proto__ || (0, _getPrototypeOf2.default)(M_Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpened: false,
      value: _this.props.value || '',
      inputValue: ''
    }, _this.handleClickOutside = function () {
      _this.setState({ isOpened: false, inputValue: _this.state.value });
    }, _this.handleClick = function () {
      if (!_this.state.isOpened) _this.setState({ isOpened: true });
    }, _this.handleChange = function (selected) {
      _this.setState({ inputValue: selected, isOpened: false, value: selected });
      _this.props.onChange(selected);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_Dropdown, [{
    key: 'getListOptions',
    value: function getListOptions(options, isOpened, selected) {
      var _this2 = this;

      var renderOptions = void 0;

      if (options.length) {
        renderOptions = options.map(function (option) {
          return _react2.default.createElement(
            'ol',
            {
              className: cn('list-options-item', { selected: selected === option }),
              key: 'key_' + option,
              onClick: function onClick() {
                return _this2.handleChange(option);
              }
            },
            option
          );
        });
      } else {
        renderOptions = _react2.default.createElement(
          'ol',
          {
            className: cn('list-options-item'),
            onClick: function onClick() {
              return _this2.setState({ inputValue: '' });
            }

          },
          'No results'
        );
      }

      return _react2.default.createElement(
        'div',
        { className: cn('list-wrapper', { closed: !isOpened }) },
        _react2.default.createElement(
          'ul',
          { className: cn('list-options') },
          renderOptions
        )
      );
    }
  }, {
    key: 'getOptions',
    value: function getOptions(options, filter) {
      return options.filter(function (country) {
        return country.toLowerCase().includes(filter.toLowerCase());
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          options = _props.options,
          selected = _props.selected,
          error = _props.error;
      var _state = this.state,
          isOpened = _state.isOpened,
          inputValue = _state.inputValue;

      var filteredOptions = this.getOptions(options, inputValue);
      var listOptions = this.getListOptions(filteredOptions, isOpened, selected);
      return _react2.default.createElement(
        'div',
        { className: cn('root'), onClick: this.handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('select', { isOpened: isOpened }) },
          _react2.default.createElement(
            'div',
            { className: cn('inner') },
            _react2.default.createElement(_A_InputText_H2.default, {
              error: error,
              setFocus: isOpened,
              placeholder: 'Your country',
              value: inputValue,
              onFocus: function onFocus() {
                return _this3.setState({ inputValue: '' });
              },
              handleChange: function handleChange(value) {
                return _this3.setState({ inputValue: value });
              }
            })
          )
        ),
        listOptions
      );
    }
  }]);
  return M_Dropdown;
}(_react.Component);

M_Dropdown.propTypes = {
  options: T.array.isRequired,
  selected: T.string.isRequired,
  error: T.string
};

M_Dropdown.defaultProps = {};

exports.default = (0, _reactOnclickoutside2.default)(M_Dropdown);

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _A_InputText_H_ = __webpack_require__(197);

var _A_InputText_H_2 = _interopRequireDefault(_A_InputText_H_);

var _A_Btn_H_ = __webpack_require__(196);

var _A_Btn_H_2 = _interopRequireDefault(_A_Btn_H_);

var _SimpleForm = __webpack_require__(66);

var _SimpleForm2 = _interopRequireDefault(_SimpleForm);

var _M_SocialLinks_F = __webpack_require__(200);

var _M_SocialLinks_F2 = _interopRequireDefault(_M_SocialLinks_F);

__webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_SimpleForm_H');

var HOC_CONFIG = {
  fieldNames: ['email'],
  validations: {
    email: ['required', 'email']
  }
};

var FIELDS_CONFIG = [{
  fieldName: 'email',
  placeholder: 'Your e-mail'
}];

var O_SubscribeForm = function (_Component) {
  (0, _inherits3.default)(O_SubscribeForm, _Component);

  function O_SubscribeForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, O_SubscribeForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = O_SubscribeForm.__proto__ || (0, _getPrototypeOf2.default)(O_SubscribeForm)).call.apply(_ref, [this].concat(args))), _this), _this._createInputs = function (fieldsConfig) {
      return fieldsConfig.map(function (_ref2) {
        var fieldName = _ref2.fieldName,
            placeholder = _ref2.placeholder;
        return _react2.default.createElement(_A_InputText_H_2.default, {
          key: fieldName + '_field',
          value: _this.props.fields[fieldName].value,
          onChange: true,
          placeholder: placeholder,
          error: _this.props.fields[fieldName].error,
          handleChange: function handleChange(text) {
            return _this.props.onFieldChange(fieldName, text);
          }
        });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(O_SubscribeForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          mix = _props.mix,
          formHasErrors = _props.formHasErrors,
          handleSubmit = _props.handleSubmit,
          submited = _props.submited;


      return _react2.default.createElement(
        'div',
        null,
        submited ? _react2.default.createElement(
          'div',
          { className: cn('title') },
          'Great that we are friends now! Thank you for the confidence you have placed in us. Promise no spam.'
        ) : _react2.default.createElement(
          'form',
          { className: cn([mix]), onSubmit: handleSubmit },
          this._createInputs(FIELDS_CONFIG),
          _react2.default.createElement(
            _A_Btn_H_2.default,
            {
              mix: cn('submit-btn'),
              formHasErrors: formHasErrors,
              type: 'submit'
            },
            'JOIN US'
          )
        )
      );
    }
  }]);
  return O_SubscribeForm;
}(_react.Component);

exports.default = (0, _SimpleForm2.default)(O_SubscribeForm, HOC_CONFIG);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(19);

var _redux = __webpack_require__(28);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _Subscribe = __webpack_require__(482);

var _Subscribe2 = _interopRequireDefault(_Subscribe);

var _Ambasadors = __webpack_require__(480);

var _Ambasadors2 = _interopRequireDefault(_Ambasadors);

var _actions = __webpack_require__(54);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var O_SimpleForm_H = function (_Component) {
  (0, _inherits3.default)(O_SimpleForm_H, _Component);

  function O_SimpleForm_H() {
    (0, _classCallCheck3.default)(this, O_SimpleForm_H);
    return (0, _possibleConstructorReturn3.default)(this, (O_SimpleForm_H.__proto__ || (0, _getPrototypeOf2.default)(O_SimpleForm_H)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_SimpleForm_H, [{
    key: 'getForm',
    value: function getForm(formType, _ref) {
      var submit = _ref.submit,
          props = (0, _objectWithoutProperties3.default)(_ref, ['submit']);

      switch (formType) {
        case 'subscribe':
          return _react2.default.createElement(_Subscribe2.default, (0, _extends3.default)({}, props, { handleSubmit: function handleSubmit(data) {
              return submit('subscribe', data);
            } }));
        case 'ambasadors':
          return _react2.default.createElement(_Ambasadors2.default, (0, _extends3.default)({}, props, { handleSubmit: function handleSubmit(data) {
              return submit('ambassadors', data);
            } }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var formType = this.props.formType;
      // console.log('this.props from Simple Form',this.props);
      // console.log('formType from Simple Form',formType);

      return formType ? this.getForm(formType, this.props) : null;
    }
  }]);
  return O_SimpleForm_H;
}(_react.Component);

O_SimpleForm_H.propTypes = {
  formType: T.oneOf(['subscribe', 'ambasadors'])
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  var actions = (0, _redux.bindActionCreators)({ submit: _actions.submit }, dispatch);
  return (0, _extends3.default)({}, actions);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(O_SimpleForm_H);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _A_InputText_H = __webpack_require__(59);

var _A_InputText_H2 = _interopRequireDefault(_A_InputText_H);

var _A_Textarea_H = __webpack_require__(132);

var _A_Textarea_H2 = _interopRequireDefault(_A_Textarea_H);

var _A_Title_H = __webpack_require__(8);

var _A_Title_H2 = _interopRequireDefault(_A_Title_H);

var _A_Btn_H = __webpack_require__(30);

var _A_Btn_H2 = _interopRequireDefault(_A_Btn_H);

var _SimpleForm = __webpack_require__(66);

var _SimpleForm2 = _interopRequireDefault(_SimpleForm);

var _Dropdown = __webpack_require__(485);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

__webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_SimpleForm_H');

var HOC_CONFIG = {
  fieldNames: ['email', 'name', 'country', 'bio'],
  validations: {
    email: ['required', 'email'],
    name: 'required',
    country: 'required',
    bio: 'required'
  }
};

var O_AmbasadorsForm = function (_Component) {
  (0, _inherits3.default)(O_AmbasadorsForm, _Component);

  function O_AmbasadorsForm() {
    (0, _classCallCheck3.default)(this, O_AmbasadorsForm);
    return (0, _possibleConstructorReturn3.default)(this, (O_AmbasadorsForm.__proto__ || (0, _getPrototypeOf2.default)(O_AmbasadorsForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(O_AmbasadorsForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mix = _props.mix,
          formHasErrors = _props.formHasErrors,
          handleSubmit = _props.handleSubmit,
          submited = _props.submited;


      return _react2.default.createElement(
        'div',
        null,
        submited ? _react2.default.createElement(
          _A_Title_H2.default,
          {
            mix: cn('title')
          },
          'Thank you for your application!'
        ) : _react2.default.createElement(
          'form',
          { className: cn([mix]), onSubmit: handleSubmit },
          _react2.default.createElement(_A_InputText_H2.default, {
            value: this.props.fields['email'].value,
            onChange: true,
            placeholder: 'email',
            label: 'email',
            error: this.props.fields['email'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('email', text);
            }
          }),
          _react2.default.createElement(_A_InputText_H2.default, {
            value: this.props.fields['name'].value,
            onChange: true,
            placeholder: 'Your name',
            label: 'Your name',
            error: this.props.fields['name'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('name', text);
            }
          }),
          _react2.default.createElement(_Dropdown2.default, {
            label: 'Country',
            placeholder: 'Choose country',
            selected: this.props.fields['country'].value,
            value: this.props.fields['country'].value,
            options: countries,
            onChange: function onChange(country) {
              return _this2.props.onFieldChange('country', country);
            },
            error: this.props.fields['country'].error
          }),
          _react2.default.createElement(_A_Textarea_H2.default, {
            value: this.props.fields['bio'].value,
            onChange: true,
            label: 'Bio',
            placeholder: 'Bio',
            error: this.props.fields['bio'].error,
            handleChange: function handleChange(text) {
              return _this2.props.onFieldChange('bio', text);
            }
          }),
          _react2.default.createElement(
            _A_Btn_H2.default,
            {
              mix: cn('submit-btn'),
              error: formHasErrors,
              type: 'submit'
            },
            formHasErrors ? 'Check errors' : 'Continue'
          )
        )
      );
    }
  }]);
  return O_AmbasadorsForm;
}(_react.Component);

exports.default = (0, _SimpleForm2.default)(O_AmbasadorsForm, HOC_CONFIG);


var countries = ["Afghanistan", "Aland Islands", "Albania", "Algeria", "AmericanSamoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran,", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Rwanda", "Reunion", "Saint Barthelemy", "Saint Helena, Ascension and Tristan Da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Yemen", "Zambia", "Zimbabwe"];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(789);

var _utils = __webpack_require__(1);

var _reactOnclickoutside = __webpack_require__(103);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _A_InputText_H = __webpack_require__(59);

var _A_InputText_H2 = _interopRequireDefault(_A_InputText_H);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('M_Dropdown_H');

var M_Dropdown = function (_Component) {
  (0, _inherits3.default)(M_Dropdown, _Component);

  function M_Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, M_Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = M_Dropdown.__proto__ || (0, _getPrototypeOf2.default)(M_Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpened: false,
      value: _this.props.value || '',
      inputValue: ''
    }, _this.handleClickOutside = function () {
      _this.setState({ isOpened: false, inputValue: _this.state.value });
    }, _this.handleClick = function () {
      if (!_this.state.isOpened) _this.setState({ isOpened: true });
    }, _this.handleChange = function (selected) {
      _this.setState({ inputValue: selected, isOpened: false, value: selected });
      _this.props.onChange(selected);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(M_Dropdown, [{
    key: 'getListOptions',
    value: function getListOptions(options, isOpened, selected) {
      var _this2 = this;

      var renderOptions = void 0;

      if (options.length) {
        renderOptions = options.map(function (option) {
          return _react2.default.createElement(
            'ol',
            {
              className: cn('list-options-item', { selected: selected === option }),
              key: 'key_' + option,
              onClick: function onClick() {
                return _this2.handleChange(option);
              }
            },
            option
          );
        });
      } else {
        renderOptions = _react2.default.createElement(
          'ol',
          {
            className: cn('list-options-item'),
            onClick: function onClick() {
              return _this2.setState({ inputValue: '' });
            }

          },
          'No results'
        );
      }

      return _react2.default.createElement(
        'div',
        { className: cn('list-wrapper', { closed: !isOpened }) },
        _react2.default.createElement(
          'ul',
          { className: cn('list-options') },
          renderOptions
        )
      );
    }
  }, {
    key: 'getOptions',
    value: function getOptions(options, filter) {
      return options.filter(function (country) {
        return country.toLowerCase().includes(filter.toLowerCase());
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          options = _props.options,
          selected = _props.selected,
          error = _props.error;
      var _state = this.state,
          isOpened = _state.isOpened,
          inputValue = _state.inputValue;

      var filteredOptions = this.getOptions(options, inputValue);
      var listOptions = this.getListOptions(filteredOptions, isOpened, selected);
      return _react2.default.createElement(
        'div',
        { className: cn('root'), onClick: this.handleClick },
        _react2.default.createElement(
          'div',
          { className: cn('select', { isOpened: isOpened }) },
          _react2.default.createElement(
            'div',
            { className: cn('inner') },
            _react2.default.createElement(_A_InputText_H2.default, {
              error: error,
              setFocus: isOpened,
              placeholder: 'Your country',
              value: inputValue,
              onFocus: function onFocus() {
                return _this3.setState({ inputValue: '' });
              },
              handleChange: function handleChange(value) {
                return _this3.setState({ inputValue: value });
              }
            })
          )
        ),
        listOptions
      );
    }
  }]);
  return M_Dropdown;
}(_react.Component);

M_Dropdown.propTypes = {
  options: T.array.isRequired,
  selected: T.string.isRequired,
  error: T.string
};

M_Dropdown.defaultProps = {};

exports.default = (0, _reactOnclickoutside2.default)(M_Dropdown);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _A_InputText_H_ = __webpack_require__(197);

var _A_InputText_H_2 = _interopRequireDefault(_A_InputText_H_);

var _A_Btn_H_ = __webpack_require__(196);

var _A_Btn_H_2 = _interopRequireDefault(_A_Btn_H_);

var _SimpleForm = __webpack_require__(66);

var _SimpleForm2 = _interopRequireDefault(_SimpleForm);

var _M_SocialLinks_F = __webpack_require__(200);

var _M_SocialLinks_F2 = _interopRequireDefault(_M_SocialLinks_F);

__webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_SimpleForm_H_3');

var HOC_CONFIG = {
  fieldNames: ['email'],
  validations: {
    email: ['required', 'email']
  }
};

var FIELDS_CONFIG = [{
  fieldName: 'email',
  placeholder: 'Leave your e-mail'
}];

var O_SubscribeForm = function (_Component) {
  (0, _inherits3.default)(O_SubscribeForm, _Component);

  function O_SubscribeForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, O_SubscribeForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = O_SubscribeForm.__proto__ || (0, _getPrototypeOf2.default)(O_SubscribeForm)).call.apply(_ref, [this].concat(args))), _this), _this._createInputs = function (fieldsConfig) {
      return fieldsConfig.map(function (_ref2) {
        var fieldName = _ref2.fieldName,
            placeholder = _ref2.placeholder;
        return _react2.default.createElement(_A_InputText_H_2.default, {
          key: fieldName + '_field',
          value: _this.props.fields[fieldName].value,
          onChange: true,
          placeholder: placeholder,
          error: _this.props.fields[fieldName].error,
          handleChange: function handleChange(text) {
            return _this.props.onFieldChange(fieldName, text);
          }
        });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(O_SubscribeForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          mix = _props.mix,
          formHasErrors = _props.formHasErrors,
          handleSubmit = _props.handleSubmit,
          submited = _props.submited;


      return _react2.default.createElement(
        'div',
        null,
        submited ? _react2.default.createElement(
          'div',
          { className: cn('submitted') },
          _react2.default.createElement(
            'div',
            { className: 'hf' },
            'Great that we are friends now!'
          ),
          _react2.default.createElement(
            'div',
            { className: 'hf-2' },
            _react2.default.createElement(_M_SocialLinks_F2.default, { mix: cn('social-links'), type: 'section' })
          )
        ) : _react2.default.createElement(
          'form',
          { className: cn([mix]), onSubmit: handleSubmit },
          this._createInputs(FIELDS_CONFIG),
          _react2.default.createElement(
            _A_Btn_H_2.default,
            {
              mix: cn('submit-btn'),
              formHasErrors: formHasErrors,
              type: 'submit'
            },
            'JOIN US'
          )
        )
      );
    }
  }]);
  return O_SubscribeForm;
}(_react.Component);

exports.default = (0, _SimpleForm2.default)(O_SubscribeForm, HOC_CONFIG);

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(790);

var _utils = __webpack_require__(1);

var _A_H = __webpack_require__(20);

var _A_H2 = _interopRequireDefault(_A_H);

var _A_Link = __webpack_require__(37);

var _A_Link2 = _interopRequireDefault(_A_Link);

var _A_Container = __webpack_require__(16);

var _A_Container2 = _interopRequireDefault(_A_Container);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('O_TextUsHere');


var O_TextUsHere = function O_TextUsHere(_ref) {
  var title = _ref.title,
      text = _ref.text,
      _ref$link = _ref.link,
      url = _ref$link.url,
      linkText = _ref$link.linkText;

  return _react2.default.createElement(
    _A_Container2.default,
    { type: 'equal' },
    _react2.default.createElement(
      'div',
      { className: cn('root') },
      _react2.default.createElement(
        _A_H2.default,
        { type: 'section' },
        title
      ),
      _react2.default.createElement(
        'span',
        { className: cn('subtitle') },
        text
      ),
      _react2.default.createElement(
        _A_Link2.default,
        { to: url, target: '_blank', type: 'section-link' },
        linkText
      )
    )
  );
};

O_TextUsHere.propTypes = {
  title: T.string.isRequired,
  text: T.string.isRequired,
  link: T.shape({
    linkText: T.string,
    url: T.string
  })
};

O_TextUsHere.defaultProps = {
  title: '',
  text: '',
  link: {
    linkText: '',
    url: ''
  }
};
exports.default = O_TextUsHere;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

__webpack_require__(792);

var _utils = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cn = (0, _utils.cssClassName)('TeleFooter');

var TeleFooter = function (_React$Component) {
  (0, _inherits3.default)(TeleFooter, _React$Component);

  function TeleFooter(props) {
    (0, _classCallCheck3.default)(this, TeleFooter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TeleFooter.__proto__ || (0, _getPrototypeOf2.default)(TeleFooter)).call(this, props));

    _this.setCookie = function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    _this.toggleTelegramBar = function (e) {
      e.preventDefault();
      _this.setState({ isHidden: !_this.state.isHidden });
      if (window.innerWidth < 750) {
        window.Intercom("boot", { app_id: "y9l4iy41" });
      }
    };

    _this.handleLinkClick = function (e) {
      if (window.ga) window.ga('send', 'event', 'other', 'telegram-btn-click');
      if (window.fbq) window.fbq('trackCustom', 'telegramToolBarClick');
      _this.setState({ isHidden: !_this.state.isHidden });
      if (window.innerWidth < 750) {
        window.Intercom("boot", { app_id: "y9l4iy41" });
      }
      _this.setCookie("telegaHidden", 1, 100);
    };

    _this.state = {
      isHidden: false
    };
    return _this;
  }

  (0, _createClass3.default)(TeleFooter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: cn('tele-footer', this.state.isHidden ? 'is-hidden' : '') },
        _react2.default.createElement(
          'div',
          { className: 'tele-title' },
          'Join Our Channel ',
          _react2.default.createElement('br', null),
          'with Secret News'
        ),
        _react2.default.createElement(
          'a',
          { className: 'tele-button', href: 'https://t.me/hmqtalk', target: '_blank', onClick: function onClick() {
              _this2.handleLinkClick();
            } },
          'Join our Telegram'
        ),
        _react2.default.createElement(
          'div',
          { className: 'close', onClick: this.toggleTelegramBar },
          _react2.default.createElement(
            'svg',
            { width: '19', height: '20', viewBox: '0 0 19 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            _react2.default.createElement('line', { y1: '-0.5', x2: '25', y2: '-0.5', transform: 'translate(0 1) rotate(45)', stroke: '#ffffff' }),
            _react2.default.createElement('line', { y1: '-0.5', x2: '25', y2: '-0.5', transform: 'translate(17.6777 1) rotate(135)',
              stroke: '#ffffff' })
          )
        )
      );
    }
  }]);
  return TeleFooter;
}(_react2.default.Component);

exports.default = TeleFooter;


TeleFooter.propTypes = {
  mix: T.string //BEM mixin from parent block
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(90);

var _reactHotLoader = __webpack_require__(298);

var _App = __webpack_require__(297);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootEl = document.getElementById('container');

(0, _reactDom.render)(_react2.default.createElement(
  _reactHotLoader.AppContainer,
  null,
  _react2.default.createElement(_App2.default, null)
), rootEl, function () {
  delete window.__INITIAL_STATE__;
});

if (false) {
  module.hot.accept('./App', function () {

    var NextApp = require('./App').default;
    (0, _reactDom.render)(_react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(NextApp, null)
    ), rootEl);
  });
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(317);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutRoute = function (_Component) {
  (0, _inherits3.default)(AboutRoute, _Component);

  function AboutRoute() {
    (0, _classCallCheck3.default)(this, AboutRoute);
    return (0, _possibleConstructorReturn3.default)(this, (AboutRoute.__proto__ || (0, _getPrototypeOf2.default)(AboutRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(AboutRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return AboutRoute;
}(_react.Component);

exports.default = AboutRoute;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(320);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(205);

var _actions2 = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmbassadorsRoute = function (_Component) {
  (0, _inherits3.default)(AmbassadorsRoute, _Component);

  function AmbassadorsRoute() {
    (0, _classCallCheck3.default)(this, AmbassadorsRoute);
    return (0, _possibleConstructorReturn3.default)(this, (AmbassadorsRoute.__proto__ || (0, _getPrototypeOf2.default)(AmbassadorsRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(AmbassadorsRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions2.setTheme)('dark'));

      //if(__SERVER__) {
      //  return dispatch(fetchAmbassadors())
      //}
    }
  }]);
  return AmbassadorsRoute;
}(_react.Component);

exports.default = AmbassadorsRoute;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(324);

var _container2 = _interopRequireDefault(_container);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

var _actions = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnniversaryRoute = function (_Component) {
  (0, _inherits3.default)(AnniversaryRoute, _Component);

  function AnniversaryRoute() {
    (0, _classCallCheck3.default)(this, AnniversaryRoute);
    return (0, _possibleConstructorReturn3.default)(this, (AnniversaryRoute.__proto__ || (0, _getPrototypeOf2.default)(AnniversaryRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(AnniversaryRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return AnniversaryRoute;
}(_react.Component);

exports.default = AnniversaryRoute;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(135);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _container = __webpack_require__(368);

var _container2 = _interopRequireDefault(_container);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

var _actions = __webpack_require__(15);

var _actions2 = __webpack_require__(543);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppRoute = function (_Component) {
  (0, _inherits3.default)(AppRoute, _Component);

  function AppRoute() {
    (0, _classCallCheck3.default)(this, AppRoute);
    return (0, _possibleConstructorReturn3.default)(this, (AppRoute.__proto__ || (0, _getPrototypeOf2.default)(AppRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _container2.default,
        null,
        this.props.children
      );
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref, query, params, location) {
      var dispatch = _ref.dispatch,
          getState = _ref.getState;

      if (true) {
        var state = getState();
        //state.wikiArticles.loaded || dispatch(fetchWiki())
        //state.partners.loaded || dispatch(fetchPartners())
        //state.ambassadors.loaded || dispatch(fetchAmbassadors())
      }

      if ((0, _initialLoad2.default)()) return;
      return _promise2.default.all([dispatch((0, _actions.setRoute)(location.pathname))]
      //dispatch(fetchUserNumber())
      );
    }
  }]);
  return AppRoute;
}(_react.Component);
//import {fetchWiki} from 'store/entities/wikiArticles/actions';
//import {fetchAmbassadors} from 'store/entities/ambassadors/actions'
//import {fetchPartners} from 'store/entities/partners/actions'


AppRoute.propTypes = {
  children: T.any.isRequired
};

exports.default = AppRoute;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var T = _interopRequireWildcard(_propTypes);

var _container = __webpack_require__(372);

var _container2 = _interopRequireDefault(_container);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

var _actions = __webpack_require__(15);

var _actions2 = __webpack_require__(548);

var _actions3 = __webpack_require__(205);

var _actions4 = __webpack_require__(546);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppRoute = function (_Component) {
  (0, _inherits3.default)(AppRoute, _Component);

  function AppRoute() {
    (0, _classCallCheck3.default)(this, AppRoute);
    return (0, _possibleConstructorReturn3.default)(this, (AppRoute.__proto__ || (0, _getPrototypeOf2.default)(AppRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _container2.default,
        null,
        this.props.children
      );
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref, query, params, location) {
      var dispatch = _ref.dispatch,
          getState = _ref.getState;

      if (true) {
        var state = getState();
        //state.wikiArticles.loaded || dispatch(fetchWiki())
        //state.partners.loaded || dispatch(fetchPartners())
        //state.ambassadors.loaded || dispatch(fetchAmbassadors())
      }

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setRoute)(location.pathname));
    }
  }]);
  return AppRoute;
}(_react.Component);

AppRoute.propTypes = {
  children: T.any.isRequired
};

exports.default = AppRoute;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(326);

var _container2 = _interopRequireDefault(_container);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

var _actions = __webpack_require__(521);

var _actions2 = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CareersRoute = function (_Component) {
  (0, _inherits3.default)(CareersRoute, _Component);

  function CareersRoute() {
    (0, _classCallCheck3.default)(this, CareersRoute);
    return (0, _possibleConstructorReturn3.default)(this, (CareersRoute.__proto__ || (0, _getPrototypeOf2.default)(CareersRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(CareersRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      dispatch((0, _actions2.setTheme)('dark'));

      // if(initialLoad()) return;
      // return(
      //   dispatch(fetchCareers())
      // )
    }
  }]);
  return CareersRoute;
}(_react.Component);

exports.default = CareersRoute;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(328);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CareersItemRoute = function (_Component) {
  (0, _inherits3.default)(CareersItemRoute, _Component);

  function CareersItemRoute() {
    (0, _classCallCheck3.default)(this, CareersItemRoute);
    return (0, _possibleConstructorReturn3.default)(this, (CareersItemRoute.__proto__ || (0, _getPrototypeOf2.default)(CareersItemRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(CareersItemRoute, [{
    key: 'render',
    value: function render() {
      var jobId = this.props.params.jobId;

      return _react2.default.createElement(_container2.default, { id: jobId });
    }
  }]);
  return CareersItemRoute;
}(_react.Component);

exports.default = CareersItemRoute;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.careers = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(24);

var _Careers = __webpack_require__(495);

var _Careers2 = _interopRequireDefault(_Careers);

var _CareersItem = __webpack_require__(496);

var _CareersItem2 = _interopRequireDefault(_CareersItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// layout uses index route prepare data hook

var careers = exports.careers = _react2.default.createElement(
  _reactRouter.Route,
  {
    path: 'careers'
    // prepareData={Careers.prepareData}
  },
  _react2.default.createElement(_reactRouter.IndexRoute, {
    component: _Careers2.default
  }),
  _react2.default.createElement(_reactRouter.Route, { path: ':jobId', component: _CareersItem2.default })
);

exports.default = careers;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(330);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactUsRoute = function (_Component) {
  (0, _inherits3.default)(ContactUsRoute, _Component);

  function ContactUsRoute() {
    (0, _classCallCheck3.default)(this, ContactUsRoute);
    return (0, _possibleConstructorReturn3.default)(this, (ContactUsRoute.__proto__ || (0, _getPrototypeOf2.default)(ContactUsRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContactUsRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return ContactUsRoute;
}(_react.Component);

exports.default = ContactUsRoute;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(332);

var _container2 = _interopRequireDefault(_container);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeeplinkRoute = function (_Component) {
  (0, _inherits3.default)(DeeplinkRoute, _Component);

  function DeeplinkRoute() {
    (0, _classCallCheck3.default)(this, DeeplinkRoute);
    return (0, _possibleConstructorReturn3.default)(this, (DeeplinkRoute.__proto__ || (0, _getPrototypeOf2.default)(DeeplinkRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(DeeplinkRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }]);
  return DeeplinkRoute;
}(_react.Component);

exports.default = DeeplinkRoute;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _page = __webpack_require__(334);

var _page2 = _interopRequireDefault(_page);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorRoute = function (_Component) {
  (0, _inherits3.default)(ErrorRoute, _Component);

  function ErrorRoute() {
    (0, _classCallCheck3.default)(this, ErrorRoute);
    return (0, _possibleConstructorReturn3.default)(this, (ErrorRoute.__proto__ || (0, _getPrototypeOf2.default)(ErrorRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(ErrorRoute, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          err = _props.params.err,
          _props$location$query = _props.location.query,
          url = _props$location$query.url,
          error = _props$location$query.error;

      return _react2.default.createElement(_page2.default, { err: err, url: url, error: error });
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return ErrorRoute;
}(_react.Component);

ErrorRoute.propTypes = {
  params: _propTypes2.default.shape({
    err: _propTypes2.default.string
  }).isRequired
};

exports.default = ErrorRoute;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(335);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FrequentlyAskedQuestionsRoute = function (_Component) {
  (0, _inherits3.default)(FrequentlyAskedQuestionsRoute, _Component);

  function FrequentlyAskedQuestionsRoute() {
    (0, _classCallCheck3.default)(this, FrequentlyAskedQuestionsRoute);
    return (0, _possibleConstructorReturn3.default)(this, (FrequentlyAskedQuestionsRoute.__proto__ || (0, _getPrototypeOf2.default)(FrequentlyAskedQuestionsRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(FrequentlyAskedQuestionsRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return FrequentlyAskedQuestionsRoute;
}(_react.Component);

exports.default = FrequentlyAskedQuestionsRoute;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(337);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import initialLoad from 'utils/initialLoad'

var HomeRoute = function (_Component) {
  (0, _inherits3.default)(HomeRoute, _Component);

  function HomeRoute() {
    (0, _classCallCheck3.default)(this, HomeRoute);
    return (0, _possibleConstructorReturn3.default)(this, (HomeRoute.__proto__ || (0, _getPrototypeOf2.default)(HomeRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }]);
  return HomeRoute;
}(_react.Component);

exports.default = HomeRoute;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(355);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HumaniqReport2018Route = function (_Component) {
  (0, _inherits3.default)(HumaniqReport2018Route, _Component);

  function HumaniqReport2018Route() {
    (0, _classCallCheck3.default)(this, HumaniqReport2018Route);
    return (0, _possibleConstructorReturn3.default)(this, (HumaniqReport2018Route.__proto__ || (0, _getPrototypeOf2.default)(HumaniqReport2018Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(HumaniqReport2018Route, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return HumaniqReport2018Route;
}(_react.Component);

exports.default = HumaniqReport2018Route;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(357);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactUsRoute = function (_Component) {
  (0, _inherits3.default)(ContactUsRoute, _Component);

  function ContactUsRoute() {
    (0, _classCallCheck3.default)(this, ContactUsRoute);
    return (0, _possibleConstructorReturn3.default)(this, (ContactUsRoute.__proto__ || (0, _getPrototypeOf2.default)(ContactUsRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContactUsRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return ContactUsRoute;
}(_react.Component);

exports.default = ContactUsRoute;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(359);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstExchange2Route = function (_Component) {
  (0, _inherits3.default)(InstExchange2Route, _Component);

  function InstExchange2Route() {
    (0, _classCallCheck3.default)(this, InstExchange2Route);
    return (0, _possibleConstructorReturn3.default)(this, (InstExchange2Route.__proto__ || (0, _getPrototypeOf2.default)(InstExchange2Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(InstExchange2Route, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return InstExchange2Route;
}(_react.Component);

exports.default = InstExchange2Route;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(361);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalRoute = function (_Component) {
  (0, _inherits3.default)(LegalRoute, _Component);

  function LegalRoute() {
    (0, _classCallCheck3.default)(this, LegalRoute);
    return (0, _possibleConstructorReturn3.default)(this, (LegalRoute.__proto__ || (0, _getPrototypeOf2.default)(LegalRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(LegalRoute, [{
    key: 'render',
    value: function render() {
      var page = this.props.route.path;
      return _react2.default.createElement(_container2.default, { page: page });
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return LegalRoute;
}(_react.Component);

exports.default = LegalRoute;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(24);

var _Legal = __webpack_require__(506);

var _Legal2 = _interopRequireDefault(_Legal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legal = _react2.default.createElement(
  _reactRouter.Route,
  { path: 'legal', prepareData: _Legal2.default.prepareData },
  _react2.default.createElement(_reactRouter.Route, { path: 'general-privacy-policy', component: _Legal2.default, section: 'general-privacy-policy' }),
  _react2.default.createElement(_reactRouter.Route, { path: 'data-privacy-policy', component: _Legal2.default, section: 'general-privacy-policy' }),
  _react2.default.createElement(_reactRouter.Route, { path: 'user-terms-of-service', component: _Legal2.default, section: 'general-privacy-policy' })
);

exports.default = Legal;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(434);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import initialLoad from 'utils/initialLoad'

var News1Route = function (_Component) {
  (0, _inherits3.default)(News1Route, _Component);

  function News1Route() {
    (0, _classCallCheck3.default)(this, News1Route);
    return (0, _possibleConstructorReturn3.default)(this, (News1Route.__proto__ || (0, _getPrototypeOf2.default)(News1Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(News1Route, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }]);
  return News1Route;
}(_react.Component);

exports.default = News1Route;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(374);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import initialLoad from 'utils/initialLoad'

var News1Route = function (_Component) {
  (0, _inherits3.default)(News1Route, _Component);

  function News1Route() {
    (0, _classCallCheck3.default)(this, News1Route);
    return (0, _possibleConstructorReturn3.default)(this, (News1Route.__proto__ || (0, _getPrototypeOf2.default)(News1Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(News1Route, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }]);
  return News1Route;
}(_react.Component);

exports.default = News1Route;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(394);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import initialLoad from 'utils/initialLoad'

var News1Route = function (_Component) {
  (0, _inherits3.default)(News1Route, _Component);

  function News1Route() {
    (0, _classCallCheck3.default)(this, News1Route);
    return (0, _possibleConstructorReturn3.default)(this, (News1Route.__proto__ || (0, _getPrototypeOf2.default)(News1Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(News1Route, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }]);
  return News1Route;
}(_react.Component);

exports.default = News1Route;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(414);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import initialLoad from 'utils/initialLoad'

var News1Route = function (_Component) {
  (0, _inherits3.default)(News1Route, _Component);

  function News1Route() {
    (0, _classCallCheck3.default)(this, News1Route);
    return (0, _possibleConstructorReturn3.default)(this, (News1Route.__proto__ || (0, _getPrototypeOf2.default)(News1Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(News1Route, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }]);
  return News1Route;
}(_react.Component);

exports.default = News1Route;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(454);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(15);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenSourceRoute = function (_Component) {
  (0, _inherits3.default)(OpenSourceRoute, _Component);

  function OpenSourceRoute() {
    (0, _classCallCheck3.default)(this, OpenSourceRoute);
    return (0, _possibleConstructorReturn3.default)(this, (OpenSourceRoute.__proto__ || (0, _getPrototypeOf2.default)(OpenSourceRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(OpenSourceRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return OpenSourceRoute;
}(_react.Component);

exports.default = OpenSourceRoute;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(457);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wiki0Route = function (_Component) {
  (0, _inherits3.default)(Wiki0Route, _Component);

  function Wiki0Route() {
    (0, _classCallCheck3.default)(this, Wiki0Route);
    return (0, _possibleConstructorReturn3.default)(this, (Wiki0Route.__proto__ || (0, _getPrototypeOf2.default)(Wiki0Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(Wiki0Route, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_container2.default, null);
    }
  }]);
  return Wiki0Route;
}(_react.Component);

exports.default = Wiki0Route;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(459);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wiki0Route = function (_Component) {
  (0, _inherits3.default)(Wiki0Route, _Component);

  function Wiki0Route() {
    (0, _classCallCheck3.default)(this, Wiki0Route);
    return (0, _possibleConstructorReturn3.default)(this, (Wiki0Route.__proto__ || (0, _getPrototypeOf2.default)(Wiki0Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(Wiki0Route, [{
    key: 'render',
    value: function render() {
      var level0 = this.props.params.level0;


      return _react2.default.createElement(_container2.default, { level0: level0 });
    }
  }]);
  return Wiki0Route;
}(_react.Component);

exports.default = Wiki0Route;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(461);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wiki0Route = function (_Component) {
  (0, _inherits3.default)(Wiki0Route, _Component);

  function Wiki0Route() {
    (0, _classCallCheck3.default)(this, Wiki0Route);
    return (0, _possibleConstructorReturn3.default)(this, (Wiki0Route.__proto__ || (0, _getPrototypeOf2.default)(Wiki0Route)).apply(this, arguments));
  }

  (0, _createClass3.default)(Wiki0Route, [{
    key: 'render',
    value: function render() {
      var _props$params = this.props.params,
          level0 = _props$params.level0,
          id = _props$params.id;


      return _react2.default.createElement(_container2.default, { level0: level0, id: id });
    }
  }]);
  return Wiki0Route;
}(_react.Component);

exports.default = Wiki0Route;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(463);

var _container2 = _interopRequireDefault(_container);

var _initialLoad = __webpack_require__(21);

var _initialLoad2 = _interopRequireDefault(_initialLoad);

var _actions = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {fetchWiki} from "entities/wikiArticles/actions";
var WikiLayoutRoute = function (_Component) {
  (0, _inherits3.default)(WikiLayoutRoute, _Component);

  function WikiLayoutRoute() {
    (0, _classCallCheck3.default)(this, WikiLayoutRoute);
    return (0, _possibleConstructorReturn3.default)(this, (WikiLayoutRoute.__proto__ || (0, _getPrototypeOf2.default)(WikiLayoutRoute)).apply(this, arguments));
  }

  (0, _createClass3.default)(WikiLayoutRoute, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _container2.default,
        null,
        this.props.children
      );
    }
  }], [{
    key: 'prepareData',
    value: function prepareData(_ref) {
      var dispatch = _ref.dispatch;

      //if(__SERVER__){
      //  dispatch(fetchWiki())
      //}
      if ((0, _initialLoad2.default)()) return;
      dispatch((0, _actions.setTheme)('dark'));
    }
  }]);
  return WikiLayoutRoute;
}(_react.Component);

exports.default = WikiLayoutRoute;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(24);

var _WikiLayout = __webpack_require__(516);

var _WikiLayout2 = _interopRequireDefault(_WikiLayout);

var _Wiki = __webpack_require__(513);

var _Wiki2 = _interopRequireDefault(_Wiki);

var _Wiki3 = __webpack_require__(514);

var _Wiki4 = _interopRequireDefault(_Wiki3);

var _Wiki5 = __webpack_require__(515);

var _Wiki6 = _interopRequireDefault(_Wiki5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import WikiSearch from './WikiSearch'

//import {cleanWikiSearch} from 'store/entities/wikiSearch/actions'
var Wiki = function Wiki(store) {
  return _react2.default.createElement(
    _reactRouter.Route,
    {
      path: 'wiki',
      component: _WikiLayout2.default,
      prepareData: _WikiLayout2.default.prepareData

    },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Wiki2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':level0' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Wiki4.default }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _Wiki6.default })
    )
  );
};

exports.default = Wiki;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(24);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _About = __webpack_require__(490);

var _About2 = _interopRequireDefault(_About);

var _App = __webpack_require__(493);

var _App2 = _interopRequireDefault(_App);

var _App_old = __webpack_require__(494);

var _App_old2 = _interopRequireDefault(_App_old);

var _Home = __webpack_require__(502);

var _Home2 = _interopRequireDefault(_Home);

var _Error = __webpack_require__(500);

var _Error2 = _interopRequireDefault(_Error);

var _ContactUs = __webpack_require__(498);

var _ContactUs2 = _interopRequireDefault(_ContactUs);

var _Legal = __webpack_require__(507);

var _Legal2 = _interopRequireDefault(_Legal);

var _OpenSource = __webpack_require__(512);

var _OpenSource2 = _interopRequireDefault(_OpenSource);

var _Ambassadors = __webpack_require__(491);

var _Ambassadors2 = _interopRequireDefault(_Ambassadors);

var _Wiki = __webpack_require__(517);

var _Wiki2 = _interopRequireDefault(_Wiki);

var _Anniversary = __webpack_require__(492);

var _Anniversary2 = _interopRequireDefault(_Anniversary);

var _Careers = __webpack_require__(497);

var _Careers2 = _interopRequireDefault(_Careers);

var _News = __webpack_require__(508);

var _News2 = _interopRequireDefault(_News);

var _News3 = __webpack_require__(510);

var _News4 = _interopRequireDefault(_News3);

var _News5 = __webpack_require__(509);

var _News6 = _interopRequireDefault(_News5);

var _News7 = __webpack_require__(511);

var _News8 = _interopRequireDefault(_News7);

var _InstExchange = __webpack_require__(504);

var _InstExchange2 = _interopRequireDefault(_InstExchange);

var _InstExchange3 = __webpack_require__(505);

var _InstExchange4 = _interopRequireDefault(_InstExchange3);

var _Deeplink = __webpack_require__(499);

var _Deeplink2 = _interopRequireDefault(_Deeplink);

var _FrequentlyAskedQuestions = __webpack_require__(501);

var _FrequentlyAskedQuestions2 = _interopRequireDefault(_FrequentlyAskedQuestions);

var _HumaniqReport = __webpack_require__(503);

var _HumaniqReport2 = _interopRequireDefault(_HumaniqReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import HmqExplorer from './Hmq'
var getRoutes = function getRoutes(store) {
  return _react2.default.createElement(
    _reactRouter.Route,
    {
      path: '/',
      prepareData: _App2.default.prepareData
    },
    _react2.default.createElement(
      _reactRouter.Route,
      {
        component: _App2.default
      },
      _react2.default.createElement(_reactRouter.IndexRoute, {
        component: _Home2.default
      }),
      _Legal2.default,
      _Careers2.default,
      _react2.default.createElement(_reactRouter.Route, { path: 'open-source',
        prepareData: _OpenSource2.default.prepareData,
        component: _OpenSource2.default
      }),
      _react2.default.createElement(_reactRouter.Route, { path: 'ambassadors',
        prepareData: _Ambassadors2.default.prepareData,
        component: _Ambassadors2.default
      }),
      _react2.default.createElement(_reactRouter.Route, { path: 'contact-us',
        component: _ContactUs2.default,
        prepareData: _ContactUs2.default.prepareData

      }),
      _react2.default.createElement(_reactRouter.Route, { path: 'report-2018',
        component: _HumaniqReport2.default,
        prepareData: _HumaniqReport2.default.prepareData

      }),
      _react2.default.createElement(_reactRouter.Route, { path: '/news-1',
        component: _News2.default
      }),
      _react2.default.createElement(_reactRouter.Route, { path: '/news-322',
        component: _News4.default
      }),
      _react2.default.createElement(_reactRouter.Route, { path: '/news-41',
        component: _News8.default
      }),
      _react2.default.createElement(_reactRouter.Route, { path: '/news-21',
        component: _News6.default
      }),
      _react2.default.createElement(_reactRouter.Route, { path: '/exchange',
        component: _InstExchange2.default
      }),
      _react2.default.createElement(_reactRouter.Route, { path: '/hmqexchange',
        component: _InstExchange4.default
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: '/anniversary',
        component: _Anniversary2.default,
        prepareData: _About2.default.prepareData
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: '/about',
        component: _About2.default,
        prepareData: _About2.default.prepareData
      }),
      _react2.default.createElement(_reactRouter.Route, { path: '/faq',
        component: _FrequentlyAskedQuestions2.default,
        prepareData: _FrequentlyAskedQuestions2.default.prepareData

      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: '/error/:err',
        prepareData: _Error2.default.prepareData,
        component: _Error2.default
      })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '/deeplink',
      component: _Deeplink2.default
    }),
    _react2.default.createElement(
      _reactRouter.Route,
      {
        component: _App_old2.default
      },
      (0, _Wiki2.default)(store)
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      {
        component: _App2.default
      },
      _react2.default.createElement(_reactRouter.Route, {
        path: '*',
        prepareData: _Error2.default.prepareData,
        component: _Error2.default
      })
    )
  );
};

exports.default = getRoutes;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(28);

var _rootReducer = __webpack_require__(556);

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _error = __webpack_require__(555);

var _error2 = _interopRequireDefault(_error);

var _humaniqBackendApi = __webpack_require__(75);

var _humaniqBackendApi2 = _interopRequireDefault(_humaniqBackendApi);

var _butterCmsApi = __webpack_require__(206);

var _butterCmsApi2 = _interopRequireDefault(_butterCmsApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _redux.applyMiddleware)(_humaniqBackendApi2.default, _butterCmsApi2.default, _error2.default);

var store = function store() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _redux.createStore)(_rootReducer2.default, initialState, enhancer);
};

exports.default = store;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _constants = __webpack_require__(12);

var _api = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initAmbassadors = {
  entities: [],
  loaded: false,
  data: {
    ambassadors: [{
      name: "Achille Agbe Julien",
      country: "Cote d�Ivoire",
      bio: "Achille graduated from the Abidjan University and EDHEC Business School with a final degree in Private Business Law (Master). Has gained an MBA and also runs his own consulting firm (Ismarten Ltd). Achille acts as the Managing Director of EIC Corporation.",
      picLink: "/pics/AchilleAgbeJulien.png",
      picLink2x: "/pics/AchilleAgbeJulien_2x.png"
    }, {
      name: "Adewale Bankolo",
      country: "Nigeria",
      bio: "Adewale Bankolo is a prominent Nigerian Libertarian. Adewale describes himself as \"very passionate about issues pertaining to entrepreneurship, free market, cryptocurrency, and financial inclusion\". He is the Chapter Director (Nigeria) at the Bastiat Society - an international society of principled wealth creators.",
      picLink: "/pics/AdewaleBankolo.png",
      picLink2x: "/pics/AdewaleBankolo_2x.png"
    }, {
      name: "Alakanani Itireleng",
      country: "Botswana",
      bio: "Alakanani is a qualified teacher. She has a BA in humanities, Post Graduate Diploma in Education and MBA in international business. Alakanani is an entrepreneur, she runs a blockchain technology hub Satoshicentre. Alakanani is a bitcoin enthusiastic and trainer.",
      picLink: "/pics/AlakananiItireleng.png",
      picLink2x: "/pics/AlakananiItireleng_2x.png"
    }, {
      name: "Bashir Aminu",
      country: "Nigeria",
      bio: "Founder of Cryptogene, the largest cryptocurrency community in Africa and a hub that aims at the application and use of blockchain tools by producing quality products and end-user services valuable to enthusiastic and engaged individuals.",
      picLink: "/pics/BashirAminu.png",
      picLink2x: "/pics/BashirAminu_2x.png"
    }, {
      name: "Chernoh Saeed Sow",
      country: "Sierra Leone",
      bio: "CEO and founder of the Sierra Leone Bitcoin Network � SLBNet and also the Africoin Report blog on the Let�s Talk Bitcoin Network website. He is a tech entrepreneur and a bitcoin savvy person who has also been involved in many projects to help spread bitcoin knowledge in Sierra Leone and Africa as a whole.",
      picLink: "/pics/ChernohSaeedSow.png",
      picLink2x: "/pics/ChernohSaeedSow_2x.png"
    }, {
      name: "Donald Madzinga",
      country: "South Africa",
      bio: "Donald was born in Zimbabwe but he currently lives in South Africa. He trades currencies as well as provides consultancy on Blockchain technology to corporates.",
      picLink: "/pics/DonaldMadzinga.png",
      picLink2x: "/pics/DonaldMadzinga_2x.png"
    }, {
      name: "Itumeleng Isaac Lejone",
      country: "Lesotho",
      bio: "Itumeleng is a founder and CEO of IIL Capital - an investment company that focuses on venture capitalism for upcoming entrepreneurs. They also partner with other technology companies to build IOT, blockchain, games and other technology products.",
      picLink: "/pics/ItumelengIsaacLejone.png",
      picLink2x: "/pics/ItumelengIsaacLejone_2x.png"
    }, {
      name: "Karabo Segale",
      country: "South Africa",
      bio: "Karabo was born in South Africa and lives in North West Province in a small town called Rustenburg in Ramoga Village. Is an Ambassador for Humaniq, a businessman, is into trading and mining Bitcoins.",
      picLink: "/pics/KaraboSegale.png",
      picLink2x: "/pics/KaraboSegale_2x.png"
    }, {
      name: "Kayode Babarinde",
      country: "Nigeria",
      bio: "Kayode is currently working on \"Cryptocurrency and Blockchain Technology\" as his Masters project at the Centre for Entrepreneurship and Innovation, University of Ibadan, Nigeria.",
      picLink: "/pics/KayodeBabarinde.png",
      picLink2x: "/pics/KayodeBabarinde_2x.png"
    }, {
      name: "Koketso Pelo",
      country: "Botswana",
      bio: "Koketso is a director at Satoshi centre and is also studying software engineering in the Limkokwing University, with the area of interest in cryptocurrency and blockchain technology.",
      picLink: "/pics/KoketsoPelo.png",
      picLink2x: "/pics/KoketsoPelo_2x.png"
    }, {
      name: "Mogopodi Phiri",
      country: "South Africa",
      bio: "Technician with both scientific and engineering backgrounds. In 2015 he was introduced to Bitcoin and studied crypto-currencies and Blockchain technology and its applications through the internet, networking and joining crypto-currency discussion groups on different social media platforms.",
      picLink: "/pics/MogopodiPhiri.png",
      picLink2x: "/pics/MogopodiPhiri_2x.png"
    }, {
      name: "Mohammed Bukar",
      country: "Nigeria",
      bio: "Mohammed is a Humaniq Ambassador representing Abuja, Nigeria. He has a degree in Computer science and Masters in Information systems. Mohammed is also a crypto currency and blockchain enthusiast.",
      picLink: "/pics/MohammedBukar.png",
      picLink2x: "/pics/MohammedBukar_2x.png"
    }, {
      name: "Noah Roger Justin",
      country: "Cameroon",
      bio: "Noah is a cryptocurrency investor and trader, running bitcoin educational courses.",
      picLink: "/pics/NoahRogerJustin.png",
      picLink2x: "/pics/NoahRogerJustin_2x.png"
    }, {
      name: "Oladimeji Shekoni",
      country: "Nigeria",
      bio: "Oladimeji is a counselling Psychotherapist in Philadelphia Specialist Hospital, Lagos. Entrepreneur, Crypto-Enthusiast.",
      picLink: "/pics/OladimejiShekoni.png",
      picLink2x: "/pics/OladimejiShekoni_2x.png"
    }, {
      name: "Peter Samson",
      country: "Botswana",
      bio: "IT entrepreneur born in Mwanza region, currently living in Dar es Salaam region Tanzania. Peter has opened a Meetup group about Bitcoin just to bring bitcoiners together to discuss ways on how Bitcoin can be implemented in Tanzania. They prepared the Coinfest as a Bitcoin tradition to celebrate and exchange ideas about Bitcoin.",
      picLink: "/pics/PeterSamson.png",
      picLink2x: "/pics/PeterSamson_2x.png"
    }, {
      name: "Philip Agyei Asare",
      country: "Ghana",
      bio: "Philip is the Founder and CEO of Pak Universal Services and the founder of Dream Foundation Ghana, a non-profit created to empower young entrepreneurs, whom he says are the intellectual, social and cultural lifeblood of a country. Philip is also a member of the Conscious Entrepreneurship Foundation.",
      picLink: "/pics/PhilipAgyeiAsare.png",
      picLink2x: "/pics/PhilipAgyeiAsare_2x.png"
    }, {
      name: "Roderick P. Clantina",
      country: "Phillippines",
      bio: "Roderick is a private employee as an inventory assistant, but his area of interest is cryptocurrency and financial inclusion.",
      picLink: "/pics/RoderickPClantina.png",
      picLink2x: "/pics/RoderickPClantina_2x.png"
    }]
  }
};

function addUrl(arr) {
  return arr.map(function (_ref) {
    var picLink2x = _ref.picLink2x,
        other = (0, _objectWithoutProperties3.default)(_ref, ['picLink2x']);

    return (0, _extends3.default)({}, other, {
      logoLink2x: _api.ENPOINT_AMBASSADORS + picLink2x
    });
  });
}

exports.default = function () {
  var ambassadors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initAmbassadors;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      data = _ref2.data;

  return (0, _extends3.default)({}, ambassadors, { loaded: true, entities: addUrl(initAmbassadors.data.ambassadors)

    /*switch (type) {
      case FETCH + AMBASSADORS + SUCCESS:
        return {...ambassadors, loaded: true, entities: addUrl(data.ambassadors)}
    }
     return ambassadors;*/
  });
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.fetchCareers = fetchCareers;

var _helpers = __webpack_require__(109);

var _constants = __webpack_require__(12);

var _humaniqBackendApi = __webpack_require__(75);

var _api = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCareers() {
  return (0, _defineProperty3.default)({}, _humaniqBackendApi.BACKEND_CALL, {
    endpoint: _api.ENDPOINT_CAREERS,
    method: 'GET',
    types: (0, _helpers.createFetchActions)(_constants.CAREERS)
  });
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateFormat = function dateFormat(date) {
  return (0, _moment2.default)(date).local().format('DD/MM/YYYY');
}; // import {numberFormat} from 'utils'


var mapper = function mapper() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return data.map(function (_ref) {
    var updatedAt = _ref.updatedAt,
        createdAt = _ref.createdAt,
        other = (0, _objectWithoutProperties3.default)(_ref, ['updatedAt', 'createdAt']);
    return (0, _extends3.default)({
      createdAt: dateFormat(createdAt),
      edited: createdAt !== updatedAt
    }, other);
  });
};

exports.default = mapper;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(522);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var careersInit = {
  loading: false,
  loaded: false,
  entities: [{
    createdAt: "23/04/2018",
    edited: true,
    _id: "5addeecdc46dec3930725430",
    title: "Head of Analytics and Targeting ",
    body: "<h3>Duties and responsibilities:</h3>\n<p>● Procurement of native advertising<br />● Purchase of banner advertising<br />● CPA<br />● Purchase of video advertising<br />● Working on analytics and conversion optimisation<br />● Distribution of traffic via affiliate programs<br />● Testing / developing of creative content<br />● Cooperation with PR, SMM and trading departments<br />● Retargeting&nbsp;</p>\n<br/><h3>Required skills:</h3>\n<p>● Experience in working with crypto-currency projects<br />● Experience in working with end-to-end analytics systems<br />● Analytical mindset<br />● Experience in working with crypto-exchange partner networks<br />● Ability to perform tasks quickly and accurately<br />● Ability to bypass FB and Google limitations<br />● Punctuality and diligence<br />● Experience in working with analytics systems other than GA (Ninjacat, Mixpanel, Thrivehive, Looker, Funnel.io, Bizible, Maroon.ai)<br />● Spoken English, along with German, French, Korean and Chinese<br />● Ability and willingness to relocate - preferre&nbsp;</p>\n",
    subtitle: "(Post-ICO Marketing) ",
    visible: true
  }, {
    createdAt: "28/04/2018",
    edited: false,
    _id: "5ae4573bc46dec3930725432",
    title: "Head of PR ",
    body: "<p><strong>Duties and responsibilities:</strong><br />● Generation of info traffic<br />● Progressing tasks from the initial data input stage to a published article with the shortest possible turnaround<br />● Co-operation with content producers and SMM manager<br />● Working with analytical systems (Meltwater, Cision, MuckRack, Anewstip, Traackr, Haro, hey.press)<br />● Online liaison with partners (exchanges, exchange points)</p>\n<br/><p><strong>Required skills:</strong><br />● Experience in working with crypto-currency media (selection criteria - a portfolio of case studies to hand)<br />● Availability of own database of journalist contacts<br />● Prior experience in working with top-tier financial publications<br />● Creativity, good imagination<br />● Knowledge of the financial market and commercial terminology<br />● Locating startups, finances, and crypto-currency projects within the market context<br />● Spoken English, along with German, French, Korean and Chinese<br />● Knowledge of the unbanked market - bonus&nbsp;<br />● Contacts in alternative blockchain projects - bonus&nbsp;<br />● A desire to develop and grow professionally, openness, zest&nbsp;</p>\n",
    subtitle: "",
    visible: true
  }, {
    createdAt: "28/04/2018",
    edited: false,
    _id: "5ae45751c46dec3930725433",
    title: "Head of SMM & Community management",
    body: "<p><strong>Duties and responsibilities:</strong><br />● Working with a community (AMA, webinars, events and competitions, other entertainment)<br />● Maintaining the project social networks - Twitter, Facebook, Instagram, Reddit<br />● Bitcointalk, Reddit forum support<br />● Social networking strategy development&nbsp;<br />● Working with the PR, analytical, traffic and trading departments<br />● Working with Influencers<br />● Working with bounty managers<br />● Company image-making&nbsp;<br />● Working with analytics systems<br />● Post-automation</p>\n<br/><p><strong>Required skills:</strong><br />● Experience in working with crypto-currency projects<br />● Creativity (portfolio of creative content)<br />● Spoken English (German, French, Korean and Chinese will be a bonus)<br />● Knowledge of the unbanked market - bonus<br />● Contacts in other blockchain projects - bonus<br />● Locating startups, finances, and crypto-currency projects within the market context<br />● Proactive, independent, strong communication skills<br />● Ability to answer complex questions<br />● Willingness to relocate - preferred&nbsp;&nbsp;</p>\n",
    subtitle: "",
    visible: true
  }, {
    createdAt: "28/04/2018",
    edited: true,
    _id: "5ae45764c46dec3930725434",
    title: "E-mail marketing manager",
    body: "<p><strong>Duties and responsibilities:</strong><br />● Project e-mail marketing strategy development (automatic, trigger, manual distribution)<br />● Base segmentation<br />● Analytics and optimisation of mailing lists (AB testing)<br />● Preparation and creation of e-mail newsletters using built-in editors<br />● Creation of manual and automated mailing lists&nbsp;</p>\n<br/><p><strong>Required skills:</strong><br />● Experience in the fintech industry<br />● A set of prior successful e-mail generation cases available&nbsp;<br />● Fluent English, copywriting skills<br />● Knowledge of HTML / CSS and experience in writing emails<br />● Ability to select email content and understanding the basic principles of email design&nbsp;</p>\n",
    subtitle: "",
    visible: true
  }, {
    createdAt: "28/04/2018",
    edited: false,
    _id: "5ae4577ec46dec3930725435",
    title: "Project Manager",
    body: "<p><strong>Role specifics:</strong><br />Web token exchange, airdrop, analytics dashboard, investor" + " profile, trading bot development, development of smart contracts and a decentralised exchange, crowd" + " funding platform development.<br /><strong><br />Duties and responsibilities:</strong><br />● TOR" + " drafting for the product team<br />● Monitoring of implementation and deadlines&nbsp;<br />● Assessment of sub-project budgeting<br />● Development of selected projects in accordance with user requests<br />● Suggesting new features.</p>\n<br/><p><strong>Required skills:</strong></p>\n" + "" + "<p>● Ability to formalise product requirements based on the founder high-level vision&nbsp; <br />● " + " Previous product/project manager work experience in the blockchain field&nbsp;</li>\n" + "<br />● Strong cryptocurrency market knowledge and understanding of pertaining terminology<br />● Experience in managing a team of product experts (design, frontend, backend)&nbsp;</p>\n",
    subtitle: "",
    visible: true
  }, {
    createdAt: "28/04/2018",
    edited: true,
    _id: "5ae457a5c46dec3930725436",
    title: "Frontend developer",
    body: "<h3>Role specifics:</h3>\n<p>Development of a client application for the purchase of tokens in exchange for" + " cryptocurrency directly off the website, investor profiles, development of the client side of the" + " analytics dashboard, development of the client side of the crowdfunding portal, development of a gaming" + " portal.</p>\n<br/><h3>Duties and responsibilities:</h3>\n<p>● Development of web applications with a focus on" + " fintech<br />○ Multitude of diagrams, graphs, progress bars<br />○ Trading interfaces<br />○" + " Mathematical calculations<br />● Technical support for the marketing department&nbsp;<br />○" + " Technical execution of AB tests<br />○ Analytics, cross-cutting analytics</p>\n" + "<p>● Analytics dashboard" + " development&nbsp;<br/>○ Working with map APIs (geolocation)&nbsp;<br/>○&nbsp;Interaction with internal and" + " external API services</p>" + "<br/><h3>Required skills:</h3><p>● Experience in working with the React / Redux / ES6 /" + " Webpack / Babel / npm stack<br />● Experience in working with Canvas / d3 / TradingView graphics libraries<br />● Understanding of the HTTP / https / ajax / WebSocket protocol features&nbsp;<br />● Understanding the principles of blockchain operation and knowledge of associated terminology (token, address, private key, hash)<br />● Understanding of the basics of web application security<br />● Knowledge of exchange terminology (order, trade, candle, volume) and principles of the market structure.<br />● Technical background<br />● Accuracy, precision&nbsp;<br/>● Experience in working as part of a team&nbsp;&nbsp;</p>\n",
    subtitle: "",
    visible: true
  }, {
    createdAt: "28/04/2018",
    edited: false,
    _id: "5ae457c0c46dec3930725437",
    title: "Fintech backend developer",
    body: "<h3>Role specifics:&nbsp;</h3>\n<p>Development of the token exchange backend, development of the investor" + " profile backend, crowd-funding portal development, analytics dashboard" + " development.&nbsp;</p><br/><p><strong>Duties" + " and responsibilities:</strong><br />● Interaction with the APIs of various exchanges&nbsp;<br />●" + " Development" + " of exchange points’ financial automation<br />● Working with the Ethereum node<br />● Interaction with the crypto-currency processing services APIs<br><br />Required skills:&nbsp;<br />● Over 3 years of experience in working with golang<br />● Deep understanding of blockchain systems operation&nbsp;<br />● Experience in development of crypto-currency services<br />● Understanding of the HTTP / https / ajax / WebSocket protocol features&nbsp;<br />● Knowledge of exchange terminology (order, trade, candle, volume) and the principles of market structure.<br />● Deep knowledge of web application security<br />● Technical background&nbsp;<br />● Experience in working as part of a team&nbsp;</p>\n",
    subtitle: "",
    visible: true
  }, {
    createdAt: "28/04/2018",
    edited: false,
    _id: "5ae457e4c46dec3930725438",
    title: "Product Manager",
    body: "<p>● You have over 3 years of experience in the PM position&nbsp;<br />● You have managed at least two projects to targets levels. From scratch - preferred<br />● Customer Development experience, ability to quickly verify hypotheses, create<br />&nbsp;MVP solutions, conduct A / B tests, make product related decisions.<br />● You practice a data-driven approach to decision-making.<br />● Your Project Management skills are outstanding - you can set processes within the team, design functionality together with developers and release solutions on time meeting the deadlines.&nbsp;<br />● You can single handedly resolve problems of any complexity<br />● Your spoken English is at the Upper-intermediate level - you will have to conduct many in-depth interviews in English.<br><br />Goals to be achieved:<br />● Set up and maintain the hypothesis verification process with ongoing Customer Development and prototyping.<br />● Find the Product &lt;&gt; Market fit new user segments and needs in the most interesting market in Africa.<br />● Achieve multiple growth of the main product customer retention metrics&nbsp;</p>\n",
    subtitle: "",
    visible: true
  }]
};

exports.default = function () {
  var careers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : careersInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;

  switch (type) {
    case _constants.FETCH + _constants.CAREERS + _constants.START:
      return (0, _extends3.default)({}, careers, { loading: true });
    case _constants.FETCH + _constants.CAREERS + _constants.SUCCESS:
      return (0, _extends3.default)({}, careers, {
        loading: false,
        loaded: true,
        entities: (0, _mapper2.default)(data.entities)
      });
    case _constants.FETCH + _constants.CAREERS + _constants.FAIL:
      return (0, _extends3.default)({}, careers, { loading: false });
  }
  return careers;
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var blockNumber = _ref.blockNumber,
      timestampIso = _ref.timestampIso,
      hash = _ref.hash,
      parentHash = _ref.parentHash,
      difficulty = _ref.difficulty,
      gasLimit = _ref.gasLimit,
      gasUsed = _ref.gasUsed;

  var _time = (0, _moment2.default)(timestampIso, 'YYYYMMDDTHHmmss[Z]');
  return {
    blockNumber: blockNumber,
    height: '' + blockNumber,
    // height: `${blockNumber} (${transactionBlockCount} block confirmations)`,
    fromNow: _time.fromNow(),
    timeStamp: _time.format('MMM-DD-YYYY h:mm:ss a +UTC'),
    hash: hash,
    parentHash: parentHash,
    difficulty: (0, _utils.numberFormat)(difficulty),
    gasLimit: (0, _utils.numberFormat)(gasLimit),
    gasUsed: (0, _utils.numberFormat)(gasUsed)
  };
};

// blockNumber:4197049
// timestampIso:"2017-08-24T04:22:04Z"
// hash:"0x49e7e74b25f3a2643dc3ea83ddc45134a09e2260f5e8acec2c94c35335957b0d"
// parentHash:"0xe10da4e23ba24b47742c069380dab81f328c633bdfd236fb11279920a253896c"
// difficulty:1809404073379822
// gasLimit:6712392
// gasUsed:5965889
// transactionBlockCount:1
// initdata:"4197049"

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(524);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqBlockInit = {
  loading: false,
  loaded: false,
  blockNumber: '',
  height: '',
  fromNow: '',
  timeStamp: '',
  hash: '',
  parentHash: '',
  difficulty: '',
  gasLimit: '',
  gasUse: ''
};

exports.default = function () {
  var hmqBlock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqBlockInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_BLOCK + _constants.START:
      return (0, _extends3.default)({}, hmqBlock, { loading: true });
    case _constants.REQUEST + _constants.HMQ_BLOCK + _constants.SUCCESS:
      return (0, _extends3.default)({}, hmqBlock, { loading: false, loaded: true }, (0, _mapper2.default)(data));
    case _constants.REQUEST + _constants.HMQ_BLOCK + _constants.FAIL:
      return (0, _extends3.default)({}, hmqBlock, { loading: false });
  }
  return hmqBlock;
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = {
  '3h': 'HH:mm:ss',
  '1d': 'MMM DD, HH:mm:ss',
  '1w': 'MMM DD, h a',
  '1m': 'DD HH:mm:ss',
  '1y': 'HH:mm:ss',
  'ALL': 'L'
};

exports.default = function (rates, period) {

  var _rates = rates.map(function (_ref) {
    var timestampIso = _ref.timestampIso,
        rate = _ref.rate;

    if (rate && rate.usd) {
      return { timestampIso: timestampIso, rate: rate };
    } else {
      return;
    }
  });

  _rates = _rates.filter(function (n) {
    return n != undefined;
  });

  var min = 9999999999;
  _rates.forEach(function (_ref2) {
    var rate = _ref2.rate;

    if (rate && min > rate.usd) min = rate.usd;
  });

  var delta = min * 0.9;
  var entities = _rates.map(function (_ref3) {
    var timestampIso = _ref3.timestampIso,
        rate = _ref3.rate;


    var ethString = rate.eth ? (+rate.eth).toFixed(5) + ' ETH)' : '';

    return {
      date: (0, _moment2.default)(timestampIso, 'YYYYMMDDTHHmmss[Z]').format('YYYY-MM-DD, HH:mm:ss'),
      dateShow: _moment2.default.utc(timestampIso, 'YYYYMMDDTHHmmss[Z]').local().format(format[period]),
      valueShow: '$ ' + (+rate.usd).toFixed(3) + ' ' + ethString,
      value: (rate.usd - delta) * 10000
    };
  });

  var same = entities.every(function (rate, i) {
    return i === 0 || rate.value === entities[i - 1].value;
  });

  return {
    entities: entities.reverse(),
    period: period,
    same: same
  };
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(526);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqGraphInit = {
  loading: false,
  loaded: true,
  entities: [],
  period: ''
};

exports.default = function () {
  var hmqGraph = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqGraphInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_GRAPH + _constants.START:
      return (0, _extends3.default)({}, hmqGraph, { loading: true });
    case _constants.REQUEST + _constants.HMQ_GRAPH + _constants.SUCCESS:
      var period = data.initdata;
      return (0, _extends3.default)({}, hmqGraph, { loading: false, loaded: true
      }, (0, _mapper2.default)(data.rates, period));
    case _constants.REQUEST + _constants.HMQ_GRAPH + _constants.FAIL:
      return (0, _extends3.default)({}, hmqGraph, { loading: false });
  }

  return hmqGraph;
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var info = _ref.info,
      amount = _ref.amount,
      fee = _ref.fee,
      gas = _ref.gas,
      blockchain = _ref.blockchain;

  var _time = (0, _moment2.default)(info.timestampIso, 'YYYYMMDDTHHmmss[Z]');

  return {
    txHash: info.hash,
    block: blockchain.blockNumber,
    numberConfirmations: blockchain.numberConfirmations,
    fromNow: _time.fromNow(),
    timeStamp: _time.format('MMM-DD-YYYY h:mm:ss a +UTC'),
    from: info.senderAddress,
    to: info.receiverAddress,
    value: (+amount.hmq).toFixed(2) + ' HMQ ($' + (+amount.usd).toFixed(2) + ')',
    // gasLimit:
    fee: (+fee.eth).toFixed(8) + ' ($' + (+fee.usd).toFixed(2) + ')',
    usedByTransaction: gas.usedByTransaction,
    status: info.status
  };
};

// blockNumber:4197049
// timestampIso:"2017-08-24T04:22:04Z"
// hash:"0x49e7e74b25f3a2643dc3ea83ddc45134a09e2260f5e8acec2c94c35335957b0d"
// parentHash:"0xe10da4e23ba24b47742c069380dab81f328c633bdfd236fb11279920a253896c"
// difficulty:1809404073379822
// gasLimit:6712392
// gasUsed:5965889
// transactionBlockCount:1
// initdata:"4197049"
// import {numberFormat} from 'utils'

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(528);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqHashInit = {
  loading: false,
  loaded: false
};

exports.default = function () {
  var hmqHash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqHashInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_HASH + _constants.START:
      return (0, _extends3.default)({}, hmqHash, { loading: true });
    case _constants.REQUEST + _constants.HMQ_HASH + _constants.SUCCESS:
      return (0, _extends3.default)({}, hmqHash, { loading: false, loaded: true }, (0, _mapper2.default)(data));
    case _constants.REQUEST + _constants.HMQ_HASH + _constants.FAIL:
      return (0, _extends3.default)({}, hmqHash, { loading: false });
  }
  return hmqHash;
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

exports.default = function (_ref) {
  var totalTransactions = _ref.totalTransactions,
      balance = _ref.balance,
      address = _ref.address;
  return {
    totalTransactions: totalTransactions,
    balance: (0, _utils.numberFormat)(balance.hmq) + ' HMQ ($' + (0, _utils.numberFormat)(+balance.usd, 2) + ')',
    address: address
  };
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

exports.default = function (arr) {
  return arr.map(function (_ref) {
    var info = _ref.info,
        amount = _ref.amount;
    return {
      txHash: info.hash,
      block: null,
      from: info.senderAddress,
      to: info.receiverAddress,
      time: info.timestampIso,
      usdAmount: (0, _utils.numberFormat)(+amount.usd, 2),
      hmqAmount: (0, _utils.numberFormat)(+amount.hmq, 2),
      status: info.status
    };
  });
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COUNT = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(530);

var _mapper2 = _interopRequireDefault(_mapper);

var _mapperT = __webpack_require__(531);

var _mapperT2 = _interopRequireDefault(_mapperT);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COUNT = exports.COUNT = 30;

var hmqHolderInit = {
  loading: false,
  loaded: false,
  totalTransactions: 0,
  balance: 'no data',
  address: '',
  transactions: {
    entities: [],
    loading: false,
    loaded: false,
    complete: false,
    offset: 0,
    clean: false
  }
};

exports.default = function () {
  var hmqHolder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqHolderInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_HOLDER + _constants.START:
      return (0, _extends3.default)({}, hmqHolder, { loading: true, address: data });
    case _constants.REQUEST + _constants.HMQ_HOLDER + _constants.SUCCESS:
      return (0, _extends3.default)({}, hmqHolder, { loading: false, loaded: true }, (0, _mapper2.default)(data));
    case _constants.REQUEST + _constants.HMQ_HOLDER + _constants.FAIL:
      return (0, _extends3.default)({}, hmqHolder, { loading: false });
    case _constants.REQUEST + _constants.HMQ_HOLDER_T + _constants.START:
    case _constants.REQUEST + _constants.HMQ_HOLDER_T + _constants.SUCCESS:
    case _constants.REQUEST + _constants.HMQ_HOLDER_T + _constants.FAIL:
    case _constants.CLEAN + _constants.HMQ_HOLDER_T:
      return (0, _extends3.default)({}, hmqHolder, { transactions: hmqHolderT(hmqHolder.transactions, { type: type, data: data }, hmqHolder.totalTransactions, hmqHolder.address) });

  }
  return hmqHolder;
};

var hmqHolderT = function hmqHolderT(_hmqHolderT, _ref2, totalTransactions, address) {
  var type = _ref2.type,
      data = _ref2.data;


  switch (type) {
    case _constants.CLEAN + _constants.HMQ_HOLDER_T:
      return (0, _extends3.default)({}, hmqHolderInit.transactions, { loading: _hmqHolderT.loading });
    case _constants.REQUEST + _constants.HMQ_HOLDER_T + _constants.START:
      var clean = address !== data;
      return (0, _extends3.default)({}, _hmqHolderT, { loading: true, clean: clean });
    case _constants.REQUEST + _constants.HMQ_HOLDER_T + _constants.SUCCESS:
      var entities = void 0,
          complete = void 0;
      var oldEntities = _hmqHolderT.entities;

      if (data.transactions.length === 0) {
        entities = oldEntities;
        complete = true;
      } else if (totalTransactions < COUNT) {
        var newEntities = (0, _mapperT2.default)(data.transactions);
        entities = (0, _utils.arrayUnique)(oldEntities.concat(newEntities));
        complete = true;
      } else {
        var _newEntities = (0, _mapperT2.default)(data.transactions);
        entities = (0, _utils.arrayUnique)(oldEntities.concat(_newEntities));
        complete = false;
      }

      var offset = entities.length;

      return (0, _extends3.default)({}, _hmqHolderT, { loading: false, loaded: true, entities: entities, complete: complete, offset: offset });
    case _constants.REQUEST + _constants.HMQ_HOLDER_T + _constants.FAIL:
      return (0, _extends3.default)({}, _hmqHolderT, { loading: false });
  }
  return _hmqHolderT;
};

//    entities = arrayUnique(oldEntities.concat(newEntities));

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return arr.map(function (_ref) {
    var address = _ref.address,
        walletRank = _ref.walletRank,
        hmqPercentage = _ref.hmqPercentage,
        totalTransactions = _ref.totalTransactions,
        balance = _ref.balance;
    return {
      address: address,
      rank: walletRank,
      pecentage: (+hmqPercentage).toFixed(2),
      txns: totalTransactions,
      usdAmount: (0, _utils.numberFormat)(+balance.usd, 2),
      hmqAmount: (0, _utils.numberFormat)(+balance.hmq, 2),
      time: (0, _moment2.default)().format()
    };
  });
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(533);

var _mapper2 = _interopRequireDefault(_mapper);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqHoldersInit = {
  loading: false,
  loaded: false,
  entities: [],
  lastOffset: undefined
};

exports.default = function () {
  var hmqHolders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqHoldersInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_HOLDERS + _constants.START:
      return (0, _extends3.default)({}, hmqHolders, { loading: true });
    case _constants.REQUEST + _constants.HMQ_HOLDERS + _constants.SUCCESS:
      var entities = (0, _utils.arrayUnique)(hmqHolders.entities.concat((0, _mapper2.default)(data.wallets)));
      return (0, _extends3.default)({}, hmqHolders, { loading: false, loaded: true, entities: entities, lastOffset: data.initdata });
    case _constants.REQUEST + _constants.HMQ_HOLDERS + _constants.FAIL:
      return (0, _extends3.default)({}, hmqHolders, { loading: false });
  }
  return hmqHolders;
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, oldEntities) {
  var transactions = _ref.transactions,
      nextTimestampIso = _ref.nextTimestampIso;

  var entities = void 0,
      complete = void 0;

  if (transactions.length === 0) {
    complete = true;
    entities = oldEntities;
  } else {
    complete = false;
    var newEntities = transactions.map(function (_ref2) {
      var info = _ref2.info,
          amount = _ref2.amount,
          blockchain = _ref2.blockchain;
      return {
        txHash: info.hash,
        block: blockchain.blockNumber || undefined,
        from: info.senderAddress,
        to: info.receiverAddress,
        time: info.timestampIso,
        usdAmount: (0, _utils.numberFormat)(+amount.usd, 2),
        hmqAmount: (0, _utils.numberFormat)(+amount.hmq, 2),
        status: info.status
      };
    });
    entities = (0, _utils.arrayUnique)(oldEntities.concat(newEntities));
  }
  entities.sort(function (left, right) {
    return _moment2.default.utc(right.time, 'YYYYMMDDTHHmmss[Z]').diff(_moment2.default.utc(left.time, 'YYYYMMDDTHHmmss[Z]'));
  });
  return {
    entities: entities,
    complete: complete,
    next: nextTimestampIso
  };
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(535);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqLogInit = {
  loading: false,
  loaded: false,
  entities: []
};

exports.default = function () {
  var hmqLog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqLogInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_LOG + _constants.START:
      return (0, _extends3.default)({}, hmqLog, { loading: true });
    case _constants.REQUEST + _constants.HMQ_LOG + _constants.SUCCESS:
      return (0, _extends3.default)({}, hmqLog, { loading: false, loaded: true }, (0, _mapper2.default)(data, hmqLog.entities));
    case _constants.REQUEST + _constants.HMQ_LOG + _constants.FAIL:
      return (0, _extends3.default)({}, hmqLog, { loading: false });
  }
  return hmqLog;
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

exports.default = function (data) {
  var preEntities = [];
  for (var key in data) {
    if (data[key]) preEntities.push(data[key]);
  }
  var entities = preEntities.map(function (_ref) {
    var name = _ref.name,
        link = _ref.link,
        hmqVolumeRank = _ref.hmqVolumeRank,
        marketPair = _ref.marketPair,
        tokenValue = _ref.tokenValue,
        lastHours24 = _ref.lastHours24;
    return {
      address: name,
      url: link,
      rank: hmqVolumeRank,
      price: '$ ' + (+tokenValue.usd).toFixed(5),
      pair: marketPair.first + '\\' + marketPair.second,
      usdAmount: (0, _utils.numberFormat)(+lastHours24.tradesVolume.usd, 2),
      hmqAmount: (0, _utils.numberFormat)(+lastHours24.tradesVolume.hmq, 2),
      status: true
    };
  });

  return {
    entities: entities
  };
};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(537);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqMarketsInit = {
  loading: false,
  loaded: false,
  entities: []
};

exports.default = function () {
  var hmqMarkets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqMarketsInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_MARKETS + _constants.START:
      return (0, _extends3.default)({}, hmqMarkets, { loading: true });
    case _constants.REQUEST + _constants.HMQ_MARKETS + _constants.SUCCESS:
      return (0, _extends3.default)({}, hmqMarkets, { loading: false, loaded: true }, (0, _mapper2.default)(data));
    case _constants.REQUEST + _constants.HMQ_MARKETS + _constants.FAIL:
      return (0, _extends3.default)({}, hmqMarkets, { loading: false });
  }
  return hmqMarkets;
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (dataArray) {

  var entities = dataArray.map(function (_ref) {
    var type = _ref.type,
        value = _ref.value;

    if (type === 'walletAddress') {
      return {
        address: value,
        type: 'holder'
      };
    } else {
      return {
        txHash: value,
        type: 'log'
      };
    }
  });
  return entities;
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(539);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqSearchInit = {
  loading: false,
  loaded: false,
  entities: [],
  searchTerm: ''
};

exports.default = function () {
  var hmqSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqSearchInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.HMQ_SEARCH + _constants.START:
      return (0, _extends3.default)({}, hmqSearch, { loading: true, request: data });
    case _constants.HMQ_SEARCH + _constants.SUCCESS:

      return (0, _extends3.default)({}, hmqSearch, {
        loading: false,
        loaded: true,
        request: data.initdata,
        entities: (0, _mapper2.default)(data.searchResults)
      });
    case _constants.HMQ_SEARCH + _constants.FAIL:
      return (0, _extends3.default)({}, hmqSearch, { loading: false });
    case _constants.CLEAN + _constants.HMQ_SEARCH:
      return (0, _extends3.default)({}, hmqSearchInit);
  }
  return hmqSearch;
};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

exports.default = function (data) {

  var _tokenSupplyHmq = (0, _utils.safeDA)(data, ['tokenSupply', 'hmq'], 0);
  var _tokenSupplyUsd = (0, _utils.safeDA)(data, ['tokenSupply', 'usd'], 0);
  var _lastHours24TradesVolumeUsd = (0, _utils.safeDA)(data, ['lastHours24', 'tradesVolume', 'usd'], 0);
  var _lastHours24TradesVolumeHmq = (0, _utils.safeDA)(data, ['lastHours24', 'tradesVolume', 'hmq'], 0);

  var _tokenValueUsd = (0, _utils.safeDA)(data, ['tokenValue', 'usd'], 0);
  var _tokenValueEth = (0, _utils.safeDA)(data, ['tokenValue', 'eth'], 0);

  var tokenSupplyString = (0, _utils.numberFormat)(_tokenSupplyHmq) + ' HMQ ($ ' + (0, _utils.numberFormat)(Math.round(_tokenSupplyUsd * 100) / 100) + ')';
  var volume24String = (0, _utils.numberFormat)(Math.round(_lastHours24TradesVolumeHmq * 100) / 100) + ' HMQ ($ ' + (0, _utils.numberFormat)(Math.round(_lastHours24TradesVolumeUsd)) + ' )';
  var tokenValueString = '$ ' + Math.round(_tokenValueUsd * 10000) / 10000 + ' (' + (+_tokenValueEth).toFixed(6) + ' ETH)';

  return {
    tokenSupplyString: tokenSupplyString,
    volume24String: volume24String,
    tokenValueString: tokenValueString,
    participatingExchanges: data.participatingExchanges,
    lastHours24: data.lastHours24,
    totalWallets: data.totalWallets,
    totalTransactions: data.totalTransactions,
    totalTransactions24: data.totalTransactions24
  };
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(541);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hmqStatisticInit = {
  loading: false,
  loaded: false,
  volume24String: 'no data',
  tokenSupplyString: 'no data',
  tokenValueString: 'no data',
  tokenSupply: {
    hmq: 'no data',
    usd: 'no data',
    eth: 'no data'
  },
  totalWallets: 'no data',
  totalTransactions: 'no data',
  totalTransactions24: 'no data',
  tokenValue: {
    hmq: 'no data',
    usd: 'no data',
    eth: 'no data'
  },
  participatingExchanges: 0,
  lastHours24: {
    tradesVolume: {
      hmq: 'no data',
      usd: 'no data',
      eth: 'no data'
    },
    numberTransactions: 'no data'
  }

};

exports.default = function () {
  var hmqStatistic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hmqStatisticInit;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.HMQ_STATISTICS + _constants.START:
      return (0, _extends3.default)({}, hmqStatistic, { loading: true });

    case _constants.REQUEST + _constants.HMQ_STATISTICS + _constants.SUCCESS:
      return (0, _extends3.default)({}, hmqStatistic, { loading: false, loaded: true }, (0, _mapper2.default)(data));
    case _constants.REQUEST + _constants.HMQ_STATISTICS + _constants.FAIL:
      return (0, _extends3.default)({}, hmqStatistic, { loading: false });
  }
  return hmqStatistic;
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.fetchUserNumber = fetchUserNumber;

var _helpers = __webpack_require__(109);

var _constants = __webpack_require__(12);

var _humaniqBackendApi = __webpack_require__(75);

var _api = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchUserNumber() {
  return (0, _defineProperty3.default)({}, _humaniqBackendApi.BACKEND_CALL, {
    endpoint: _api.ENDPOINT_USERS_NUMBER,
    method: 'GET',
    types: (0, _helpers.createRequestActions)(_constants.USERS_NUMBER)
  });
}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initHome = {
  users_number: undefined
};

exports.default = function () {
  var home = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initHome;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.REQUEST + _constants.USERS_NUMBER + _constants.START:
      return (0, _extends3.default)({}, home, { loading: true });
    case _constants.REQUEST + _constants.USERS_NUMBER + _constants.SUCCESS:
      return (0, _extends3.default)({}, home, { loading: false, loaded: true, users_number: data.total_installations });
    case _constants.REQUEST + _constants.USERS_NUMBER + _constants.FAIL:
      return (0, _extends3.default)({}, home, { loading: false });
  }
  return home;
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initNavigation = {
  openRoute: [],
  isMenuOpened: false,
  isPopupOpened: false,
  isPeopleModalOpened: false,
  personData: {},
  popupType: null,
  hmqSection: '',
  theme: 'bright'
};

exports.default = function () {
  var navigation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initNavigation;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;


  switch (type) {
    case _constants.SET + _constants.THEME:
      return (0, _extends3.default)({}, navigation, { theme: data });
    case _constants.SET + _constants.OPEN_ROUTE:
      return (0, _extends3.default)({}, navigation, { openRoute: data });
    case _constants.OPEN + _constants.MENU:
      return (0, _extends3.default)({}, navigation, { isMenuOpened: true });
    case _constants.CLOSE + _constants.MENU:
      return (0, _extends3.default)({}, navigation, { isMenuOpened: false });
    case _constants.TOGGLE + _constants.MENU:
      var isMenuOpened = !navigation.isMenuOpened;
      return (0, _extends3.default)({}, navigation, { isMenuOpened: isMenuOpened });
    case _constants.SET + _constants.HMQ_SECTION:
      return (0, _extends3.default)({}, navigation, { hmqSection: data });
    case _constants.OPEN + _constants.POPUP:
      return (0, _extends3.default)({}, navigation, { isPopupOpened: true, popupType: data });
    case _constants.CLOSE + _constants.POPUP:
      return (0, _extends3.default)({}, navigation, { isPopupOpened: false, popupType: null });
    case _constants.OPEN + _constants.PEOPLE_MODAL:
      return (0, _extends3.default)({}, navigation, { isPeopleModalOpened: true, personData: data });
    case _constants.CLOSE + _constants.PEOPLE_MODAL:
      return (0, _extends3.default)({}, navigation, { isPeopleModalOpened: false, popupType: null });
  }
  return navigation;
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.fetchPartners = fetchPartners;

var _helpers = __webpack_require__(109);

var _humaniqBackendApi = __webpack_require__(75);

var _api = __webpack_require__(45);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPartners() {
  return (0, _defineProperty3.default)({}, _humaniqBackendApi.BACKEND_CALL, {
    endpoint: _api.ENDPOINT_PARTNERS_LIST,
    method: 'GET',
    types: (0, _helpers.createFetchActions)(_constants.PARTNERS)
  });
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _constants = __webpack_require__(12);

var _api = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initPartners = {
  entities: [],
  loaded: false,
  data: {
    partners: [{
      title: "Bitaps",
      type: "Technical Partners",
      description: "Bitaps is a platform based on full Bitcoin node with blockchain network events. Bitaps.com is a Bitcoin Block Explorer (Browser).",
      link: "https://bitaps.com/",
      logoLink: "/logos/bitaps.jpg",
      logoLink2x: "/logos/bitaps_2x.jpg"
    }, {
      title: "Blockchain Age",
      type: "Media Partners",
      description: "The Global Leader in Blockchain Research and Consultancy.",
      link: "https://blockchainage.com/",
      logoLink: "/logos/blockchainage.jpg",
      logoLink2x: "/logos/blockchainage_2x.jpg"
    }, {
      title: "Blockchain Community",
      type: "Business Partners",
      description: "Blockchain.community is a voluntary borderless community of entrepreneurs, services, experts and blockchain enthusiasts.",
      link: "http://blockchain.community/",
      logoLink: "/logos/blockchaincommunity.jpg",
      logoLink2x: "/logos/blockchaincommunity_2x.jpg"
    }, {
      title: "Deep Knowledge Ventures",
      type: "Business Partners",
      description: "Deep Knowledge Ventures is a venture capital firm based in Hong Kong with an office in London. The fund primarily invests in healthcare and artificial intelligence.",
      link: "http://www.deepknowledgeventures.com/",
      logoLink: "/logos/deepknowledgeventures.jpg",
      logoLink2x: "/logos/deepknowledgeventures_2x.jpg"
    }, {
      title: "Deloitte",
      type: "Business Partners",
      description: "Deloitte provides industry-leading audit, consulting, tax, and advisory services to many of the world's most admired brands, including 80 percent of the Fortune 500.",
      link: "https://www2.deloitte.com/us/en.htm",
      logoLink: "/logos/deloitte.jpg",
      logoLink2x: "/logos/deloitte_2x.jpg"
    }, {
      title: "Future Fintech",
      type: "Business Partners",
      description: "Future Fintech - the international community of experts in the area of financial and blokchain technology projects as well as the selection of the program and the acceleration fintech startups from Russia, CIS countries and Europe.",
      link: "http://www.futurefintech.org/",
      logoLink: "/logos/futurefintech.jpg",
      logoLink2x: "/logos/futurefintech_2x.jpg"
    }, {
      title: "Hedge Think",
      type: "Media Partners",
      description: "Digital meeting place for fund managers and investors.",
      link: "https://www.hedgethink.com/",
      logoLink: "/logos/hedgethink.jpg",
      logoLink2x: "/logos/hedgethink_2x.jpg"
    }, {
      title: "Intelligent HQ",
      type: "Media Partners",
      description: "The definitive authority for social businesses a digital network for growth, education, change and innovation.",
      link: "https://www.intelligenthq.com/",
      logoLink: "/logos/intelligenthq.jpg",
      logoLink2x: "/logos/intelligenthq_2x.jpg"
    }, {
      title: "Level39",
      type: "Business Partners",
      description: "Level39 is the world's most connected community for finance, cybersecurity, retail and smart-city technology businesses.",
      link: "http://www.level39.co/",
      logoLink: "/logos/l39.jpg",
      logoLink2x: "/logos/l39_2x.jpg"
    }, {
      title: "NTechLab",
      type: "Technical Partners",
      description: "NTechLab develops and implements artificial intelligence algorithms. We are a team of experts in machine and deep learning.",
      link: "http://ntechlab.com/",
      logoLink: "/logos/ntechlab.jpg",
      logoLink2x: "/logos/ntechlab_2x.jpg"
    }, {
      title: "Open Business Council",
      type: "Media Partners",
      description: "Open Business Council - SME Startups resources, Trade Finance, Invoice Finance, Asset Finance, Business Intelligence, software.",
      link: "https://www.openbusinesscouncil.org/",
      logoLink: "/logos/openbusinesscouncil.jpg",
      logoLink2x: "/logos/openbusinesscouncil_2x.jpg"
    }, {
      title: "Richtopia",
      type: "Media Partners",
      description: "A complete media brand covering effective leadership, emerging technologies, global economics, inspirational people, smart investing & strategic marketing.",
      link: "https://richtopia.com/",
      logoLink: "/logos/richtopia.jpg",
      logoLink2x: "/logos/richtopia_2x.jpg"
    }, {
      title: "The Invaders",
      type: "Technical Partners",
      description: "Leading expert group in Kotlin Android development",
      link: "http://theinvaders.ru",
      logoLink: "/logos/theinvaders.jpg",
      logoLink2x: "/logos/theinvaders_2x.jpg"
    }, {
      title: "Think Rise by Barclays",
      type: "Business Partners",
      description: "Rise London, the home of fintech and Barclays Accelerator powered by Techstars, is the place where great minds co-create the future of financial services.",
      link: "https://thinkrise.com/",
      logoLink: "/logos/thinkrise.jpg",
      logoLink2x: "/logos/thinkrise_2x.jpg"
    }, {
      title: "TradersDNA",
      type: "Media Partners",
      description: "TradersDNA offers premiere resources for trading and investing education and digital resources for personal finance.",
      link: "https://www.tradersdna.com/",
      logoLink: "/logos/tradersdna.jpg",
      logoLink2x: "/logos/tradersdna_2x.jpg"
    }, {
      title: "Vexor",
      type: "Technical Partners",
      description: "Vexor is a distributed cloud web-service for building and testing software, a continuous integration tool.",
      link: "https://vexor.io/",
      logoLink: "/logos/vexor.jpg",
      logoLink2x: "/logos/vexor_2x.jpg"
    }]
  }
};

function addUrl(arr) {
  return arr.map(function (_ref) {
    var logoLink2x = _ref.logoLink2x,
        other = (0, _objectWithoutProperties3.default)(_ref, ['logoLink2x']);

    return (0, _extends3.default)({}, other, {
      logoLink2x: _api.ENDPOINT_PARTNERS + logoLink2x
    });
  });
}

exports.default = function () {
  var partners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initPartners;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      data = _ref2.data;

  return (0, _extends3.default)({}, partners, { loaded: true, entities: addUrl(initPartners.data.partners)

    /*switch (type) {
      case FETCH + PARTNERS + SUCCESS:
        return {...partners, loaded: true, entities: addUrl(data.partners)}
    }
     return partners;*/
  });
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(55);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.fetchWiki = fetchWiki;

var _constants = __webpack_require__(12);

var _butterCmsApi = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchWiki() {
  return (0, _defineProperty3.default)({}, _butterCmsApi.BUTTER_CMS_CALL, {
    butter: _constants.WIKI,
    data: {
      collection: 'technical_mecca,about_humaniq' //all articles
    }
  });
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

exports.default = function (data) {

  var _preparedData = {};

  for (var valueName in data) {
    if (data.hasOwnProperty(valueName)) {
      (function () {
        var level0Title = _utils.convert.toTitleCase(valueName);
        var _kebabCaseName = _utils.convert.toKebab(valueName);
        _preparedData[_kebabCaseName] = {
          ids: [],
          entities: {},
          level0Title: level0Title
        };

        data[valueName].forEach(function (_ref) {
          var title = _ref.title,
              category = _ref.category,
              article = _ref.article;

          var pseudoId = _utils.convert.toCleanKebab(title);

          _preparedData[_kebabCaseName].ids.push(pseudoId);
          _preparedData[_kebabCaseName].entities[pseudoId] = { title: title, id: pseudoId, level0: _kebabCaseName, level1: category, article: article };
        });
      })();
    }
  }
  return _preparedData;
};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _constants = __webpack_require__(12);

var _mapper = __webpack_require__(549);

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initLevel0 = {
  level0Title: '',
  ids: [],
  entities: {}
};

var initWikiArticles = {
  loading: false,
  loaded: false,
  'technical-mecca': (0, _extends3.default)({}, initLevel0),
  'about-humaniq': (0, _extends3.default)({}, initLevel0),
  descriptions: [{
    level0: "about-humaniq",
    level1: "root",
    description: "Humaniq is about people as much as we are about technology. So who are we, who are our community members, and how can you become part of our story? Here we share what motivates us, the positive change we want to bring about, and the ways in which you can become involved yourself",
    img: '/img/illustrations/wiki-about-humaniq.svg'
  }, {
    level0: "about-humaniq",
    level1: "Getting Started",
    description: "What drives us at Humaniq, and how is our app, and our HMQ coin, different to the mobile wallets and cryptocurrency we've seen in the past? Find out more about our mission to harness the Blockchain for good and get your questions about our mission to bring financial services to the global unbanked answered here."
  }, {
    level0: "about-humaniq",
    level1: "Community",
    description: "Whether it is our users in the Global South, our HMQ coin holders and investors, or our partners developing new financial services for an unserved market, our community makes Humaniq. Find out the many ways you can get involved in our community and help us achieve our mission to bring the global unbanked into the 21st Century economy. "
  }, {
    level0: "about-humaniq",
    level1: "Contributing",
    description: "As a user of the Humaniq App, or as a Fintech developer and believer in our project, how can you contribute? We set out the ways you can share your thoughts and ideas with us, participate in our community, contribute as an investor and work with us as a developer using our platform and HMQ coin here."
  }, {
    level0: "technical-mecca",
    level1: "root",
    description: "Humaniq is working to help those shut out of the 21st Century and to support entrepreneurs to offer much-needed financial services to the global unbanked. What we do is made possible by technology allowing a massive untapped market to be served. Read more about the technology behind the Humaniq App and the HMQ coin cryptocurrency.",
    img: '/img/illustrations/wiki-technical-mecca.svg'

  }, {
    level0: "technical-mecca",
    level1: "Crypto Basics",
    description: "How can Humaniq liberate people from a reliance on the old,centralised banks, and how can we help make a more collaborative, peer-to-peer economy happen? How can we maintain a record of all transactions without banks, and offer financial services everywhere? Whether you want to know about the Blockchain or smart contracts, decentralised apps or gas, here we share the technical underpinnings of the Humaniq app and the HMQ cryptocurrency."
  }],
  data: {
    about_humaniq: [{
      title: "Banking in Humaniq",
      article: "<p>Banking with Humaniq is simple and secure. The first time that you use the Humaniq app, you authenticate your identity so that you never need any passwords or documentation to access your account. Our face recognition technology will confirm your identity and keep your transactions secure. You are then issued with HMQ, Humaniq coins, for passing bio-identification, so you can immediately get started.</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU62d\" alt=\"\" /></p>\r\n<p>You gain more HMQ for engaging with the app, for example by recommending friends and by making transactions. The more people you know who use the app, the more powerful the app becomes. HMQ enables a peer-to-peer economy. One of the main functions is sending or receiving HMQ directly to other users of the app instantly and at virtually zero-cost - making sending sums smaller than $10 without losing money possible for the first time.</p>\r\n<p>We are also talking to major shopping franchises in the markets we are targeting about making HMQ a payment option. And we are working to provide the infrastructure necessary to exchange cryptocurrency for local currency.</p>\r\n<p>We will also be adding further services over time. The plan is that you will be able to use the app to access micro-finance lenders for small loans in a &lsquo;Borrow&rsquo; tab, and even employment in the &lsquo;Earn&rsquo; tab, where on-line, paid tasks are collected and available for you to perform. Humaniq is a bank that pays.</p>",
      category: "Getting Started"
    }, {
      title: "Code of Conduct",
      article: "<p>We invite you to get involved in Humaniq. We want to build a global community and an economy where everybody matters and can get involved. Our code of conduct underpins our hopes. We would like it to be honoured by everybody joining and taking part in Humaniq.</p>\r\n<ol>\r\n<li><strong>Communicate and share.</strong> Humaniq can achieve our mission of bringing banking to the unbanked if we are aware of what is working well and what is working less well. Successes help us to show users, partners and investors potential uses and impacts of the Humaniq app and the HMQ tokens, knowledge that helps us to achieve our aims. And constructive criticism helps us to change things so that we can better serve all those currently shut out of opportunities to progress. The Humaniq team will also be as open as we can.</li>\r\n<li><strong>Respect others.</strong> Everybody matters and everybody has ideas and needs to be heard. We want to encourage feedback and suggestions in our community as Humaniq grows. We can all help to do this by being respectful of others and what they have to say. A peer-to-peer economy both tears down old ways of doing things and makes individual respect more important. And a community where everybody feels comfortable to express themselves and to contribute is a community that will learn, strengthen and flourish.</li>\r\n<li><strong>Collaborate</strong>. The beauty of the Humaniq app is that it underpins peer-to-peer collaboration. This allows partnerships between the many, and active participants rather than service user relationships people have with traditional banking institutions. This requires you all to pour your energies into this new way of working. So whether you are a Humaniq app user or a developer, we invite you to enter into the spirit of this new way of creating value and building an economy. The Humaniq team will respond positively. We want to facilitate peer-to-peer lending, partnership and support and to foster the provision of new services delivered by others through our app.</li>\r\n</ol>",
      category: "Getting Started"
    }, {
      title: "Core values",
      article: "<p>Humaniq believes in a humanitarian capitalism and in technology for good.</p>\r\n<p><br />Humaniq believes that people can pull themselves out of poverty with access to smartphones, to a network, and to finance.</p>\r\n<p><br />Humaniq believes in cryptocurrency that achieves value through expanding services to those not served and creating new opportunities in the 21st Century economy.</p>",
      category: "Getting Started"
    }, {
      title: "FAQ",
      article: "<p><strong>How is Humaniq different? Aren&rsquo;t you just another mobile wallet?</strong></p>\r\n<p>Humaniq is a cryptocurrency unlike any other. We are working to put currency into the hands of the 2bn unbanked people. The barriers to use are low, with voice and face recognition technologies used so that the uneducated and the undocumented can access the app and open an account.</p>\r\n<p><strong>It sounds accessible. But is this enough to succeed in putting cryptocurrency into the hands of the many?</strong></p>\r\n<p>With Humaniq, everybody can mint coins. Unlike with other cryptocurrencies, it is not about being the first to own the coins, or having access to specialised hardware or spending a lot on electricity. Everybody, once they have used their face to pass authentication, is rewarded with HMQ. Then, when they interact with the app, they earn more. The minting of coins will continue until we have 2 billion users.</p>\r\n<p><strong>But wasn&rsquo;t other cryptocurrency also aimed at developing countries?</strong></p>\r\n<p>Other crypto also uses Ethereum&rsquo;s custom-built Blockchain to provide new, safe and secure, currency. But it is not used in unbanked regions because it is limited in supply, because of relative usage complexity, and because it is not promoted. The transaction capacity limit of Bitcoin is 250 thousand, compared to PayPal&rsquo;s 100 million active accounts. We have researched the markets we are targeting, and recruited dozens of prominent bitcoiners living in developing countries to our Humaniq Ambassador Program. They are teaching people how to use Humaniq - and earn cryptocurrency for that.</p>\r\n<p><strong>Why use the Blockchain to make payments?</strong></p>\r\n<p>The Blockchain is a decentralised way of confirming transactions that steps into the breach that has been created by centralised banks not serving 2 billion people around the world. The Blockchain allows payments to be checked and confirmed so there can be no double payments or lost payments, without there being a centralised authority. This technology therefore underpins an expansion of banking services to those currently shut out from the digital economy because of the existing banking infrastructure.</p>\r\n<p><strong>Why the Ethereum Blockchain?</strong></p>\r\n<p>The Humaniq app runs on the Ethereum platform, which is a way of running Blockchain-based, decentralised apps without unnecessary complexity and risk entailed in deploying a new Blockchain. The Ethereum Blockchain, which was first launched in the summer of 2015, is a well-established platform to provide secure banking without a central server. Using a ready and operating Blockchain allowed us to create a solution to the need for security for transactions quickly, without needless expenditure or loss of quality. This allows us to put more time and energy into concentrating on what matters most: our people-focused business model.</p>\r\n<p><strong>Why invest in Humaniq?</strong></p>\r\n<p>We are pleased that so many people responded so positively to our Initial Coin Offering. Nearly 12,000 people have bought HMQ cryptocurrency because they believe in our vision to provide banking to the unbanked. Humaniq has been highlighted as in the top ten per cent of cryptocurrencies by value, with a market valuation of over $5m, and our ICO as one of the most successful in the last two years. Our vision will make HMQ the de facto currency for developing countries, the oil that runs the engines of their economies.</p>\r\n<p><strong>Why did you hold an ICO?</strong></p>\r\n<p>We already had access to capital for our project but we believe it is fair to allow everybody to invest and to participate in Humaniq. We also wanted to help build our community and to have an opportunity to tell the story of Humaniq to more people in the media. Our belief that many would want to be involved and to support and help steer Humaniq proved well-founded: nearly 12,000 participated in the ICO held in April 2017 after reading our white paper. Our strategy&nbsp;is to focus on the massive potential of providing banking to the unbanked.</p>",
      category: "Getting Started"
    }, {
      title: "Beliefs",
      article: "<ul>\r\n<li>Humaniq believes in equality. Widening access to the digital economy and to financial services will reduce inequality.</li>\r\n<li>Humaniq believes in effort. People newly gaining access to lending improve their incomes and quality of life.</li>\r\n<li>Humaniq believes in people. People have amazing capacities and talents, but too often face barriers to harnessing and unleashing them.</li>\r\n</ul>",
      category: "Getting Started"
    }, {
      title: "Mission",
      article: "<ul>\r\n<li>Humaniq exists to bring banking to everybody and digital currency to the many.</li>\r\n<li>Humaniq wants to open the 21st Century economy to all those shut out from its opportunities around the world.</li>\r\n<li>Humaniq aims to create new opportunities for entrepreneurs to offer services to those who currently are excluded from financial services.</li>\r\n</ul>",
      category: "Getting Started"
    }, {
      title: "Users",
      article: "<p>Users are the backbone of our community. As a user, you can recommend friends to join the network and immediately earn HMQ tokens, and be rewarded for the invitations. Humaniq is a platform for peer-to-peer collaboration, and you can communicate with everybody in the network using chat. You can ask any questions or suggestions you have about using Humaniq app or HMQ coins on our forum. You can spread the world in your country through our Global Ambassador Program. And you can share your stories of how Humaniq has helped you to save, collaborate, earn or progress with us at X.</p>",
      category: "Contributing"
    }, {
      title: "Participants",
      article: "<p>Put your money into humanitarian capitalism and support the inclusion of 2bn people who are currently shut out from the 21st Century economy&rsquo;s opportunities. You can, even if you missed our ICO, obtain HMQ by exchanging Bitcoin for our new, egalitarian cryptocurrency on bittrex.com. You will join close to 12,000 HMQ holders who contributed over $5m and took the total market capital to $30m. You can&hellip;You will be investing whilst the community is still growing and whilst the app is still to launch.</p>",
      category: "Contributing"
    }, {
      title: "Developers",
      article: "<p>You can develop new financial services for the Humaniq global community. You can offer your services such as lending and insurance to an untapped market of billions using the APIs offered by our Ethereum-based platform. You can use the Ethereum Blockchain to take care of currency transfers and data processing securely. You can take advantage of our fund to help accelerate and grow some of our young start-up partners. You can give the unbanked access to the finance and banking services they need to grow and prosper.</p>",
      category: "Contributing"
    }, {
      title: "Tell a Friend",
      article: "<p>All our Humaniq users are our ambassadors, essential to achieving our aim of giving the over two billion unbanked people new opportunities to receiving and earning money, and accessing finance. This includes users with a formal role to spread the word who are on our Humaniq Ambassador Program. These are dozens of Bitcoiners living in developing countries such as Afghanistan, Botswana, Indonesia, Pakistan and Sierra Leone who have started to introduce Humaniq and its possibilities to others - and who earn cryptocurrency in return. In addition, everybody using the app is rewarded by recommending friends through the platform.</p>",
      category: "Community"
    },
    //{
    //  title: "Newsletter",
    //  article: "<p>If you prefer to receive comprehensive Humaniq updates on a regular basis, you should sign up to our weekly newsletter. All fresh news of Humaniq and its app will be available in one place, in your inbox, saving your time. To subscribe please follow <a title=\"Subscribe Form\" href=\"https://about.humaniq.com/form/subscribe\">this link</a>.</p>",
    //  category: "Community"
    //},
    {
      title: "Podcasts",
      article: "<p>At Humaniq we believe that it is important to share the latest news and achievements with our followers. We enjoy keeping the community updated on the events we are taking part in, meetups we are arranging, new countries we are visiting on our mission, and strategic partnerships we establish.</p>\r\n<p>Currently, as we are developing and launching our app - we are producing two types of weekly reviews on alternate weeks. One is a general overview of the latest Humaniq activities. Another is specific technical review, dedicated to the app development updates.</p>\r\n<p>We share Humaniq news via weekly video round-ups on our youtube channel. From now on we will also keep you posted with our podcasts featuring &nbsp;regular round-ups as well as some more stories, pics and team members opinions.&nbsp;</p>",
      category: "Community"
    }, {
      title: "ICO",
      article: "<p>Our ICO (Initial Coin Offering) was the first major opportunity to obtain Humaniq tokens and join the global community that uses HMQ and believes in HMQ as the digital currency for the many. It followed a pre-ICO in December 2016 which raised $110,000.</p>\r\n<p>The opportunity to be part of Humaniq was widened to many more people in the ICO from the 6th April to the 27th April. There were in total 11,600 participants who made an average contribution of $430, raising $5.1m for the project. Each participant was able to buy 1,000 HMQ tokens or more. The majority of those supporting our vision and joining our community were motivated by our strategy and the huge untapped potential market of the 2bn unbanked people in the world.</p>\r\n<p>The HMQ tokens were then released on the 5th May, with a fifth issued for the HMQ team, including to invest in business development and marketing. Following the ICO, Humaniq has appeared on the following exchanges:Bittrex, Liqui, &nbsp;Yobit, C-CEX. The majority of the HMQ tokens will be created by the unbanked later this year when the Humaniq app starts to be piloted in areas currently shut out of financial services.</p>",
      category: "Community"
    }, {
      title: "Blog",
      article: "<p>The stories of the difference that Humaniq makes to individual lives are shared on the Humaniq <a href=\"https://blog.humaniq.co/\">blog</a>. Whether it&rsquo;s how smartphones can pay for themselves when people download, log into and use the app, or how the app provides a new way for microfinance to be provided without field representatives, the blog tells these stories.<br />The blog is also a platform where Humaniq shares the latest on our own story as it unfolds. This includes the latest developments on our ICO (initial coin offering), the mentions we receive from experts &nbsp;in Fintech, Blockchain, financial inclusion and collaborative economy media, forums and blogs, as well as the descriptions of our participation in events with industry partners. As we start to pilot the app, it will also include the stories of our users, how they are using Humaniq, and the difference it is making to their lives. We already have examples of how the app can be used, including, recently, how it can save people on some of the lowest incomes on Earth money on instant messaging.</p>\r\n<p>We would love to hear from users and we always welcome feedback by emailing <a title=\"Humaniq info email\" href=\"mailto:info@humaniq.com\">info@humaniq.com</a>.</p>",
      category: "Community"
    },
    //{
    //  title: "Forum",
    //  article: "<p>Our online community <a href=\"http://forum.humaniq.co/?_ga=2.125649673.288255945.1497543283-1400472941.1497267288\">forum</a> is open to everybody and discusses everything from Humaniq&rsquo;s aims and ambitions to questions concerning the functionality of the app and how to use the HMQ cryptocurrency. Whether it is the process of having your identity confirmed, or of how you start to send and receive HMQ, this is the place to share and ask any questions that you have.</p>\r\n<p>The forum is also a place to get up-to-date information on our fast-moving project, including on the exchange rate with other cryptocurrencies, and the latest on the different Ethereum wallets that can currently accept HMQ tokens. There are even plans for a list of all local exchanges around the world where Humaniq trading to convert tokens into local currencies will be available through our partners. Here on our forum we are also sharing the latest on the development of Humaniq, including the planned B2B platform enabling third parties to offer lending and insurance.</p>\r\n<p>During the app&rsquo;s pre-beta stage, comments in our forum are positively encouraged as our developers work to continually improve the app and make mobile banking for all simple and seamless!</p>",
    //  category: "Community"
    //},
    {
      title: "Grow the Humaniq Community",
      article: "<p>Humaniq is banking centred on the needs of people. Our global community of users, partners and coin holders makes Humaniq. Close to 12,000 people backed our vision in our ICO (Initial Coin Offering) and joined our community by buying HMQ tokens And dozens of the most prominent of the 3 million cryptocurrency-users in a number of countries in the Global South, from Sierra Leone to Indonesia, are engaging local communities about Humaniq.&nbsp;</p>",
      category: "Community"
    }, {
      title: "User stories",
      article: "<p>Humaniq is an app that opens up a world of possibilities for users, giving the unbanked people living around the world financial services for the first time.</p>\r\n<p>The ways in which this will help them to progress and to improve their lives are manifold and independent cryptocurrency and Fintech experts and commentators have recognised this. Members of this community have said in a number of reviews of our project that it will be &ldquo;<a href=\"https://www.youtube.com/watch?v=AX2v7IXvDo8\">life-changing</a>&rdquo; for the global unbanked and that it &ldquo;<a href=\"https://www.youtube.com/watch?v=tnIrxvcDtvU&amp;t=11s\">solves a clear problem,</a>&rdquo; the lack of access in developing nations to digital currency and the ability to make transactions easily and cheaply. This, the community says, means Humaniq is &ldquo;<a href=\"https://www.youtube.com/watch?v=yv1_HW1Kqxg&amp;t=118s\">empowering the impoverished,</a>&rdquo; ,&nbsp;&nbsp;allowing more people to participate in the digital economy,&nbsp;and is an &ldquo;<a href=\"https://www.youtube.com/watch?v=gSbzqcKxJ8o\">extremely vital</a>&rdquo; project that is &ldquo;<a href=\"https://www.youtube.com/watch?v=TL_hzCK-5A8\">unique</a>&rdquo; among cryptocurrency projects and is a good investment that has &ldquo;<a href=\"https://www.youtube.com/watch?v=TL_hzCK-5A8\">explosive, long-term potential</a>&rdquo;.</p>\r\n<p>They have also commented on the specific benefits of Humaniq, including how it meets the need for an app that allows <a href=\"https://www.youtube.com/watch?v=LdtJb-hIzXE&amp;t=196s\">peer-to-peer finance</a> to be offered and provides <a href=\"https://www.youtube.com/watch?v=yv1_HW1Kqxg&amp;t=118s\">the opportunity to earn income</a> to the 2bn unbanked in Africa, Asia and Latin America. We are pleased that the mission that excites us, to bring those currently shut out of the 21st Century economy into it, is sparking the interest and involvement of others too.</p>\r\n<p>&nbsp;</p>\r\n<p><strong>As Told by Humaniq</strong></p>\r\n<p>Humaniq ambassadors live in the countries that have the biggest need for banking services and to participate in the 21st Century economy, such as Sierra Leone and Tanzania. They share our belief in opening up banking to all those shut out from routes to borrowing, sending, and earning money. They are <a href=\"https://www.youtube.com/watch?v=Q-6WU_DBsk0\">the passionate people</a> working alongside us who are best-placed to tell the stories of all those who stand to benefit from the opportunities that making banking accessible.</p>\r\n<p>Humaniq&rsquo;s partners and advisors, meanwhile, the &lsquo;<a href=\"https://www.youtube.com/playlist?list=PL2Ubxa5YQEQi_f7kAL2cYGU08Z3cvsXLh\">faces of Humaniq</a>,&rsquo; are all those amazing people who are working with us because they, too, want a world where everybody can progress and improve their lives by accessing finance and making transactions. They include those developing digital inclusion applications sitting on top of the Humaniq app that will unleash its full potential as a platform for the global unbanked, all based on the Ethereum Blockchain and all fuelled by the HMQ tokens. They include Kumar Gaurav, founder of Cashaa, a peer-to-peer marketplace powered by the Blockchain, and Tim Campbell, founder of the Bright Ideas trust to widen access to entrepreneurship.</p>\r\n<p>Members of the core team at Humaniq also share their stories, with Dinis Guarda, our CEO, sharing how he became involved in the project to widen financial inclusion across the globe while creating a new peer-to-peer economy: see <a href=\"https://www.youtube.com/watch?v=wcUaCZtJQ9Q\">here</a> and <a href=\"https://www.youtube.com/watch?v=4os5LJsUwCE\">here</a>. Dinis and the team also provide regular updates as the project progresses to give an insight into what is happening behind the scenes and to invite questions and involvement, including in <a href=\"https://www.youtube.com/watch?v=s8Lg-LGqE1A\">a Facebook live</a> in June 2017.</p>",
      category: "Community"
    }, {
      title: "Blockchain pour les débutants",
      article: "<p>Le but d&rsquo;Humaniq est d'autonomiser la population non-bancaris&eacute;e en utilisant la technologie de la blockchain.</p>\r\n<p>Il est important de savoir comment cela fonctionne. Cette s&eacute;rie permettra de d&eacute;couvrir toutes les notions fondamentales gr&acirc;ce &agrave; des extraits simples et faciles &agrave; comprendre.</p>\r\n<p>A la base, une blockchain est un livret de transactions ; ce qui n'a rien de r&eacute;volutionnaire. Cependant, les formes traditionnelles de stockage sont compl&egrave;tement centralis&eacute;es : lorsque vous mettez votre argent dans une banque, par exemple, vous &ecirc;tes s&ucirc;r et certain que votre argent est en s&eacute;curit&eacute;. Sa base de donn&eacute;es pourrait &ecirc;tre hack&eacute;e mais personne ne s&rsquo;en rendrait compte, si ce n&rsquo;est la banque.</p>\r\n<p>La blockchain fonctionne sur le principe de d&eacute;centralisation et de &laquo;&nbsp;confiance aveugle&nbsp;&raquo;. L&rsquo;int&eacute;grit&eacute; des donn&eacute;es est garantie par des logarithmes, ce que tout le monde peut v&eacute;rifier. Voil&agrave; ce que veut dire le terme de &laquo;confiance aveugle&raquo; : Au lieu de faire confiance &agrave; une seule entit&eacute; - comme par exemple une banque -, vous vous appuyez sur les r&egrave;gles cryptographiques qui garantissent la s&eacute;curit&eacute; de vos donn&eacute;es.</p>\r\n<p>Cependant, il est important de comprendre ces r&egrave;gles et comment la blockchain est devenue inviolable.</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6FX\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>",
      category: "French stories"
    }, {
      title: "Blockchain for beginners",
      article: "<p>Humaniq's goal is to empower the unbanked by using blockchain technology.</p>\r\n<p>As such, it&rsquo;s important to understand how it works. This series will cover all of the core concepts in short and easy-to-understand snippets.</p>\r\n<p>At its core, a blockchain is simply a ledger of transactions, which by itself is nothing ground-breaking. However, traditional forms of storage are completely centralized: when you put your money in a bank, for example, you are trusting it to store it safely for you. Its databases could be hacked, and no one would be able to notice it, except for the bank itself.</p>\r\n<p>Blockchain operates under the principle of decentralized and &ldquo;trustless&rdquo; storage. The integrity of the data is guaranteed by cryptography and math, which is verifiable by anyone. This is what trustless means: instead of trusting any single entity, like a bank, you rely on cryptographic rules that guarantee the safety of the data.</p>\r\n<p>However, it is useful to understand exactly what are these rules, and how blockchain achieves its goal of being tamper-proof.</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6FX\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>",
      category: "English stories"
    }, {
      title: "Under the hood of blockchains",
      article: "<p>The most essential building block of blockchain technology is the concept of a \"cryptographic hash\". A hash function is a sort of one-way encryption mechanism: it is very easy to create a hash string from an input, but almost impossible to understand what&rsquo;s the input that generated a given hash.</p>\r\n<p>Hash strings, or simply hashes, look like this: 6b1cfe66c8f23dab339467ddfe8302d37cdcc2b9d280f148fed55379edffaf7a</p>\r\n<p>Every transaction in a blockchain system has its own unique hash, which functions as an identifier. To make the system work, the transactions must be grouped into single chunks called &ldquo;blocks&rdquo;, hence the term &ldquo;blockchain&rdquo;. Every block has its own unique hash identifier as well, but more on that later.</p>\r\n<p>A block must have something called a &ldquo;block header&rdquo;, a set of values representing its properties. This is where all the magic happens!</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6CJ\" alt=\"Blockchain structure\" style=\"width: 100%; max-width: 100%;\" /></p>\r\n<p>Inside the block header the hashes of all of the transactions contained in the block are summed into one &ldquo;master hash&rdquo; called the Merkle Root. This hash is a unique representation of all of the transactions inside the block, and even the tiniest alteration in one of the components would produce a completely different Merkle Root.</p>\r\n<p>The Merkle root is then added together with the hash identifier of the previous block (and several other values) to create a new hash string: the identifier of the new block. Thus, every single block directly depends on the previous one, forming a chain.</p>\r\n<p></p>",
      category: "English stories"
    }, {
      title: "Ce qui se cache sous les blockchains",
      article: "<p>Le concept essentiel de la technologie de la blockchain, c&rsquo;est le concept du &laquo;hachage cryptographique&raquo;. Une fonction de hachage est une sorte de m&eacute;canisme de chiffrage : il est tr&egrave;s facile de cr&eacute;er une cha&icirc;ne de hash &agrave; partir de l&rsquo;entr&eacute;e, mais il est presque impossible de comprendre l&rsquo;entr&eacute;e qui a g&eacute;n&eacute;r&eacute; une donn&eacute;e de hachage.</p>\r\n<p>Les hachages des cha&icirc;nes, ou simplement les hachages, ressemblent &agrave; &ccedil;a : 6b1cfe66c8f23dab339467ddfe8302d37cdcc2b9d280f148fed55379edffaf7a</p>\r\n<p>Dans une blockchain, chaque transaction a son propre hash qui fonctionne comme un identifiant. Pour que le syst&egrave;me fonctionne, les transactions doivent &ecirc;tre regroup&eacute;es en fragments appel&eacute;s &laquo;blocks&raquo;, d'o&ugrave; le terme &laquo;blockchain&raquo;. Chaque bloc a son propre identifiant hash ; mais nous verrons cela plus tard.</p>\r\n<p>Un bloc doit avoir ce que l&rsquo;on appelle un &laquo;bloc d&rsquo;en-t&ecirc;te&raquo;, un ensemble de valeurs repr&eacute;sentant ses propri&eacute;t&eacute;s. Et c&rsquo;est l&agrave; que la magie se produit!</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6Vf\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>\r\n<p>A l&rsquo;int&eacute;rieur du bloc d&rsquo;en-t&ecirc;te, il y a tous les hashes de toutes les transactions contenues dans le bloc qui sont r&eacute;unis dans un &laquo;&nbsp;master hash&nbsp;&raquo;, appel&eacute; le racine Merkle. Cet hash est une repr&eacute;sentation unique de toutes les transactions du block et m&ecirc;me la plus petite alt&eacute;ration de l&rsquo;un des composants produirait une racine Merkle compl&egrave;tement diff&eacute;rente.</p>\r\n<p>La racine Merkle est ensuite ajout&eacute;e &agrave; l'identifiant hash du block d'avant (et &agrave; de nombreuses autres valeurs) pour cr&eacute;er un nouveau hash : l&rsquo;identifiant du nouveau block. Ainsi, chaque bloc d&eacute;pend directement de celui d'avant, formant une cha&icirc;ne.</p>",
      category: "French stories"
    }, {
      title: "Why Blockchain is secure and tamper-proof",
      article: "<p>Let's make an example. The TestCoin blockchain currently has 12 blocks.</p>\r\n<p>An attacker changes one transaction in block 10 to give himself more TestCoin and transmits his new version of the blockchain to everybody in the world.<br />However, by changing the transaction, he changes the Merkle Root of block 10, which in turn changes the hash identifier the entire block.</p>\r\n<p>Now, if you recalculate the hash of block 11, it doesn&rsquo;t coincide with the one it already has. This makes it extremely obvious that block 10 has been tampered with, and everybody rejects this new version of the blockchain.</p>\r\n<p>This is how the blockchain achieves its security: changing even just one transaction inside an already existing block would render all of the blocks afterwards invalid.</p>\r\n<p>Of course, one could ask: &ldquo;Can&rsquo;t the attacker just recalculate all of the blocks after the one he changed, and get away with it?&rdquo;. Indeed he could, but this is where the concepts of proof-of-work and mining come in, which will be explained in the next installment of the series!<img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6SR\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>\r\n<p></p>",
      category: "English stories"
    }, {
      title: "En quoi cela rend-il le système de Blockchain inviolable?",
      article: "<p>Prenons un exemple. La blockchain du TestCoin contient 12 blocs.</p>\r\n<p>Un hacker change une transaction dans le bloc 10 pour avoir plus de TestCoin et transmet sa nouvelle version de la blockchain &agrave; tout le monde.<br />Cependant, en passant une transaction, il change la racine Merkle du bloc n &deg; 10, ce qui change l'identifiant hash de tout le bloc.</p>\r\n<p>Maintenant, si vous recalculez le hash du bloc 11, il n'ira pas avec l'identifiant qu'il avait auparavant. La modification du bloc 10 sera &eacute;vidente; tout le monde rejette donc la nouvelle blockchain.</p>\r\n<p>C'est ainsi que la blockchain atteint son objectif de s&eacute;curit&eacute;: en changeant ne serait-ce qu'une transaction dans un bloc d&eacute;j&agrave; existant, tous les blocs suivants ne sera plus valides.</p>\r\n<p>Bien s&ucirc;r, on pourrait se demander: &laquo;Est-ce que le hacker ne pourrait pas juste calculer tous les blocs qui viennent apr&egrave;s celui qu'il a chang&eacute;? &raquo;En effet, il pourrait, mais c'est l&agrave; o&ugrave; les concepts de preuve-de-travail et de mineurs sont en jeu. Nous l'expliquerons dans la s&eacute;rie s&eacute;rie!</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6SR\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>",
      category: "French stories"
    }, {
      title: "Safer way to save your money",
      article: "<p>Life happens. Sometimes it is too dangerous to walk with some cash in your pocket. Especially when you have a significant amount on you. So it&rsquo;s obvious that it&rsquo;s safer to use electronic transactions for some payments or just for saving. Usually we use computers or phones to access our bank accounts. But what if we don&rsquo;t use a bank and use Humaniq instead?</p>\r\n<p>With Humaniq App, you can always access your money. Even without the phone you first used the App on!</p>\r\n<p>So what if your phone is lost, or you have a new one? First of all, if someone&rsquo;s found your phone, he or she won&rsquo;t be able to use your money, because they won&rsquo;t have access to your Humaniq wallet without you. It's only you who can access your money.</p>\r\n<p>So open Humaniq App on another phone. To keep your money safe for you, the App checks your identity. You take a photo of your face, and you put your password in. And then you are ready!</p>\r\n<p>On the new phone you can start using your Humaniq wallet again! Humaniq App is the safe way to keep money and to pay.&nbsp;</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6Il\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>\r\n<p></p>",
      category: "English stories"
    }, {
      title: "June 09-24th, Dar es Salaam: Humaniq seafood weeks in Pweza Cafe!",
      article: "<figure class=\"image\"><a href=\"http://bit.ly/2sGOKxP\"><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6PD\" alt=\"Show this coupon to a waiter in Pweza Cafe, tell magic word &quot;Humaniq&quot; and get 10% off\" style=\"width: 100%; max-width: 100%;\" /></a></figure>\r\n<p><a href=\"http://bit.ly/2sGOKxP\"><strong>Save</strong></a> this coupon, show it to the waiter or tell a secret word \"Humaniq\" and get 10% off on all orders (in-cafe, delivery, takeaway) from 10,000 TZS in Pweza Cafe, Dar es Salaam. Also get 5 HMQ after sending photo of your order receipt to +255 684 602 709 in your Humaniq app. Enjoy our exclusive offer and share it with friends! This discount lasts only from June 9th till June 24th.</p>\r\n<p style=\"text-align: center;\"><a href=\"http://bit.ly/2sGOKxP\"><strong>CLICK HERE TO SAVE THE COUPON</strong></a>&nbsp;|&nbsp;Pweza Cafe on&nbsp;<a href=\"http://bit.ly/2sHVgnK\"><strong>instagram</strong></a></p>",
      category: "English stories"
    }, {
      title: "What is the Blockchain good for",
      article: "<p><span>What is the Blockchain good for? It puts you in control of your money so you can save and pay for things safely - without the Government or banks.<span class=\"Apple-converted-space\">&nbsp;</span></span></p>\r\n<p><span>Any national currency you have can be taken away from you. Online payment providers can freeze your accounts. But the Blockchain means you have some digital money that no government, bank, mobile or other company can touch.</span></p>\r\n<p><span>This digital money, cryptocurrency, is for everybody, wherever you live, or what ID you have. You only need a smartphone.</span></p>\r\n<p><span>How do you use cryptocurrency? In the Humaniq Community, you can easily do business with other people. You can see who is trusted, and do business with them directly - with no middle-man.<span class=\"Apple-converted-space\">&nbsp;</span></span></p>\r\n<p><span>You simply send and get HMQ coin with Humaniq App. You don&rsquo;t need big businesses or big prices.</span></p>\r\n<p><span>The more people who have cryptocurrency, the more and more useful it becomes. The Humaniq Community is growing to one million HMQ users this year. And you get rewarded for inviting your friends and family to join!</span></p>\r\n<p><span>Why? Because Blockchain and cryptocurrency like HMQ means a new economy, with more opportunities for you.</span></p>\r\n<p><span><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU65r\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></span></p>",
      category: "English stories"
    }, {
      title: "Pourquoi la Blockchain est bien ",
      article: "<p><span>Pourquoi la Blockchain est bien&nbsp;? Parce que vous avez la main mise sur votre argent et ni le gouvernement ni les banques ne peut y toucher.</span></p>\r\n<p><span>Avec une monnaie nationale, le gouvernement, les banques ou autres soci&eacute;t&eacute;s peuvent geler vos comptes ou pr&eacute;lever de l&rsquo;argent dessus. Mais avec la Blockchain, personne ne peut y toucher.</span></p>\r\n<p><span>Cette monnaie num&eacute;rique est pour tout le monde. Vous pouvez y avoir acc&egrave;s quel que soit l&rsquo;endroit o&ugrave; vous vivez et quel que soit votre identit&eacute;. Vous avez seulement besoin d&rsquo;un smartphone.</span></p>\r\n<p><span>Comment marche la crypto-monnaie&nbsp;? Chez Humaniq, vous pouvez facilement faire affaires avec d&rsquo;autres personnes sans tierce-personne.</span></p>\r\n<p><span>Vous envoyez simplement vos tokens HMQ avec l&rsquo;application Humaniq. Vous n&rsquo;avez pas besoin d&rsquo;avoir une grande entreprise ou payer des sommes monstrueuses.</span></p>\r\n<p><span>Plus les gens utilisent les crypto-monnaies, plus elles deviennent utiles. La communaut&eacute; Humaniq va sur son million d&rsquo;utilisateurs cette ann&eacute;e. Et on vous r&eacute;compense lorsque vous invitez des amis ou de la famille&nbsp;!</span></p>\r\n<p><span>Pourquoi&nbsp;? Parce que la Blockchain et la crypto-monnaie signifient une nouvelle &eacute;conomie et de nouvelles opportunit&eacute;s pour vous.</span></p>\r\n<p></p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU65r\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>",
      category: "French stories"
    }, {
      title: "Blockchain ni nzuri kwa nini",
      article: "<p>Blockchain ni nzuri kwa nini? Inakupa udhibiti wa pesa yako ili uweze kuokoa na kulipa vitu kwa usalama - bila Serikali au mabenki.</p>\r\n<p>Fedha yoyote ya taifa unayoweza kuwa nayo inaweza kuchukuliwa kutoka kwako. Watoaji wa malipo ya mtandaoni wanaweza kufungia akaunti zako. Lakini Blockchain ina maana una pesa fulani ya kidijitali ambayo hakuna serikali, benki, simu au kampuni nyingine inayoweza kugusa.<br />Fedha hii ya kidijitali, sarafu ya kidijitali, ni kwa kila mtu, popote unapoishi, au ID gani unayo. Unahitaji tu smartphone.</p>\r\n<p>Je, unatumiaje sarafu ya kidijitali? Katika jumuiya ya Humaniq, unaweza kufanya biashara kwa urahisi na watu wengine. Unaweza kuona nani anayeaminiwa, na kufanya biashara nao moja kwa moja - bila mtu wa kati.</p>\r\n<p>Unatuma tu na kupata sarafu za HMQ na App ya Humaniq. Huna haja ya biashara kubwa au bei kubwa.<br />Zaidi watu wengi wanavyokua na sarafu ya kidijitali, zaidi na zaidi inakuwa inahitajika. Jumuiya ya Humaniq inakua na kufikia watumiaji milioni moja wa HMQ mwaka huu. Na utapata thawabu kwa kuwakaribisha marafiki na familia yako kujiunga!</p>\r\n<p>Kwa nini? Kwa sababu Blockchain na sarafu za kidijitali kama HMQ inamaanisha uchumi mpya, na fursa zaidi kwako.</p>\r\n<p></p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU65r\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>\r\n<p style=\"text-align: center;\"><span><b>Karibisha marafiki na upate thawabu!</b></span></p>",
      category: "Swahili stories"
    }, {
      title: "Njia salama ya kuhifadhi pesa yako",
      article: "<p><a name=\"story\"></a>Maisha hutokea. Wakati mwingine ni hatari sana kutembea na fedha katika mfuko wako. Hasa wakati una kiasi kikubwa. Kwa hiyo ni dhahiri kuwa ni salama kutumia miamala ya kielektroniki kwa malipo fulani au tu kwa kuhifadhi. Kwa kawaida tunatumia kompyuta au simu ili kufikia akaunti zetu za benki. Lakini ni nini ikiwa hatutumii benki na kutumia Humaniq badala yake?</p>\r\n<p>Kwa programu(App) ya Humaniq, unaweza kuifikia pesa yako daima. Hata bila ya simu unatumia Programu ya kwanza!</p>\r\n<p>Basi nini kama simu yako imepotea, au una simu mpya? Awali ya yote, ikiwa mtu ameipata simu yako, yeye hawezi kutumia pesa yako, kwa sababu hatakuwa na uwezo wa kuingia kwenye mkoba wako wa Humaniq bila wewe. Ni wewe tu ambaye anaweza kufikia pesa zako.</p>\r\n<p>Hivyo fungua programu(App) ya Humaniq kwenye simu nyingine. Ili kuweka fedha yako salama kwako, App inachunguza utambulisho wako. Unachukua picha ya uso wako, na kuweka neno lako la siri. Na kisha uko tayari!</p>\r\n<p>Katika simu mpya unaweza kuanza kutumia mkoba wako wa Humaniq tena! Humaniq App ni njia salama ya kuweka fedha na kulipa.</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6Il\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>",
      category: "Swahili stories"
    }, {
      title: "HMQ contest! Win 20 HMQ!",
      article: "<p><a name=\"story\"></a>Join our Facebook community to always receive the latest news and find answers to your questions. We regularly hold surveys and contests, in fact we have one right now! <strong><a href=\"https://www.facebook.com/humaniq.co/photos/a.570857303123407.1073741829.536426589899812/796977737178028/?type=3\">Tap this picture, leave a comment at the post below</a></strong> for a chance to win 20 HMQ!</p>\r\n<p><a href=\"https://www.facebook.com/humaniq.co/photos/a.570857303123407.1073741829.536426589899812/796977737178028/?type=3\"><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6Lz\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></a></p>",
      category: "English stories"
    }, {
      title: "Chance de gagner 20 HMQ!",
      article: "<p><a name=\"story\"></a>Suivez notre page Facebook pour recevoir les nouveaut&eacute;s et r&eacute;ponses &agrave; vos questions. Nous organisons r&eacute;guli&egrave;rement des enqu&ecirc;tes et des concours, vous pouvez y participer maintenant! <a href=\"https://www.facebook.com/humaniq.co/photos/a.570857303123407.1073741829.536426589899812/796977737178028/?type=3\"><strong>Laissez un commentaire en dessous</strong></a> pous avoir une chance de gagner 20 HMQ. Simple!</p>\r\n<p><a href=\"https://www.facebook.com/humaniq.co/photos/a.570857303123407.1073741829.536426589899812/796977737178028/?type=3\"><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6Lz\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></a></p>",
      category: "French stories"
    }, {
      title: "How to save money with crypto",
      article: "<p><span style=\"font-weight: 400;\">Many people are excited by digital currency because every coin can be worth more tomorrow. It might, but nobody knows the future. What is certain is that using digital currency saves you money today.</span></p>\r\n<p><span style=\"font-weight: 400;\">Want to send or receive money? You lose so much in fees. Want to sell goods and services? You lose money to take payments by card. Want to borrow money for your future? Again, it is so expensive.</span></p>\r\n<p><span style=\"font-weight: 400;\">When your family send you money, banks take 7 cents of every dollar sent globally. They take even more in some areas - twice as much in South Africa. Banks issuing payment cards take around 50 cents of your money when you sell something for $20. And interest on loans can be even more: to borrow 5,000 Kenyan Shillings, you can pay 1,800 Kenyan Shillings!</span></p>\r\n<p><span style=\"font-weight: 400;\">So if you want to send, charge or borrow money, how can you keep more of it? Cutting out the middleman is how. Banking on the Blockchain is the way to escape high charges.</span></p>\r\n<p><span style=\"font-weight: 400;\">When your family member sends you $100 in digital money, you pay pennies, not many dollars. And it&rsquo;s only a fixed, small fee for taking payment by digital money - $1 on average in Bitcoin as we enter July 2018. And the Blockchain can cut the high cost of loans too. How does the Blockchain do all this? </span></p>\r\n<p><span style=\"font-weight: 400;\">Simply put, it means less administration - no bank buildings and fewer staff. The Blockchain can save you money as you deal directly with other people.</span></p>\r\n<p><span style=\"font-weight: 400;\"><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU695\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></span></p>\r\n<p></p>\r\n<p></p>\r\n<p></p>",
      category: "English stories"
    }, {
      title: "Why Crypto can better than real money",
      article: "<p>Cryptocurrency (which is HMQ, Bitcoin, Etherum and many more) has many advantages over &lsquo;real&rsquo; or old money &ndash; and the possibilities for this new, better money &ndash; like HMQ &ndash; are growing every day.</p>\r\n<p>Cryptocurrency supplied by its users and investors is valuable in a way old money can never be. It gives the people a way to grow their money in line with the growth of the new, digital economy. So national banks and politicians alone cannot make your money buy less.</p>\r\n<p>Cryptocurrency gives close-to-zero fees in a way old money cannot &ndash; even when you are sending money to people in other countries. It does this by cutting costs by ending unnecessary bank administration. So you keep more of your own money.</p>\r\n<p>Best of all: cryptocurrency expands opportunities in a way that old money cannot. This digital currency opens doors and connects people to new goods and services even if you don't have a bank account. You can do business with small traders in other regions or even nations. The old money was only useful in your local market &ndash; or to buy from global companies.</p>\r\n<p>Cryptocurrency: it is your money, only growing more, costing you less, and getting you further.</p>\r\n<p><img src=\"https://storage.googleapis.com/humaniq_media/7U7LeuHRmj1z2hZzbIU6Yt\" alt=\"\" style=\"width: 100%; max-width: 100%;\" /></p>",
      category: "English stories"
    }],
    technical_mecca: [{
      title: "What is a Blockchain?",
      article: "<p>A blockchain is a new kind of internet, that makes an entirely new kind of banking possible. A blockchain frees people from the need for any big, central authority in order to simply transact and speak with each other. It is a shared, decentralised database run by a peer-to-peer network of computers or nodes, as opposed to the central server that runs traditional applications and websites. Every request to make a transaction, such as when one person agrees to lend money to another who wishes to borrow, is information that is distributed across this network, not stored in one place. The result is a permanent, incorruptible and secure record of each and every transaction, stored across the network publically and chronologically on what is referred to as a &lsquo;digital ledger&rsquo; in &lsquo;blocks&rsquo; of data.</p>",
      category: "Crypto Basics"
    }, {
      title: "How transactions are verified",
      article: "<p>A blockchain, as a decentralised network, liberates people from a reliance on the old, centralised banks, opening up banking services to those currently able to access them. To make this possible, however, there is a challenge that needs to be overcome. The shared, distributed record of the fact that all the transactions have been made requires some of the computing power of those providing the computers, or nodes, to run the system. In order to achieve this, each person who offers their hardware and storage space for the purpose of sustaining the blockchain is rewarded with cryptocurrency. The amount that they are paid is calculated by an internal, virtual machine called gas, which efficiently and fairly identifies the relative cost of different computing operations, in order to incentivise contributions.</p>",
      category: "Crypto Basics"
    }, {
      title: "HMQ and Ethereum",
      article: "<p>HMQ is the Humaniq cryptocurrency token. The Ethereum platform facilitated the launch of our currency for the global unbanked by providing a common standard. This ERC20 standard allowed HMQ to immediately work with all decentralised apps that also conform to the standard, which means that if you use any of a number of mobile wallet such as, for example, Coinbase and Jaxx you can hold HMQ. It also means that HMQ are easily exchangeable with other cryptocurrency tokens that follow the ERC20 rules, including Ether, the Ethereum token. Humaniq is still young: our ICO (initial coin offer) was only held in April 2017 and the Humaniq app launch is scheduled for August. But HMQ can already be exchanged with other currencies in a number of online exchanges: SpaceBTC, Yobit, Bittrexx Liqui and C-CEX.</p>",
      category: "Crypto Basics"
    }, {
      title: "Why Ethereum?",
      article: "<p>The Ethereum Blockchain provided a ready and operating blockchain for Humaniq to effectively provide banking to the unbanked with a new, decentralised app. In addition, it also offers smart contract functionality that facilitate online contractual agreements within the Humaniq app, making peer-to-peer lending and other collaborations between Humaniq users easy. They are smart because repayments and other transactions that Humaniq users commit to are automatically executed. This allows the expansion of microfinance, which to date has relied on intermediaries charging fees. The Ethereum Blockchain also underpins an encrypted messaging system between Humaniq app users, which provides privacy and security.</p>",
      category: "Crypto Basics"
    }, {
      title: "Ethereum vs Bitcoin",
      article: "<p>Blockchains are still best-known for being the medium that made the cryptocurrency Bitcoin possible. The Bitcoin Blockchain was introduced in 2009 for the purpose of tracking all transactions made in that digital money. Blockchain technology potentially is suitable for recording far more than the amount of cryptocurrency being held and used, including agreements between people. Other providers have since launched other blockchains in order to cater for such wider applications, including Ethereum, which in 2016 launched a new, open-source, blockchain as a platform for any applications that cut out middle-men and widen access to services.. Ethereum facilitates a blockchain-based economy because every new start-up does not need to deploy their own blockchain, with the possibility of revolutionising a range of financial services, including credit and insurance.</p>",
      category: "Crypto Basics"
    }, {
      title: "Why use a blockchain?",
      article: "<p>Blockchains offer a way to confirm that transactions have taken place without any go-between, such as a traditional bank, needed to carry out, check, and record everything. This allows banking services to be offered everywhere, including to people and in areas that are not served by banks, and so are shut out of the 21st Century economy&rsquo;s opportunities. It also opens up the possibility of a new, peer-to-peer, sharing economy, where people can directly send and receive, lend and borrow money to and from each other, rather than relying on financial industry and its fee-charging field representatives. This way of providing financial services is not only more democratic and accessible, it also offers better security, because there is no central server for hackers to attack, and the information on transactions cannot be tampered with.</p>",
      category: "Crypto Basics"
    }]
  }
};

exports.default = function () {
  var wikiArticles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initWikiArticles;
  var _ref = arguments[1];
  var type = _ref.type,
      data = _ref.data;

  return (0, _extends3.default)({}, wikiArticles, { loading: false, loaded: true }, (0, _mapper2.default)(initWikiArticles.data));

  /*switch (type) {
    case REQUEST + WIKI + START:
      return {...wikiArticles, loading: true};
    case REQUEST + WIKI + SUCCESS:
      return {...wikiArticles, loading: false, loaded: true, ...mapper(data)};
    case REQUEST + WIKI + FAIL:
      return {...wikiArticles, loading: false};
  }
  return wikiArticles;*/
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity) {
  return [_constants.FETCH + entity + _constants.START, _constants.FETCH + entity + _constants.SUCCESS, _constants.FETCH + entity + _constants.FAIL];
};

var _constants = __webpack_require__(12);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity) {
  return [_constants.POST + entity + _constants.START, _constants.POST + entity + _constants.SUCCESS, _constants.POST + entity + _constants.FAIL];
};

var _constants = __webpack_require__(12);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity) {
  return [_constants.REQUEST + entity + _constants.START, _constants.REQUEST + entity + _constants.SUCCESS, _constants.REQUEST + entity + _constants.FAIL];
};

var _constants = __webpack_require__(12);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {
  module.exports = require('./configureStore.dev');
} else {
  module.exports = __webpack_require__(519);
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(12);

var Console = console;

exports.default = function () {
  return function (next) {
    return function (action) {
      var type = action.type,
          data = action.data;

      if (type !== _constants.ERROR) return next(action);

      Console.warn('error middleware notification :', data);
      return next(action);
    };
  };
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(28);

var _reducer = __webpack_require__(545);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(547);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(550);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(527);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(520);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(542);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(538);

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = __webpack_require__(534);

var _reducer16 = _interopRequireDefault(_reducer15);

var _reducer17 = __webpack_require__(532);

var _reducer18 = _interopRequireDefault(_reducer17);

var _reducer19 = __webpack_require__(536);

var _reducer20 = _interopRequireDefault(_reducer19);

var _reducer21 = __webpack_require__(525);

var _reducer22 = _interopRequireDefault(_reducer21);

var _reducer23 = __webpack_require__(529);

var _reducer24 = _interopRequireDefault(_reducer23);

var _reducer25 = __webpack_require__(540);

var _reducer26 = _interopRequireDefault(_reducer25);

var _reducer27 = __webpack_require__(544);

var _reducer28 = _interopRequireDefault(_reducer27);

var _reducer29 = __webpack_require__(523);

var _reducer30 = _interopRequireDefault(_reducer29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import wikiSearch from 'store/entities/wikiSearch/reducer'
exports.default = (0, _redux.combineReducers)({
  navigation: _reducer2.default,
  partners: _reducer4.default,
  ambassadors: _reducer10.default,
  wikiArticles: _reducer6.default,
  //wikiSearch,
  hmqGraph: _reducer8.default,
  hmqStatistic: _reducer12.default,
  hmqMarkets: _reducer14.default,
  hmqHolders: _reducer16.default,
  hmqHolder: _reducer18.default,
  hmqLog: _reducer20.default,
  hmqBlock: _reducer22.default,
  hmqHash: _reducer24.default,
  hmqSearch: _reducer26.default,
  home: _reducer28.default,
  careers: _reducer30.default
  // transactions,
});
// import transactions from 'store/entities/transactions/reducer'

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._isDateValid = exports._date = undefined;

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _date = exports._date = function _date(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  _moment2.default.locale(locale);
  return (0, _moment2.default)(date).format('ll');
};

var _isDateValid = exports._isDateValid = function _isDateValid(date) {
  return (0, _moment2.default)(date).isValid();
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashLinkScroll = hashLinkScroll;
function hashLinkScroll() {
  var hash = window.location.hash;

  if (hash !== '') {
    setTimeout(function () {
      var id = hash.replace('#', '');
      var element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }, 0);
  } else {
    window.scrollTo(0, 0);
  }
}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  var query = void 0;
  if (location) {
    query = (0, _qs.parse)(location.search.substr(1));
  }
  var prepareDataFns = routes.map(function (route) {
    return route.prepareData;
  }).filter(function (el) {
    return !!el;
  });
  return prepareDataFns.map(function (prepareData) {
    prepareData(store, query, params, location);
  });
};

var _qs = __webpack_require__(162);

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  setTimeout(function () {
    var els = document.getElementsByClassName('progress');
    els[0].style.height = 0;
    setTimeout(function () {
      els[0].style.display = 'none';
    }, 500);
  }, 2000);
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEmail = validateEmail;
exports.validateWebsiteName = validateWebsiteName;
exports.validateMaxLength = validateMaxLength;
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validateWebsiteName(url) {
  var re = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
  return re.test(url);
}

function validateMaxLength() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var lenght = arguments[1];

  return text.length <= lenght;
}

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[489]);


// WEBPACK FOOTER //
// bundle.e9eb26f204d10d62714f.js